import { timelineTranslations } from "./translations/timeline";
import RecapSottoscrizioniPaziente from './translations/RecapSottoscrizioniPaziente';
import PlanSheet from './translations/PlanSheet';

const base = {
  it: {
    RichiediServizioChat: {
      testo: "La chat con il medico non è attiva per il tuo profilo. Chiamaci al numero verde {numero} per richiederla.",
      bottone: "Richiedi il servizio",
      aria: "Richiedi il servizio: chiama il numero verde {numero}",
    },
    ChatPartecipanti: {
      titolo: "Aggiungi un partecipante",
      conferma: "Aggiungi",
      spiegazione: "Può entrare un collega che ha già una sua chat con questo paziente. Vedrà anche i messaggi scritti finora.",
      caricamento: "Caricamento dei medici",
      errore_elenco: "Non è stato possibile caricare i medici.",
      nessuno: "Nessun collega ha ancora una sua chat con questo paziente. Il collega la apre dalla scheda del paziente: bottone della chat, poi «Abilita la chat». Fatto questo, qui compare il suo nome.",
      scegli: "Scegli il medico",
      aggiunto: "Il medico è entrato nella conversazione",
      titolo_successo: "Fatto",
      errore_aggiunta: "Non è stato possibile aggiungere il medico",
      in_chat: "In questa conversazione",
      aggiungi: "Aggiungi",
      tu: "tu",
      titolo_errore: "Errore",
      con_altri: "Con anche {nomi}",
    },
    SoapTemplatesManager: {
      conferma_eliminazione_titolo: "Conferma eliminazione",
      conferma_eliminazione: 'Il modello "{titolo}" sta per essere eliminato.',
      elimina: "Elimina",
      eliminato: "Modello eliminato",
      eliminazione_fallita: "Non è stato possibile eliminare il modello",
    },
    SearchUtenteDashboard: {
      seleziona: "Seleziona",
      solo_in_agenda: "Solo in agenda",
      voce_agenda_non_apribile_titolo: "Voce di agenda",
      voce_agenda_non_apribile:
        "Il risultato scelto viene da un appuntamento in agenda, non da una scheda paziente, e non ha una scheda da aprire. La persona va cercata per codice fiscale, cognome o nome.",
    },
    ModalChatPaziente: {
      paziente: "Paziente",
      titolo_operatore_proprie: "Le mie conversazioni",
      titolo_cittadino: "Chat Clinica con i tuoi Medici",
      titolo_con_paziente: "Chat Clinica con {nome}",
    },
    ModalNuovoCanale: {
      titolo: "Abilita Chat Medico-Paziente",
      conferma: "Abilita canale",
      label_operatore: "Operatore sanitario (medico o infermiere)",
      descrizione_operatore: "Il professionista sanitario abilitato al servizio",
      scegli_operatore: "Seleziona un operatore",
      label_paziente: "Paziente",
      descrizione_paziente: "Ricerca per cognome, nome o codice fiscale",
      placeholder_ricerca: "Cerca paziente",
      cerca: "Cerca",
      scegli_paziente: "Seleziona il paziente trovato",
      caricamento: "Caricamento in corso",
      nota: "L'abilitazione consente lo scambio asincrono di messaggi e documenti protetti tra il paziente e il medico designato.",
      errore_operatori: "Non è stato possibile recuperare gli operatori idonei",
      canale_creato: "Canale di chat abilitato",
      titolo_successo: "Operazione riuscita",
      errore_creazione: "Non è stato possibile abilitare il canale di chat",
      titolo_errore: "Errore",
    },
    ChatPazientiWhitelist: {
      titolo: "Chat medico-paziente - gestione whitelist",
      sottotitolo: "Abilitazione e monitoraggio dei canali di messaggistica asincrona fra pazienti e professionisti sanitari.",
      nuovo_canale: "Abilita nuovo canale",
      filtra_stato: "Filtra per stato",
      aggiorna: "Aggiorna elenco",
      nessun_canale: "Nessun canale di chat con i filtri selezionati.",
      caricamento: "Caricamento dei canali in corso",
      stato_tutti: "Tutti gli stati",
      stato_solo_attivi: "Solo canali attivi",
      stato_solo_revocati: "Solo canali revocati",
      col_paziente: "Paziente",
      col_operatore: "Medico o operatore",
      col_stato: "Stato",
      col_data: "Data abilitazione",
      col_azioni: "Azioni",
      stato_attivo: "Attivo",
      stato_revocato: "Revocato",
      azione_visualizza: "Visualizza la chat clinica con il paziente",
      azione_archivia: "Archivia la trascrizione nel profilo sanitario",
      azione_revoca: "Revoca il canale",
      azione_riattiva: "Riattiva il canale",
      conferma_revoca_titolo: "Revoca del canale",
      conferma_revoca_ok: "Revoca",
      conferma_revoca_testo: "La chat con {paziente} viene revocata: non sarà più possibile inviare nuovi messaggi. Lo storico resta consultabile.",
      paziente: "Paziente",
      revoca_riuscita: "Canale revocato",
      revoca_fallita: "Non è stato possibile revocare il canale",
      caricamento_fallito: "Non è stato possibile caricare i canali della struttura",
      riattivazione_riuscita: "Canale riattivato",
      riattivazione_fallita: "Non è stato possibile riattivare il canale",
      archiviazione_riuscita: "Trascrizione archiviata nell'archivio sanitario del paziente",
      archiviazione_titolo: "Archiviazione completata",
      archiviazione_fallita: "Non è stato possibile archiviare la trascrizione",
      errore: "Errore",
    },
    PatientChatSection: {
      titolo_cittadino: "Chat con i tuoi medici",
      titolo_operatore: "Messaggistica e chat clinica",
      sottotitolo_cittadino: "Comunicazione diretta e sicura con i professionisti sanitari abilitati.",
      sottotitolo_operatore: "Storico e gestione delle conversazioni dirette con il paziente.",
      abilita_medico: "Abilita nuovo medico",
      caricamento: "Caricamento della chat in corso",
      nessun_canale: "Nessun canale di chat abilitato",
      nessun_canale_operatore: "Abilitando un medico si avvia lo scambio asincrono di messaggi clinici con questo paziente.",
      nessun_canale_cittadino: "Nessun medico ha ancora abilitato un canale di messaggistica per il tuo profilo.",
      abilita_ora: "Abilita la chat",
      elenco_cittadino: "I tuoi medici",
      elenco_operatore: "Canali chat",
      revocato: "Revocato",
      archivia: "Archivia nel profilo",
      archivia_tooltip: "Genera la trascrizione in PDF e la archivia nell'archivio sanitario",
      nessun_messaggio: "Nessun messaggio in questa conversazione.",
      inizia_a_scrivere: "La discussione si avvia con il primo messaggio.",
      allegato: "Allegato",
      file: "file",
      dimensione_file: "({kb} KB, massimo 4 MB)",
      rimuovi_allegato: "Rimuovi allegato",
      allega_tooltip: "Allega un documento o una immagine, massimo 4 MB",
      placeholder_cittadino: "Scrivi un messaggio al medico",
      placeholder_operatore: "Scrivi un messaggio clinico al paziente",
      invia: "Invia",
      allegati_consentiti: "Allegati consentiti: PDF, immagini e referti, fino a 4 MB",
      canale_revocato: "Canale revocato.",
      seleziona_canale: "La conversazione si apre selezionando un canale.",
      file_troppo_grande: "Il file selezionato supera la dimensione massima di 4 MB.",
      file_troppo_grande_titolo: "File troppo grande",
      invio_fallito: "Non è stato possibile inviare il messaggio",
      archiviazione_riuscita: "Trascrizione della chat archiviata nell'archivio sanitario",
      archiviazione_titolo: "Archiviazione completata",
      archiviazione_fallita: "Non è stato possibile archiviare la trascrizione",
      errore: "Errore",
      titolo_medico: "Dott. {nome}",
      operatore: "Operatore",
      paziente: "Paziente",
      download_fallito: "Non è stato possibile scaricare l'allegato",
      download_fallito_titolo: "Errore nel download",
    },
    ...timelineTranslations.it,
    SegnalazioneCittadino: {
      menu: "Segnalazioni",
      torna_indietro: "Torna indietro",
      intro_titolo: "Come funziona",
      intro_testo: "Quando invii una segnalazione, viene inoltrata alla struttura che ti ha preso in carico per il progetto selezionato. Gli operatori la leggono e ti rispondono direttamente qui: trovi la loro risposta nella conversazione della segnalazione e, quando c'è un nuovo messaggio non letto, un avviso sulla voce \"Segnalazioni\" del menu. Riceverai anche una notifica via email.",
      nuova_segnalazione: "Nuova segnalazione",
      progetto: "Progetto",
      descrivi: "Descrivi cosa vuoi segnalare",
      scrivi_placeholder: "Scrivi...",
      invia: "Invia segnalazione",
      nessun_progetto: "Nessun progetto con il servizio segnalazioni attivo.",
      le_tue_segnalazioni: "Le tue segnalazioni",
      nessuna_segnalazione: "Non hai ancora inviato segnalazioni.",
      vedi_conversazione: "Vedi conversazione",
      nascondi_conversazione: "Nascondi conversazione",
      tu: "Tu",
      operatore: "Operatore",
      nessuna_risposta: "Nessuna risposta ancora.",
      rispondi: "Rispondi",
      scrivi_risposta_placeholder: "Scrivi una risposta...",
      invia_risposta: "Invia risposta",
      caricamento: "Caricamento",
      stato_gestita: "Gestita",
      stato_in_attesa: "In attesa",
      errore_progetti: "Errore nel caricamento dei progetti",
      errore_segnalazioni: "Errore nel caricamento delle segnalazioni",
      errore_conversazione: "Errore nel caricamento della conversazione",
      segnalazione_inviata: "Segnalazione inviata con successo",
      errore_invio: "Errore nell'invio della segnalazione",
      risposta_inviata: "Risposta inviata",
      errore_invio_risposta: "Errore nell'invio della risposta"
    },
    AccessibilityToolbar: {
      title: "Impostazioni di accessibilità",
      toggleLabel: "Accessibilità",
      close: "Chiudi menu accessibilità",
      textSizeLabel: "Dimensione testo",
      increaseText: "Aumenta dimensione testo",
      decreaseText: "Riduci dimensione testo",
      textScaleChanged: "Dimensione testo impostata a {value}%",
      accessibleColors: "Colori accessibili",
      bigCursor: "Cursore ingrandito",
      focusHighlight: "Evidenziazione focus tastiera",
      reducedMotion: "Stop animazioni",
      easyRead: "Alta leggibilità",
      reset: "Reimposta preferenze",
      resetConfirmation: "Preferenze di accessibilità ripristinate.",
      featureEnabled: "{feature} attivato.",
      featureDisabled: "{feature} disattivato.",
      skipToContent: "Vai al contenuto principale"
    },
    AdminOperatorsList: {
      abilita_tooltip: "Abilita utenza",
      email_verificata: "Email verificata",
      password: "Password",
      abilita_utenza_titolo: "Abilitare utenza operatore",
      abilita_utenza_testo: "Confermi l'abilitazione di questa utenza?",
      nome: "Nome",
      email: "Email",
      ruolo: "Ruolo",
      operatore: "operatore",
      abilitazione_successo: "Utenza abilitata",
      abilitazione_errore: "Errore durante l'abilitazione dell'utenza"
    },
    OperatorFeaturePermissions: {
      titolo_modale: "Permessi Funzionalità",
      gestisci_permessi: "gestisci permessi",
      gestisci_permessi_aria: "Gestisci permessi funzionalità per {nome}",
      seleziona_gruppo: "Seleziona tutte le voci del gruppo {gruppo}",
      salva: "Salva modifiche",
      applica_a_tutti: "Applica a tutti gli operatori",
      applica_a_tutti_desc: "Le modifiche verranno applicate a tutti gli operatori della struttura",
      applica_a_tutti_label: "Applica le modifiche a tutti gli operatori della struttura",
      permessi_aggiornati: "Permessi aggiornati",
      errore_caricamento: "Non è stato possibile caricare i permessi",
      errore_salvataggio: "Non è stato possibile aggiornare i permessi",
      permesso_non_disponibile: "Uno o più permessi non sono più disponibili per questa struttura. La lista è stata aggiornata."
    },
    RoleDropdownSelect: {
      seleziona_ruolo: "Seleziona un ruolo",
      info_ruolo: "Informazioni sul ruolo"
    },
    NavigationAdmin: {
      menu: "Menu",
      dashboard: "Dashboard",
      accessibility: "Accessibilità",
      servizi: "Servizi",
      aziende: "Aziende",
      aziende_portale_concura: "Portale {app}",
      aziende_sito_pubblico: "Sito Pubblico",
      utenti: "Utenti",
      contatti: "Contatti",
      registrazioni: "Registrazioni",
      prenotazioni: "Prenotazioni",
      sottoscrizioni: "Sottoscrizioni",
      pagamenti: "Pagamenti",
      voucher: "Voucher",
      screening: "Screening",
      raccolte: "Raccolte",
      questionari: "Questionari",
      sessioni: "Sessioni",
      piani_terapeutici: "Piani Terapeutici",
      alerts: "Alerts",
      logs: "Logs",
      reports: "Reports",
      impostazioni: "Impostazioni",
      logout: "Esci",
      toggle_menu_visibility: "Mostra o nascondi il menu",
      toggle_menu_size: "Riduci o espandi il menu",
      toggle_submenu: "Apri o chiudi il sottomenu {name}",
      logo_alt: "Logo applicazione - Torna alla home",
      toggle_menu: "Apri o chiudi il menu di navigazione",
      logout_confirm_title: "Confermi di voler uscire dall'area privata?",
      logout_confirm_ok: "Sì, esci"
    },
    PagamentiPiattaforma: {
      titolo: "Pagamenti Piattaforma",
      titolo_prossimi: "Pagamenti Prossimi",
      titolo_passati: "Pagamenti Passati",
      data_da: "Data da",
      data_a: "Data a",
      esito: "Esito",
      rinnovo_abilitato: "Rinnovo abilitato",
      tutti: "Tutti",
      si: "Sì",
      no: "No",
      elementi: "elementi",
      elementi_per_pagina: "Elementi per pagina",
      di: "di",
      totale: "Totale",
      totale_ok: "Totale OK",
      importo_totale: "Importo totale",
      importo_ok: "Importo OK",
      prima_attivazione: "Prima attivazione",
      rinnovi: "Rinnovi",
      col_utente: "Utente",
      col_abbonamento: "Abbonamento",
      col_prossimo_pagamento: "Prossimo pagamento",
      col_importo_previsto: "Importo previsto",
      col_voucher: "Voucher",
      col_giorni_scadenza: "Giorni alla scadenza",
      col_rinnovo: "Rinnovo",
      col_data_pagamento: "Data pagamento",
      col_importo: "Importo",
      col_esito: "Esito",
      col_metodo: "Metodo",
      col_fattura: "N. Fattura",
      col_oggetto: "Oggetto",
      scarica_fattura: "Scarica fattura",
      nessun_pagamento_prossimo: "Nessun pagamento prossimo trovato",
      nessun_pagamento_passato: "Nessun pagamento passato trovato",
      errore_caricamento: "Errore durante il caricamento dei pagamenti",
      esito_fittizio: "Fittizio",
      riepilogo_prossimi: "Riepilogo pagamenti prossimi",
      riepilogo_passati: "Riepilogo pagamenti passati",
      voucher_assente: "Assente",
      voucher_applicato: "Applicato",
      voucher_valido: "Valido",
      voucher_non_valido: "Non valido",
      rinnovo_attivo: "Automatico",
      rinnovo_disabilitato: "Disabilitato"
    },
    GestioneAziende: {
      azioni_azienda: "Azioni per {name}",
      scheda: "Scheda",
      chiudi_scheda: "Chiudi scheda",
      panoramica: "Panoramica"
    },
    GestioneAziendePubbliche: {
      elementi_per_pagina: "Elementi per pagina",
      titolo: "Aziende Sito Pubblico",
      descrizione: "Gestisci le aziende visibili nella rubrica del sito pubblico",
      nuova_azienda: "Nuova azienda",
      cerca_placeholder: "Cerca per denominazione, comune, provincia...",
      filtro_provincia: "Filtra per provincia",
      filtro_regione: "Filtra per regione",
      filtro_stato: "Filtra per stato",
      tutte: "Tutte",
      abilitate: "Abilitate",
      disabilitate: "Disabilitate",
      col_denominazione: "Denominazione",
      col_comune: "Comune",
      col_provincia: "Provincia",
      col_regione: "Regione",
      col_telefono: "Telefono",
      col_email: "Email",
      col_sito_web: "Sito Web",
      col_stato: "Stato",
      col_azioni: "Azioni",
      stato_attivo: "Attiva",
      stato_inattivo: "Non attiva",
      btn_modifica: "Modifica",
      btn_elimina: "Elimina",
      nessuna_azienda: "Nessuna azienda trovata",
      caricamento: "Caricamento in corso...",
      errore_caricamento: "Errore durante il caricamento delle aziende",
      modal_nuova_titolo: "Nuova Azienda Sito Pubblico",
      modal_modifica_titolo: "Modifica Azienda",
      modal_elimina_titolo: "Conferma eliminazione",
      modal_elimina_messaggio: "Sei sicuro di voler eliminare l'azienda \"{name}\"? L'operazione non può essere annullata.",
      form_denominazione: "Denominazione",
      form_denominazione_placeholder: "Inserisci denominazione azienda",
      form_email: "Email",
      form_email_placeholder: "email@azienda.it",
      form_telefono: "Telefono",
      form_telefono_placeholder: "+39 000 0000000",
      form_indirizzo: "Indirizzo",
      form_indirizzo_placeholder: "Via/Piazza, numero civico",
      form_cap: "CAP",
      form_cap_placeholder: "00000",
      form_comune: "Comune",
      form_comune_placeholder: "Nome comune",
      seleziona_comune: "Seleziona Comune",
      form_provincia: "Provincia",
      form_provincia_placeholder: "es. Milano",
      seleziona_provincia: "Seleziona Provincia",
      form_regione: "Regione",
      form_regione_placeholder: "es. Lombardia",
      seleziona_regione: "Seleziona Regione",
      form_sito_web: "Sito Web",
      form_sito_web_placeholder: "https://www.esempio.it",
      form_immagine: "Immagine profilo",
      form_immagine_carica: "Carica immagine",
      form_immagine_rimuovi: "Rimuovi immagine",
      form_immagine_formati: "Formati accettati: JPEG, PNG, GIF, WebP. Max 2MB",
      form_abilitata: "Azienda abilitata",
      form_abilitata_help: "Se abilitata, l'azienda sarà visibile sul sito pubblico",
      btn_salva: "Salva",
      btn_annulla: "Annulla",
      btn_conferma_elimina: "Elimina",
      successo_creazione: "Azienda creata con successo",
      successo_modifica: "Azienda aggiornata con successo",
      successo_eliminazione: "Azienda eliminata con successo",
      errore_creazione: "Errore durante la creazione dell'azienda",
      errore_modifica: "Errore durante l'aggiornamento dell'azienda",
      errore_eliminazione: "Errore durante l'eliminazione dell'azienda",
      errore_campi_obbligatori: "Compila tutti i campi obbligatori (denominazione, regione, comune, provincia)",
      errore_cap_invalido: "Il CAP deve essere composto da 5 cifre numeriche",
      errore_url_invalido: "Inserisci un URL valido (es. https://www.esempio.it)",
      aria_modifica: "Modifica azienda {name}",
      aria_elimina: "Elimina azienda {name}",
      aria_stato: "Stato azienda: {status}",
      aria_immagine_anteprima: "Anteprima immagine profilo azienda"
    },
    CompanyFeaturePermissions: {
      titolo_modale: "Permessi Funzionalità Struttura",
      gestisci_permessi: "Gestione permessi",
      gestisci_permessi_aria: "Gestisci permessi funzionalità della struttura",
      descrizione: "Abilita o disabilita le funzionalità disponibili per questa struttura. La disabilitazione revoca il permesso anche a tutti gli operatori. Le modifiche avranno effetto al prossimo accesso degli operatori.",
      seleziona_gruppo: "Seleziona tutte le voci del gruppo {gruppo}",
      salva: "Salva modifiche",
      permessi_aggiornati: "Permessi struttura aggiornati",
      errore_caricamento: "Non è stato possibile caricare i permessi della struttura",
      errore_salvataggio: "Non è stato possibile aggiornare i permessi della struttura"
    },
    DettaglioAzienda: {
      si: "Sì",
      no: "No",
      gratuita_titolo: "Gratuità per il cittadino",
      gratuita_da_progetto: "Come da progetto",
      gratuita_gratuito: "Gratuito",
      gratuita_a_pagamento: "A pagamento",
      gratuita_stato_gratuito: "Al cittadino il servizio risulta gratuito.",
      gratuita_stato_a_pagamento: "Al cittadino il servizio risulta a pagamento.",
      gratuita_nota_progetto:
        "Un progetto della struttura rende gratuito questo servizio.",
      gratuita_nota_nessun_progetto:
        "Nessun progetto della struttura rende gratuito questo servizio.",
      gratuita_nota_pregresso:
        "Le prenotazioni già create non cambiano: la scelta vale da adesso in avanti.",
      gratuita_aggiornata: "Gratuità aggiornata correttamente",
      gratuita_errore: "Errore durante l'aggiornamento della gratuità",
      control_room_toggle_active: "Attivo",
      control_room_toggle_inactive: "Disattivo",
      control_room_toggle_enable_aria: "Attiva servizio Control Room",
      control_room_toggle_disable_aria: "Disattiva servizio Control Room",
      control_room_enable_success: "Servizio Control Room attivato correttamente",
      control_room_disable_success: "Servizio Control Room disattivato correttamente",
      control_room_toggle_error: "Errore durante l'aggiornamento del servizio Control Room",
      control_room_unavailable: "Servizio Control Room non disponibile",
      control_room_company_missing: "Azienda non disponibile",
      cup_privato_si: "Sì",
      cup_privato_no: "No",
      configura: "Configura",
      titolo_configurazione_generico: "Configurazione servizio",
      titolo_configurazione_servizio: "Configurazione servizio {name}",
      nessun_contenuto_configurazione:
        "Nessun contenuto di configurazione disponibile per questo servizio",
      warning_somministrazione_sottoscrizioni: "Assicurati per potere usufruire in modo corretto della funzionalità che anche il servizio \"Pazienti\" sia attivo",
      warning_attivazione_permessi: "All'attivazione del servizio verranno ripristinati automaticamente i permessi precedentemente configurati per la struttura e per i suoi operatori.",
      warning_disattivazione_permessi: "La disattivazione del servizio nasconderà i permessi corrispondenti per la struttura e per i suoi operatori. I permessi verranno preservati e ripristinati automaticamente alla riattivazione.",
      visibile_only_project_patients: "Ricercabile solo da pazienti aderenti ai progetti della struttura",
      sede_legale: "Sede Legale",
      sede_operativa: "Sede Operativa",
      sede_legale_denominazione: "Denominazione società",
      sede_legale_titolare: "titolare",
      sede_operativa_titolare: "titolare sede operativa",
      sede_legale_partita_iva: "partita iva",
      sede_legale_codice_fiscale: "codice fiscale",
      sede_legale_email: "email",
      sede_legale_pec: "pec",
      codice_asl: "codice asl",
      comunale: "comunale",
      azienda: "azienda",
      codice_titolare: "codice titolare",
      codice_tracciabilita: "codice tracciabilità",
      contatti: "contatti",
      telefono: "telefono",
      fax: "fax",
      contatto_dpo: "contatto DPO"
    },
    NuovaCompany: {
      si: "Sì",
      no: "No",
      nome_titolare: "Nome del titolare",
      cognome_titolare: "Cognome del titolare",
      servizio_somministrazione_label: "La struttura può somministrare sottoscrizioni in fase di arruolamento",
      servizio_somministrazione_aria: "Abilita somministrazione sottoscrizioni",
      servizio_control_room_label: "La struttura può inviare richieste alla Control Room",
      servizio_control_room_aria: "Abilita invio richieste Control Room",
      visibile_only_project_patients_label: "Ricercabile solo da pazienti aderenti ai progetti della struttura",
      visibile_only_project_patients_aria: "Limita visibilità ai pazienti aderenti ai progetti della struttura",
      sezione_sede_operativa: "Sede Operativa",
      sezione_impostazioni_struttura: "Impostazioni Struttura",
      sede_operativa_uguale_sede_legale: "I dati coincidono con la sede legale",
      sede_operativa_uguale_sede_legale_aria: "Copia i dati della sede legale nella sede operativa",
      sezione_sede_legale: "Sede Legale",
      sede_legale_uguale_sede_operativa: "I dati coincidono con la sede operativa",
      sede_legale_uguale_sede_operativa_aria: "Copia i dati della sede operativa nella sede legale",
      sede_legale_denominazione: "Denominazione società",
      placeholder_denominazione: "denominazione società...",
      sede_legale_nome_titolare: "Nome Titolare",
      sede_legale_cognome_titolare: "Cognome Titolare",
      partita_iva: "Partita IVA",
      codice_fiscale: "Codice fiscale",
      sede_legale_partita_iva: "Partita IVA",
      sede_legale_codice_fiscale: "CF",
      sede_legale_indirizzo: "Indirizzo",
      sede_legale_cap: "Cap",
      sede_legale_frazione: "Frazione",
      sede_legale_regione: "Regione",
      sede_legale_provincia: "Provincia",
      sede_legale_comune: "Comune",
      sede_legale_email: "Email",
      sede_legale_pec: "PEC",
      placeholder_nome: "nome...",
      placeholder_cognome: "cognome...",
      placeholder_partita_iva: "partita iva...",
      placeholder_codice_fiscale: "codice fiscale...",
      placeholder_indirizzo: "indirizzo...",
      placeholder_cap: "CAP...",
      placeholder_frazione: "frazione...",
      placeholder_email: "email...",
      placeholder_pec: "pec...",
      partita_iva_title: "Partita IVA deve essere di 11 cifre numeriche",
      seleziona_regione: "Seleziona Regione",
      seleziona_provincia: "Seleziona Provincia",
      seleziona_comune: "Seleziona Comune",
      errore_caricamento_province: "Errore durante il caricamento delle province della sede legale",
      errore_caricamento_comuni: "Errore durante il caricamento dei comuni della sede legale",
      errore_sede_legale_obbligatoria: "Compila i campi obbligatori della sede legale",
      errore_sede_legale_partita_iva: "La partita IVA della sede legale deve essere di 11 cifre numeriche",
      errore_sede_legale_codice_fiscale: "Il codice fiscale della sede legale non è valido",
      errore_sede_legale_email: "Inserisci un indirizzo email valido per la sede legale",
      errore_sede_legale_pec: "Inserisci un indirizzo PEC valido per la sede legale",
      sede_legale_telefono: "Telefono",
      placeholder_telefono: "telefono..."
    },
    ModificaCompany: {
      si: "Sì",
      no: "No",
      servizio_somministrazione_label: "La struttura può somministrare sottoscrizioni in fase di arruolamento",
      servizio_somministrazione_aria: "Abilita somministrazione sottoscrizioni",
      servizio_control_room_label: "La struttura può inviare richieste alla Control Room",
      servizio_control_room_aria: "Abilita invio richieste Control Room",
      visibile_only_project_patients_label: "Ricercabile solo da pazienti aderenti ai progetti",
      visibile_only_project_patients_aria: "Limita visibilità ai pazienti aderenti ai progetti della struttura",
      sezione_sede_operativa: "Sede Operativa",
      sezione_impostazioni_struttura: "Impostazioni Struttura",
      sede_operativa_uguale_sede_legale: "I dati coincidono con la sede legale",
      sede_operativa_uguale_sede_legale_aria: "Copia i dati della sede legale nella sede operativa",
      sezione_sede_legale: "Sede Legale",
      sede_legale_uguale_sede_operativa: "I dati coincidono con la sede operativa",
      sede_legale_uguale_sede_operativa_aria: "Copia i dati della sede operativa nella sede legale",
      sede_legale_denominazione: "Denominazione società",
      placeholder_denominazione: "denominazione società...",
      sede_legale_nome_titolare: "Nome Titolare",
      sede_legale_cognome_titolare: "Cognome Titolare",
      partita_iva: "Partita IVA",
      codice_fiscale: "Codice fiscale",
      sede_legale_partita_iva: "Partita IVA",
      sede_legale_codice_fiscale: "CF",
      sede_legale_indirizzo: "Indirizzo",
      sede_legale_cap: "Cap",
      sede_legale_frazione: "Frazione",
      sede_legale_regione: "Regione",
      sede_legale_provincia: "Provincia",
      sede_legale_comune: "Comune",
      sede_legale_email: "Email",
      sede_legale_pec: "PEC",
      placeholder_nome: "nome...",
      placeholder_cognome: "cognome...",
      placeholder_partita_iva: "partita iva...",
      placeholder_codice_fiscale: "codice fiscale...",
      placeholder_indirizzo: "indirizzo...",
      placeholder_cap: "CAP...",
      placeholder_frazione: "frazione...",
      placeholder_email: "email...",
      placeholder_pec: "pec...",
      partita_iva_title: "Partita IVA deve essere di 11 cifre numeriche",
      seleziona_regione: "Seleziona Regione",
      seleziona_provincia: "Seleziona Provincia",
      seleziona_comune: "Seleziona Comune",
      errore_caricamento_province: "Errore durante il caricamento delle province della sede legale",
      errore_caricamento_comuni: "Errore durante il caricamento dei comuni della sede legale",
      errore_sede_legale_obbligatoria: "Compila i campi obbligatori della sede legale",
      errore_sede_legale_partita_iva: "La partita IVA della sede legale deve essere di 11 cifre numeriche",
      errore_sede_legale_codice_fiscale: "Il codice fiscale della sede legale non è valido",
      errore_sede_legale_email: "Inserisci un indirizzo email valido per la sede legale",
      errore_sede_legale_pec: "Inserisci un indirizzo PEC valido per la sede legale",
      sede_legale_telefono: "Telefono",
      placeholder_telefono: "telefono..."
    },
    EwsIndicator: {
      tooltip_dati_incompleti: "Dati incompleti: apri i dettagli",
      tooltip_ews_obsoleta: "EWS obsoleta — rilevata {eta} fa, rivalutazione richiesta",
      tooltip_news2_score: "Punteggio NEWS2: {score} ({rischio})",
      tooltip_storico: "Storico calcoli NEWS2",
      tooltip_informazioni: "Informazioni NEWS2",
      badge_ews: "EWS: {score} - {date}",
      badge_obsoleta: "— rilevata {eta} fa, rivalutazione richiesta",
      rivaluta: "Rivaluta",
      chiudi: "Chiudi",
      modale_warning_titolo: "Dati clinici incompleti per NEWS2",
      attenzione_calcolo_parziale: "Attenzione: calcolo parziale",
      warning_descrizione: "Il punteggio NEWS2 visualizzato è parziale poiché alcuni parametri fisiologici non sono stati registrati nelle ultime 4 ore.",
      parametri_mancanti: "Parametri mancanti",
      warning_nota: "I parametri non rilevati di recente non concorrono al calcolo del punteggio totale, rendendo l’indice clinico potenzialmente sottostimato.",
      modale_info_titolo: "Guida clinica NEWS2 (Early Warning Score)",
      info_descrizione: "Il NEWS2 (National Early Warning Score 2) è lo standard raccomandato dal Royal College of Physicians per la valutazione della gravità clinica e l’identificazione precoce del deterioramento acuto dei pazienti. Il punteggio totale è calcolato sommando i punteggi individuali (da 0 a 3) assegnati a 7 parametri fisiologici.",
      parametro: "Parametro",
      param_resp_rate: "Frequenza respiratoria (rr)",
      param_spo2_scala_1: "Saturazione O2 (Scala 1) (%)",
      param_spo2_scala_2: "Saturazione O2 (Scala 2 / BPCO) (%)",
      param_ossigenoterapia: "Ossigenoterapia supplementare",
      param_sbp: "Pressione SBP (mmHg)",
      param_heart_rate: "Frequenza cardiaca (hr)",
      param_body_temp: "Temperatura corporea (°C)",
      param_loc: "Stato di coscienza (ACVPU)",
      si_ossigeno: "Sì (O2)",
      no_aria: "No (Aria)",
      loc_alert_breve: "Alert (Vigile)",
      loc_alterato_breve: "Nuova confusione / V / P / U",
      interpretazione_bande: "Interpretazione delle bande di rischio",
      punteggio_singolo: "Punteggio 3 su singolo parametro",
      rischio_basso: "Rischio basso.",
      rischio_basso_azione: "Monitoraggio standard.",
      rischio_medio_basso: "Rischio medio-basso (Override).",
      rischio_medio_basso_azione: "Richiede rivalutazione medica urgente.",
      rischio_medio: "Rischio medio.",
      rischio_medio_azione: "Richiede rivalutazione e monitoraggio più frequente.",
      rischio_alto: "Rischio alto.",
      rischio_alto_azione: "Emergenza clinica, richiede immediata escalation medica.",
      modale_storico_titolo: "Storico calcoli EWS (NEWS2)",
      nessun_calcolo: "Nessun calcolo NEWS2 registrato per questo paziente.",
      colonna_data_ora: "DATA E ORA",
      colonna_punteggio: "PUNTEGGIO",
      colonna_rischio: "CLASSE DI RISCHIO",
      colonna_azioni: "AZIONI RACCOMANDATE",
      colonna_tipo_dati: "TIPO DATI",
      espandi_dettaglio: "Espandi dettaglio del calcolo",
      comprimi_dettaglio: "Comprimi dettaglio del calcolo",
      parziale: "Parziale",
      completo: "Completo",
      snapshot_titolo: "Snapshot dei parametri al momento del calcolo",
      rilevato_il: "Rilevato il {data}",
      non_disponibile: "N/D",
      rischio_non_disponibile: "Non disponibile",
      risk_low: "Rischio basso",
      risk_low_medium: "Rischio medio-basso",
      risk_medium: "Rischio medio",
      risk_high: "Rischio alto",
      snapshot_resp_rate: "Freq. respiratoria (rr)",
      snapshot_spo2: "Saturazione (spo2)",
      snapshot_suppl_o2: "Ossigenoterapia (suppl_o2)",
      snapshot_body_temp: "Temp. corporea (temperature)",
      snapshot_sbp: "Pres. sistolica (sys)",
      snapshot_heart_rate: "Freq. cardiaca (hr)",
      snapshot_loc: "Stato coscienza (loc)",
      loc_a: "A - Alert (Sveglio/Vigile)",
      loc_c: "C - Confusion (Confuso)",
      loc_v: "V - Voice (Verbale)",
      loc_p: "P - Pain (Dolore)",
      loc_u: "U - Unresponsive (Non risponde)"
    },
    ArchivioSanitarioComponent: {
      aria_tablist_label: "Sezioni profilo sanitario",
      tab_parametri: "Parametri",
      tab_esami: "Esami",
      tab_sintomi: "Sintomi",
      tab_referti: "Referti",
      tab_altri_file: "Altri file",
      tab_questionari: "Questionari",
      tab_sessioni: "Sessioni",
      aria_selector_parametri: "Seleziona sezione Parametri",
      aria_selector_esami: "Seleziona sezione Esami",
      aria_selector_sintomi: "Seleziona sezione Sintomi",
      aria_selector_referti: "Seleziona sezione Referti",
      aria_selector_altri_file: "Seleziona sezione Altri file",
      aria_selector_scores: "Seleziona sezione Scores",
      aria_selector_questionari: "Seleziona sezione Questionari",
      aria_selector_sessioni: "Seleziona sezione Sessioni",
      modifica_rilevazione: "Modifica rilevazione",
      elimina_rilevazione: "Elimina rilevazione"
    },
    RilevazioniComponent: {
      aria_tablist_label: "Sezioni dell'archivio sanitario",
      tab_parametri: "Parametri",
      tab_esami: "Esami",
      tab_referti: "Referti",
      tab_altri_file: "Altri file",
      tab_questionari: "Questionari",
      tab_sessioni: "Sessioni",
      modifica_rilevazione: "Modifica rilevazione",
      elimina_rilevazione: "Elimina rilevazione"
    },
    SingleAnnotationComponent: {
      toggle_contenuto: "Mostra/nascondi contenuto annotazione",
      soapLabel: "nota sanitaria",
      visita: "visita/prestazione",
      abilita_modifica: "Abilita modifica annotazione",
      elimina_nota: "Elimina annotazione"
    },
    SinglePrescriptionAnnotationComponent: {
      toggle_contenuto: "Mostra/nascondi contenuto annotazione",
      elimina_nota: "Elimina nota prescrizione"
    },
    PatientPrescriptions: {
      mese_precedente: "Mese precedente",
      mese_successivo: "Mese successivo"
    },
    NewPrescriptionAnnotationComponent: {
      elimina_allegato: "Elimina allegato {name}",
      allegati_referto: "Allegati referto",
      conferma_rimozione: "Conferma rimozione",
      conferma: "Conferma"
    },
    PatientList: {
      vai_a_scheda: "Vai a scheda paziente",
      completa: "Completa"
    },
    PreConsulto: {
      appuntiNonSalvati: "Non è stato possibile salvare gli appunti del consulto.",
      consultoNonAvviato: "Il collegamento non è riuscito: il consulto resta aperto e si può riavviare.",
      vedi_questionario: "Vedi questionario compilato",
      vedi_questionario_label: "Vedi questionario"
    },
    SchedaFamiliareSperimentazione: {
      toggle_menu: "Espandi/comprimi menu sezioni",
      conferma_cancellazione: "Conferma cancellazione",
      conferma: "Conferma",
      errore_cancellazione: "Errore durante la cancellazione. Riprova.",
      caricamento_episodi: "Caricamento episodi..."
    },
    SessionDetailModal: {
      dettaglio_sessione: "Dettaglio sessione",
      questionari_nella_sessione: "Questionari nella sessione",
      vedi: "Vedi"
    },
    SchedaPaziente: {
      chat_tooltip: "Chat clinica con il paziente",
      paziente: "Paziente",
      archivio_sanitario: "Archivio sanitario",
      apri_archivio_sanitario: "Apri archivio sanitario",
      paziente_non_in_carico: "L'utente selezionato non è nella tua lista pazienti."
    },
    PersonalizzazioneGrafica: {
      descrizione: "Scegli i colori e il banner con cui la tua azienda appare ai pazienti.",
      banner_descrizione: "Il banner compare in testa alle pagine dei pazienti presi in carico.",
      banner_dimensioni: "Dimensione consigliata: 1200×200 pixel.",
      titolo: "Personalizzazione grafica",
      descrizione:
        "Configura i colori della piattaforma per la tua struttura. Le modifiche saranno visibili a tutti gli operatori.",
      sezione_colori: "Colori",
      colore_primario: "Colore primario",
      colore_secondario: "Colore secondario",
      seleziona_colore_primario: "Seleziona il colore primario",
      seleziona_colore_secondario: "Seleziona il colore secondario",
      placeholder_hex: "es. #009DA9",
      valore_hex_primario: "Valore esadecimale del colore primario",
      valore_hex_secondario: "Valore esadecimale del colore secondario",
      anteprima: "Anteprima",
      anteprima_bottone_primario: "Anteprima bottone con colore primario",
      anteprima_bottone_secondario: "Anteprima bottone con colore secondario",
      anteprima_bottone_outline: "Anteprima bottone con bordo secondario",
      bottoni: "Bottoni",
      bottone_primario: "Bottone primario",
      bottone_secondario: "Bottone secondario",
      bottone_outline: "Bottone outline",
      campioni_colore: "Campioni colore",
      primario: "Primario",
      secondario: "Secondario",
      sfondo_primario: "Sfondo primario",
      sfondo_secondario: "Sfondo secondario",
      ripristina_default: "Ripristina colori predefiniti",
      salva_personalizzazione: "Salva personalizzazione colori",
      salva: "Salva personalizzazione",
      salvataggio_ok: "Personalizzazione grafica salvata correttamente",
      salvataggio_errore:
        "Non è stato possibile salvare la personalizzazione",
      errore_formato_hex:
        "Formato colore non valido. Utilizzare il formato esadecimale (es. #009DA9)",
      sezione_banner: "Banner dashboard",
      banner_descrizione:
        "Carica un'immagine banner che verrà mostrata sotto l'intestazione della dashboard per tutti gli operatori della struttura.",
      carica_banner: "Carica banner",
      sostituisci_banner: "Sostituisci banner",
      rimuovi_banner: "Rimuovi banner",
      banner_dimensioni:
        "Dimensioni consigliate: 1200×150 px. Formati accettati: JPG, PNG, WebP. Max 8 MB.",
      banner_anteprima: "Anteprima banner dashboard",
      banner_caricato_ok: "Banner caricato correttamente",
      banner_rimosso_ok: "Banner rimosso correttamente",
      banner_errore_upload: "Non è stato possibile caricare il banner",
      banner_errore_rimozione: "Non è stato possibile rimuovere il banner",
      conferma_caricamento: "Conferma caricamento",
      anteprima_banner_titolo: "Anteprima banner",
    },
    PatientQuickSearch: {
      titolo: "Cerca un paziente",
      campo: "Cerca per",
      cognome: "Cognome",
      nome: "Nome",
      codice_fiscale: "Codice fiscale",
      placeholder_surname: "Cognome del paziente…",
      placeholder_name: "Nome del paziente…",
      placeholder_cf: "Codice fiscale del paziente…",
      nessuno: "Nessun paziente arruolato con questo dato.",
      aiuto: "Scrivi almeno due lettere e scegli il paziente: si apre la sua scheda.",
    },
    PatientArchive: {
      download_fallito: "Non è stato possibile scaricare il documento selezionato",
      download_fallito_titolo: "Errore nel download",
      titolo: "Archivio sanitario",
      title: "Altri file",
      carica_documento: "Carica documento",
      annulla_caricamento: "Annulla caricamento",
      caricamento_contenuti: "Caricamento contenuti...",
      nessun_documento: "Nessun documento disponibile",
      nome_documento: "Documento",
      data_caricamento: "Data caricamento",
      azioni: "Azioni",
      archivia: "Archivia",
      ripristina: "Ripristina",
      elimina: "Elimina",
      visualizza_documento: "Visualizza documento {name}"
    },
    PatientArchiveCittadino: {
      titolo: "Archivio sanitario",
      title: "Altri file",
      nuovo_documento: "Nuovo file",
      modal_upload_titolo: "Carica nuovo documento",
      visualizza: "Visualizza",
      scarica: "Scarica",
      elimina_risorsa: "Elimina risorsa",
      conferma_eliminazione_titolo: "Conferma eliminazione",
      conferma_eliminazione_testo: "Sei sicuro di voler eliminare definitivamente questo documento?",
      nessun_documento: "Nessun documento disponibile",
      caricato_da: "Caricato da",
      aria_visualizza: "Visualizza {name}",
      aria_scarica: "Scarica {name}",
      aria_elimina: "Elimina {name}",
      apri_documento: "Apri documento {name}",
      documento_alt: "Pagina del documento",
      anteprima_alt: "Anteprima immagine"
    },
    ListaPazienti: {
      placeholder_nome: "Nome",
      placeholder_cognome: "Cognome",
      placeholder_username: "Username (email o telefono)",
      placeholder_codice_univoco: "Codice Univoco",
      placeholder_codice_fiscale: "Codice Fiscale",
      aria_campo_nome: "Campo di ricerca per nome paziente",
      aria_campo_cognome: "Campo di ricerca per cognome paziente",
      aria_campo_username: "Campo di ricerca per username, email o telefono",
      aria_campo_codice_univoco: "Campo di ricerca per codice univoco paziente",
      aria_campo_codice_fiscale: "Campo di ricerca per codice fiscale",
      ricerca_avanzata: "Ricerca avanzata",
      chiudi_ricerca_avanzata: "Chiudi filtri",
      filtro_patologia: "Patologia",
      placeholder_patologia: "Filtra per patologia...",
      filtro_terapia: "Terapia / Farmaco",
      placeholder_terapia: "Filtra per farmaco o principio attivo...",
      filtro_prenotazione: "Stato prenotazione",
      opzione_tutti: "Tutti i pazienti",
      opzione_con_prenotazione: "Con prenotazione attiva/futura",
      opzione_senza_prenotazione: "Senza prenotazioni",
      azzera_filtri: "Azzera filtri",
      tooltip_username: "Lo username può essere l'indirizzo email o il numero di telefono del paziente",
      help_username: "Email o telefono",
      username_help_title: "Ricerca per username",
      username_help_text: "Inserisci l'indirizzo email del paziente. Se il paziente è stato registrato senza email, puoi cercare utilizzando il suo numero di telefono.",
      bottone_cerca: "Cerca",
      aria_bottone_cerca: "Esegui ricerca pazienti",
      colonna_nome_cognome: "Nome e Cognome",
      colonna_codice_fiscale: "Codice Fiscale",
      colonna_data_nascita: "Data Nascita",
      colonna_telefono: "Telefono",
      colonna_email: "Email",
      colonna_azioni: "Azioni",
      codice_univoco_label: "Codice univoco",
      pin_label: "Pin",
      aria_scheda_assistito: "Apri scheda assistito di {name} {surname}",
      aria_scheda_medica: "Apri cartella clinica di {name} {surname}",
      tooltip_scheda_paziente: "Scheda paziente",
      tooltip_scheda_familiari: "Scheda familiari",
      errore_caricamento: "Non è stato possibile prelevare la lista pazienti",
      nessun_paziente: "Nessun paziente trovato",
      caricamento_pazienti: "Caricamento lista pazienti in corso...",
      bottone_richieste: "Richieste",
      aria_control_room_richieste: "Apri richieste control room per {name} {surname}",
      aria_nuova_richiesta: "Crea nuova richiesta control room per {name} {surname}",
      aria_count_richieste: "{count} richieste control room",
      nuova_richiesta_modal_title: "Nuova richiesta Control Room",
      invia_richiesta: "Invia richiesta",
      nuova_richiesta_placeholder: "Funzionalità in fase di sviluppo",
      funzionalita_in_sviluppo: "Funzionalità in fase di sviluppo",
      control_room_modal_ok: "Chiudi",
      control_room_loading: "Caricamento richieste control room in corso...",
      control_room_empty: "Nessuna richiesta inviata per questo paziente.",
      control_room_error_load: "Non è stato possibile recuperare le richieste della control room",
      control_room_col_codice: "Codice richiesta",
      control_room_col_tipo: "Tipologia",
      control_room_col_stato: "Stato",
      control_room_col_inviata: "Inviata il",
      control_room_col_gestita: "Gestita il",
      control_room_col_chiusa: "Chiusa il",
      control_room_modal_title_generic: "Richieste control room",
      control_room_modal_title: "Richieste control room per {name} {surname}",
      control_room_table_caption: "Elenco richieste inviate alla control room",
      control_room_template_title: "Dettagli della richiesta",
      control_room_status_pending: "In attesa",
      control_room_status_in_progress: "In lavorazione",
      control_room_status_completed: "Completata",
      control_room_status_rejected: "Rifiutata",
      control_room_status_cancelled: "Annullata",
      control_room_type_reservation: "Prenotazione",
      control_room_type_teleconsultation: "Teleconsulto",
      control_room_type_support: "Supporto",
      control_room_type_generic: "Generica",
      control_room_error_generic: "Errore generico durante la creazione della richiesta",
      control_room_error_incomplete: "Compila tutti i campi obbligatori",
      sottoscrizione_attiva: "Sottoscrizione attiva",
      sottoscrizione_pending: "Sottoscrizione in attesa di pagamento",
      sottoscrizione_inattiva: "Nessuna sottoscrizione",
      control_room_request_sent: "Richiesta inviata correttamente alla control room",
      control_room_error_send: "Errore durante l'invio della richiesta"
    },
    ControlRoomRequestCard: {
      aria_toggle: "Espandi o comprimi dettagli richiesta {type}",
      nessun_dettaglio: "Nessun dettaglio disponibile per questa richiesta"
    },
    CompilaRichiestaControlRoom: {
      select_placeholder: "Seleziona un'opzione...",
      company_picker_placeholder: "Cerca struttura per nome, città o provincia",
      loading_template: "Caricamento template richiesta...",
      reservation_type_prestazione: "Prestazione sanitaria",
      reservation_type_teleconsulto: "Teleconsulto",
      reservation_type_prodotto: "Prodotto farmaceutico"
    },
    NuovaRichiestaControlRoom: {
      loading: "Caricamento...",
      select_type_prompt: "Seleziona il tipo di richiesta che desideri inviare:",
      aria_select_type: "Seleziona tipo di richiesta",
      no_templates: "Nessun template di richiesta disponibile",
      error_loading_templates: "Errore nel caricamento dei template disponibili",
      error_loading_template: "Errore nel caricamento del template richiesta",
      template_not_found: "Template richiesta non trovato"
    },
    NuovaRichiestaControlRoomModal: {
      modal_title: "Nuova richiesta Control Room",
      modal_title_for: "Nuova richiesta Control Room per {name} {surname}",
      invia_richiesta: "Invia richiesta",
      error_generic: "Errore generico durante l'invio della richiesta",
      error_incomplete: "Richiesta incompleta. Compila tutti i campi obbligatori",
      error_send: "Errore durante l'invio della richiesta",
      request_sent: "Richiesta inviata con successo"
    },
    ControlRoomRequests: {
      bottone_richieste: "Richieste",
      aria_control_room_richieste: "Apri richieste control room per {name} {surname}",
      aria_nuova_richiesta: "Crea nuova richiesta control room per {name} {surname}",
      aria_count_richieste: "{count} richieste control room",
      tooltip_visualizza_richieste: "Visualizza le richieste che hai inviato alla Control Room",
      tooltip_nuova_richiesta: "Nuova richiesta",
      control_room_modal_ok: "Chiudi",
      control_room_loading: "Caricamento richieste control room in corso...",
      control_room_empty: "Nessuna richiesta inviata per questo paziente.",
      control_room_error_load: "Non è stato possibile recuperare le richieste della control room",
      control_room_modal_title_generic: "Richieste control room",
      control_room_modal_title: "Richieste control room per {name} {surname}",
      control_room_type_reservation: "Prenotazione",
      control_room_type_teleconsultation: "Teleconsulto",
      control_room_type_support: "Supporto",
      control_room_type_generic: "Generica"
    },
    CupPrivatoDashboard: {
      buongiorno: "Buongiorno",
      buon_pomeriggio: "Buon pomeriggio",
      buonasera: "Buonasera",
      lista_pazienti: "I pazienti che hai arruolato",
      mostra_info: "Informazioni",
      nascondi_info: "Nascondi",
      info_title: "Benvenuto nella tua Dashboard",
      info_intro: "Da qui puoi gestire tutti i tuoi pazienti e le funzionalità disponibili:",
      info_pazienti_title: "Lista Pazienti",
      info_pazienti_desc: "Cerca pazienti per cognome, codice fiscale o username. Accedi alle schede mediche complete, visualizza i dati anagrafici e consulta le richieste inviate alla Control Room per ogni paziente.",
      info_richieste_title: "Richieste Control Room",
      info_richieste_desc: "Richiedi supporto alla Control Room di ConCura per prenotazioni di prestazioni sanitarie, teleconsulti, assistenza generica o altre necessità. Monitora lo stato di tutte le richieste inviate e ricevi risposte dal team di supporto.",
      info_arruola_title: "Arruola Pazienti",
      info_arruola_desc: "Registra nuovi pazienti inserendo i dati anagrafici, contatti e informazioni necessarie. Una volta arruolati potrai erogargli servizi, inviare richieste alla Control Room e gestire il loro percorso di cura."
    },
    welcome: "Benvenuto",
    logout: "Esci",
    profile: "Profilo",
    hello: "Ciao",
    esci: "Esci",
    seleziona_lingua: "Seleziona lingua",
    non_verificato_email: "Non hai ancora verificato il tuo indirizzo email",
    tooltip_email: "Per potere utilizzare la piattaforma è necessario verificare l'indirizzo email",
    non_verificato_telefono: "Non hai ancora verificato il tuo numero di telefono",
    tooltip_telefono: "Per potere utilizzare la piattaforma è necessario verificare il numero di telefono",
    non_compilata_anagrafica: "Non hai ancora compilato la tua anagrafica",
    tooltip_anagrafica: "Per usufruire a pieno di tutti i servizi messi a disposizione da questa piattaforma è necessario compilare la propria scheda anagrafica",
    titolo_informativa: "Termini e Condizioni e Informativa Privacy",
    testo_informativa: "Per concludere la registrazione è necessario confermare la presa visione delle",
    condizioni_generali: "condizioni generali di contratto",
    informativa_privacy: "Informativa Privacy",
    ho_letto_privacy: "Ho letto e accetto la",
    ho_letto_termini: "Ho letto e accetto",
    termini_uso: "Termini e Condizioni d'uso del servizio",
    accetto_esplicitamente: "Ai sensi dell'articolo 1341 e ss c.c. accetto espressamente le previsioni di cui agli articoli 2, 7, 8, 10, 12 dei presenti",
    titolo_marketing: "Autorizzazione alle comunicazioni commerciali",
    conferma_scelte: "Conferma le mie scelte",
    registrati: "Registrati",
    placeholder_password: "Password",
    dimenticato_password: "Ho dimenticato la password",
    accedi: "Accedi",
    testo_recupera_password: "Inserisci l'indirizzo email utilizzato in fase di registrazione.",
    placeholder_inserisci_email: "Inserisci email...",
    alert_demo_cie_spid: "Accesso con CIE e SPID non disponibile in ambiente demo",
    mail_inviata: "Mail inviata! Controlla la tua posta elettronica.",
    email_non_valida: "Indirizzo non valido",
    hai_bisogno_aiuto: "Hai bisogno di aiuto?",
    contattaci: "Contattaci",
    indietro: "Indietro",
    registrazione: "Registrazione",
    registrati_descrizione: "Registrati gratuitamente alla nostra piattaforma per entrare nel mondo ConCura e ricevere un servizio su misura, rapido e sempre al tuo fianco per prenderti cura della tua salute.",
    numero_supporto: "800.770.272",
    step: "Step",
    sono_cittadino: "Sono un cittadino",
    sono_operatore: "Sono un operatore sanitario",
    utenza_disabilitata: "Utenza disabilitata",
    messaggio_utenza_disabilitata: "La tua utenza è stata disabilitata",
    reimposta_password_titolo: "Reimposta la tua password",
    reimposta_password_descrizione_1: "La nuova password deve contenere almeno 8 caratteri, di cui almeno un numero, una maiuscola, una minuscola ed un",
    reimposta_password_descrizione_2: "Deve essere diversa da quella attuale e dalle ultime {count} utilizzate.",
    reimposta_password_carattere_speciale: "carattere speciale",
    tooltip_password_special_chars: "Vale qualunque simbolo, per esempio ! @ # $ % & * ? , . _ -",
    placeholder_nuova_password: "Password...",
    placeholder_conferma_password: "Conferma password...",
    credenziali_errate: "Credenziali errate.",
    salva_nuova_password: "Salva nuova password",
    manuali_uso: "Manuali d'uso",
    video_tutorial: "Video Tutorial",
    scarica_versione_aggiornata: "Scarica la versione aggiornata",
    scarica_versione_inglese: "Scarica la versione inglese",
    ultima_versione: "Ultima versione",
    altre_versioni: "Altre versioni",
    nessun_manuale: "Nessun manuale disponibile",
    scarica_selezionato: "Scarica versione selezionata",
    recupera_password: "Recupera la tua password",
    mail_inviata_controlla: "Mail inviata! Controlla la tua posta elettronica.",
    non_ho_ricevuto_email: "Non ho ricevuto l'email",
    inserisci_email_registrazione: "Inserisci l'indirizzo email utilizzato in fase di registrazione.",
    placeholder_email: "email@ ...",
    caricamento: "Caricamento...",
    carica: "Carica",
    salvataggio: "Salvataggio...",
    crea_sessione: "Crea sessione",
    salva_modifiche: "Salva modifiche",
    si_elimina: "Sì, elimina",
    si_procedi: "Sì, procedi",
    conferma_eliminazione: "Conferma eliminazione",
    rimuovi: "Rimuovi",
    invia: "Invia",
    non_ricordo_email: "Non ricordo l'indirizzo email",
    sms_inviato_cf: "Abbiamo inviato un sms contenente il link per ripristinare la password al numero di telefono indicato per questo codice fiscale.\nAttendi qualche istante.",
    non_ho_ricevuto_sms: "Non ho ricevuto l'SMS",
    inserisci_codice_fiscale: "Inserisci il tuo codice fiscale.",
    sms_inviato_telefono_riserva: "Un sms contenente il link per ripristinare la password è stato inviato al numero di telefono di riserva, se impostato. Attendi qualche istante.",
    nessun_link_contatta_assistenza: "Se non lo hai impostato o non hai ricevuto nessun link e non sei quindi riuscito a recuperare l'accesso,",
    invia_richiesta_supporto: "invia una richiesta di supporto in assistenza",
    torna_login: "Torna alla pagina di login",
    invia_numero_riserva: "Invia al numero di riserva",
    registrazione_successo: "Registrazione avvenuta con successo!",
    benvenuto: "Benvenuto",
    email_confermata_successo: "Grazie per aver confermato il tuo indirizzo email.",
    email_gia_verificata: "Email già verificata.",
    email_gia_verificata_descrizione: "Hai già confermato il tuo indirizzo email. Se non lo hai ancora fatto, procedi con la compilazione della tua scheda anagrafica.",
    vai_scheda_anagrafica: "Scheda anagrafica",
    vai_al_login: "Vai al login",
    conferma_email: "Conferma la tua email",
    link_non_valido: "Il link utilizzato non è più valido.",
    email_non_ricevuta_controlla_spam: "Se non hai ricevuto la mail di conferma controlla nella cartella spam della tua casella di posta elettronica oppure",
    richiedi_nuova_mail: "richiedi una nuova mail di conferma",
    invia_nuova_mail: "Invia nuova mail",
    verifica_numero_telefono: "Verifica il tuo numero di telefono",
    verifica_istruzioni_1: "Per utilizzare la piattaforma è necessario completare la procedura di registrazione verificando il numero di telefono indicato.",
    verifica_istruzioni_link: "Controlla il numero indicato.",
    verifica_istruzioni_2: 'Clicca su "invia codice di verifica" per inviare il codice OTP di accesso via SMS al numero indicato.',
    inserisci_numero_telefono: "Inserisci il tuo numero di telefono",
    inserisci_istruzioni: "Per utilizzare la piattaforma è necessario inserire e verificare il numero di telefono.",
    etichetta_numero_telefono: "Numero di telefono:",
    placeholder_numero: "1234...",
    salva_numero: "Salva numero",
    invia_codice_verifica: "Invia codice di verifica",
    verifica_fuori_piattaforma: "Verifica numero di telefono fuori piattaforma",
    verifica_otp: "Verifica OTP",
    codice_verificato: "Codice verificato correttamente!",
    prosegui_istruzioni: "Grazie per aver completato la procedura. Clicca su 'Chiudi' per proseguire.",
    sms_inviato: "Abbiamo inviato via SMS il codice di verifica al numero {numero}",
    inserisci_codice: "Inserisci il codice numerico ricevuto via SMS:",
    otp_status_0: "Codice di verifica inviato",
    otp_status_minus1: "Errore di sistema",
    otp_status_1: "Codice verificato correttamente",
    otp_status_2: "Codice errato",
    otp_status_3: "Codice scaduto",
    otp_status_4: "Codice già verificato",
    otp_status_5: "Codice cancellato",
    codice_scade: "Il codice inviato scadrà tra",
    secondi: "secondi",
    codice_scaduto: "Codice scaduto",
    non_ricevuto: "Non hai ricevuto il codice?",
    invia_nuovo_codice: "Invia nuovo codice",
    alternativa: "In alternativa,",
    invia_otp_riserva: "invia OTP al numero di riserva (se disponibile).",
    chiudi: "Chiudi",
    verifica: "Verifica",
    verifica_non_completata: "Non è stato possibile completare la verifica.",
    verifica_controlla_assistenza: "Controlla che il numero memorizzato in anagrafica sia corretto. In caso di difficoltà, contatta l'assistenza.",
    verifica_manuale: "Verifica Manuale",
    manuale_istruzioni: "Per favore, chiama il numero dell'utente per verificare il contatto.",
    chiama: "Chiama",
    contrassegna_verificato: "Contrassegna numero come verificato",
    non_possibile_effettuare_procedura: "Non è stato possibile effettuare la procedura.",
    numero_verificato_successo: "Numero contrassegnato come verificato.",
    errore_verifica_numero: "Si è verificato un errore durante la verifica del numero.",
    vai_homepage: "Vai alla homepage",
    errore_salvataggio_pagamento: "Errore salvataggio pagamento. Verificare nella propria area privata.",
    effettua_login: "Effettua il login",
    richieste_prenotazione: "Servizi attivi",
    servizi_prenotabili: "Servizi prenotabili",
    prenota_visite_prestazioni: "Prenota visite e prestazioni",
    richiedi_farmaci: "Richiedi farmaci",
    prenota_teleconsulto: "Prenota un teleconsulto",
    contatta_medico: "Contatta un medico",
    chat_con_medico: "Chat con il medico",
    chat_con_medico_desc: "Scrivi ai medici che ti seguono",
    teleconsulto_rapido_desc: "Un medico ti contatta entro 60 minuti",
    teleconsulto_pediatrico_desc: "Per i tuoi figli, risponde un pediatra",
    visite_prestazioni: "Visite e prestazioni",
    farmaci: "Farmaci",
    teleconsulti: "Teleconsulti",
    errore_recupero_prenotazioni: "Non è stato possibile recuperare le prenotazioni recenti",
    HomeHealthSummary: {
      titolo: "Il tuo profilo sanitario",
      nessunParametro: "Nessun parametro registrato.",
    },
    CittadinoHome: {
      hero_titolo: "Parla con un medico",
      hero_testo_rapido:
        "Un medico ti richiama entro 60 minuti. Per quello che può aspettare, scrivi ai medici che ti seguono.",
      hero_testo_chat:
        "Scrivi ai medici che ti seguono: ti rispondono nella tua chat.",
      da_fare_titolo: "Da fare oggi",
      da_fare_scorri: "Scorri le cose da fare",
      da_fare_precedenti: "Cose da fare precedenti",
      da_fare_successivi: "Cose da fare successive",
      prenota_titolo: "Prenota un servizio",
      prenota_visite: "Visite e prestazioni",
      prenota_farmaci: "Farmaci e prodotti",
      prenota_teleconsulto: "Teleconsulto specialistico",
    },
    DaRicordare: {
      titolo: "I tuoi appuntamenti",
      appuntamenti: "Appuntamenti",
      promemoria: "Promemoria",
      prossimiAppuntamenti: "Prossimi appuntamenti",
      nessunAppuntamento: "Nessun appuntamento in programma.",
      teleconsulto: "Teleconsulto",
      visita: "Visita",
      ordine: "Ordine",
    },
    buongiorno: "Buongiorno",
    buon_pomeriggio: "Buon pomeriggio",
    buona_sera: "Buona sera",
    attesa_pagamento: "attesa pagamento",
    vai_alla_prenotazione: "Vai alla prenotazione",
    vedi_dettagli_prenotazione: "Vedi dettagli prenotazione",
    nessuna_prenotazione_oggi: "Nessuna prenotazione per oggi.",
    vedi_tutte_sottoscrizioni: "Vedi tutte le sottoscrizioni",
    piano_attivo: "Piano attivo",
    durata_minima: "Durata minima",
    si_rinnova_il: "Si rinnova il",
    scadra_il: "Scadrà il",
    leggi_di_piu: "Leggi di più",
    cosa_prevede_sottoscrizione: "Cosa prevede la tua sottoscrizione",
    prestazioni_disponibili: "Prestazioni disponibili",
    ordine_farmaci_disponibili: "Ordine farmaci disponibili",
    effettua_upgrade_sottoscrizione: "Effettua l'upgrade della sottoscrizione",
    gratis: "GRATIS",
    piani: "Piani",
    mese: "mese",
    anno: "anno",
    subscriptionDetail: {
      base: "Sottoscrizioni Base",
      advanced: "Sottoscrizioni Avanzate",
      monitoring: "Sottoscrizioni Monitoraggio"
    },
    CompilazioneQuestionario: {
      otp_verifica_titolo: "Invia OTP all'operatore",
      otp_verifica_testo: "Invia il codice OTP all'operatore per validare la compilazione.",
      invio_successo: "Questionario inviato correttamente."
    },
    successUpdate: "Anagrafica aggiornata con successo!",
    convenzioni: "Convenzioni",
    richiedi_voucher: "Richiedi il voucher",
    richiedi_teleconsulto_rapido: "Richiedi Teleconsulto Rapido",
    teleconsulto_rapido: "Teleconsulto Rapido",
    medico_contatto_entro_60_minuti: "Un medico ti contatterà entro 60 minuti dalla richiesta.",
    durata_massima_15_minuti: "Il Teleconsulto Rapido ha una durata massima di 15 minuti.",
    scrivi_motivo: "Scrivi il motivo",
    iva_esclusa: "+ IVA",
    riprova: "Riprova",
    annulla: "Annulla",
    in_attesa_di_risposta: "In attesa di risposta",
    medico_presto_disponibile: "A breve il medico prenderà in carico la tua richiesta",
    programmato_ore: "Programmato per le ore",
    clicca_per_pagamento_nexi: "Clicca su 'Completa acquisto' per avviare la sessione sicura di pagamento Nexi e finalizzare il tuo acquisto.",
    clicca_per_privacy_nexi: "Clicca",
    carte_accettate: "Carte accettate:",
    completa_acquisto: "Completa acquisto",
    link_pagamento_inviato: "Un link per il pagamento è stato inviato al tuo indirizzo email.",
    errore_pagamento_link: "Non è stato possibile inizializzare il pagamento. Contattare l'assistenza",
    errore_salvataggio_pagamento_semplice: "Errore salvataggio pagamento",
    non_puoi_lasciare_pagina_pagamento: "Non puoi uscire da questa pagina durante la procedura di pagamento.",
    richiedi_tc_pediatrico: "Richiedi Teleconsulto Pediatrico",
    teleconsulto_pediatrico: "Teleconsulto Pediatrico",
    tc_pediatrico_descrizione_1: "Un medico ti contatterà entro 60 minuti dalla richiesta.",
    tc_pediatrico_descrizione_2: "Il Teleconsulto Pediatrico ha una durata massima di 15 minuti.",
    motivo_richiesta: "Motivo della richiesta",
    placeholder_motivo: "Scrivi il motivo",
    costo_prestazione: "Costo della prestazione",
    iva_inclusa: "IVA inclusa",
    piu_iva: "+ iva {percentuale} %",
    in_attesa_risposta: "In attesa di risposta",
    tc_medico_in_carico: "A breve il medico prenderà in carico la tua richiesta",
    rimani_collegato: "Rimani collegato",
    programmato_per_ore: "Programmato per le ore",
    avvia_ora: "Avvia ora",
    errore_info_pagamento: "Non è stato possibile recuperare le informazioni relative al pagamento",
    errore_inoltro_richiesta: "Non è stato possibile inoltrare la richiesta",
    nessun_operatore_disponibile: "Nessun operatore disponibile in questo momento",
    transazione_non_finalizzata: "Transazione non finalizzata",
    errore_operazione: "Non è stato possibile effettuare l'operazione",
    registra_familiare: "Registra familiare",
    scegli_familiare: "Scegli familiare",
    titolo_nuovo_familiare: "Nuovo familiare",
    placeholder_nome: "Nome...",
    placeholder_cognome: "Cognome...",
    placeholder_cf: "Codice fiscale...",
    numero_tessera_sanitaria: "Numero Tessera Sanitaria",
    placeholder_ts_number: "Numero tessera...",
    fascia_eta: "Fascia d'età",
    seleziona_fascia_eta: "Seleziona fascia d'età",
    relazione: "Relazione",
    seleziona_relazione: "Seleziona relazione",
    maschile: "Maschile",
    femminile: "Femminile",
    campi_obbligatori: "*Campi obbligatori",
    salva: "Salva",
    nuovo_familiare_successo: "Nuovo familiare inserito con successo!",
    errore_salvataggio_familiare: "Non è stato possibile salvare le informazioni.",
    tutti: "Tutti",
    nuovo: "Nuovo",
    paziente_non_trovato: "Paziente non trovato",
    data_di_nascita: "Data di nascita",
    non_indicata: "Non indicata",
    i_tuoi_familiari: "I tuoi familiari",
    aggiungi: "Aggiungi",
    tooltip_familiari_1: "Le persone non registrate in piattaforma che hai inserito come tuoi familiari.",
    tooltip_familiari_2: "Clicca sul \"+\" per creare nuovi membri: una volta aggiunti potrai prenotare farmaci e servizi per loro.",
    i_tuoi_assistiti: "I tuoi assistiti",
    tooltip_assistiti: "Le persone che ti hanno scelto come loro caregiver. Queste persone ti hanno dato il permesso di prenotare farmaci e servizi per conto loro.",
    nessun_assistito_registrato: "Non ci sono assistiti registrati per questa utenza.",
    i_tuoi_caregiver: "I tuoi caregiver",
    tooltip_caregivers: "Le persone che si occupano di te. I soggetti di seguito elencati possono prenotare farmaci e servizi per conto tuo.",
    nessun_caregiver_registrato: "Non ci sono caregivers registrati per questa utenza.",
    vuoi_abilitare: "Vuoi abilitare",
    vuoi_disabilitare: "Vuoi disabilitare",
    come_tuo_caregiver: "come tuo caregiver?",
    conferma_informativa: "Per procedere alla conferma è necessario confermare la presa visione dell'informativa.",
    ho_letto_informativa: "Ho letto e compreso l'informativa privacy",
    acconsento_trattamento_dati: "Acconsento al trattamento dei miei dati personali per le finalità indicate nell'informativa",
    no_annulla: "No, annulla",
    si_conferma: "Sì, conferma",
    nessun_utente_selezionato: "Nessun utente selezionato",
    errore_recupero_informazioni: "Non è stato possibile recuperare le informazioni.",
    caregiver_abilitato: "Caregiver abilitato",
    caregiver_disabilitato: "Caregiver disabilitato",
    abilita_caregiver: "Abilita caregiver",
    disabilita_caregiver: "Disabilita caregiver",
    registrazione_step: "Step {n}",
    titolo: "Titolo",
    nome: "Nome",
    cognome: "Cognome",
    codice_azienda: "Codice azienda",
    tooltip_codice_azienda: "Il codice azienda si trova nella sezione impostazioni dell'operatore amministratore di struttura",
    inserisci_codice_azienda: "Inserisci il codice di 10 cifre fornito dalla tua azienda.",
    codice_fiscale: "Codice fiscale",
    data_nascita: "Data di nascita",
    genere: "Genere",
    uomo: "uomo",
    donna: "donna",
    nazione_nascita: "Nazione di nascita",
    indirizzo: "Indirizzo e numero civico",
    telefono: "Numero di telefono",
    ordine: "Ordine",
    id_albo: "ID Iscrizione Albo",
    specializzazione: "Specializzazione",
    specializzazione_placeholder: "Specializzazione medica...",
    consulta_termini: "Consulta Termini e Condizioni d'uso del servizio",
    completa: "Completa",
    informativa_commerciale: "Autorizzazione alle comunicazioni commerciali",
    accetta_informativa: "Ho letto e accetto l'Informativa Privacy",
    accetta_termini: "Ho letto e accetto i Termini e Condizioni d'uso del servizio",
    accetta_articoli: "Ai sensi dell'articolo 1341 e ss c.c. accetto espressamente le previsioni di cui agli articoli 2, 7, 8, 10, 12 dei presenti Termini e Condizioni d'uso",
    acconsento_marketing: "Acconsento alla ricezione di comunicazioni commerciali per finalità promozionali",
    avanti: "Avanti",
    regione_residenza: "Regione di residenza",
    regione: "Regione",
    provincia_residenza: "Provincia di residenza",
    provincia: "Provincia",
    comune: "Comune",
    comune_residenza: "Comune di residenza",
    indirizzo_numero_civico: "Indirizzo e numero civico",
    cap: "CAP",
    seleziona_regione: "Seleziona Regione",
    seleziona_provincia: "Seleziona Provincia",
    seleziona_comune: "Seleziona Comune",
    placeholder_indirizzo: "Indirizzo",
    placeholder_cap: "CAP",
    email: "Email",
    numero_telefono: "Numero di telefono",
    telefono_fisso: "Telefono fisso",
    aderisco_progetto: "Aderisco al progetto",
    nessun_progetto: "Nessun progetto",
    nessuna_selezione: "--",
    password: "Password",
    conferma_password: "Conferma password",
    password_requisiti: "La password non può includere il nome né il cognome e deve contenere almeno 8 caratteri, di cui almeno un numero, una maiuscola, una minuscola ed un",
    carattere_speciale: "carattere speciale",
    tooltip_carattere_speciale: "Vale qualunque simbolo, per esempio ! @ # $ % & * ? , . _ -",
    termini_condizioni_privacy: "Termini e Condizioni e Informativa Privacy",
    concludi_registrazione_testo: "Per concludere la registrazione è necessario confermare la presa visione",
    termini_condizioni_link: "condizioni generali di contratto",
    informativa_privacy_link: "Informativa Privacy",
    accetto_informativa_privacy: "Ho letto e accetto la",
    accetto_comunicazioni_commerciali: "Acconsento alla ricezione di comunicazioni commerciali per finalità promozionali come da Informativa Privacy",
    progetto_selezionato_testo: "**Selezionando il progetto {projectName}, la struttura sanitaria coinvolta nel progetto verrà inserita nel tuo circolo di cura",
    consulta_informativa_privacy: "Consulta Informativa Privacy",
    accetto_termini_condizioni: "Ho letto e accetto",
    termini_condizioni_uso: "Termini e Condizioni d'uso del servizio",
    non_accetto: "Non accetto",
    e: "e",
    accetto_articoli_cc: "Ai sensi dell'articolo 1341 e ss c.c. accetto espressamente le previsioni di cui agli articoli 2, 7, 8, 10, 12 dei presenti",
    autorizzazione_marketing: "Autorizzazione alle comunicazioni commerciali",
    accetto_marketing: "Acconsento alla ricezione di comunicazioni commerciali per finalità promozionali come da",
    scheda: {
      rilevazioni: "Rilevazioni",
      patologie: "Patologie",
      terapie: "Terapie",
      note: "Note",
      dispositivi: "Dispositivi",
      genere: "Genere",
      regione: "Regione",
      indirizzo: "Indirizzo",
      data_nascita: "Data di nascita",
      provincia: "Provincia",
      telefono: "Telefono",
      codice_fiscale: "Codice Fiscale",
      comune: "Comune",
      email: "Email",
      non_indicato: "Non indicato",
      utente_non_trovato: "Utente non trovato",
      alert_recupero_errore: "Non è stato possibile recuperare le informazioni."
    },
    familiari: {
      nessun_familiare: "Non ci sono familiari registrati per questa utenza.",
      familiari: "Familiari",
      annulla: "Annulla",
      salva: "Salva",
      nessun_elemento_selezionato: "Nessun elemento selezionato",
      alert_recupero_errore: "Non è stato possibile recuperare le informazioni richieste.",
      alert_creazione_successo: "Familiare aggiunto con successo",
      alert_creazione_errore: "Non è stato possibile invitare il familiare",
      alert_invito_successo: "Familiare invitato con successo",
      alert_salvataggio_successo: "Informazioni aggiornate con successo",
      alert_salvataggio_errore: "Non è stato possibile aggiornare le informazioni.",
      maschile: "Maschile",
      femminile: "Femminile",
      eta_pediatrica: "età pediatrica",
      adulto: "adulto",
      anziano: "anziano",
      figlio: "figlio",
      genitore: "genitore",
      coniuge: "coniuge",
      convivente: "convivente",
      nipote: "nipote",
      altro_parente: "altro(parente)",
      altro_non_parente: "altro(non parente)",
      ts_non_inserita: "Non inserita",
      seleziona_tipo_inserimento: "Seleziona il tipo di inserimento",
      inserimento_semplice: "Inserimento semplice",
      inserimento_semplice_descrizione: "Inserisci manualmente un utente non presente nel sistema",
      utente_registrato: "Utente registrato",
      utente_registrato_descrizione: "Se l'utente è presente nella piattaforma puoi inserirlo tramite codice utente",
      nuovo_familiare: "Nuovo familiare",
      condivisione_dati: "I dati identificativi del tuo familiare saranno condivisi con i professionisti sanitari del tuo circolo di cura",
      nome: "Nome",
      nome_placeholder: "Nome...",
      cognome: "Cognome",
      cognome_placeholder: "Cognome...",
      cf: "Codice fiscale",
      cf_placeholder: "Codice fiscale...",
      ts: "Numero Tessera Sanitaria",
      ts_placeholder: "numero tessera...",
      fascia_eta: "Fascia d'età",
      fascia_eta_seleziona: "seleziona fascia d'età",
      relazione: "Relazione",
      relazione_seleziona: "Seleziona relazione",
      genere: "Genere",
      autorizzazione_dichiarazione: "* Secondo il DPR n.445/2000, dichiaro di essere autorizzato, dalla legge o dal mio familiare, ad utilizzare i servizi ConCura per gestire i dati medici per suo conto",
      campi_obbligatori: "*Campi obbligatori",
      richiesta_codice_descrizione: "Ricerca un tuo parente o un tuo assistito tramite codice utente - visualizzabile nella sezione \"Impostazioni\", sotto \"Codice utente personale\" - ed invitalo a far parte della tua famiglia. L'utente invitato riceverà una email tramite la quale potrà accettare il tuo invito e designarti come proprio caregiver.",
      label_codice: "Inserisci codice utente",
      placeholder_codice: "Codice utente...",
      bottone_cerca: "Cerca",
      utente_trovato: "Trovato un utente:",
      domanda_inviare_richiesta: "Inviare richiesta?",
      invia_richiesta: "Invia richiesta",
      invita: "Invita",
      utente_non_trovato: "Nessun utente trovato.",
      alert_codice_non_trovato: "Codice utente non associato a nessun utente"
    },
    informativa: {
      titolo: "INFORMATIVA SUL TRATTAMENTO DEI DATI PERSONALI PER I SERVIZI DI PRENOTAZIONI, ORDINI E SERVIZI DI TELECONSULTO GESTITI DA FAMILIARI E CAREGIVER",
      sottotitolo: "(art. 14 Reg. UE 679/2016)",
      blocco_1: `
		<h6 class="text-center bg-primary text-white py-2  border-bottom border-dark">Chi tratta i dati del mio familiare/assistito?</h6>
		<p class="px-1 mb-0 border-bottom border-dark">
			Il Titolare del trattamento è la società/ente sanitario aderente a <b>{{ appName }}</b> che tratta i Suoi dati personali per tutte le finalità di seguito precisate,
			della quale può visualizzare i dati di riferimento nella sezione <span class="text-prim-grad-1 fw-bolder">"Il mio circolo di cura"</span> della sua area riservata.
		</p>
	`,
      quali_dati: `
		<h6 class="text-center">1. QUALI MIEI DATI VENGONO TRATTATI?</h6>
		<p>Il Titolare tratterà i Suoi seguenti dati personali:</p>
		<ul>
			<li>Nome e cognome</li>
			<li>Codice fiscale</li>
			<li>Numero tessera sanitaria (facoltativo)</li>
			<li>Fascia di età di appartenenza</li>
			<li>Relazione con il Suo familiare/caregiver</li>
			<li>Tipologia di prestazione, data e ora della prestazione</li>
			<li>Prodotto per cui viene effettuato l'ordine</li>
      <li>Codice NRE e codice REV della ricetta</li>
      <li>Ricetta in formato PDF (facoltativo)</li>
      <li>Patologia per la quale viene richiesto il teleconsulto</li>
      <li>Data e ora del teleconsulto</li>
    </ul>
  `,
      finalita: `
    <h6 class="text-center">2. PER QUALI FINALITÀ SONO TRATTATI I MIEI DATI E PERCHÉ IL TRATTAMENTO È LEGITTIMO?</h6>
    <p>Il Titolare tratta i Suoi dati per consentirLe di prenotare tramite un Suo familiare/caregiver:</p>
    <ul>
      <li>prestazioni presso la farmacia;</li>
      <li>ordini presso la farmacia;</li>
      <li>servizi di teleconsulto presso la farmacia.</li>
    </ul>
    <p>Questo trattamento è legittimo perché:</p>
    <ul>
      <li>per i dati comuni (es. anagrafici), è necessario per dare esecuzione a un contratto di cui Lei è parte;</li>
      <li>per i dati di salute, è basato sul consenso che Lei può manifestare tramite il Suo familiare/caregiver.</li>
    </ul>
  `,
      comunicazioni: `
    <h6 class="text-center">3. A CHI SONO COMUNICATI I MIEI DATI?</h6>
    <p>I Suoi dati sono comunicati:</p>
    <ul>
      <li>alla società Qwince Innovation S.r.l. per la gestione della Piattaforma;</li>
      <li>ai soggetti a cui Lei deciderà di rendere conoscibili i Suoi dati (es. familiari/caregiver).</li>
    </ul>
    <p>
      L'elenco completo è disponibile scrivendo a <a href="mailto:assistenza@concura.online">assistenza@concura.online</a>. I Suoi dati non saranno diffusi.
		</p>
	`,
      trasferimenti: `
		<h6 class="text-center">4. I MIEI DATI SONO TRASFERITI FUORI DALL'UNIONE EUROPEA?</h6>
    <p>No, i Suoi dati non vengono trasferiti al di fuori dell'Unione Europea.</p>
	`,
      conservazione: `
		<h6 class="text-center">5. PER QUANTO TEMPO SONO CONSERVATI I MIEI DATI?</h6>
		<p>
			I dati sono conservati per tutta la durata dell'attività dell'account. Alla disattivazione, saranno cancellati definitivamente o anonimizzati.
		</p>
	`,
      profilazione: `
		<h6 class="text-center">6. SARÒ SOTTOPOSTO A PROFILAZIONE?</h6>
		<p>
			No, i Suoi dati non saranno utilizzati per profilazione né decisioni automatizzate.
		</p>
	`,
      diritti: `
		<h6 class="text-center">7. QUALI SONO I MIEI DIRITTI?</h6>
		<p>Lei ha i seguenti diritti:</p>
		<ul>
			<li><b>Accesso:</b> ottenere conferma e accesso ai dati trattati.</li>
			<li><b>Rettifica:</b> correggere dati inesatti o incompleti.</li>
			<li><b>Cancellazione:</b> in caso di dati non più necessari, trattati illecitamente o obblighi di legge.</li>
			<li><b>Limitazione:</b> in attesa di verifica, opposizione o per motivi giudiziari.</li>
			<li><b>Portabilità:</b> ricevere i dati in formato leggibile e trasferirli ad altro titolare.</li>
			<li><b>Opposizione a decisioni automatizzate:</b> diritto a non essere sottoposto a profilazione automatizzata.</li>
		</ul>
		<p>Può esercitare i Suoi diritti scrivendo al Titolare. Risponderemo entro 30 giorni.</p>
	`,
      raccolta: `
		<h6 class="text-center">8. COME SONO STATI RACCOLTI I MIEI DATI DAL TITOLARE?</h6>
		<p>I Suoi dati sono stati forniti dal Suo familiare/caregiver.</p>
	`,
      reclamo: `
		<h6 class="text-center">9. COME POSSO PRESENTARE RECLAMO?</h6>
		<p>
			Può proporre reclamo all'Autorità Garante per la protezione dei dati personali, secondo le modalità su
      <a href="https://www.garanteprivacy.it" target="_blank">www.garanteprivacy.it</a>.
    </p>
  `
    },
    utente_non_trovato: "Utente non trovato",
    misurazioni: {
      parametri: "Parametri",
      esami: "Esami",
      referti: "Referti",
      nuovo_parametro_btn: "Nuovo parametro",
      inserisci: "Inserisci",
      inserisci_parametro: "Inserisci {nome}",
      nuova_rilevazione_sintomo: "Nuovo sintomo",
      nuovo_parametro_title: "Nuova rilevazione parametro",
      nuova_rilevazione_sintomo_title: "Nuova rilevazione sintomo",
      intensita_sintomo_aria: "Intensità del sintomo {nome}, valore intero da 1 a 10",
      trova_parametro: "Trova parametro",
      nuovo_esame_btn: "Nuovo esame",
      nuovo_esame_title: "Nuova rilevazione esame",
      nuovo_referto_btn: "Nuovo referto",
      nessuna_rilevazione: "Nessuna rilevazione registrata.",
      nessun_referto: "Nessun referto caricato.",
      nuovo_referto_title: "Nuovo referto",
      referto_carica_da_file: "Carica referto a partire da file",
      referto_scrivi: "Scrivi referto",
      referto_carica_desc: "Carica un PDF o immagine già pronto",
      referto_scrivi_desc: "Compila il referto con Valutazione, Prescrizione e allegati",
      referto_modal_question: "Come vuoi creare il referto?",
      cerca: "Cerca...",
      inserisci_data: "Inserisci data",
      inserisci_ora: "Inserisci ora",
      visibile_solo_a_me: "visibile solo a me**",
      storico: "Storico",
      anno: "Anno",
      mese: "Mese",
      giorno: "Giorno",
      valori_rilevati: "Valori rilevati",
      referto_seen: "scaricato",
      referto_unseen: "non ancora scaricato",
      nessuna_altra_rilevazione: "Non ci sono altre rilevazioni",
      modifica_valore: "Modifica Valore",
      valore_placeholder: "Valore*",
      conferma: "Conferma",
      si_elimina: "Sì, elimina",
      no_annulla: "No, annulla",
      data_ora: "Data e Ora Rilevazione",
      valori_riferimento: "Valori di riferimento",
      annotazioni: "Annotazioni",
      fuori_soglia_lab: "Valore fuori soglia di laboratorio",
      parametro_osservato: "Il parametro è sotto osservazione.",
      parametro_non_osservato: "Parametro non osservato.",
      visualizza_soglie: "Visualizza soglie",
      imposta_soglie: "Imposta soglie",
      tutti: "tutti",
      referti_richiedono_sottoscrizione: "Per caricare referti occorre avere una sottoscrizione attiva.",
      errore_generico: "Qualcosa è andata storta",
      inserimento_successo: "Misurazione inserita correttamente",
      inserimento_errore: "Non è stato possibile inserire la misurazione",
      aggiornamento_successo: "Misurazione aggiornata correttamente",
      aggiornamento_errore: "Non è stato possibile aggiornare la misurazione",
      eliminazione_successo: "Misurazione eliminata correttamente",
      eliminazione_errore: "Non è stato possibile eliminare la misurazione",
      download_errore: "Non è stato possibile scaricare la risorsa",
      referto: "questo referto",
      esame: "questo esame",
      rilevazione: "questa rilevazione",
      visibileSoloMe: "**se selezioni questa opzione soltanto tu potrai vedere",
      scarica: "Scarica",
      aggiungi: "Aggiungi",
      salva_modifiche: "Salva modifiche",
      cancel_title: "Annulla",
      soglie_parametro: "Soglie sul parametro {parametro}",
      elimina_valore: "Vuoi eliminare questo valore di",
      mesi: {
        gennaio: 'Gennaio',
        febbraio: 'Febbraio',
        marzo: 'Marzo',
        aprile: 'Aprile',
        maggio: 'Maggio',
        giugno: 'Giugno',
        luglio: 'Luglio',
        agosto: 'Agosto',
        settembre: 'Settembre',
        ottobre: 'Ottobre',
        novembre: 'Novembre',
        dicembre: 'Dicembre'
      }
    },
    soglie: {
      valori_soglia_per_parametro: "Valori di soglia sul parametro",
      descrizione_soglie_custom: "Configurando le soglie di criticità dei valori su un parametro...",
      valori_default_parametro: "Valori di default per il parametro",
      descrizione_valori_default: "Di seguito i valori-soglia disponibili per il parametro...",
      usa_default: "Utilizza valori di default per il monitoraggio",
      nessun_valore_default: "Non ci sono valori di default per il parametro",
      soglie_personalizzate: "Soglie personalizzate",
      errore_generico: "Qualcosa è andata storta",
      valori_modificati_successo: "Valori modificati correttamente",
      errore_modifica_valori: "Non è stato possibile modificare il valore",
      note_aggiornate: "Note aggiornate correttamente",
      errore_note: "Non è stato possibile aggiornare le note",
      soglia_eliminata: "Soglia eliminata correttamente",
      errore_eliminazione: "Non è stato possibile eliminare il valore",
      valori_impostati: "Valori impostati correttamente",
      conferma_operazione: "Conferma operazione",
      si_elimina: "Sì, elimina",
      no_annulla: "No, annulla",
      sicuro_eliminare: "Sei sicuro di voler eliminare questa soglia?",
      modifica_note: "Modifica note",
      note_soglia: "Note soglia",
      note_titolo: "Note di soglia",
      note_descrizione: "In questi spazi puoi inserire delle note per indicare, in caso di rilevazione del parametro nella soglia selezionata, eventuali azioni da suggerire o intraprendere ai fini diagnostici (Protocollo diagnostico) e/o operativi (Protocollo operativo). Valorizzare uno solo oppure entrambi i campi.",
      protocollo_diagnostico: "Protocollo diagnostico:",
      protocollo_operativo: "Protocollo operativo:",
      placeholder_diagnostico: "Si raccomanda l'indagine per, il consulto con...",
      placeholder_operativo: "Si raccomanda il controllo di, l'assunzione di, l'interruzione di...",
      annulla: "Annulla",
      salva_note: "Salva note"
    },
    PatologieComponent: {
      nessuna: "Nessuna patologia registrata",
      title: "Patologie",
      new: "Nuova patologia",
      create: "Crea terapia per",
      primaria: "Primaria",
      priorita: "Priorità",
      impostaPrimaria: "Imposta la tipologia come primaria",
      impostaPrimariaHelp: "Solo una patologia può essere primaria",
      searchTitle: "Cerca patologia",
      searchPlaceholder: "Cerca patologia per nome o codice...",
      searchDescription: "*fonte: classificazione ICD-10 aggiornata",
      selectPatologia: "Seleziona patologia",
      nomePatologia: "Nome patologia*",
      tipo: "Tipologia*",
      inizio: "Data di inizio",
      fine: "Data di fine",
      visibileSoloAMe: "visibile solo a me**",
      visibilitaDescrizione: "**se selezioni questa opzione soltanto tu potrai vedere questa patologia",
      annotazioni: "Annotazioni",
      campiObbligatori: "*Campi obbligatori",
      annulla: "Annulla",
      salva: "Salva",
      modifica: "Modifica",
      inseritaIl: "inserita il",
      codicePatologia: "Codice Patologia (ICD-10):",
      vedi: "Vedi",
      successSave: "Patologia memorizzata con successo!",
      failSave: "Non è stato possibile salvare la patologia",
      successUpdate: "Modifiche memorizzate con successo!",
      failUpdate: "Non è stato possibile salvare le modifiche",
      failFetch: "Non è stato possibile recuperare le patologie",
      cronica: "cronica",
      acuta: "acuta",
      stagionale: "stagionale",
      data_inizio: "inizio",
      dal: "dal",
      al: "al",
      seleziona_patologia: "Seleziona patologia",
      vedi_dettaglio: "Visualizza dettaglio patologia"
    },
    IndiceAderenza: {
      title: "Indice di Aderenza",
      references: "Riferimenti:",
      level0: "non determinabile",
      level1: "scarso",
      level2: "medio",
      level3: "ottimale"
    },
    TerapieComponent: {
      activeTitle: "Terapie in atto",
      newTherapy: "Nuova terapia",
      downloadProspetto: "Prospetto terapie",
      until: "Fino al",
      since: "Dal",
      finished: "Terminata il",
      historyTitle: "Storico terapie",
      noHistory: "Nessun elemento nello storico",
      edit: "Modifica",
      resume: "Riprendi",
      suspend: "Sospendi",
      downloadReminder: "Scarica promemoria",
      createdAt: "Data di inserimento:",
      deleteConfirmTitle: "Conferma eliminazione",
      deleteConfirmText: "Confermi di voler eliminare la terapia?",
      downloadError: "Non è stato possibile scaricare il prospetto.",
      fetchError: "Non è stato possibile recuperare le terapie",
      suspended: "sospesa",
      resumed: "ripresa",
      therapy: "Terapia",
      operationFailed: "Non è stato possibile eseguire l'operazione",
      deleted: "Terapia eliminata!",
      deleteError: "Non è stato possibile eliminare la terapia",
      downloadReminderError: "Non è stato possibile scaricare il promemoria",
      si_conferma: "Sì, conferma",
      no_annulla: "No, annulla",
      scaricaProspetto: "Scarica Prospetto Terapie",
      nuovaTerapia: "Nuova Terapia",
      elimina: "Elimina",
      elimina_terapia: "Elimina terapia",
      vedi: "Vedi",
      vedi_terapia: "Visualizza dettaglio terapia",
      conferma: "Conferma",
      testoConfermaSospensione: "Confermi di voler {azione} la terapia?",
      azioneSospendere: "sospendere",
      azioneRiprendere: "riprendere"
    },
    RecapTherapy: {
      pathology: "patologia",
      indicazione: "Indicazione",
      noPathology: "Patologia non indicata",
      dosage: "Posologia",
      of: "di",
      byRoute: "per via",
      toTake: "Da assumere:",
      duration: "Durata",
      from: "Da",
      until: "fino a",
      followEvery: "La terapia va seguita ogni",
      for: "per",
      startingFrom: "a partire da",
      undefined: "indeterminata",
      notes: "Annotazioni",
      noNotes: "nessuna nota",
      details: "Dettagli",
      prescriber: "Prescrittore",
      source: "Fonte informativa",
      sideEffects: "Effetti collaterali",
      allergicReactions: "Reazioni allergiche",
      interactions: "Interazioni",
      notIndicated: "non indicato",
      reminder: "Promemoria",
      tenMinutesBefore: "10 minuti prima della somministrazione",
      adherenceIndex: "Indice di Aderenza",
      selectDrug: "Seleziona farmaco",
      searchDrug: "Cerca farmaco per nome..",
      notFound: "Prodotto non trovato",
      frequency: "Frequenza",
      frequencyAndDosage: "Frequenza, modalità e dosaggio somministrazione",
      daily: "al dì",
      asNeeded: "al bisogno",
      every: "ogni",
      onlyOneIntakeTime: "Con questa frequenza è possibile selezionare al massimo un momento di assunzione",
      morning: "Mattina",
      midMorning: "Meta mattina",
      lunch: "Pranzo",
      afternoon: "Pomeriggio",
      evening: "Sera",
      night: "Notte",
      prescriberSelect: "indica chi ha prescritto la terapia",
      sourceSelect: "indica fonte informativa",
      sideEffectsPlaceholder: "eventuali effetti collaterali attribuite al farmaco..",
      allergicReactionsPlaceholder: "eventuali reazioni allergiche attribuite al farmaco..",
      interactionsPlaceholder: "possibili interazioni con farmaci o alimenti individuate..",
      privateInfoNote: "**se selezioni questa opzione soltanto tu potrai vedere questa terapia",
      visibleOnlyToMe: "visibile solo a me**",
      cancel: "Annulla",
      saveChanges: "Salva modifiche",
      saveSuccess: "Nuova terapia salvata",
      saveError: "Si è verificato un errore durante il salvataggio",
      startDate: "A partire dal",
      endDate: "Fino al",
      unitsSing: {
        mese: "mese",
        settimana: "settimana",
        giorno: "giorno"
      },
      unitsPlur: {
        mesi: "mesi",
        settimane: "settimane",
        giorni: "giorni",
        ore: "ore"
      },
      unit: {
        compressa: "compressa",
        capsula: "capsula",
        goccia: "goccia",
        inalazione: "inalazione",
        busta: "busta",
        supposta: "supposta",
        scatola: "scatola",
        cerotto: "cerotto",
        fiala: "fiala",
        fleboclisi: "fleboclisi",
        ovulo: "ovulo",
        sacca: "sacca",
        flacone: "flacone",
        confezione: "confezione",
        kilogrammo: "kilogrammo",
        kit: "kit",
        millilitro: "millilitro",
        milligrammo: "milligrammo",
        applicazione: "applicazione",
        UI: "UI"
      },
      vias: {
        orale: "Orale",
        transdermica: "Transdermica",
        nasale: "Nasale",
        endovena: "Endovena",
        intramuscolo: "Intramuscolo",
        oftalmica: "Oftalmica",
        rettale: "Rettale",
        uretale: "Uretale",
        vaginale: "Vaginale",
        sottocute: "Sottocute"
      }
    },
    EditTherapy: {
      Annotazioni: 'Annotazioni',
      Annulla: 'Annulla',
      Farmaco_indicato: 'Farmaco indicato',
      Mattina: 'Mattina',
      Meta_mattina: 'Meta mattina',
      Notte: 'Notte',
      Ore: 'Ore',
      Pomeriggio: 'Pomeriggio',
      Pranzo: 'Pranzo',
      Prodotto_non_trovato: 'Prodotto non trovato',
      Salva_modifiche: 'Salva modifiche',
      Sera: 'Sera',
      al_bisogno: 'al bisogno',
      al_di: 'al dì',
      indica_prescrittore: 'indica chi ha prescritto la terapia',
      indica_fonte: 'indica fonte informativa',
      indica_patologia: 'indica patologia',
      mesi: 'mesi',
      non_indicare_patologia: 'non indicare patologia',
      occasionale: 'occasionale',
      ogni: 'ogni',
      ore: 'ore',
      giorni: 'giorni',
      per_sempre: 'per sempre',
      periodica: 'periodica',
      settimane: 'settimane',
      ikey_descrizione: '{{ ikey.descrizione }}',
      prod_Nome: '{{ prod.Nome }}',
      dosaggio: 'dosaggio',
      durata_terapia: "Durata terapia"
    },
    Common: {
      genericError: "Si è verificato un errore."
    },
    nuovaPrenotazioneSalvata: {
      prenotazionePassata: "Prenotazione passata",
      testoIstruzioni: "Seleziona una prestazione, una data e una fascia oraria per cui inserire una prestazione già eseguita.",
      prestazione: "Prestazione da inserire*",
      dataInserimento: "Data di inserimento*",
      labelHelp: "Utilizza i cursori per navigare tra le date",
      fasciaOraria: "Fascia oraria*",
      placeholderData: "Seleziona una data",
      selezionaFascia: "Seleziona una fascia oraria",
      mattina: "mattina",
      pomeriggio: "pomeriggio",
      sera: "sera",
      modalTitle: "Nuova prenotazione passata",
      success: "Prenotazione inserita con successo",
      error: "Errore nell'inserimento della prenotazione"
    },
    SelectCompanyHealthService: {
      loading: "Caricamento in corso...",
      empty: "Non ci sono prestazioni attive e disponibili",
      choose: "scegli prestazione",
      loadError: "Errore nel caricamento delle prestazioni sanitarie"
    },
    PatientAnnotations: {
      mese_precedente: "Mese precedente",
      mese_successivo: "Mese successivo",
      title: "Visite/Note",
      new: "Nuova nota/visita",
      info: "Inserisci una nota sanitaria nella scheda del paziente. Questa nota non sarà mostrata al paziente.",
      month: "Mese",
      year: "Anno",
      all: "Tutti",
      yours: "Le tue note",
      noneForMonth: "Nessuna nota per questo mese.",
      noneForFilters: "Nessuna nota con questi criteri.",
      loadError: "Non è stato possibile recuperare le note",
      months: {
        january: "gennaio",
        february: "febbraio",
        march: "marzo",
        april: "aprile",
        may: "maggio",
        june: "giugno",
        july: "luglio",
        august: "agosto",
        september: "settembre",
        october: "ottobre",
        november: "novembre",
        december: "dicembre"
      }
    },
    ClinicalReportGenerator: {
      emit: "Emetti referto",
      modalTitle: "Genera referto firmato",
      placeholder: "Le tue annotazioni...",
      authorizeAndEmit: "Autorizza ed emetti referto",
      otpInstruction: "La struttura richiede che l'operazione venga confermata con la verifica di un codice OTP inviato al tuo numero di telefono.\n\nClicca su \"invia codice di verifica\" per inviare il codice OTP.",
      or: "oppure",
      cancel: "Annulla operazione",
      serviceNotAvailable: "Servizio non attivo per la struttura.",
      contactSupport: "Contattaci per avere informazioni",
      emitSuccess: "Report emesso correttamente",
      emitError: "Errore elaborazione report",
      downloadError: "Non è stato possibile scaricare la risorsa"
    },
    singleAnnotationComponent: {
      visible: "Visibile al paziente",
      notVisible: "Non visibile al paziente",
      soapLabel: "nota sanitaria",
      subjective: "Soggettivo",
      objective: "Obiettivo",
      assessment: "Valutazione",
      plan: "Piano",
      other: "Altro",
      saveChanges: "Salva modifiche",
      cancelChanges: "Annulla modifiche",
      modalTitle: "Conferma eliminazione",
      cancelDelete: "No, annulla",
      confirmDelete: "Sì, conferma",
      confirmDeleteText: "Confermi di voler eliminare la nota?",
      updateSuccess: "Nota aggiornata correttamente",
      updateError: "Errore nell'aggiornamento della nota",
      deleteSuccess: "Nota eliminata correttamente",
      deleteError: "Errore nell'eliminazione della nota",
      viewInvoice: "Visualizza fattura",
      issueInvoice: "Genera fattura",
      generateInvoice: "Genera fattura",
      confirmInvoice: "Conferma fattura",
      editInvoice: "Modifica bozza fattura",
      issueInvoiceTitle: "Genera fattura",
      confirmInvoiceTitle: "Conferma fattura",
      editInvoiceTitle: "Modifica Bozza Fattura",
      confirmIssue: "Conferma fattura",
      warningTitle: "Attenzione",
      issueWarning: " La fattura generata non potrà essere modificata. L'invio a SDI/TS si gestisce da Invio Documenti.",
      billingProfile: "Profilo fiscale",
      billingProfilePlaceholder: "Seleziona profilo fiscale",
      billingProfileRequired: "Seleziona il profilo fiscale da usare per la fattura.",
      billingProfilesLoadError: "Errore nel caricamento dei profili fiscali.",
      paymentMethod: "Metodo di pagamento",
      missingInvoice: "Nessuna fattura associata a questa nota/visita.",
      invoiceRequiredBeforeView: "Per visualizzare la fattura devi prima generarla da questa nota/visita.",
      downloadInvoiceError: "Errore durante il recupero della fattura.",
      missingInvoiceBeforeIssue: "Non esiste ancora una fattura collegata a questa nota/visita. Usa Genera fattura per crearla.",
      issueInvoiceDraftInfo: "Non esiste ancora una fattura collegata a questa nota/visita. Compila i dati e scegli se salvarla come bozza o generarla subito. L'invio a SDI/TS si gestisce da Invio Documenti.",
      createDraftInvoice: "Crea Bozza",
      saveDraftInvoice: "Salva bozza",
      defaultInvoiceDescription: "Prestazione sanitaria",
      patientRequiredForInvoice: "Paziente non disponibile per creare la fattura.",
      invoiceDescriptionRequired: "Inserisci una descrizione per la riga fattura.",
      invoiceLineDataRequired: "Compila descrizione, quantità e prezzo di ogni riga fattura.",
      invoiceDiscountOutOfRange: "Lo sconto di ogni riga va da 0 a 100%.",
      draftInvoiceCreated: "Bozza fattura creata correttamente.",
      draftInvoiceCreateError: "Errore durante la creazione della bozza fattura.",
      issueInvoiceLoadError: "Impossibile verificare la fattura da confermare.",
      invoiceAlreadyIssued: "La fattura è già stata generata.",
      issueInvoiceSuccess: "Fattura generata con successo.",
      issueInvoiceError: "Errore durante la generazione della fattura.",
      invoiceNotEditable: "La fattura è già stata generata e non può essere modificata.",
      missingInvoiceBeforeEdit: "Non esiste ancora una fattura modificabile per questa nota/visita.",
      loadInvoiceError: "Impossibile recuperare i dati della fattura per la modifica.",
      saveInvoiceChanges: "Salva modifiche",
      itemDescription: "Descrizione",
      itemQuantity: "Q.tà",
      itemUnitPrice: "Prezzo Unit.",
      itemDiscount: "Sconto (%)",
      itemVatRate: "IVA %",
      vatLockedByRegime: "Nel regime forfettario e in quello dei minimi le prestazioni sono senza IVA: l'aliquota resta 0%.",
      stampDutyMethodNotice: "Nel profilo di fatturazione non è ancora scelta la modalità con cui viene assolto il bollo. Le fatture ai pazienti senza IVA oltre 77,47 € sono soggette al bollo da 2 € e, finché la scelta manca, non si possono emettere.",
      stampDutyMethodMissing: "Oltre 77,47 € la fattura è soggetta al bollo: senza la modalità del bollo nel profilo non si può emettere. La bozza si può salvare.",
      stampDutyMethodMissingOnIssue: "Questa fattura è soggetta al bollo da 2 €: finché nel profilo di fatturazione manca la modalità con cui il bollo viene assolto, non si può emettere. La bozza resta salvata.",
      stampDutyMethodSettingsLink: "Apri le impostazioni di fatturazione",
      addInvoiceRow: "Aggiungi riga",
      removeInvoiceRow: "Rimuovi riga fattura",
      updateInvoiceSuccess: "Fattura aggiornata con successo.",
      updateInvoiceError: "Errore durante l'aggiornamento della fattura.",
      payment_mp01: "MP01: Contanti",
      payment_mp02: "MP02: Assegno",
      payment_mp03: "MP03: Assegno circolare",
      payment_mp05: "MP05: Bonifico",
      payment_mp06: "MP06: Vaglia cambiario",
      payment_mp07: "MP07: Bollettino bancario",
      payment_mp08: "MP08: Carta di pagamento",
      payment_mp12: "MP12: RID",
      payment_mp18: "MP18: Pagamento in conto corrente postale",
      payment_mp22: "MP22: Addebito diretto SEPA"
    },
    NewAnnotationComponent: {
      placeholder: "Aggiungi nota semplice",
      focus_input: "Attiva il campo per inserire una nuova nota",
      visibilityLabel: "Visibilità Paziente",
      notVisible: "Non visibile al paziente",
      visible: "Visibile al paziente",
      save: "Salva nota",
      cancel: "Annulla",
      success: "Nota inserita correttamente",
      error: "Errore nell'inserimento della nota"
    },
    NewSoapAnnotationComponent: {
      subjective: "Soggettivo",
      objective: "Obiettivo",
      assessment: "Valutazione",
      plan: "Piano",
      other: "Altro",
      subjectivePlaceholder: "Impressioni, sintomi riportati dal paziente, storia familiare...",
      objectivePlaceholder: "Segni, esame obbiettivo, indagini strumentali...",
      assessmentPlaceholder: "Valutazione, diagnosi, progressi...",
      planPlaceholder: "Raccomandazioni, procedure o trattamenti indicati, variazioni al piano...",
      otherPlaceholder: "Altre osservazioni rilevanti...",
      save: "Salva nota",
      cancel: "Annulla",
      success: "Nota inserita correttamente",
      error: "Errore nell'inserimento della nota",
      tipo_annotazione: "Tipo",
      tipo_nota_sanitaria: "Nota sanitaria",
      tipo_visita_prestazione: "Visita/Prestazione"
    },
    ScoresComponent: {
      vediQuestionario: "Vedi il questionario",
      title: "Questionari",
      new: "nuova rilevazione questionario",
      newBtn: "Nuovo questionario",
      newTitle: "Nuova rilevazione questionario",
      history: "Storico",
      lastScore: "Ultimo punteggio registrato",
      year: "Anno",
      month: "Mese",
      day: "Giorno",
      all: "tutti",
      values: "Valori rilevati",
      noValues: "Nessun valore registrato",
      findByScore: "Trova questionario con punteggio",
      add: "Aggiungi",
      back: "Indietro",
      complete: "Completa questionario",
      error: "qualcosa è andata storta",
      placeholder: "Cerca...",
      esito_title: "Esito questionario",
      vediQuestioniario: "Vedi questionario",
      esito: "Esito"
    },
    FrequenzaValutazioneScore: {
      frequencyPer: "Frequenza rilevazione: una valutazione ogni",
      suspended: "Valutazione sospesa",
      setFrequency: "Imposta frequenza valutazione",
      parameterNeeded: "È necessario rilevare il parametro ogni",
      toggleQuestion: "Vuoi {{ selectedFrequency.enabled ? 'disattivare' : 'attivare' }} questa frequenza di monitoraggio?",
      confirmDeleteQuestion: "Vuoi eliminare questa frequenza di monitoraggio?",
      modificaTitle: "modifica",
      seleziona_frequenza: "Seleziona frequenza",
      modifica_frequenza: "Modifica frequenza",
      sospendiTitle: "sospendi",
      riprendiTitle: "riprendi",
      eliminaTitle: "elimina",
      deleteTitle: "Modifica operazione",
      updateTitle: "Modifica impostazione",
      confirmTitle: "Conferma operazione",
      deleteConfirm: "Sì, elimina",
      saveChanges: "Salva modifiche",
      cancel: "Annulla",
      confirm: "Conferma",
      genericError: "Qualcosa è andata storta",
      setSuccess: "Valori impostati correttamente",
      updateSuccess: "Impostazione di frequenza modificate correttamente",
      updateError: "Non è stato possibile modificare la frequenza",
      deleteSuccess: "Impostazione di frequenza eliminata correttamente",
      deleteError: "Non è stato possibile eliminare la frequenza",
      sing: {
        mese: "mese",
        settimana: "settimana",
        giorno: "giorno",
        ora: "ora",
        minuto: "minuto"
      },
      plur: {
        mesi: "mesi",
        settimane: "settimane",
        giorni: "giorni",
        ore: "ore",
        minuti: "minuti"
      }
    },
    PatientDevices: {
      title: "Dispositivi",
      newDevice: "Nuovo dispositivo",
      noneAssociated: "Nessun dispositivo associato all'utente.",
      newDeviceTitle: "Nuovo dispositivo Utente",
      searchDevice: "Trova dispositivo",
      searchPlaceholder: "Cerca...",
      noneAvailable: "Nessun dispositivo disponibile per l'assegnazione.",
      codePlaceholder: "Inserisci codice*",
      back: "Indietro",
      save: "Salva",
      addSuccess: "Dispositivo aggiunto correttamente",
      addError: "Non è stato possibile aggiungere il dispositivo",
      removeSuccess: "Dispositivo rimosso correttamente",
      removeError: "Non è stato possibile rimuovere il dispositivo",
      updateCodeSuccess: "Codice prodotto aggiornato correttamente",
      updateCodeError: "Non è stato possibile aggiornare il codice prodotto",
      enabled: "abilitato",
      disabled: "disabilitato",
      examStatusUpdated: "Esame {status} correttamente",
      examStatusError: "Non è stato possibile aggiornare lo stato dell'esame",
      updateRequested: "Aggiornamento richiesto. Riceverai una notifica ad operazione completata",
      updateRequestError: "Non è stato possibile richiedere l'aggiornamento"
    },
    DeviceCard: {
      requestUpdate: "Richiedi aggiornamento dati",
      noExams: "Nessun esame abilitato su questo dispositivo.",
      confirmTitle: "Conferma operazione",
      confirmOk: "Sì, conferma",
      confirmCancel: "No, annulla",
      confirmMessage: "Vuoi dismettere il dispositivo",
      editTitle: "Modifica Dispositivo {name}",
      parameters: "Parametri",
      enabled: "Abilitato",
      disabled: "Disabilitato",
      productCode: "Codice Prodotto",
      edit: "Modifica",
      save: "Salva",
      cancel: "Annulla",
      close: "Chiudi",
      productCodePlaceholder: "Codice Prodotto",
      elimina_dispositivo: "Elimina dispositivo",
      modifica_dispositivo: "Modifica dispositivo"
    },
    EsenzioniAnamnesiComponent: {
      title: "Esenzioni",
      new: "Aggiungi",
      none: "Nessuna esenzione",
      modalTitle: "Aggiungi esenzione",
      selectLabel: "Seleziona esenzione*",
      choose: "scegli",
      save: "Salva",
      deleteTitle: "Confermi di voler eliminare l'esenzione?",
      deleteOk: "Sì, elimina",
      saveSuccess: "Esenzione memorizzata con successo!",
      saveError: "Non è stato possibile salvare l'esenzione",
      deleteSuccess: "Esenzione eliminata con successo!",
      deleteError: "Non è stato possibile eliminare l'esenzione",
      loadError: "Non è stato possibile recuperare le esenzioni",
      elimina_esenzione: "Elimina esenzione {code}"
    },
    EsenzioniComponent: {
      title: "Esenzioni",
      new: "Nuova esenzione",
      none: "Nessuna esenzione inserita",
      modalTitle: "Aggiungi esenzione",
      choose: "scegli",
      requiredField: "*Campo obbligatorio",
      cancel: "Annulla",
      save: "Salva",
      deleteTitle: "Confermi di voler eliminare l'esenzione?",
      deleteOk: "Sì, elimina",
      cancelDelete: "No, annulla",
      saveSuccess: "Esenzione memorizzata con successo!",
      saveError: "Non è stato possibile salvare l'esenzione",
      deleteSuccess: "Esenzione eliminata con successo!",
      deleteError: "Non è stato possibile eliminare l'esenzione",
      pathologiesError: "Non è stato possibile prelevare la lista di patologie",
      loadError: "Non è stato possibile recuperare le esenzioni",
      elimina_esenzione: "Elimina esenzione {code}"
    },
    ProfiloAnagraficoAssistito: {
      title: "Anagrafica Paziente",
      subtitle: "Scheda paziente",
      loadError: "Non è stato possibile recuperare le informazioni.",
      vai_scheda_assistito: "Vai alla scheda dell'assistito"
    },
    SchedaAssistito: {
      toggle_menu: "Espandi o comprimi menu sezioni",
      vai_profilo_assistito: "Vai al profilo dell'assistito"
    },
    AnagraficaPazienteComponent: {
      profile: "Profilo",
      title: "Titolo",
      titlePlaceholder: "Sig...",
      firstName: "Nome*",
      firstNamePlaceholder: "Nome...",
      lastName: "Cognome*",
      lastNamePlaceholder: "Cognome...",
      birthDate: "Data di nascita*",
      gender: "Genere",
      male: "uomo",
      female: "donna",
      taxCode: "Codice fiscale*",
      taxCodePlaceholder: "Codice fiscale...",
      healthCard: "Numero Tessera Sanitaria",
      healthCardPlaceholder: "Numero tessera...",
      birthCountry: "Nazione di nascita*",
      gp: "Medico di base",
      gpPlaceholder: "Medico di base...",
      localHealthAuthority: "Asl/Asp/Ats di riferimento",
      selectAuthority: "Scegli azienda sanitaria locale",
      cancel: "Annulla",
      save: "Salva modifiche",
      residence: "Residenza",
      region: "Regione*",
      regionPlaceholder: "Regione...",
      province: "Provincia*",
      provincePlaceholder: "Provincia...",
      city: "Comune*",
      cityPlaceholder: "Comune...",
      selectRegion: "Seleziona Regione",
      selectProvince: "Seleziona Provincia",
      selectCity: "Seleziona Comune",
      address: "Indirizzo e numero civico*",
      addressPlaceholder: "Indirizzo...",
      zip: "CAP*",
      zipPlaceholder: "CAP...",
      contacts: "Contatti",
      phone: "Numero di telefono",
      phonePlaceholder: "Telefono...",
      homePhone: "Telefono Domicilio",
      homePhonePlaceholder: "Telefono domicilio...",
      backupPhone: "Telefono di Riserva",
      backupPhonePlaceholder: "Telefono di riserva ...",
      deleteImageTitle: "Conferma eliminazione",
      confirm: "Sì, conferma",
      confirmDeleteImage: "Confermi di voler eliminare l'immagine del profilo?",
      selectCountry: "Seleziona Nazione",
      titleOptions: {
        sig: "Sig.",
        sigRa: "Sig.ra",
        dott: "Dott.",
        dottSsa: "Dott.ssa"
      },
      invalidPhone: "Numero di telefono non valido",
      success: "Modifiche effettuate correttamente",
      genericError: "Non è stato possibile completare l'operazione"
    },
    UploadComponent: {
      uploadSuccess: "caricato correttamente!",
      uploadNew: "Carica nuovo file",
      codeDetected: "Codice rilevato correttamente!",
      codeNotDetected: "Non è stato possibile rilevare il codice dalla ricetta caricata. Si prega di provare a scannerizzare il codice tramite videocamera o inserire manualmente il codice nell'apposito campo.",
      placeholder: "seleziona file...",
      upload: "Carica",
      invalidFile: "File non valido o di dimensioni eccessive (max8Mb)"
    },
    ContattiEmergenza: {
      title: "Contatti Utili",
      none: "Nessun contatto inserito.",
      newContact: "Nuovo contatto",
      modalTitle: "Aggiungi contatto utile",
      cancel: "Annulla",
      save: "Salva contatto",
      loadError: "Non è stato possibile recuperare le informazioni."
    },
    NewEmergencyContact: {
      type: "Tipo di contatto",
      firstName: "Nome*",
      firstNamePlaceholder: "Nome...",
      lastName: "Cognome*",
      lastNamePlaceholder: "Cognome...",
      organization: "Denominazione*",
      relation: "Relazione contatto*",
      selectRelation: "Seleziona tipo relazione",
      region: "Regione*",
      selectRegion: "Seleziona Regione",
      province: "Provincia*",
      selectProvince: "Seleziona Provincia",
      city: "Comune*",
      selectCity: "Seleziona Comune",
      address: "Indirizzo e numero civico",
      addressPlaceholder: "Indirizzo...",
      zip: "CAP",
      zipPlaceholder: "CAP...",
      phone: "Numero di telefono*",
      phonePlaceholder: "Telefono...",
      success: "Contatto aggiunto correttamente",
      error: "Errore nel salvataggio del contatto",
      relations: {
        family: "familiare",
        friend: "amico",
        assistance: "assistenza",
        medicalStaff: "personale medico",
        healthStaff: "personale sanitario",
        other: "altro"
      },
      contactTypes: {
        person: "persona fisica",
        place: "luogo"
      },
      cityPlaceholder: "Comune...",
      delete: "Elimina",
      edit: "Modifica",
      cancel: "Annulla",
      save: "Salva",
      confirm: "Sì, conferma",
      confirmDeleteTitle: "Conferma eliminazione",
      confirmDeleteText: "Sei sicuro di voler eliminare il contatto di emergenza per",
      updateSuccess: "Contatto aggiornato correttamente",
      updateError: "Errore nel salvataggio delle modifiche",
      deleteSuccess: "Contatto eliminato correttamente",
      deleteError: "Non è stato possibile eliminare il contatto"
    },
    AdminMain: {
      nav_label: "Navigazione amministratore"
    },
    ImpostazioniSistemaEsami: {
      titolo: "Esami, parametri e referti",
      bande: "bande",
      aggiornamento: "Aggiornamento in corso",
      cerca_placeholder: "Nome...",
      elementi_per_pagina: "Elementi per pagina",
      apri_dettaglio_lab: "Apri dettaglio valori di riferimento",
      apri_dettaglio_soglie: "Apri dettaglio soglie di monitoraggio",
      rif_maschile: "M",
      rif_femminile: "F"
    },
    LabRefHint: {
      descrizione_parametro: "Nel caso in cui il parametro clinico preveda solo un limite inferiore o superiore, è sufficiente compilare solo il minimo o solo il massimo.",
      descrizione_esame: "Nel caso in cui l'esame clinico preveda solo un limite inferiore o superiore, è sufficiente compilare solo il minimo o solo il massimo."
    },
    CreateEditDeleteParametroForm: {
      modifica: "Modifica parametro",
      elimina: "Elimina parametro",
      aggiungi: "Aggiungi",
      tipologia: "Tipologia *",
      nome: "Nome",
      unita_misura: "Unità di misura *",
      campi_obbligatori: "*parametri obbligatori",
      errore_min_maggiore_max: "Il valore minimo non può essere maggiore del massimo",
      invia: "Invia",
      seleziona_tipologia: "Seleziona tipologia",
      tipo_parametro: "Parametro",
      tipo_esame: "Esame",
      tipo_referto: "Referto",
      nuovo_parametro: "Nuovo parametro",
      modifica_label: "Modifica",
      conferma_eliminazione: "Conferma eliminazione",
      sei_sicuro: "Sei sicuro di voler eliminare",
      elimina_btn: "Elimina",
      inserito_ok: "è stato inserito correttamente",
      modificato_ok: "è stato modificato correttamente",
      eliminato_ok: "Elemento eliminato con successo",
      valore_esistente: "Valore già presente a sistema",
      errore_modifica: "Errore durante la modifica del valore",
      errore_eliminazione: "Errore durante l'eliminazione dell'elemento",
      rif_lab_default: "Valori di riferimento",
      lab_min: "Min",
      lab_max: "Max",
      soglie_monitoraggio: "Soglie di monitoraggio",
      soglie_descrizione: "Clicca su Modifica o Aggiungi in ogni colonna per impostare i valori min/max di ciascun livello di severità.",
      inizializza_soglie: "Inizializza soglie",
      soglie_inizializzate: "Soglie inizializzate con successo",
      rimuovi_tutte: "Rimuovi tutte le soglie",
      conferma_rimuovi_tutte: "Sei sicuro di voler rimuovere tutte le soglie di monitoraggio?",
      aggiungi_banda: "Aggiungi banda",
      nessuna_soglia: "Nessuna soglia di monitoraggio configurata per questo parametro.",
      livello: "Livello",
      eta_min: "Età min",
      eta_max: "Età max",
      salva_banda: "Salva banda",
      elimina_banda: "Elimina banda",
      conferma_elimina_banda: "Conferma eliminazione banda",
      conferma_elimina_banda_msg: "Sei sicuro di voler eliminare questa banda di soglia?",
      banda_aggiunta: "Banda aggiunta con successo",
      banda_aggiornata: "Banda aggiornata con successo",
      banda_eliminata: "Banda eliminata con successo",
      errore_salvataggio_banda: "Errore durante il salvataggio della banda",
      errore_eliminazione_banda: "Errore durante l'eliminazione della banda",
      differenzia_per_genere: "Valori di riferimento diversi tra uomo e donna",
      rif_lab_generico: "Generico",
      rif_lab_maschile: "Maschile",
      rif_lab_femminile: "Femminile",
      errore_min_maggiore_max_m: "Il valore minimo maschile non può essere maggiore del massimo",
      errore_min_maggiore_max_f: "Il valore minimo femminile non può essere maggiore del massimo"
    },
    OperatoreMain: {
      nav_label: "Navigazione operatore"
    },
    CompanyBanner: {
      alt: "Banner aziendale"
    },
    NavigationOperatore: {
      logo_alt: "Logo applicazione - Torna alla home",
      mie_conversazioni: "Le mie conversazioni",
      toggle_menu: "Apri o chiudi il menu di navigazione",
      accessibility: "Accessibilità",
      fatturazione: "Fatturazione",
      logout: "Esci dall'area privata",
      logout_confirm_title: "Confermi di voler uscire dall'area privata?",
      logout_confirm_ok: "Sì, esci"
    },
    InvoiceEditor: {
      title: "Nuova Fattura",
      edit_title: "Modifica Fattura",
      cancel: "Annulla",
      cancel_aria: "Torna all'elenco fatture",
      save_and_generate: "Salva e Genera",
      save_aria: "Salva fattura",
      saving: "Salvataggio in corso",
      patient_title: "Dati Paziente / Cliente",
      patient: "Paziente",
      select_patient: "Seleziona un paziente",
      recipient_name: "Nominativo",
      patient_search: "Cerca paziente...",
      address: "Indirizzo",
      city: "Città",
      tax_code: "Codice Fiscale",
      vat_optional: "P.IVA (opzionale)",
      document_title: "Dettagli Documento",
      number: "Numero",
      auto_number: "AUTO",
      date_issue: "Data Emissione",
      payment_method: "Metodo Pagamento",
      ts_objection: "Opposizione invio Sistema TS",
      payment_cash: "Contanti",
      payment_card: "POS / Carta",
      payment_transfer: "Bonifico",
      items_title: "Prestazioni",
      add_row: "+ Aggiungi Riga",
      add_row_aria: "Aggiungi riga fattura",
      col_description: "Descrizione",
      col_quantity: "Q.tà",
      col_unit_price: "Prezzo Unit.",
      col_vat_rate: "IVA %",
      col_total: "Totale",
      col_actions: "Azioni",
      row_description_aria: "Descrizione riga {number}",
      row_quantity_aria: "Quantità riga {number}",
      row_price_aria: "Prezzo riga {number}",
      row_vat_aria: "Aliquota IVA riga {number}",
      remove_row_aria: "Rimuovi riga {number}",
      vat_exempt: "0% (Esente)",
      subtotal: "Imponibile:",
      vat: "IVA:",
      stamp_duty: "Bollo (Virtuale):",
      stamp_duty_note: "Superiore a € 77,47 (esente IVA)",
      total_due: "TOTALE DA PAGARE:",
      profile_load_warning: "Non è stato possibile caricare i profili fiscali.",
      patient_load_warning: "Non è stato possibile caricare la lista pazienti.",
      load_error: "Non è stato possibile caricare la fattura.",
      patient_required: "Seleziona un paziente prima di salvare la fattura.",
      created: "Fattura creata con successo.",
      updated: "Fattura aggiornata con successo.",
      create_error: "Errore nella creazione della fattura.",
      patient_unavailable: "Paziente non disponibile"
    },
    BillingSettingsEmbedded: {
      title: "Configurazione Fatturazione",
      subtitle: "Gestisci i tuoi profili fiscali e le preferenze di invio.",
      profile_dropdown_aria: "Seleziona profilo fiscale",
      profile_placeholder: "Seleziona profilo fiscale",
      new_profile: "Crea Nuovo Profilo Fiscale",
      edit_profile: "Modifica Profilo: {name}",
      new_personal_profile: "Nuovo Profilo Personale",
      create_profile_aria: "Crea nuovo profilo fiscale",
      cancel_new_profile: "Annulla nuovo profilo",
      profile_selected: "Profilo selezionato",
      profile_studio: "Profilo Studio (Aziendale)",
      profile_personal: "Profilo Personale (Medico)",
      loading: "Caricamento...",
      save: "Salva profilo",
      save_aria: "Salva profilo fiscale",
      saving: "Salvataggio in corso",
      saved: "Profilo salvato correttamente",
      save_error: "Errore salvataggio profilo",
      load_error: "Errore caricamento profili",
      fill_required: "Compila i campi obbligatori",
      tab_fiscal: "Dati Fiscali",
      tab_invoice: "Opzioni Fattura",
      tab_privacy: "Privacy",
      tab_ts: "Sistema TS",
      tab_submission: "Invio Documenti",
      business_name: "Ragione Sociale / Nome Completo",
      business_name_placeholder: "Es. Dott. Mario Rossi",
      vat_number: "Partita IVA",
      tax_code: "Codice Fiscale",
      tax_code_required: "Codice Fiscale obbligatorio",
      tax_regime: "Regime Fiscale",
      regime_ordinario: "Ordinario",
      regime_forfettario: "Forfettario (L. 190/2014)",
      regime_minimi: "Contribuenti minimi",
      sdi_code: "Codice Destinatario",
      sdi_code_placeholder: "0000000",
      pec: "Indirizzo PEC",
      pec_placeholder: "nome{'@'}pec.it",
      address_title: "Indirizzo Sede",
      address_street: "Via / Piazza",
      address_civic: "Civico",
      address_cap: "CAP",
      address_city: "Comune",
      address_province: "Prov.",
      select_province: "Seleziona Provincia",
      invoice_advanced_title: "Dati Fatturazione Avanzati",
      albo_province: "Provincia Albo",
      albo_number: "Numero Iscrizione Albo",
      albo_number_placeholder: "Es. 12345",
      albo_number_required: "Numero Iscrizione Albo obbligatorio se si compila la Provincia Albo",
      albo_date: "Data registrazione all'Albo",
      invoice_number_start: "Codice numerazione",
      vat_rate: "Aliquota IVA",
      payment_reason: "Causale Pagamento Default",
      select_option: "Seleziona...",
      payment_mp01: "MP01: Contanti",
      payment_mp02: "MP02: Assegno",
      payment_mp03: "MP03: Assegno circolare",
      payment_mp05: "MP05: Bonifico",
      payment_mp06: "MP06: Vaglia cambiario",
      payment_mp07: "MP07: Bollettino bancario",
      payment_mp08: "MP08: Carta di pagamento",
      payment_mp12: "MP12: RID",
      payment_mp18: "MP18: Pagamento in conto corrente postale",
      payment_mp22: "MP22: Addebito diretto SEPA",
      additional_info: "Informazioni aggiuntive che compaiano nella parte inferiore di ogni fattura",
      additional_info_placeholder: "Es. Operazione in franchigia da IVA ai sensi dell'art. 1, comma 58, L. 190/2014",
      additional_info_help: "La dicitura sul bollo non va scritta qui: la aggiunge il sistema in base alla modalità scelta nella sezione «Imposta di bollo».",
      stamp_duty_title: "Imposta di bollo",
      stamp_duty_intro: "Sulle fatture senza IVA di importo superiore a 77,47 € è dovuto il bollo da 2 €, a carico di chi emette la fattura. Le fatture ai pazienti non passano dallo SDI: la modalità con cui il bollo viene assolto la sceglie il professionista, eventualmente con il proprio commercialista, e la fattura riporta la dicitura corrispondente. Senza questa scelta le fatture ai pazienti soggette a bollo non si possono emettere.",
      stamp_duty_method: "Modalità di assolvimento del bollo",
      bollo_contrassegno: "Marca da bollo sull'originale",
      bollo_contrassegno_help: "La fattura si consegna su carta, con la marca da bollo da 2 € applicata sulla copia che va al paziente.",
      bollo_virtuale_autorizzato: "Bollo virtuale autorizzato dall'Agenzia delle Entrate",
      bollo_virtuale_autorizzato_help: "Con l'autorizzazione dell'Agenzia delle Entrate (art. 15 DPR 642/1972): il bollo si versa con F24 e in fattura vanno gli estremi dell'autorizzazione.",
      bollo_documento_informatico: "Fattura in PDF conservata come documento informatico",
      bollo_documento_informatico_help: "La fattura si invia in PDF e si conserva digitalmente; il bollo si versa con F24 ai sensi dell'art. 6 del D.M. 17 giugno 2014.",
      stamp_duty_authorization: "Estremi dell'autorizzazione",
      stamp_duty_authorization_help: "Numero, data e ufficio dell'Agenzia delle Entrate che ha rilasciato l'autorizzazione, per esempio: n. 12345 del 10/01/2024, Direzione provinciale di Palermo.",
      stamp_duty_authorization_required: "Con il bollo virtuale autorizzato vanno indicati gli estremi dell'autorizzazione.",
      funds_title: "Casse Previdenziali e Ritenute",
      cassa_rate: "Cassa Albo (%)",
      cassa_name: "Nome Cassa/Note",
      inps_rate: "Rivalsa INPS (%)",
      apply_inps: "Applica Rivalsa INPS",
      wh_rate: "Ritenuta d'Acconto (%)",
      wh_taxable_perc: "% Imponibile per Ritenuta",
      wh_taxable_desc: "Percentuale dell'imponibile su cui calcolare la ritenuta",
      apply_wh: "Applica Ritenuta d'Acconto",
      privacy_title: "Privacy e Consenso Comunicazioni",
      privacy_info: "Informativa Privacy",
      privacy_info_desc: "Chiedi ai pazienti di leggere l'informativa privacy prima della visita.",
      privacy_toggle_aria: "Attiva richiesta informativa privacy",
      communication_consent: "Consenso ricezione comunicazioni",
      communication_consent_desc: "Chiedi ai pazienti, prima della visita, il consenso alla ricezione di comunicazioni.",
      communication_toggle_aria: "Attiva richiesta consenso comunicazioni",
      ts_title: "Credenziali Sistema Tessera Sanitaria",
      ts_subtitle: "Inserisci le credenziali per l'invio automatico delle spese.",
      ts_username: "Codice Identificativo",
      ts_password: "Password",
      ts_pin: "PIN",
      ts_structure_title: "Dati struttura sanitaria",
      ts_structure_desc: "Compila questi campi solo se l'invio TS deve avvenire come struttura/azienda. Lasciali vuoti per l'invio come professionista.",
      ts_cod_regione: "Codice Regione",
      ts_cod_asl: "Codice ASL",
      ts_cod_ssa: "Codice SSA",
      ts_cf_proprietario: "CF proprietario / legale rappresentante",
      ts_structure_required: "Per l'invio TS come struttura compila codice Regione, codice ASL e codice SSA.",
      ts_structure_owner_required: "Per l'invio TS come struttura indica un CF proprietario o legale rappresentante di 16 caratteri.",
      ts_encrypted_note: "NOTA: Le credenziali verranno salvate in modo cifrato.",
      ts_organization_sync_notice: "Salvando ora, il profilo fiscale verrà prima sincronizzato con ASE e poi verranno salvate le credenziali Sistema TS.",
      ts_organization_missing_data_notice: "Per salvare le credenziali Sistema TS completa prima P.IVA, codice fiscale e indirizzo del profilo fiscale.",
      manage_rates: "Gestisci Aliquote",
      vat_rates_title: "Gestione Aliquote IVA",
      vat_rate_close: "Chiudi",
      vat_rate_new: "Nuova Aliquota",
      vat_rate_edit: "Modifica Aliquota",
      vat_rate_label: "Aliquota (%)",
      vat_rate_desc: "Descrizione",
      vat_rate_desc_placeholder: "Es. IVA ordinaria 22%",
      vat_rate_natura: "Natura",
      vat_rate_none: "Nessuna (imponibile)",
      natura_n1: "Escluse ex art. 15",
      natura_n21: "Non soggette - artt. da 7 a 7-septies DPR 633/72",
      natura_n22: "Non soggette - altri casi",
      natura_n31: "Non imponibili - esportazioni",
      natura_n32: "Non imponibili - cessioni intracomunitarie",
      natura_n33: "Non imponibili - cessioni verso San Marino",
      natura_n34: "Non imponibili - operazioni assimilate cessioni all'esportazione",
      natura_n35: "Non imponibili - a seguito dichiarazioni d'intento",
      natura_n36: "Non imponibili - altre operazioni che non formano plafond",
      natura_n4: "Esenti",
      natura_n5: "Regime del margine / IVA non esposta",
      natura_n61: "Inversione contabile - rottami e materiali recupero",
      natura_n62: "Inversione contabile - oro e argento puro",
      natura_n63: "Inversione contabile - subappalto edile",
      natura_n64: "Inversione contabile - cessione fabbricati",
      natura_n65: "Inversione contabile - telefoni cellulari",
      natura_n66: "Inversione contabile - prodotti elettronici",
      natura_n67: "Inversione contabile - prestazioni edili",
      natura_n68: "Inversione contabile - settore energetico",
      natura_n69: "Inversione contabile - altri casi",
      natura_n7: "IVA assolta in altro stato UE",
      vat_rate_no_data: "Nessuna aliquota configurata. Aggiungine una sopra.",
      vat_rate_save_edit: "Salva modifica",
      vat_rate_add: "Aggiungi aliquota",
      vat_rate_cancel: "Annulla",
      vat_rate_saved: "Aliquote Salvate",
      vat_rate_actions: "Azioni",
      vat_rate_edit_aria: "Modifica aliquota {description}",
      vat_rate_delete_aria: "Elimina aliquota {description}"
    },
    FiscalDocumentSubmission: {
      title: "Invio documenti fiscali",
      filter_aria: "Filtra documenti per stato",
      refresh_aria: "Aggiorna documenti fiscali",
      loading: "Caricamento...",
      no_documents: "Nessun documento fiscale trovato.",
      table_aria: "Tabella invio documenti fiscali",
      filter_all: "Tutti gli stati",
      filter_non_inviabile: "Non inviabile",
      filter_da_inviare: "Da inviare",
      filter_presa_in_carico: "Presa in carico",
      filter_inviato: "Inviato",
      filter_scartato: "Scartato",
      filter_accolto_anomalie: "Accolto con anomalie",
      filter_accolto: "Accolto",
      col_number: "N. Fattura",
      col_date: "Data Documento",
      col_payment_date: "Data Pagamento",
      col_name: "Nominativo",
      col_tax_code: "Codice Fiscale",
      col_amount: "Competenze",
      col_sdi_status: "Stato SDI",
      col_ts_status: "Stato TS",
      col_actions: "Azioni",
      send_sdi: "SDI",
      send_ts: "TS",
      send_sdi_aria: "Invia fattura {number} allo SDI",
      send_ts_aria: "Invia fattura {number} al Sistema TS",
      refresh_sdi: "Aggiorna stato SDI",
      refresh_sdi_aria: "Aggiorna stato SDI fattura {number}",
      refresh_ts: "Aggiorna stato TS",
      refresh_ts_aria: "Aggiorna stato Sistema TS fattura {number}",
      sdi_rejection_details: "Dettaglio scarto SDI",
      sdi_rejection_details_aria: "Mostra dettaglio scarto SDI fattura {number}",
      sdi_rejection_title: "Dettaglio scarto SDI",
      sdi_rejection_invoice: "Fattura {number}",
      sdi_rejection_unknown_code: "Codice non disponibile",
      sdi_rejection_unknown_description: "Descrizione non disponibile",
      sdi_rejection_no_details: "Nessun dettaglio di scarto disponibile.",
      download_xml: "Scarica XML",
      download_xml_aria: "Scarica XML fattura {number}",
      pagination_of: "di",
      pagination_documents: "documenti",
      pagination_aria: "Paginazione documenti fiscali",
      confirm_title: "Conferma invio documento fiscale",
      confirm_ok: "Sì, procedi",
      confirm_ok_anyway: "Invia comunque",
      confirm_sdi: "Generare XML e inviare la fattura {number} allo SDI?",
      confirm_ts: "Inviare i dati di spesa sanitaria della fattura {number} al Sistema TS?",
      sdi_person_title: "Per le prestazioni sanitarie a persone fisiche l'invio allo SDI non è previsto",
      sdi_person_text: "La legge vieta di inviare allo SDI le fatture per prestazioni sanitarie rese a persone fisiche (art. 10-bis D.L. 119/2018, reso permanente dal D.Lgs. 81/2025). Al paziente si consegna la fattura in PDF o su carta, e i dati della spesa vanno al Sistema Tessera Sanitaria. L'invio allo SDI resta previsto per le prestazioni che non sono sanitarie.",
      sdi_success: "File inviato correttamente",
      sdi_error: "Errore nell'invio allo SDI",
      sdi_refresh_success: "Stato SDI aggiornato",
      sdi_refresh_error: "Errore nell'aggiornamento stato SDI",
      ts_success: "Dati inviati al Sistema TS.",
      ts_error: "Errore nell'invio al Sistema TS",
      ts_refresh_success: "Stato Sistema TS aggiornato",
      ts_refresh_error: "Errore nell'aggiornamento stato Sistema TS",
      load_error: "Errore nel caricamento dei documenti.",
      xml_download_error: "Errore nel download del file XML.",
      sdi_non_inviabile: "Non inviabile",
      sdi_da_inviare: "Da inviare",
      sdi_presa_in_carico: "Presa in carico",
      sdi_scartato: "Scartato",
      sdi_accolto_anomalie: "Accolto con anomalie",
      sdi_accolto: "Accolto",
      ts_non_inviabile: "Non inviabile",
      ts_da_inviare: "Da inviare",
      ts_inviato: "Inviato",
      ts_accolto: "Accolto",
      ts_accolto_anomalie: "Accolto con anomalie",
      ts_scartato: "Scartato"
    },
    PrenotazioniCittadinoMain: {
      newRequest: "Nuova richiesta di prenotazione",
      pending: "In sospeso",
      confirmed: {
        plural: "Confermate",
        singular: "Confermati"
      },
      history: "Storico",
      inactiveService: "Servizio non attivo."
    },
    UserReservations: {
      myBookings: "Le mie prenotazioni",
      assistiti: "Assistiti",
      noReservations: "Nessuna prenotazione.",
      loadError: "Non è stato possibile recuperare le prenotazioni recenti",
      updateSuccess: "Richiesta aggiornata con successo",
      genericError: "Non è stato possibile effettuare l'operazione",
      downloadError: "Non è stato possibile scaricare il promemoria",
      sendSuccess: "Richiesta inviata con successo"
    },
    DettaglioPrenotazioneCittadino: {
      cost: "costo {costo}",
      productRequest: "Richiesta prodotti",
      teleconsulto: "Teleconsulto",
      estimatedDate: "DATA E ORA (STIMATA)",
      toConfirm: "Da confermare",
      requestCode: "CODICE RICHIESTA",
      forWho: "Per conto di",
      status: "STATO",
      nameSurname: "NOME E COGNOME",
      taxCode: "CODICE FISCALE",
      booking: "Prenotazione",
      location: "PRESSO",
      details: "Dettagli",
      operationDate: "DATA OPERAZIONE",
      yourNotes: "LE TUE NOTE",
      purchase: "Acquista",
      date: "DATA"
    },
    UserDetailPrestazione: {
      attachments: "ALLEGATI",
      prescription: "RICETTA",
      download: "Scarica",
      questionnaireToFill: "QUESTIONARIO DA COMPILARE",
      completeQuestionnaire: "Completa questionario",
      questionnaire: "QUESTIONARIO",
      questionnaireMin: "Questionario",
      openQuestionnaire: "Apri questionario",
      downloadPdf: "Scarica in formato PDF",
      notes: "NOTE PRESTAZIONE:",
      operatorNotes: "NOTE DELL'OPERATORE",
      confirmBooking: "Conferma prenotazione",
      rejectChanges: "Rifiuta modifiche",
      cancelBooking: "Annulla appuntamento",
      confirmCancelTitle: "Conferma Annullamento",
      confirmCancelMessage: "Sei sicuro di voler annullare questo appuntamento?",
      confirm: "Sì, Conferma",
      cancel: "Annulla",
      loadQuestionnaireError: "Non è stato possibile recuperare il questionario",
      downloadError: "Non è stato possibile scaricare la risorsa"
    },
    FilledSurveyShower: {
      totalScore: "Punteggio totalizzato",
      resultValue: "Risultato",
      numericScore: "Punteggio",
      scoreClass: "Esito",
      description: "Descrizione",
      questions: "Domande",
      noFile: "Nessun file caricato",
      information: "Informativa",
      hide_unanswered: "Nascondi le domande non compilate"
    },
    ImageShower: {
      downloadAttachment: "scarica allegato",
      downloadError: "non è stato possibile recuperare l'allegato"
    },
    PickMessageForm: {
      attachMessage: "Allega un messaggio per l'utente:",
      noMessage: "Nessun messaggio",
      placeholder: "Scrivi messaggio...",
      cancel: "No, chiudi",
      confirm: "Sì, procedi"
    },
    UserDetailTeleconsulto: {
      expectedDuration: "DURATA PREVISTA",
      actualDuration: "DURATA EFFETTIVA",
      minutes: "minuti",
      prescription: "RICETTA",
      download: "Scarica",
      questionnaire: "QUESTIONARIO",
      openQuestionnaire: "Apri questionario",
      downloadPdf: "Scarica in formato PDF",
      toFillQuestionnaire: "QUESTIONARIO DA COMPILARE",
      completeQuestionnaire: "Completa questionario",
      teleconsultation: "TELECONSULTO",
      goToTeleconsultation: "Vai al teleconsulto",
      operatorNotes: "NOTE DELL'OPERATORE",
      notes: "NOTE",
      saveChanges: "Salva modifiche",
      confirmBooking: "Conferma prenotazione",
      rejectChanges: "Rifiuta modifiche",
      cancelBooking: "Annulla prenotazione",
      confirmCancelTitle: "Conferma Annullamento",
      confirmCancelMessage: "Sei sicuro di voler annullare questo appuntamento?",
      confirm: "Sì, Conferma",
      cancel: "Annulla",
      questionnaireError: "Non è stato possibile recuperare il questionario",
      downloadError: "Non è stato possibile scaricare la risorsa"
    },
    UserDetailProdotto: {
      medicalPrescription: "RICETTA MEDICA",
      vetPrescription: "RICETTA VETERINARIA",
      productsAvailable: "I prodotti in ricetta sono disponibili",
      productsNotAvailable: "I prodotti in ricetta non sono disponibili",
      reminder: "Ricorda di portare con te il pin della ricetta quando vai a ritirare l'ordine!",
      requestedProducts: "PRODOTTI RICHIESTI",
      generic: "GENERICO",
      prescription: "Prescrizione",
      prescriptionNeeded: "necessaria",
      prescriptionNotNeeded: "non necessaria",
      product: "Prodotto",
      available: "disponibile",
      notAvailable: "non disponibile",
      orderNotes: "NOTE SULL'ORDINE",
      prescriptionShort: "RICETTA",
      noPrescriptionAttached: "Nessuna ricetta allegata",
      operatorNotes: "NOTE DELL'OPERATORE",
      saveChanges: "Salva modifiche",
      confirmOrder: "Conferma ordine",
      rejectChanges: "Rifiuta modifiche",
      cancelOrder: "Annulla ordine",
      confirmCancelTitle: "Conferma Annullamento",
      confirmCancelMessage: "Sei sicuro di voler annullare questo appuntamento?",
      confirm: "Sì, Conferma",
      cancel: "Annulla",
      downloadError: "Non è stato possibile scaricare la risorsa",
      download: "Scarica"
    },
    UpdateReservationDate: {
      reschedule: "Modifica",
      modalTitle: "Richiedi modifica data/ora",
      currentDateTime: "Data e ora attualmente previste:",
      selectNewDate: "Scegli nuova data ed ora*:",
      updateNotes: "Aggiorna note",
      cancel: "Annulla",
      submit: "Invia",
      fetchError: "Non è stato possibile prelevare la richiesta",
      submitError: "Non è stato possibile inoltrare la richiesta"
    },
    DatetimeSelection: {
      selectDateTime: "Scegli data ed ora",
      month: "Mese",
      year: "Anno",
      prev: "Precedente",
      next: "Successiva",
      noAvailabilityThisWeek: "Nessuna disponibilità per questa settimana. Prova a verificare le disponibilità per le prossime settimane.",
      noAvailabilityThisWeekMsg: "Nessuna disponibilità per la settimana e la prestazione scelta",
      noAvailabilityForService: "Non è stato possibile trovare disponibilità per questo servizio",
      infoNoAvailability: "La prestazione scelta non ha nessuna disponibilità per la settimana corrente",
      teleconsultDurationError: "Errore nel recupero della durata del teleconsulto. Riprova più tardi.",
      months: {
        january: "Gennaio",
        february: "Febbraio",
        march: "Marzo",
        april: "Aprile",
        may: "Maggio",
        june: "Giugno",
        july: "Luglio",
        august: "Agosto",
        september: "Settembre",
        october: "Ottobre",
        november: "Novembre",
        december: "Dicembre"
      }
    },
    PreferenzeSelection: {
      selectPreferences: "Seleziona giorni e orari di preferenza",
      noPreference: "Non ho particolari preferenze",
      hasPreference: "Voglio indicare le preferenze",
      preferredDate: "Data di preferenza*",
      preferredTimeSlot: "Fascia oraria di preferenza*",
      datePlaceholder: "Scegli una data",
      labelHelp: "Utilizza i cursori per navigare tra le date",
      addPreference: "Aggiungi preferenza",
      saveAndContinue: "Salva e procedi",
      saveSelection: "Salva selezione",
      timeOptions: {
        morning: "mattina",
        afternoon: "pomeriggio",
        evening: "sera",
        allDay: "tutto il giorno"
      }
    },
    ChatComponent: {
      operatore: "Operatore",
      paziente: "Paziente",
      startChat: "Chatta",
      viewConversation: "Vedi conversazione",
      title: "Conversazione",
      connectionError: "Non è stato possibile collegarsi",
      messageSendError: "non è stato possibile inoltrare il messaggio",
      updateError: "non è stato possibile aggiornare la conversazione",
      fetchMessagesError: "non è stato possibile recuperare i messaggi precedenti",
      downloadError: "Non è stato possibile scaricare la risorsa",
      loadingError: "Impossibile caricare il modulo di chat",
      utenteConnesso: "...connesso.",
      presenzaDentro: "{nome} è nella conversazione",
      presenzaFuori: "{nome} non è più nella conversazione",
      solaLettura: "Non è possibile inviare messaggi in questa conversazione.",
      conversazioneChiusa:
        "La conversazione è chiusa: puoi consultare i messaggi.",
      realtimeUnavailable: "Collegamento in tempo reale non disponibile: i messaggi vengono comunque salvati"
    },
    CardPrenotazioneCittadino: {
      waitingForPayment: "attesa pagamento",
      waitingForConfirmation: "attesa conferma",
      location: "Presso:",
      scheduledFor: "Prenotazione effettuata per:",
      costOnSite: "Costo in sede:",
      memo: "Promemoria",
      calendar: "Calendar",
      view: "Visualizza",
      pay: "Paga",
      ore: "ore"
    },
    NuovoOrdineCittadino: {
      need: "Di cosa hai bisogno",
      forWhom: "Per chi",
      at: "Presso",
      date: "Data",
      cancel: "Annulla",
      confirm: "Conferma",
      summary: "Riepilogo",
      noFacilities: "Nessuna struttura disponibile per la prenotazione.",
      scrollFacilities: "Scorri le strutture",
      previousFacilities: "Strutture precedenti",
      nextFacilities: "Strutture successive",
      tryOtherFilters: "Prova a cambiare i filtri di ricerca.",
      saveAndProceed: "Salva e procedi",
      backToFacilities: "Torna alle strutture",
      selectCompanyPreference: "Seleziona una preferenza tra le strutture convenzionate",
      availabilityPrompt: "INDICA LE TUE DISPONIBILITÀ",
      selectedDates: "Date selezionate:",
      fillQuestionnaire: "Compila il questionario",
      service: "Servizio:",
      generic: "generico",
      reminder: "Ricorda di portare con te il pin della ricetta quando vai a ritirare l'ordine.",
      assignedStructureChoice: "Scelta struttura affidata a",
      preferenzeOrLocation: "Preferenza struttura",
      preferenzeFallback: "Presso",
      dateTimeSelected: "Data ed ora selezionate:",
      dateTimeEstimated: "Data ed ora(stimata):",
      selectedPreferences: "Preferenze scelte:",
      attachedPrescription: "Ricetta allegata:",
      serviceFee: "Costo gestione del servizio:",
      totalDue: "Totale dovuto:",
      free: "Gratuito",
      operatorNote: "Se vuoi, aggiungi una nota per l'operatore",
      operatorNoteProduct: "Se vuoi, aggiungi una nota per l'operatore (per esempio un indirizzo di consegna diverso da quello di residenza)",
      confirmInstruction: 'Cliccando su "procedi" inoltrerai la richiesta di prenotazione.',
      waitForOperator: "Attendi che",
      operatorWillContactWithPayment: "un operatore ti contatti per la conferma della prenotazione e pagamento del servizio.",
      operatorWillContact: "un operatore ti contatti per la conferma della prenotazione.",
      readPolicy: "Per procedere alla conferma dell'ordine è necessario",
      acknowledgePolicy: "confermare la presa visione dell'informativa",
      autoAssignProduct: "Affidati a {app} per scelta della struttura",
      autoAssignHealth: "Affidati a {app} per la scelta della struttura sanitaria",
      vatExcluded: "iva {iva}% esclusa",
      informRead: "Ho letto e compreso",
      informativeLink: "l'informativa privacy",
      informConsent: "Acconsento al trattamento dei miei dati personali per le finalità indicate nell'informativa",
      proceed: "Procedi",
      viewReservation: "Visualizza prenotazione",
      downloadCalendar: "Scarica calendar",
      downloadReminder: "Scarica promemoria",
      purchaseCompleted: "Acquisto completato",
      purchasePending: "Acquisto in attesa di pagamento",
      informativaProdotto: "informativa prodotto",
      informativaPrestazione: "informativa prestazione",
      informativaTeleconsulto: "informativa teleconsulto",
      genericError: "Non è stato possibile completare l'operazione.",
      preferencesUpdated: "Preferenze aggiornate correttamente!",
      updatePreferencesError: "Non è stato possibile aggiornare le preferenze",
      noAvailabilityThisWeek: "La prestazione scelta non ha nessuna disponibilità per la settimana corrente",
      noAvailabilityThisService: "Non è stato possibile trovare disponibilità per questo servizio",
      noAvailabilityWeek: "Nessuna disponibilità per la settimana corrente",
      bookingSuccess: "Prenotazione inviata con successo!",
      bookingError: "Non è stato possibile inviare la richiesta",
      reminderDownloadError: "Non è stato possibile scaricare il promemoria",
      questionnaireSendError: "Non è stato possibile inviare il questionario",
      paymentInfoError: "Non è stato possibile recuperare le informazioni relative al pagamento",
      companyNotFound: "Non è stato possibile trovare aziende per il servizio richiesto",
      downloadFailed: "Non è stato possibile scaricare la risorsa",
      costo: "costo",
      timeSlots: {
        morning: 'mattina',
        afternoon: 'pomeriggio',
        allday: 'tutto il giorno'
      },
      preferenzaStruttura: "Preferenza struttura",
      presso: "Presso",
      preferenzeScelte: "Preferenze Scelte",
      informativa: "Informativa",
      skipConfirmationEmail: "Non inviare email di conferma prenotazione",
      skipConfirmationEmailHelp: "Se selezionato, l'utente non riceverà l'email di conferma della prenotazione",
      bypassPreferences: "Continua senza preferenze",
      bypassPreferencesHelp: "Procedi senza inserire le preferenze del paziente"
    },
    CalendarioDisponibilitaGiornalieraCittadino: {
      chooseDateTime: "Scegli data e ora tra le disponibilità",
      labelHelp: "Utilizza i cursori per navigare tra le date",
      day: "giorno",
      noAvailability: "Nessuna disponibilità per il giorno selezionato",
      giorno_precedente: "Giorno precedente",
      giorno_successivo: "Giorno successivo"
    },
    FamiliareCard: {
      modifica_familiare: "Modifica dettagli familiare"
    },
    OperatoreDashboardServiziCard: {
      vai_a_in_attesa: "Vai a prenotazioni in attesa",
      vai_a_confermate: "Vai a prenotazioni confermate",
      vai_a_annullate: "Vai a prenotazioni annullate",
      vai_a_evase: "Vai a prenotazioni evase"
    },
    CompanyHomeDashboard: {
      vai_appuntamenti: "Vai agli appuntamenti",
      prenota_appuntamento: "Prenota un appuntamento"
    },
    FrequenzeRilevazioni: {
      titleModifica: "Modifica la frequenza",
      titleElimina: "Elimina la frequenza",
      titleSospendi: "Sospendi la frequenza",
      titleRiprendi: "Riprendi la frequenza",
      titleAdd: "Nuova frequenza monitoraggio",
      titleUpdate: "Modifica impostazione",
      titleDelete: "Modifica operazione",
      titleConfirm: "Conferma operazione",
      labelEvery: "È necessario rilevare il parametro ogni",
      labelFrequency: "Frequenza rilevazione: una misurazione ogni",
      labelSuspended: "Rilevazione sospesa",
      labelDeleteQuestion: "Vuoi eliminare questa frequenza di monitoraggio?",
      labelEnableQuestion: "Vuoi attivare questa frequenza di monitoraggio?",
      labelDisableQuestion: "Vuoi disattivare questa frequenza di monitoraggio?",
      buttonSetFrequency: "Imposta frequenza rilevazione",
      buttonSave: "Salva frequenza",
      buttonCancel: "Annulla",
      buttonConfirm: "Conferma",
      buttonEdit: "Salva modifiche",
      buttonDeleteYes: "Sì, elimina",
      buttonDeleteNo: "No, annulla",
      everyPlural: {
        0: "mesi",
        1: "settimane",
        2: "giorni",
        3: "ore",
        4: "minuti"
      },
      everySingular: {
        0: "mese",
        1: "settimana",
        2: "giorno",
        3: "ora",
        4: "minuto"
      },
      error_generic: "Qualcosa è andata storta",
      success_saved: "Valori impostati correttamente",
      success_updated: "Impostazione di frequenza modificata correttamente",
      error_update: "Non è stato possibile modificare la frequenza",
      success_deleted: "Impostazione di frequenza eliminata correttamente",
      error_delete: "Non è stato possibile eliminare la frequenza",
      months: "mesi",
      month: "mese",
      weeks: "settimane",
      week: "settimana",
      days: "giorni",
      day: "giorno",
      hours: "ore",
      hour: "ora",
      minutes: "minuti",
      minute: "minuto",
      seleziona_frequenza: "Seleziona frequenza",
      modifica_frequenza: "Modifica frequenza"
    },
    RefertoDimissioni: {
      contattaci: "Contattaci per avere informazioni",
      contattaci_label: "Contattaci per avere informazioni"
    },
    PickMessageCarousel: {
      messaggio_precedente: "Messaggio precedente",
      messaggio_successivo: "Messaggio successivo"
    },
    SearchCompany: {
      back: "Torna indietro",
      noResults: "Nessun risultato con questi parametri di ricerca.",
      rangeHelp: 'Utilizza il campo "range" per aumentare o diminuire il raggio di ricerca',
      geolocWarning: "Per utilizzare questa funzionalità devi acconsentire alla condivisione della tua posizione.",
      allowConsent: "Concedi consenso",
      meters: "metri",
      repeatSearch: "Ripeti ricerca",
      searchByPosition: "Cerca utilizzando la mia posizione attuale",
      searchHelp: 'Compila uno o più campi e premi su "cerca" per visualizzare i risultati della ricerca',
      labelRegion: "Regione*",
      selectRegion: "Seleziona Regione",
      labelProvince: "Provincia*",
      selectProvince: "Seleziona Provincia",
      labelMunicipality: "Comune*",
      selectMunicipality: "Seleziona Comune",
      labelName: "Denominazione",
      placeholderName: "Denominazione...",
      requiredFields: "*parametri obbligatori",
      clearFields: "Pulisci campi",
      search: "Cerca",
      increaseRange: "Aumenta il raggio di ricerca",
      clickToSetPreferredFromHome: 'Clicca sulla sede che vuoi impostare come nuova preferita e conferma la scelta premendo su "Conferma scelta"',
      clickToSetPreferred: 'Clicca sulla sede di tua preferenza e conferma la scelta premendo su "Conferma scelta"',
      setAsPreferred: "Imposta come Preferito",
      cancel: "Annulla",
      confirm: "Conferma scelta",
      noResultsSearch: "Nessun risultato per questa ricerca",
      successPreferences: "preferenze aggiornate correttamente!",
      errorPreferences: "non è stato possibile aggiornare le preferenze"
    },
    FeverPrivacy: {
      titolo: "Informativa Privacy Fever",
      logo_alt: "Logo Fever",
      pdf_title: "Documento PDF informativa privacy Fever",
      pdf_aria_label: "Visualizzatore PDF per informativa privacy Fever",
      scarica_pdf: "Scarica PDF",
      scarica_aria_label: "Scarica l'informativa privacy Fever in formato PDF",
      indietro_aria_label: "Torna alla pagina precedente"
    },
    FeverDownload: {
      header_aria: "Intestazione Fever con descrizione app",
      logo_alt: "Logo Fever",
      hero_text_before: "L'app per aiutare i genitori a gestire",
      febbre: "febbre",
      hero_text_middle: "e",
      dolore: "dolore",
      hero_text_after: "nei bambini in modo semplice e sicuro.",
      lucky_alt: "Lucky, la mascotte di Fever",
      download_aria: "Sezione download app Fever",
      scarica_app: "SCARICA L'APP",
      super_lucky_alt: "Super Lucky in volo",
      google_play_aria: "Scarica Fever su Google Play",
      google_play_alt: "Disponibile su Google Play",
      app_store_aria: "Scarica Fever su App Store",
      app_store_alt: "Scarica su App Store"
    },
    FillSurvey: {
      privacyIntro: "Maggiori dettagli saranno reperibili alla",
      privacyPolicy: "Informativa Privacy",
      termsIntro: "Le condizioni di utilizzo sono consultabili",
      termsLink: "qui",
      requiredAnswer: "Questa domanda è obbligatoria",
      okProceed: "Ok, procedi",
      back: "Torna indietro",
      next: "Procedi",
      thankYou: "Grazie per aver compilato il questionario!",
      canContinueBooking: "Puoi proseguire con la prenotazione.",
      continue: "Prosegui",
      skip: "Salta",
      reset: "Azzera risposta",
      finishStep: "Fine"
    },
    SurveyUploader: {
      filesUploaded: "File caricati correttamente!",
      fileUploaded: "File caricato correttamente!",
      remove: "Rimuovi",
      upload: "Carica",
      select_file: "seleziona file...",
      select_more_file: "seleziona uno o più file..."
    },
    SurveySliderInput: {
      selettore_valore: "Selettore del valore",
      valore_corrente: "Valore corrente",
      non_risposto: "Non risposto"
    },
    SurveyQuestionInput: {
      campo_risposta: "Risposta",
      campo_obbligatorio: "Il campo è obbligatorio",
      aiuto_slider: "Come si usa",
      aiuto_slider_titolo: "Come scegliere il valore",
      aiuto_slider_testo:
        "Trascina la pallina lungo la barra per scegliere un valore: spostala verso destra per un valore più alto, verso sinistra per uno più basso. In alternativa, tocca direttamente il punto della barra che ti interessa.",
      aiuto_slider_label: "Aiuto: come usare il selettore per scegliere il valore"
    },
    NewSubjectSelection: {
      forMe: "Per me",
      forFamilyMember: "Per un mio familiare",
      forAssisted: "Per un mio assistito",
      chooseFamilyMember: "scegli familiare",
      chooseAssisted: "scegli assistito",
      noneRegistered: "Non hai registrato alcun",
      continueToRegister: "Prosegui per registrarlo",
      registerNow: "Registralo ora",
      selectFamilyMember: "Seleziona familiare",
      selectAssisted: "Seleziona assistito",
      cannotFetchInfo: "Non è stato possibile recuperare le informazioni richieste",
      cannotFetchInfoShort: "Non è stato possibile recuperare le informazioni."
    },
    ProductSelection: {
      productSelectionTitle: "Selezione prodotti",
      searchInstruction: "Cerca nel prontuario i prodotti che ti servono digitando qui sotto almeno 3 caratteri:",
      searchLabel: "Cerca prodotto",
      searchPlaceholder: "Cerca prodotto...",
      noProductFound: "Nessun prodotto trovato",
      for: "per",
      selectOneOrMore: "Seleziona uno o più prodotti da prontuario",
      selectProductsOption: "Seleziona prodotti...",
      selectProductOption: "Seleziona prodotto...",
      selectedProductsTitle: "Elenco prodotti selezionati",
      quantityLabel: "Quantità:",
      generic: "Generico",
      cannotFindProduct: "Non trovo il prodotto che cerco",
      insertManualProduct: "Inserisci prodotto fuori prontuario",
      manualProductLabel: "Nome prodotto*:",
      manualProductPlaceholder: "Inserisci nome prodotto...",
      add: "Aggiungi",
      prescriptionExplanation: "Se vuoi effettuare un ordine per una ricetta medica o veterinaria compila uno dei campi sottostanti. Non è necessario inserire manualmente i prodotti previsti dalla ricetta.",
      insertNRECode: "Inserisci il codice qui sotto",
      nreLabel: "Inserisci codice NRE ricetta",
      nrePlaceholder: "Inserisci NRE ricetta...",
      insertREVCode: "Se veterinaria, inserisci il codice qui sotto",
      revLabel: "Inserisci codice REV ricetta",
      revDescription: "*13 caratteri. Non inlcudere il pin.",
      revPlaceholder: "Inserisci REV ricetta...",
      pdfUploadAlt: "In alternativa, puoi caricare la ricetta in formato PDF",
      pdfUploadInstruction: "Carica la ricetta in formato pdf: il sistema leggerà il codice NRE dal file e lo inserirà nell'apposito campo. I file caricati qui non vengono salvati nel sistema. La lettura del codice è valida solo per le ricette NRE, per le ricette veterinarie si prega di inserire il codice manualmente nell'apposito campo.",
      scanWithCamera: "Oppure Scannerizzare il codice ricetta NRE tramite la videocamera",
      saveOrder: "Salva ordine",
      prodotto: "Prodotto:"
    },
    BarcodeComponent: {
      instructions: "Premi il tasto qui sotto per attivare lo scanner. Una volta attivo, inquadra i due codici a barre presente in alto a destra nella ricetta, uno alla volta nell'ordine da sinistra a destra (prima il codice più breve e poi quello più lungo). Una volta rilevato il codice completo, conferma se corrisponde a quello scritto sulla richiesta.",
      scanWithCamera: "Rileva codice tramite la videocamera del dispositivo",
      cancelOperation: "Annulla operazione",
      codeDetected: "Codice Rilevato:",
      invalidCode: "Codice non valido",
      confirm: "Conferma",
      retry: "Riprova"
    },
    NewPrestazioneSelection: {
      searchLabel: "Cerca la visita o la prestazione di cui hai bisogno",
      searchPlaceholder: "Inserisci il nome della prestazione",
      skip_payment_label: "Richiedo che per questa prenotazione non venga richiesto un pagamento"
    },
    PickHealthServiceFromCompany: {
      skip_payment_label: "Richiedo che per questa prenotazione non venga richiesto un pagamento"
    },
    SkipPaymentCheckbox: {
      title: "Richiedo prenotazione senza pagamento",
      section_title: "La prenotazione:",
      standard_label: "segue le regole di pagamento standard",
      skip_label: "deve essere senza pagamento",
      standard_description: "Verrà applicato il pagamento in base alla sottoscrizione del paziente, alle eventuali prestazioni gratuite disponibili o alle impostazioni dei progetti a cui il paziente è iscritto",
      skip_description: "Non verrà richiesto alcun pagamento, anche in assenza di sottoscrizione attiva e con prestazioni gratuite ancora disponibili",
      section_label: "Attiva o disattiva la richiesta di prenotazione senza pagamento"
    },
    TeleconsultoSurveySelection: {
      reasonLabel: "Per quale motivo richiedi il consulto?",
      fetchError: "Non è stato possibile recuperare i questionari"
    },
    StepperButtons: {
      remainingFreeBookings: "Prenotazioni gratuite rimanenti",
      goBack: "Torna indietro",
      continue: "Continua"
    },
    PrivacyInfoComponent: {
      title: "INFORMATIVA SUL TRATTAMENTO DEI DATI PERSONALI ORDINI PER ME/PER I FAMILIARI/ASSISTITI",
      controllerLabel: "Il responsabile del trattamento è:",
      controllerAddress: "Sede legale:",
      controllerEmail: "Email:",
      controllerDPO: "Dati di contatto del Data Protection Officer (DPO):",
      whoProcessesData: "Chi tratta i miei dati?",
      whoProcessesDataContent: `
    <p class="px-1 mb-0 border-bottom border-dark">
      Il Titolare del trattamento è Qwince Innovation S.R.L.
    </p>
    <p class="px-1 mb-0 border-bottom border-dark">
      Sede legale:
    </p>
    <p class="px-1 mb-0 border-bottom border-dark">
      Indirizzo mail: info@concura.online / PEC: qwince.legalmail.it
    </p>
    <p class="px-1 mb-0">
      Dati di contatto del Data Protection Officer (DPO): dpo@qwince.com.
    </p>
  `,
      controller: "Responsabile del trattamento",
      controllerContent: `
    <p>Il responsabile del trattamento è:</p>
    <p>Sede legale:</p>
    <p>Email:</p>
    <p v-if="company.contatto_dpo" class="px-1 mb-0">
      Dati di contatto del Data Protection Officer (DPO): {{ company.contatto_dpo }}
    </p>
  `,
      section1Title: "1. PER QUALI FINALITÀ SONO TRATTATI I MIEI DATI/ I DATI DEL MIO FAMILIARE/ASSISTITO E PERCHÉ IL TRATTAMENTO È LEGITTIMO?",
      section1Content: `
    <p>Il Titolare tratta i dati per consentirLe di prenotare per Lei o per un Suo familiare/assistito ordini presso la propria struttura. Questo trattamento è legittimo perché:</p>
    <ul>
      <li>per quanto riguarda i dati comuni (es. anagrafici) il trattamento è necessario per dare esecuzione a un contratto;</li>
      <li>per quanto riguarda i dati di salute il trattamento è basato sul consenso che Lei può manifestare spuntando l'apposita casella situata prima del tasto di invio dei dati per effettuare il singolo ordine.</li>
    </ul>
  `,
      section2Title: "2. A CHI SONO COMUNICATI I MIEI DATI/ I DATI DEL MIO FAMILIARE/ASSISTITO?",
      section2Content: `
    <p>I Suoi dati sono comunicati a una società di consulenza informatica e a Qwince Innovation Srl per la gestione della Piattaforma. Lei può richiedere l'elenco completo dei destinatari dei Suoi dati personali scrivendo all'indirizzo mail <a href="mailto:assistenza@concura.online" class="text-secondary">assistenza@concura.online</a>. In ogni caso i Suoi dati personali non saranno diffusi.</p>
  `,
      section3Title: "3. I MIEI DATI/ I DATI DEL MIO FAMILIARE/ASSISTITO SONO TRASFERITI FUORI DALL'UNIONE EUROPEA?",
      section3Content: `
    <p>I dati non vengono trasferiti al di fuori dell'Unione Europea.</p>
	`,
      section4Title: "4. PER QUANTO TEMPO SONO CONSERVATI I MIEI DATI/ I DATI DEL MIO FAMILIARE/ASSISTITO?",
      section4Content: `
		<p>Il Titolare conserverà i dati personali per un periodo di tempo non superiore a quello necessario a conseguire le finalità per le quali li sta trattando. Nello specifico i Suoi dati saranno conservati per tutto il tempo in cui il profilo rimarrà attivo e pertanto fino alla disattivazione del Suo profilo. Al termine di tale periodo, salvo obblighi di legge, il Titolare cancellerà i dati in maniera irreversibile – tramite metodi di distruzione o cancellazione sicura – o li conserverà in una forma anonima che non consenta, neanche indirettamente, la Sua identificazione.</p>
	`,
      section5Title: "5. SARÒ SOTTOPOSTO A PROFILAZIONE?",
      section5Content: `
		<p>I dati non verranno in nessun caso utilizzati per ottenere informazioni relative alle Sue preferenze o al Suo comportamento né Lei sarà sottoposto ad alcuna decisione basata unicamente sul trattamento automatizzato dei Suoi dati personali.</p>
	`,
      section6Title: "6. QUALI SONO I MIEI DIRITTI?",
      section6Content: `
		<p>Lei ha i seguenti diritti:</p>
		<ul>
			<li><b>Diritto di accesso ai dati:</b> ottenere conferma che sia in corso un trattamento, accedere ai dati e ricevere informazioni sul trattamento.</li>
			<li><b>Diritto di rettifica:</b> ottenere la rettifica o l'integrazione dei dati inesatti o incompleti.</li>
      <li>
        <b>Diritto alla cancellazione:</b> ottenere la cancellazione dei dati personali senza ingiustificato ritardo se:
        <ul>
          <li>i dati non sono più necessari;</li>
          <li>sono stati trattati illecitamente;</li>
          <li>devono essere cancellati per obbligo legale;</li>
          <li>sono stati raccolti per servizi della società dell'informazione.</li>
				</ul>
			</li>
			<li>
				<b>Diritto alla limitazione del trattamento:</b> nei casi in cui:
				<ul>
					<li>contesta l'esattezza dei dati;</li>
          <li>il trattamento è illecito ma si oppone alla cancellazione;</li>
          <li>i dati sono necessari per un diritto in sede giudiziaria;</li>
          <li>si oppone al trattamento in attesa della verifica della prevalenza dei suoi interessi.</li>
        </ul>
      </li>
      <li><b>Diritto alla portabilità:</b> ricevere i dati in formato strutturato e trasmetterli a un altro titolare.</li>
      <li><b>Diritto di non essere sottoposto a decisione automatizzata:</b> incluso la profilazione che produca effetti giuridici significativi.</li>
    </ul>
    <p>Può esercitare i Suoi diritti scrivendo al Titolare. Riceverà risposta entro 30 giorni.</p>
  `,
      section7Title: "7. SONO OBBLIGATO A FORNIRE I MIEI DATI/ I DATI DEL MIO FAMILIARE/ASSISTITO?",
      section7Content: `
    <p>Lei è libero di non fornire i dati, ma se non li fornisce non Le sarà possibile procedere ad effettuare l'ordine.</p>
	`,
      section8Title: "8. COME POSSO PRESENTARE RECLAMO?",
      section8Content: `
		<p>Se desidera proporre un reclamo in merito al trattamento dei dati o alla gestione di un reclamo già presentato, può farlo direttamente all'Autorità di controllo secondo le modalità indicate sul sito <a href="https://www.garanteprivacy.it" target="_blank">www.garanteprivacy.it</a>.</p>
  `
    },
    RiepilogoPrenotazione: {
      service: "Servizio:",
      generic: "generico",
      rememberPin: "Ricorda di portare con te il pin della ricetta quando vai a ritirare l'ordine.",
      structureAssigned: "Scelta struttura affidata a",
      selectedDateTime: "Data ed ora selezionate:",
      estimatedDateTime: "Data ed ora (stimata):",
      downloadableDocs: "Documenti Scaricabili",
      docsNote: "Sono presenti documenti correlati a questa prenotazione, puoi visualizzarli cliccando su ciascuno di essi. I documenti contenenti campi da compilare vanno scaricati, stampati, compilati e presentati in sede di appuntamento.",
      recommendations: "Raccomandazioni",
      thankYou: "Grazie",
      forRequest: "per la richiesta di prenotazione.",
      forBooking: "per la prenotazione.",
      confirmationMessage: "A breve riceverai una comunicazione da parte di un nostro operatore per la conferma della prenotazione.",
      structurePreference: "Preferenza Struttura Sanitaria:"
    },
    PickNuovaPrenotazioneType: {
      ricerca_per_visita: "Ricerca per visita o prestazione",
      ricerca_per_centro: "Ricerca per centro erogatore",
      skip_payment_label: "Richiedo che per questa prenotazione non venga richiesto un pagamento",
      skip_payment_help: "La prenotazione verrà contrassegnata come gratuita"
    },
    PickCompanyOperator: {
      labelAssign: "Operatore da assegnare alla prenotazione",
      labelPreference: "Preferenza Operatore Sanitario",
      noPreference: "Nessuna Preferenza",
      emailDocumentiFirmatiInfo: "L'operatore selezionato riceverà le email dei documenti firmati durante la prestazione."
    },
    qui: "QUI",
    NewPreferenzeSelection: {
      insertAtLeast3: "Inserisci almeno 3 preferenze e relative fasce orarie.",
      saveAndProceed: "Salva e procedi",
      saveSelection: "Salva selezione",
      selectDaysAndTimes: "Seleziona giorni e orari di preferenza",
      noPreference: "Non ho particolari preferenze",
      wantToSpecify: "Voglio indicare le preferenze",
      labelHelp: "Utilizza i cursori per navigare tra le date",
      datePlaceholder: "Scegli una data",
      timeSlotLabel: "Fascia oraria di preferenza*",
      addPreference: "Aggiungi preferenza",
      timeOptions: {
        morning: "mattina",
        afternoon: "pomeriggio",
        evening: "sera",
        allday: "tutto il giorno"
      },
      dateLabel: "Data di preferenza*"
    },
    PreferenzePicker: {
      morning: "Mattina",
      afternoon: "Pomeriggio",
      allday: "Tutto il giorno",
      days: {
        long: {
          monday: "Lunedì",
          tuesday: "Martedì",
          wednesday: "Mercoledì",
          thursday: "Giovedì",
          friday: "Venerdì",
          saturday: "Sabato",
          sunday: "Domenica"
        },
        short: {
          monday: "L",
          tuesday: "M",
          wednesday: "M",
          thursday: "G",
          friday: "V",
          saturday: "S",
          sunday: "D"
        }
      },
      months: {
        gennaio: "gennaio",
        febbraio: "febbraio",
        marzo: "marzo",
        aprile: "aprile",
        maggio: "maggio",
        giugno: "giugno",
        luglio: "luglio",
        agosto: "agosto",
        settembre: "settembre",
        ottobre: "ottobre",
        novembre: "novembre",
        dicembre: "dicembre"
      },
      scegliFasciaOraria: "Scegli la fascia oraria che preferisci",
      preferenze_selezionate: "Preferenze selezionate",
      rimuovi_preferenza: "Rimuovi preferenza",
      rimuovi_preferenza_aria: "Rimuovi preferenza del {date}",
      nessuna_preferenza_selezionata: "Nessuna preferenza selezionata",
      mese_precedente: "Mese precedente",
      mese_successivo: "Mese successivo",
      calendario_preferenze: "Calendario selezione preferenze date",
      rimuovi_data: "Rimuovi data selezionata",
      seleziona_giorno: "Seleziona {date}",
      giorno_selezionato: "{date} - selezionato",
      giorno_non_selezionabile: "{date} - non selezionabile"
    },
    SearchCompanyFilters: {
      removeFilter: "Rimuovi filtro",
      searchCenter: "Cerca centro erogatore",
      namePlaceholder: "Denominazione",
      type: "Tipologia",
      region: "Regione",
      province: "Provincia",
      municipality: "Comune",
      zip: "CAP",
      zipPlaceholder: "CAP"
    },
    ClinicalTimeline: {
      titolo: "Timeline clinica",
      conteggio_eventi: "eventi",
      cerca_placeholder: "Cerca nella timeline...",
      zoom_label: "Periodo mostrato",
      zoom_mese: "Ultimo mese",
      zoom_trimestre: "Ultimi 3 mesi",
      zoom_semestre: "Ultimi 6 mesi",
      zoom_anno: "Ultimo anno",
      zoom_oltre_anno: "Oltre un anno",
      zoom_tutto: "Tutto lo storico",
      filtri_categoria: "Filtra per categoria",
      cat_patologie: "Patologie",
      cat_terapie: "Terapie",
      cat_fuori_norma: "Valori fuori norma",
      cat_note: "Note",
      cat_referti: "Referti",
      filtro_patologie: "Mostra o nascondi le patologie",
      filtro_terapie: "Mostra o nascondi le terapie",
      filtro_fuori_norma: "Mostra o nascondi i valori fuori norma",
      filtro_note: "Mostra o nascondi le note",
      filtro_referti: "Mostra o nascondi i referti",
      filtro_attivo: "Filtro attivo",
      rimuovi_filtro: "Rimuovi il filtro",
      caricamento: "Caricamento della timeline...",
      nessun_evento: "Nessun evento clinico nel periodo scelto.",
      ricerca_vuota: "La ricerca non ha prodotto risultati.",
      valore: "Valore",
      min: "Minimo",
      max: "Massimo",
    },
    SearchUtente: {
      cerca: "Cerca",
      istruzioni_base: "Cerca un utente per codice fiscale o username.",
      istruzioni_estese: "Inserisci il codice fiscale o lo username (email o telefono) dell'utente che vuoi cercare.",
      label_cerca_cf: "Cerca per codice fiscale",
      label_cerca_username: "Cerca per username",
      placeholder_cf: "Inserisci codice fiscale...",
      placeholder_username: "Inserisci email o telefono...",
      utente_trovato_con: "Utente trovato con",
      email: "email",
      codice_fiscale: "codice fiscale",
      istruzioni_otp: "Per procedere, l'utente deve autorizzare l'accesso tramite codice OTP.",
      oppure: "oppure",
      annulla_torna_indietro: "Annulla e torna indietro",
      nessun_utente_trovato: "Nessun utente trovato",
      registra: "Registra nuovo utente"
    },
    CittadinoAgenda: {
      title: "Calendario",
      serviceInactive: "Servizio non attivo."
    },
    CalendarioCittadino: {
      month: "Mese",
      year: "Anno",
      previous: "Precedente",
      next: "Successiva",
      showMondayOnly: "mostra solo lunedì",
      showTuesdayOnly: "mostra solo martedì",
      showWednesdayOnly: "mostra solo mercoledì",
      showThursdayOnly: "mostra solo giovedì",
      showFridayOnly: "mostra solo venerdì",
      showSaturdayOnly: "mostra solo sabato",
      showSundayOnly: "mostra solo domenica",
      noRequests: "Nessuna richiesta qui.",
      teleconsulto: "Teleconsulto",
      ordine: "Ordine",
      prestazioneSanitaria: "Prestazione sanitaria",
      evento: "Evento",
      statusConfirmed: "Confermato",
      statusCompleted: "Evaso/Concluso",
      statusForwarded: "Inoltrato/In attesa di risposta",
      statusError: "Errore/Rifiutato/Annullato",
      fetchError: "non è stato possibile recuperare le prenotazioni",
      updateSuccess: "Richiesta aggiornata con successo",
      genericError: "non è stato possibile effettuare l'operazione",
      downloadError: "non è stato possibile scaricare il promemoria",
      months: {
        january: "Gennaio",
        february: "Febbraio",
        march: "Marzo",
        april: "Aprile",
        may: "Maggio",
        june: "Giugno",
        july: "Luglio",
        august: "Agosto",
        september: "Settembre",
        october: "Ottobre",
        november: "Novembre",
        december: "Dicembre"
      },
      daysShort: {
        mon: "lun",
        tue: "mar",
        wed: "mer",
        thu: "gio",
        fri: "ven",
        sat: "sab",
        sun: "dom"
      },
      rangeDate: "{start} - {end}"
    },
    Eventi: {
      nuovoEvento: "Nuovo evento",
      nomeLabel: "Nome Evento*",
      luogoLabel: "Luogo*",
      dataLabel: "Data*",
      dataPlaceholder: "Seleziona una data",
      oraLabel: "Ora*",
      noteLabel: "Note",
      notePlaceholder: "Aggiungi delle note (facoltativo)",
      parametriObbligatori: "*parametri obbligatori",
      salva: "Salva",
      salvaModifiche: "Salva modifiche",
      modifica: "Modifica evento",
      elimina: "Elimina evento",
      annullaModifiche: "Annulla modifiche",
      confermaElimina: "Confermi di voler eliminare l'evento?",
      okElimina: "Sì, elimina",
      annullaElimina: "No, annulla",
      testoConfermaElimina: `Se confermi, l'evento "{{titolo}}" verrà eliminato definitivamente.`,
      titoloNuovo: "Nuovo Evento",
      titoloModifica: "Modifica Evento",
      titoloDettagli: "Dettagli Evento",
      successoModifica: "Evento modificato con successo",
      erroreModifica: "Errore durante la modifica dell'evento",
      successoCreazione: "Evento creato con successo",
      erroreCreazione: "Errore durante la creazione dell'evento",
      successoEliminazione: "Evento eliminato con successo",
      erroreEliminazione: "Errore durante l'eliminazione dell'evento"
    },
    Calendario: {
      salva_evento: "Salva evento",
      aggiungi_a_lista_pazienti: "L'appuntamento si può prendere lo stesso. Per avere l'utente in carico — la sua scheda, il suo storico — va aggiunto alla lista pazienti, dalla sezione Pazienti.",
      rimuovi_filtro_stato: "Rimuovi filtro stato",
      rimuovi_filtro_servizio: "Rimuovi filtro servizio",
      rimuovi_filtro_prestazione: "Rimuovi filtro prestazione",
      rimuovi_filtro_annullati: "Rimuovi filtro esclusione annullati",
      aggiungi_nota_slot: "Aggiungi nuovo evento allo slot",
      nuovo_evento: "Nuovo evento",
      nuova_nota: "nuovo evento",
      tab_nota_semplice: "Nota semplice",
      tab_prenotazione: "Prenota appuntamento",
      durata_slot: "Durata impegno slot",
      durata_minuti: "{minutes} minuti",
      data_ora_inizio: "Data e ora inizio",
      dettaglio_opzionale: "Dettaglio (opzionale)",
      placeholder_titolo_evento: "Inserisci il titolo dell'evento o della nota...",
      placeholder_dettaglio_evento: "Inserisci dettagli o annotazioni aggiuntive...",
      chiudi: "Chiudi",
      modifica_nota: "Modifica",
      titolo_nota: "Titolo",
      testo_nota: "Dettaglio",
      salva_nota: "Salva",
      elimina_nota: "Elimina",
      conferma_eliminazione_nota: "Conferma eliminazione",
      testo_conferma_eliminazione_nota: "Sei sicuro di voler eliminare questo evento?",
      nota_volante: "Nota agenda",
      nessuna_prestazione: "Nessuna prestazione configurata",
      crea_prestazione: "Crea una prestazione sanitaria →",
      nota_salvata: "Evento salvato con successo",
      nota_eliminata: "Evento eliminato con successo",
      errore_nota_obbligatoria: "Inserisci il titolo dell'evento",
      errore_salvataggio_nota: "Non è stato possibile salvare l'evento",
      errore_eliminazione_nota: "Non è stato possibile eliminare l'evento",
      apri_promemoria_agenda: "Apri evento",
      apri_nota_agenda: "Apri evento",
      sezione_nota: "Nota",
      sezione_paziente: "Paziente",
      sezione_prestazione: "Prestazione",
      sezione_quando: "Quando",
      sezione_note: "Note"
    },
    CalendarioCittadinoMobile: {
      labelHelp: "Utilizza i cursori per navigare tra le date",
      day: "giorno",
      loading: "caricamento",
      noRequests: "Nessuna richiesta qui.",
      teleconsulto: "Teleconsulto",
      ordine: "Ordine",
      prestazioneSanitaria: "Prestazione sanitaria",
      evento: "Evento",
      statusConfirmed: "Confermato",
      statusCompleted: "Evaso/Concluso",
      statusForwarded: "Inoltrato/In attesa di risposta",
      statusError: "Errore/Rifiutato/Annullato",
      fetchError: "non è stato possibile recuperare le prenotazioni",
      updateSuccess: "Richiesta aggiornata con successo",
      operationError: "non è stato possibile effettuare l'operazione",
      downloadError: "non è stato possibile scaricare il promemoria",
      requestSuccess: "richiesta inviata con successo",
      giorno_precedente: "Vai al giorno precedente",
      giorno_successivo: "Vai al giorno successivo"
    },
    PreviewConsultoCittadino: {
      avvia: "Avvia",
      termina: "Termina",
      messaggi: "Messaggi",
      consulto: "Consulto",
      status: "stato",
      questionario: "Il tuo questionario",
      tempoRimanente: "Tempo rimanente",
      durata: "Durata",
      consultoConcluso: "Consulto concluso.",
      vaiAiReferti: "Vai ai tuoi referti",
      consultiPrevisti: "Consulti previsti per oggi",
      ora: "Ore",
      con: "con",
      durataPrevista: "durata prevista",
      minuti: "minuti",
      nessunConsulto: "Nessun consulto previsto per oggi",
      abbonamentoNonAttivo: "Purtroppo non è possibile effettuare il consulto: la farmacia selezionata non ha più l'abbonamento attivo per il servizio.",
      erroreRichieste: "non è stato possibile prelevare le richieste",
      connessione: {
        attesa: "Attesa connessione...",
        inCorso: "Connessione in corso...",
        connesso: "Connesso.",
        fallita: "Connessione non riuscita. Termina e riavvia la connessione.",
        abbandonato: "L'utente ha abbandonato il consulto."
      },
      documentiDaFirmare: {
        titolo: "Documento da firmare",
        titoloMultipli: "Documenti da firmare",
        caricamentoDocumenti: "Caricamento documenti...",
        firmato: "Firmato",
        firma: "Firma",
        documentiCompletati: "Documenti firmati!",
        tuttiDocumentiFirmati: "Tutti i documenti sono stati firmati con successo",
        riduzioneAutomatica: "Riduzione automatica",
        firmati: "Firmati",
        documentiFirmati: "Documenti firmati",
        firmatoIl: "firmato il"
      }
    },
    DocumentSigningModal: {
      firmaDocumento: "Firma Documento",
      caricamentoDocumento: "Caricamento documento...",
      leggiAttentamente: "Leggi attentamente il documento prima di procedere con la firma digitale.",
      scorriFineFondo: "Scorri fino in fondo al documento per abilitare la firma.",
      puoiProcedere: "Hai letto l'intero documento. Puoi procedere con la firma.",
      scarica: "Scarica",
      scaricamento: "Scaricamento...",
      scorriDocumento: "Scorri il documento per abilitare la firma",
      scorriAbilitare: "Scorri tutto il documento per abilitare la firma",
      scorriPercentuale: "Scorri documento ({percentuale}%)",
      documentoFirmato: "Documento firmato con successo",
      caricamentoDatiUtente: "Caricamento dati utente...",
      erroreFirma: "Errore nella firma del documento",
      erroreCaricamento: "Errore nel caricamento del documento",
      erroreDownload: "Errore nel download del documento",
      documentoFirmatoSuccesso: "Documento firmato con successo",
      emailInviata: "Una email con il documento firmato è stata inviata a te e al personale sanitario"
    },
    VideoCaller: {
      attesaCollegamento: "In attesa che l'altro utente si colleghi...",
      reteAssente: "Segnale rete internet assente.",
      avviso: "Avviso...",
      connectionStatus: {
        1: "Apertura nuovo canale di connessione sicura...",
        2: "Connessione sicura inizializzata...",
        3: "Connessione in corso...",
        4: "Connesso!",
        5: "Errore durante il collegamento, connessione canale sicuro in chiusura...",
        6: "Errore durante il collegamento, connessione canale sicuro chiusa.",
        7: "L'utente ha abbandonato il consulto. Teleconsulto concluso.",
        8: "L'utente ha abbandonato il consulto. Teleconsulto concluso."
      },
      clientStatus: {
        1: "Nuovo client",
        2: "Client connesso ad internet",
        3: "Connessione internet interrotta. Verificare la connettività del proprio dispositivo."
      },
      connessioneFallita: "Non è stato possibile collegarsi",
      avvioMediaFallito: "Non è stato possibile avviare fotocamera e/o microfono",
      connessioneNonRiuscita: 'Non è stato possibile connettersi. Clicca su "Termina" e riavvia la sessione.',
      connessioneStabilita: "Connessione stabilita.",
      connessioneSconosciuta: "Stato connessione sconosciuto",
      connessioneInstabile: "Non è stato possibile stabilire una connessione stabile. Terminare e riavviare il consulto.",
      browserNonSupportato: "Il browser non supporta le videochiamate. Utilizzare un browser aggiornato."
    },
    LiveKitCaller: {
      nonAutorizzato: "Teleconsulto non disponibile: l'utenza non partecipa a questo consulto.",
      fotocamera: "Fotocamera",
      microfono: "Microfono",
      sceltaFotocamera: "Scegli la fotocamera",
      sceltaMicrofono: "Scegli il microfono",
      attivaAudio: "Attiva audio",
      riconnessione: "Connessione persa, riconnessione in corso...",
      cambioDispositivoFallito: "Non è stato possibile cambiare dispositivo.",
      mediaNonDisponibili:
        "Fotocamera e microfono non disponibili: il teleconsulto può iniziare dopo aver consentito l'accesso nel browser e riavviato la sessione.",
      soloAudio:
        "Fotocamera non disponibile o non autorizzata: il teleconsulto prosegue con il solo audio.",
      soloVideo:
        "Microfono non disponibile o non autorizzato: il teleconsulto prosegue senza audio.",
    },
    LiveKitMessaging: {
      tu: "Tu",
      operatore: "Operatore",
      paziente: "Paziente",
      conversazione: "Messaggi del consulto",
      messaggio: "Messaggio",
      scriviMessaggio: "Scrivi un messaggio",
      chatNonAttiva: "I messaggi si possono inviare quando il consulto è collegato.",
    },
    MessagingComponent: {
      chat: "Chat",
      invio: "invio",
      connessioneFallita: "Non è stato possibile collegarsi",
      connesso: "...connesso alla chat",
      invia_messaggio: "Invia messaggio"
    },
    PrenotazioniTeleconsultoCittadino: {
      nuovaRichiesta: "Nuova richiesta di prenotazione",
      inSospeso: "In sospeso",
      confermati: "Confermati",
      confermate: "Confermate",
      storico: "Storico",
      servizioNonAttivo: "Servizio non attivo."
    },
    TeleconsultoOperatoreMain: {
      servizio_non_abilitato: "Servizio non abilitato",
      contattaci: "Contattaci",
      per_abilitare: "per saperne di più o per abilitare il servizio",
    },
    RichiesteEmergenzaCittadinoMain: {
      titolo: "Le mie richieste",
      aggiornamento: "Aggiornamento in corso...",
      nessunaRichiesta: "Nessuna richiesta qui.",
      modalTitle: "Teleconsulto Rapido",
      modalTitlePed: "Teleconsulto Rapido",
      modalOk: "Avvia ora",
      programmato: "Programmato per le",
      servizioNonAttivo: "Servizio non attivo.",
      erroreRichieste: "non è stato possibile prelevare le richieste"
    },
    DettaglioRichiestaEmergenza: {
      attesaRisposta: "in attesa di risposta",
      terminato: "Terminato",
      programmato: "Programmato",
      annullato: "Annullato",
      dataRichiesta: "Data richiesta",
      orarioRichiesta: "Orario richiesta",
      teleconsultoCon: "Teleconsulto con",
      prenotazionePer: "Prenotazione effettuata per",
      avviaOra: "Avvia ora"
    },
    CircoloCura: {
      titolo: "Il tuo circolo di cura",
      aggiungiNuovo: "Aggiungi nuovo",
      consigliati: "Consigliati per te",
      nessunElemento: "Nessun elemento nel tuo circolo di cura.",
      area: "Area",
      sede: "Sede Operativa",
      mioCircolo: "Il mio circolo di cura",
      contatti: "Contatti",
      email: "email",
      telefono: "telefono",
      sedeLegale: "Sede legale",
      datiFiscali: "Dati fiscali",
      titolare: "Titolare",
      partitaIva: "Partita IVA",
      codiceFiscale: "Codice fiscale",
      pec: "PEC",
      apertura: "Apertura",
      chiuso: "Chiuso",
      nonInseriti: "Non inseriti",
      prenota: "Prenota",
      impostaPreferito: "Imposta come preferito",
      rimuoviCircolo: "Rimuovi dal mio circolo di cura",
      rimossoSuccesso: "Elemento rimosso correttamente!",
      rimossoErrore: "non è stato possibile rimuovere l'elemento selezionato",
      preferenzeAggiornate: "preferenze aggiornate correttamente!",
      preferenzeErrore: "non è stato possibile aggiornare le preferenze",
      infoErrore: "non è stato possibile recuperare le informazioni",
      aggiungiTooltip: "Aggiungi al tuo circolo di cura"
    },
    AddMedicoModal: {
      invitaMedico: "Invita il mio medico",
      titleTooltip: "Invita il tuo medico su ",
      nomeLabel: "Nome*",
      nomePlaceholder: "Nome...",
      cognomeLabel: "Cognome*",
      cognomePlaceholder: "Cognome...",
      cittaLabel: "Città*",
      cittaPlaceholder: "Città...",
      emailLabel: "Email",
      emailPlaceholder: "Email...",
      campiObbligatori: "*Campi obbligatori",
      invia: "Invita",
      successo: "Medico invitato correttamente!",
      erroreInvito: "non è stato possibile invitare il medico"
    },
    SottoscrizioniCittadinoMain: {
      acquisti: "Acquisti",
      acquisto: "acquisto",
      gestione: "Gestione",
      storico: "Storico",
      sottoscriviAbbonamento: "Sottoscrivi abbonamento",
      acquistaAbbonamento: "Acquista abbonamento",
      acquistaPrenotazione: "Acquista prenotazione",
      storicoAcquisti: "Storico acquisti",
      riepilogo: "Riepilogo",
      abbonamento: "Abbonamento",
      sottoscrizione: "Sottoscrizione",
      ivaInclusa: "IVA inclusa",
      ivaEsclusa: "+ iva",
      mese: "Mese",
      mesi: "Mesi",
      anno: "Anno",
      servizio: "Servizio",
      costiServizio: "Costi di gestione del servizio",
      codiceSconto: "Codice Sconto",
      voucher: "Codice sconto voucher",
      totale: "Totale",
      imponibile: "Imponibile",
      iva: "IVA",
      sottoscrivi: "Sottoscrivi",
      rinnovoAutomatico: "*L'abbonamento si rinnova automaticamente",
      ogniMese: "ogni mese",
      ogni: "ogni",
      riprova: "Riprova",
      attesaPagamento: "Acquisto in attesa di pagamento",
      homepage: "Homepage",
      completata: "Sottoscrizione abbonamento completata",
      ore: "ore",
      interrompibile: "Il rinnovo automatico può essere interrotto in qualsiasi momento.",
      completed: "completata",
      erroreGenerico: "Non è stato possibile completare l'operazione.",
      errorePagamento: "Non è stato possibile recuperare le informazioni relative al pagamento",
      sottoscrizioneSuccesso: "Sottoscrizione completata",
      erroreSottoscrizione: "Non è stato possibile completare la sottoscrizione"
    },
    PianiTerapeuticiScheda: {
      nessunPiano: "Nessun piano terapeutico registrato",
      titolo: "Piani Terapeutici",
      nuovoPiano: "Nuovo piano terapeutico",
      nessunRisultato: "La ricerca non ha prodotto risultati.",
      piano: "Piano Terapeutico",
      validoDal: "valido dal",
      al: "al",
      dal: "dal",
      pianoInvalidato: "Il piano è stato invalidato dall'Asl.",
      rinnovoRifiutato: "Il rinnovo fornitura è stato rifiutato dall'Asl.",
      motivazioni: "Motivazioni:",
      pacchetto: "Pacchetto",
      stato: "Stato",
      il: "il",
      etichetta: "Etichetta:",
      contenuto: "Contenuto:",
      quantità: "Quantità:",
      lotto: "Lotto:",
      scadenza: "Scadenza:",
      noteAsl: "Note Asl:",
      nessunPacchetto: "Ancora nessun pacchetto previsto per questo piano.",
      nessunElemento: "Nessun elemento tra i piani",
      caricaPiano: "Carica nuovo Piano Terapeutico",
      ricordaInserimento: "Ricorda di inserire e verificare tra le terapie i farmaci prescritti prima di caricare il Piano Terapeutico. Si ricorda che per ottenere il rinnovo fornitura su piani terapeutici precedentemente caricati ed ancora in corso di validità occorre non caricare un nuovo piano ma utilizzare la funzione \"rinnovo fornitura\" sulla riga piano terapeutico completato.",
      istruzioniCaricamento: "Ad ogni nuovo Piano Terapeutico emesso e portato in farmacia, verificare ed aggiornare la scheda del paziente con particolare attenzione alle terapie, sezione nella quale vanno inseriti i farmaci prescritti nel Piano Terapeutico. Dopo aver aggiornato la scheda del paziente, procedere al caricamento del Piano Terapeutico; in seguito al caricamento del documento sarà necessario indicare le date di validità del Piano e selezionare il/i farmaci inclusi nel piano dal selettore \"seleziona terapie\". Clicca su \"salva piano\" per concludere l'operazione: l'ufficio Asl di competenza riceverà una notifica e prenderà in carico il Piano. Quando il farmaco sarà pronto per la consegna al paziente, l'Asl inoltrerà una notifica agli operatori della farmacia ed al paziente.",
      documento: "Documento",
      fileCaricato: "File caricato correttamente.",
      validitàPiano: "Validità del Piano Terapeutico",
      farmaciInclusi: "Farmaci inclusi nel piano",
      selezionaTerapie: "Seleziona terapie*",
      scegliTerapie: "Scegli terapie",
      annotazioni: "Annotazioni",
      inserisciNote: "Inserisci eventuali note relative al Piano Terapeutico",
      salvaPiano: "Salva piano",
      seiSicuro: "Sei sicuro di voler eliminare questo piano?",
      rinnovoPerFarmaci: "Per quali farmaci vuoi richiedere il rinnovo?",
      questionarioPaziente: "Questionario per il paziente",
      informativaPaziente: "Informativa per il paziente",
      consentoInformativa: "Ho consegnato/comunicato l'informativa al cittadino",
      procedi: "Procedi",
      operazioneCompletata: "Operazione completata.",
      descrizioneScarica: "Cliccando sul tasto \"scarica pdf per il paziente\" puoi scaricare il questionario appena compilato in versione stampabile, comprensivo di informativa (laddove presente) e di spazio dedicato per la firma. Potrai comunque scaricare il pdf per il paziente e il questionario in altri formati accedendo alla reportistica dedicata al questionario.",
      chiudiFinestra: "Chiudi finestra",
      scaricaPdf: "Scarica PDF per il paziente",
      servizioNonAbilitato: "Servizio non abilitato",
      placeholderCerca: "Cerca identificativo...",
      rinnovoFornitura: "Rinnovo fornitura",
      somministraQuestionario: "Somministra questionario",
      caricaNuovoPiano: "Carica nuovo Piano Terapeutico",
      annulla: "Annulla",
      noAnnulla: "No, annulla",
      salva: "Salva",
      siElimina: "Sì, elimina",
      conferma: "Conferma",
      confermaOperazione: "Conferma Operazione"
    },
    CambiaStatoConsegna: {
      cambia: "Cambia",
      aggiorna: "Aggiorna",
      stato: "stato",
      title: "Aggiorna stato pacchetto consegna",
      ok: "Conferma",
      annulla: "Annulla",
      selezionaStato: "Seleziona il nuovo stato del pacchetto",
      inPreparazione: "in preparazione",
      prontoRitiro: "pronto per il ritiro",
      ritiratoProntoConsegna: "ritirato, pronto per la consegna al paziente",
      consegnato: "consegnato al paziente",
      reso: "reso dal paziente",
      successo: "Stato pacchetto modificato correttamente",
      errore: "Non è stato possibile modificare lo stato del pacchetto"
    },
    CompilaQuestionarioOperatore: {
      domandaOperatore: "- domanda per l'operatore",
      scegliOpzioni: "scegli una o più opzioni...",
      aggiungiAltro: "aggiungi altro",
      placeholderAltro: "altra opzione personalizzata",
      invia: "Invia"
    },
    GestioneSottoscrizioni: {
      titolo: "Gestione Sottoscrizioni",
      visualizzaTutte: "Visualizza tutte le sottoscrizioni",
      pianoAttivo: "Piano attivo",
      durataMinima: "Durata minima",
      mese: "mese",
      mesi: "mesi",
      anno: "anno",
      siRinnovaIl: "Si rinnova il",
      scadraIl: "Scadrà il",
      leggiDiPiu: "Leggi di più",
      prestazioniDisponibili: "Prestazioni disponibili",
      ordineFarmaci: "Ordini di farmaci disponibili",
      teleconsultoRapido: "Teleconsulto Rapido",
      teleconsultoPediatrico: "Teleconsulto Pediatrico",
      gratis: "GRATIS",
      altreSottoscrizioni: "Altre Sottoscrizioni",
      contattaci: "Contattaci",
      acquista: "Acquista",
      completaAcquisto: "Completa l'acquisto",
      elimina: "Elimina",
      confermaAnnullamento: "Confermi di voler annullare la sottoscrizione",
      siCancella: "Sì, cancella",
      noAnnulla: "No, annulla",
      piani: "Piani",
      erroreGenerico: "Non è stato possibile completare l'operazione.",
      sottoscrizioneEliminata: "Sottoscrizione eliminata con successo.",
      dataFineModificata: "Data fine sottoscrizione modificata con successo.",
      rinnovoStatoSuccesso: "Rinnovo sottoscrizione {stato} con successo.",
      attivato: "attivato",
      disattivato: "disattivato",
      mostraCard: "Mostra la tua tessera digitale",
      laTua: "La tua",
      titoloModaleCard: "La Tua Tessera Digitale",
      scrollSinistra: "Scorri sottoscrizioni a sinistra",
      scrollDestra: "Scorri sottoscrizioni a destra"
    },
    SendHelpRequest: {
      titolo: "Assistenza",
      descrizione: "Seleziona tra le opzioni quella che descrive meglio l'oggetto della tua richiesta, e dopo aver compilato il messaggio clicca su \"invia richiesta\": il sistema inoltrerà una email al centro assistenza che prenderà in carico la richiesta nel più breve tempo possibile. In base alla richiesta potrai ricevere riscontro via email oppure essere contattato da un operatore per via telefonica.",
      campiObbligatori: "*Campi obbligatori",
      inviaRichiesta: "Invia richiesta",
      titoloModale: "Richiesta di Assistenza",
      oggettoLabel: "Oggetto*",
      messaggioLabel: "Messaggio*",
      selezionaOggetto: "Seleziona un oggetto",
      richiestaInformazioni: "Richiesta informazioni",
      richiestaImplementazione: "Richiesta implementazione",
      malfunzionamento: "Malfunzionamento",
      correzioneDati: "Correzione dati errati",
      successo: "Richiesta di assistenza inviata con successo",
      errore: "Non è stato possibile inviare la richiesta",
      testoRichiestaFullMonitor: "Vorrei sapere di più sulla sottoscrizione ConCura Full Monitor"
    },
    EditSubscription: {
      titolo: "Modifica Sottoscrizione",
      infoInizio: "É possibile impostare una data di fine per la sottoscrizione, oppure disabilitare il rinnovo automatico",
      infoGiaImpostata: "Hai già impostato una data di fine sottoscrizione.",
      infoModificaVincolo: "É possibile modificare lo stato del rinnovo automatico, solo se non sono state impostate date di fine sottoscrizione.",
      infoAzzeraPerModificare: "Per procedere con l'annullamento del rinnovo automatico, azzera prima la data di fine sottoscrizione.",
      infoRiabilitaPerDataFine: "É possibile impostare una data di fine sottoscrizione solo se il rinnovo automatico è abilitato. Riabilita il rinnovo automatico per impostare una data di fine per la sottoscrizione.",
      rinnovoIl: "La sottoscrizione si rinnoverà il",
      scadraIl: "La sottoscrizione scadrà il",
      attivaProssimoPagamento: "La sottoscrizione è attiva e il prossimo pagamento è previsto per il",
      gestisciRinnovo: "Gestisci il Rinnovo Automatico",
      rinnovoAutomatico: "Rinnovo automatico",
      impostaDataFine: "Imposta una data di fine sottoscrizione",
      descrizioneDataFine: "Per le sottoscrizioni con rinnovo automatico abilitato, è possibile impostare una data di fine rinnovo. Da quella data in poi la sottoscrizione non verrà rinnovata automaticamente.",
      nessunaData: "Nessuna data di fine impostata.",
      impostaData: "Imposta una data di fine",
      modificaData: "Hai già impostato una data di fine per la sottoscrizione. Se vuoi, puoi modificarla o azzerarla.",
      selezionaPeriodo: "Seleziona",
      unMeseE: "un mese e",
      unAnno: "un anno per la data di fine sottoscrizione",
      annoFine: "Anno di fine",
      imposta: "Imposta data",
      azzera: "Azzera",
      validazioneData: "La data di fine deve essere successiva alla data di prossimo pagamento",
      gennaio: "Gennaio",
      febbraio: "Febbraio",
      marzo: "Marzo",
      aprile: "Aprile",
      maggio: "Maggio",
      giugno: "Giugno",
      luglio: "Luglio",
      agosto: "Agosto",
      settembre: "Settembre",
      ottobre: "Ottobre",
      novembre: "Novembre",
      dicembre: "Dicembre",
      meseFine: "Mese di fine"
    },
    StoricoAcquisti: {
      nessunAcquisto: "Nessun acquisto effettuato.",
      visualizzaAcquisti: "Visualizza Acquisti",
      mostraProforma: "Mostra Proforma Fattura",
      descrizione: "Descrizione",
      stato: "Stato",
      erroreGenerico: "Non è stato possibile completare l'operazione.",
      idTransazione: "ID Transazione",
      importo: "Importo",
      esito: "Esito",
      dataPagamento: "Data Pagamento",
      azioni: "Azioni",
      acquisti: "Acquisti"
    },
    SubscriptionVoucherValidator: {
      labelCodice: "Hai un codice sconto? Inseriscilo qui:",
      conferma: "Conferma",
      voucherNonValido: "Voucher non valido"
    },
    ProgettiMain: {
      servizioNonAbilitato: "Servizio non abilitato",
      contattaci: "Contattaci",
      perAbilitare: "per saperne di più o per abilitare il servizio",
      confermaEliminazione: "Confermi di voler eliminare il post selezionato?",
      siElimina: "Sì, elimina",
      noAnnulla: "No, annulla",
      caricaArticolo: "Carica un articolo",
      modificaArticolo: "Modifica articolo",
      inserisci: "Inserisci un",
      modifica: "Modifica",
      webinar: "Webinar",
      video: "Video",
      servizioNonAttivo: "Servizio non attivo.",
      erroreServizi: "Errore nel recupero dei servizi",
      errorePost: "Errore nel recupero dei post",
      postCreato: "Post creato con successo",
      erroreCreazione: "Errore nella creazione del post",
      postModificato: "Post modificato con successo",
      erroreModifica: "Errore nella modifica del post",
      postEliminato: "Post eliminato con successo",
      erroreEliminazione: "Errore nell'eliminazione del post"
    },
    ProjectPanoramica: {
      webinar: "Webinar",
      leggi_articolo: "Leggi articolo {title}",
      benvenuto: "Benvenuto/a nel Blog di",
      articoli: "Articoli",
      vediTutti: "Vedi tutti",
      nuovoArticolo: "Nuovo articolo",
      nessunArticolo: "Non ci sono articoli disponibili al momento.",
      video: "Video",
      nuovoVideo: "Nuovo video",
      nessunVideo: "Non ci sono video disponibili al momento.",
      nuovoWebinar: "Nuovo webinar",
      nessunWebinar: "Non ci sono webinar disponibili al momento.",
      videoTipoWebinar: "Video di tipo webinar",
      logo_alt: "Logo del blog"
    },
    VideoCard: {
      apri_video: "Apri video {title}"
    },
    OperatorePostCard: {
      apri_post: "Apri post {title}",
      mostra_post: "Mostra post",
      modifica: "Modifica",
      elimina: "Elimina"
    },
    CardFamiliare: {
      apri_scheda: "Apri scheda familiare {name}"
    },
    CardFamiliareSperimentazione: {
      apri_scheda: "Apri scheda bambino {index}",
      conferma_revoca_title: "Conferma revoca consenso",
      conferma_revoca_msg: "Sei sicuro di voler revocare il consenso alla sperimentazione?",
      revoca_consenso: "Revoca consenso",
      revoca_successo: "Consenso revocato con successo",
      revoca_errore: "Errore durante la revoca del consenso. Riprova.",
      conferma_approva_title: "Conferma approvazione consenso",
      conferma_approva_msg: "Sei sicuro di voler approvare il consenso alla sperimentazione?",
      approva_consenso: "Approva consenso",
      approva_successo: "Consenso approvato con successo",
      approva_errore: "Errore durante l'approvazione del consenso. Riprova.",
      conferma_elimina_title: "Conferma eliminazione paziente",
      conferma_elimina_msg: "Sei sicuro di voler eliminare questo paziente arruolato dalla sperimentazione? L'operazione non è reversibile.",
      elimina_paziente: "Elimina paziente",
      elimina_successo: "Paziente arruolato eliminato con successo dalla sperimentazione",
      elimina_errore: "Errore durante l'eliminazione del paziente arruolato. Riprova."
    },
    SchedaFamiliare: {
      toggle_menu: "Espandi o comprimi menu laterale"
    },
    NuovoBambinoSperimentazione: {
      arruola_paziente: "Arruola paziente per sperimentazione",
      prosegui: "Prosegui"
    },
    EpisodioCard: {
      rinomina_episodio: "Rinomina episodio",
      termina_episodio: "Termina episodio",
      termina: "Termina",
      caricamento: "Caricamento...",
      rinominazione_in_corso: "Rinominazione in corso...",
      terminazione_in_corso: "Terminazione in corso..."
    },
    ModaleAggiungiEventoEpisodio: {
      seleziona_somministrazione: "Seleziona evento somministrazione farmaco",
      seleziona_misurazione: "Seleziona evento misurazione",
      seleziona_sintomo: "Seleziona evento sintomo",
      torna_indietro: "Torna indietro"
    },
    RisultatoCalcolo: {
      calcolo_in_corso: "Calcolo in corso...",
      elaborazione_dosaggio: "Elaborazione del dosaggio..."
    },
    CalcoloStepByStep: {
      verifica_in_corso: "Verifica in corso...",
      controllo_parametri: "Controllo dei parametri..."
    },
    FamiliariAssistiti: {
      caricamento_familiari: "Caricamento familiari..."
    },
    FamiliariAssistitiSperimentazione: {
      caricamento_familiari: "Caricamento familiari..."
    },
    DocumentEditor: {
      caricamento_editor: "Caricamento editor documento...",
      salva_documento: "Salva documento"
    },
    PatientQueries: {
      caricamento_segnalazioni: "Caricamento segnalazioni..."
    },
    AlertEventDetail: {
      inoltra_alert: "Inoltra alert",
      perche_alert: "Mostra causa alert",
      modifica_alert: "Modifica alert",
      vai_scheda_paziente: "Vai alla scheda paziente",
      inoltra_a_struttura: "Inoltra alla struttura",
      scegli_struttura: "Scegli la struttura...",
      destinatario: "Destinatario",
      aria_destinatario: "Tipo di destinatario dell'inoltro",
      destinatario_operatore: "Un operatore",
      destinatario_ruolo: "Tutti gli operatori con un ruolo",
      operatore_destinatario: "Operatore",
      ruolo_destinatario: "Ruolo",
      scegli_operatore: "Scegli l'operatore...",
      scegli_ruolo: "Scegli il ruolo...",
      nessun_operatore_struttura: "Nessun operatore disponibile in questa struttura.",
      nessun_ruolo_struttura: "Nessun ruolo disponibile in questa struttura.",
      nota_inoltro: "Nota per il destinatario",
      nota_placeholder: "Le tue annotazioni...",
      caricamento_opzioni: "Caricamento di operatori e ruoli della struttura",
      errore_opzioni: "Non è stato possibile caricare operatori e ruoli della struttura.",
      riprova: "Riprova",
      errore_inoltro: "Non è stato possibile inoltrare l'alert.",
      inoltro_gia_fatto: "L'alert è già stato inoltrato da un altro operatore: la pagina mostra lo stato attuale.",
      inoltro_alert_chiuso: "L'alert è stato completato nel frattempo: la pagina mostra lo stato attuale.",
      destinatario_non_valido: "Il destinatario scelto non è più disponibile: operatori e ruoli della struttura sono stati ricaricati.",
      inoltro_riuscito: "Alert inoltrato correttamente.",
      inoltrato_a_operatore: "Inoltrato a {nome}",
      inoltrato_a_ruolo: "Inoltrato a: {ruolo} - {struttura}",
      inoltrato_a_tutti_operatori: "Inoltrato a: tutti gli operatori - {struttura}",
      in_gestione_da: "In gestione da {nome}",
      non_ancora_in_carico: "Non ancora preso in carico",
      prendi_in_carico: "Prendi in carico",
      subentra: "Subentra",
      conferma_subentro_titolo: "Subentro nella gestione",
      conferma_subentro: "L'alert è in gestione da {nome}. Confermando, la gestione passa a te e il cambio resta nel registro delle attività.",
      presa_in_carico_riuscita: "Alert preso in carico.",
      subentro_riuscito: "Gestione dell'alert assunta.",
      azione_non_consentita: "Operazione non consentita su questo alert.",
      alert_aggiornato: "L'alert è stato aggiornato da un altro operatore: la pagina mostra lo stato attuale.",
      errore_azione: "Non è stato possibile completare l'operazione.",
      torna_indietro: "Torna indietro",
      completa: "Completa",
      completato: "Completato",
      completamento_riuscito: "Alert impostato come completato!",
      errore_completamento: "Non è stato possibile completare l'alert."
    },
    AlertList: {
      visualizza: "Visualizza",
      completato: "Completato",
      inoltrato: "Inoltrato",
      in_gestione_da: "In gestione da {nome}",
      da_prendere_in_carico: "Da prendere in carico",
      da_gestire: "Da gestire",
      nessun_alert: "Nessun alert",
      utente_eliminato: "Utente eliminato"
    },
    UserAlertEvents: {
      inoltrato_a_ruolo: "Inoltrato a: {ruolo} - {struttura}",
      inoltrato_a_tutti_operatori: "Inoltrato a: tutti gli operatori - {struttura}",
      in_gestione_da: "In gestione da {nome}"
    },
    Ruoli: {
      "amministratore": "amministratore",
      "amministratore anagrafica": "amministratore anagrafica",
      "operatore": "operatore",
      "operatore avanzato": "operatore avanzato",
      "medico": "medico",
      "infermiere": "infermiere",
      "infermiere avanzato": "infermiere avanzato",
      "oss": "oss",
      "company-cup": "operatore CUP",
      "operatore avanzato emergenza": "operatore Teleconsulto Rapido",
      "operatore avanzato pediatrico": "operatore Teleconsulto Pediatrico",
      "operatore solo centralino emergenza": "operatore Centralino Teleconsulto Rapido",
      "operatore solo centralino pediatrico": "operatore Centralino Teleconsulto Pediatrico",
      "operatore solo centralino pediatrico ed emergenza": "operatore Centralino Teleconsulto Pediatrico ed Emergenza",
      "croom-operatore": "croom-operatore",
      "croom-operatore-sanitario": "croom-operatore-sanitario",
      "croom-admin": "croom-admin"
    },
    RuoliTitolo: {
      "operatore": "Operatore",
      "operatore avanzato": "Operatore Avanzato",
      "amministratore": "Amministratore",
      "medico": "Medico",
      "infermiere": "Infermiere",
      "infermiere avanzato": "Infermiere Avanzato",
      "oss": "OSS",
      "operatore avanzato emergenza": "Operatore Teleconsulto Rapido",
      "operatore avanzato pediatrico": "Operatore Teleconsulto Pediatrico",
      "operatore solo centralino emergenza": "Operatore Centralino Teleconsulto Rapido",
      "operatore solo centralino pediatrico": "Operatore Centralino Teleconsulto Pediatrico",
      "operatore solo centralino pediatrico ed emergenza": "Operatore Centralino Teleconsulto Pediatrico ed Emergenza"
    },
    RuoliDescrizioni: {
      "amministratore": "Può visualizzare e gestire tutte le sezioni, il pannello impostazioni e le relative sotto-sezioni, tutti i servizi e le richieste. Può scaricare i report di prenotazione e screening.",
      "amministratore anagrafica": "Può visualizzare e modificare l'anagrafica aziendale. Non ha accesso alla gestione dei servizi né degli operatori.",
      "operatore": "Ruolo base assegnato di default ai dipendenti registrati tramite codice azienda. Può gestire le richieste di prenotazione e somministrare questionari di screening, ma non può modificare le impostazioni dei servizi né creare questionari.",
      "operatore avanzato": "Può gestire le richieste di prenotazione e configurare le impostazioni dei servizi. Può creare e gestire questionari e raccolte. Non ha accesso alla sezione operatori né all'anagrafica aziendale.",
      "medico": "Ruolo clinico con pieno accesso alla gestione dei pazienti: può arruolare pazienti, gestire referti, compilare note mediche e alimentare la scheda paziente.",
      "infermiere": "Ruolo clinico orientato all'assistenza: può alimentare la scheda paziente, inserire note mediche e visualizzare i referti. Non può arruolare pazienti né gestire referti.",
      "infermiere avanzato": "Ha le stesse capacità dell'infermiere (alimentare la scheda paziente, inserire note mediche, visualizzare i referti) e in più può arruolare pazienti. Non può gestire referti.",
      "oss": "Ruolo di supporto sanitario con funzionalità limitate: può somministrare questionari e inserire note semplici.",
      "company-cup": "Operatore CUP con accesso alla gestione delle prenotazioni, impostazioni dei servizi e gestione degli operatori.",
      "operatore avanzato emergenza": "Ha gli stessi privilegi dell'operatore avanzato e, se la struttura ha attivato il servizio, accesso all'area dedicata al Teleconsulto Rapido.",
      "operatore avanzato pediatrico": "Ha gli stessi privilegi dell'operatore avanzato e, se la struttura ha attivato il servizio, accesso all'area dedicata al Teleconsulto Pediatrico.",
      "operatore solo centralino emergenza": "Dedicato alla ricezione delle richieste di Teleconsulto Rapido. Ha i privilegi dell'operatore avanzato e riceve le notifiche del servizio.",
      "operatore solo centralino pediatrico": "Dedicato alla ricezione delle richieste di Teleconsulto Pediatrico. Ha i privilegi dell'operatore avanzato e riceve le notifiche del servizio.",
      "operatore solo centralino pediatrico ed emergenza": "Dedicato alla ricezione delle richieste sia di Teleconsulto Pediatrico che di Teleconsulto Rapido. Combina le notifiche di entrambi i servizi.",
      "croom-operatore": "Operatore della Control Room con accesso alla gestione operativa quotidiana: ordini, prestazioni, questionari e schede paziente.",
      "croom-operatore-sanitario": "Operatore sanitario della Control Room. Rispetto all'operatore base può arruolare pazienti, inserire note mediche e attivare servizi paziente.",
      "croom-admin": "Amministratore della Control Room con accesso completo: gestione degli operatori della sala, delle liste pazienti e dell'anagrafica aziendale."
    },
    PrenotazioniPaziente: {
      vedi_dettaglio: "Vedi dettaglio prenotazione"
    },
    CalendarioFilters: {
      apri_filtri: "Apri filtri calendario",
      chiudi_overlay: "Chiudi pannello filtri",
      chiudi_filtri: "Chiudi filtri"
    },
    CompanyReservationCard: {
      toggle_preferito: "Imposta/rimuovi preferita",
      aggiungi_suggerimento: "Aggiungi come suggerimento",
      toggle_info: "Mostra/nascondi informazioni"
    },
    PickHealthServiceFromCompanyCard: {
      toggle_info: "Mostra/nascondi informazioni"
    },
    ProjectDetail: {
      tornaIndietro: "Torna indietro",
      nuovo: "Nuovo",
      cerca: "Cerca",
      nessunElemento: "Non ci sono elementi da mostrare",
      nonCiSono: "Non ci sono",
      daMostrare: "da mostrare",
      cercaPerTitolo: "Cerca per Titolo",
      cercaPerData: "Cerca per Data",
      subsection: {
        articolo: "articoli",
        video: "video",
        webinar: "webinar",
        "altri-contenuti": "altri contenuti",
        evento: "eventi"
      }
    },
    CreateEditArticle: {
      tipoContenuto: "Tipo contenuto",
      opzioneArticolo: "Articolo",
      opzioneAltriContenuti: "Altri contenuti (PDF)",
      immagineCopertina: "Immagine di copertina",
      filePdf: "File PDF*",
      pdfObbligatorio: "Carica un file PDF per continuare",
      apriPdf: "Apri PDF caricato",
      titolo: "Titolo*",
      placeholderTitolo: "Scrivi il titolo dell'articolo",
      contenuto: "Contenuto*",
      placeholderContenuto: "Contenuto dell'articolo",
      data: "Data",
      abilitato: "Abilitato",
      disabilitato: "Disabilitato",
      campiObbligatori: "* campi obbligatori",
      salva: "Salva",
      modifiche: "modifiche",
      nuovoArticolo: "nuovo articolo",
      immagine_copertina_alt: "Immagine di copertina dell'articolo"
    },
    ArticleShower: {
      article_image: "Immagine dell'articolo",
      apri_pdf: "Apri/scarica PDF"
    },
    CreateEditVideo: {
      immagineCopertina: "Immagine di copertina*",
      erroreCopertina: "Inserisci un'immagine di copertina",
      titolo: "Titolo*",
      placeholderTitolo: "Scrivi il titolo del video",
      abilitato: "Abilitato",
      disabilitato: "Disabilitato",
      categoriaWebinar: "Categoria Webinar",
      tipoWebinar: "Il video è di tipo Webinar",
      tipoNonWebinar: "Il video non è di tipo Webinar",
      campiObbligatori: "* campi obbligatori",
      salva: "Salva",
      modifiche: "modifiche",
      nuovoVideo: "nuovo video",
      immagine_copertina_alt: "Immagine di copertina del video"
    },
    ProfiloSanitarioMain: {
      archivioSanitario: "Archivio sanitario",
      patologie: "Patologie",
      terapie: "Terapie",
      piani: "Piani terapeutici",
      note: "Note",
      dispositivi: "Dispositivi",
      accessi: "Attività registrate",
      servizioNonAttivo: "Servizio non attivo.",
      errore: "Non è stato possibile completare l'operazione.",
      anamnesi: "Anamnesi",
      timeline: "Timeline Clinica"
    },
    LineChart: {
      gennaio: "Gennaio",
      febbraio: "Febbraio",
      marzo: "Marzo",
      aprile: "Aprile",
      maggio: "Maggio",
      giugno: "Giugno",
      luglio: "Luglio",
      agosto: "Agosto",
      settembre: "Settembre",
      ottobre: "Ottobre",
      novembre: "Novembre",
      dicembre: "Dicembre",
      ordiniAlMese: "Ordini al mese"
    },
    ArmadiettoComponent: {
      nessunaInAtto: "Nessuna terapia in atto",
      terapieInAtto: "Terapie in atto",
      prospettoTerapie: "Prospetto terapie",
      nuovaTerapia: "Nuova terapia",
      finoAl: "Fino al",
      dal: "Dal",
      elimina: "Elimina",
      vedi: "Vedi",
      storicoTerapie: "Storico Terapie",
      terminataIl: "Terminata il",
      nessunElemento: "Nessun elemento nello storico",
      modificaTerapia: "Modifica terapia",
      dettaglioTerapia: "Dettaglio terapia",
      perPatologia: "per patologia",
      patologia: "patologia",
      modifica: "Modifica",
      riprendi: "Riprendi",
      sospendi: "Sospendi",
      scaricaPromemoria: "Scarica promemoria",
      inseritaIl: "Inserita il",
      conferma: "Conferma",
      noAnnulla: "No, annulla",
      siConferma: "Sì, conferma",
      confermiSospRipr: "Confermi di voler",
      sospendere: "sospendere",
      riprendere: "riprendere",
      laTerapia: "la terapia?",
      confermaEliminazione: "Conferma eliminazione",
      confermiEliminazione: "Confermi di voler eliminare la terapia?",
      erroreRecupero: "Non è stato possibile recuperare le terapie",
      terapia: "Terapia",
      sospesa: "sospesa",
      ripresa: "ripresa",
      erroreOperazione: "Non è stato possibile eseguire l'operazione",
      eliminata: "Terapia eliminata!",
      erroreEliminazione: "Non è stato possibile eliminare la terapia",
      erroreDownloadPromemoria: "Non è stato possibile scaricare il promemoria",
      erroreDownloadProspetto: "Non è stato possibile scaricare il prospetto.",
      mattina: "mattina",
      meta_mattina: "metà mattina",
      pranzo: "pranzo",
      pomeriggio: "pomeriggio",
      sera: "sera",
      notte: "notte"
    },
    RecapTherapyModal: {
      posologia: "Posologia",
      di: "di",
      perVia: "per via",
      daAssumere: "Da assumere",
      durata: "Durata",
      terapiaOgni: "La terapia va seguita ogni",
      per: "per",
      daFinoA: "Da {{start}} fino a {{end}}",
      aPartireDa: "a partire da",
      cronica: "cronica",
      prescrittore: "Prescrittore",
      effettiCollaterali: "Effetti Collaterali",
      reazioniAllergiche: "Reazioni Allergiche",
      interazioni: "Interazioni",
      annotazioni: "Annotazioni",
      non_indicata: "non indicata",
      non_indicate: "Non indicate",
      non_indicato: "non indicato",
      non_indicati: "non indicati",
      nessuna_nota: "nessuna nota",
      typesMap: {
        Compresse: "compressa",
        Capsule: "capsula",
        Gocce: "goccia",
        Inalazioni: "inalazione",
        Buste: "busta",
        Supposte: "supposta",
        Scatole: "scatola",
        Cerotti: "cerotto",
        Fiale: "fiala",
        Fleboclisi: "fleboclisi",
        Ovuli: "ovulo",
        Sacche: "sacca",
        Flaconi: "flacone",
        Confezioni: "confezione",
        Kilogrammi: "kilogrammo",
        Kit: "kit",
        Millilitri: "millilitro",
        Milligrammi: "milligrammo",
        Applicazioni: "applicazione",
        UI: "UI"
      },
      forEveryUmsSing: {
        0: "mese",
        1: "settimana",
        2: "giorno"
      },
      forEveryUmsPlur: {
        0: "mesi",
        1: "settimane",
        2: "giorni"
      },
      assunzioni: {
        mattina: "mattina",
        meta_mattina: "metà mattina",
        pranzo: "pranzo",
        pomeriggio: "pomeriggio",
        sera: "sera",
        notte: "notte"
      }
    },
    NuovaTerapiaCittadino: {
      profiloSanitario: "Profilo sanitario",
      riepilogo: "Riepilogo",
      scaricaPromemoria: "Scarica promemoria",
      erroreDownloadPromemoria: "Non è stato possibile scaricare il promemoria"
    },
    NewTherapy: {
      titoloPatologia: "Patologia per cui è stata indicata la terapia",
      indicaPatologia: "Indica patologia",
      nonIndicare: "Non indicare",
      farmacoIndicato: "Farmaco indicato",
      labelCercaFarmaco: "Cerca farmaco",
      placeholderCercaFarmaco: "Cerca per nome o aic..",
      labelSelezionaFarmaco: "Seleziona farmaco*",
      prodottoNonTrovato: "Prodotto non trovato",
      frequenzaModalitaDosaggio: "Frequenza, modalità e dosaggio somministrazione",
      dosaggio: "Dosaggio*",
      frequenza: "Frequenza*",
      alDi: "al dì",
      alBisogno: "al bisogno",
      ore: "ore",
      daAssumere: "Da assumere",
      mattina: "Mattina",
      metaMattina: "Meta mattina",
      pranzo: "Pranzo",
      pomeriggio: "Pomeriggio",
      sera: "Sera",
      notte: "Notte",
      maxUnoAssunzione: "Con questa frequenza è possibile selezionare al massimo un momento di assunzione",
      inviaAlert: "Invia un promemoria 10 minuti prima la somministrazione",
      durataTerapia: "Durata della terapia",
      indeterminata: "Indeterminata",
      periodica: "Periodica/ciclica",
      occasionale: "Occasionale",
      mesi: "mesi",
      settimane: "settimane",
      giorni: "giorni",
      ogni: "Ogni ",
      aPartireDal: "A partire dal*",
      finoAl: "Fino al*",
      dettagli: "Dettagli",
      prescrittore: "Prescrittore terapia",
      indicaPrescrittore: "indica chi ha prescritto la terapia",
      fonte: "Fonte informativa",
      indicaFonte: "indica fonte informativa",
      effettiCollaterali: "Effetti collaterali",
      placeholderEffetti: "eventuali effetti collaterali attribuite al farmaco..",
      reazioniAllergiche: "Reazioni allergiche",
      placeholderAllergie: "eventuali reazioni allergiche attribuite al farmaco..",
      interazioni: "Interazioni",
      placeholderInterazioni: "possibili interazioni con farmaci o alimenti individuate..",
      annotazioni: "Annotazioni",
      salva: "Salva terapia",
      visibileSoloMe: "**se selezioni questa opzione soltanto tu potrai vedere questa terapia",
      posologyTypes: {
        Compresse: "Compresse",
        Capsule: "Capsule",
        Gocce: "Gocce",
        Inalazioni: "Inalazioni",
        Buste: "Buste",
        Supposte: "Supposte",
        Scatole: "Scatole",
        Cerotti: "Cerotti",
        Fiale: "Fiale",
        Fleboclisi: "Fleboclisi",
        Ovuli: "Ovuli",
        Sacche: "Sacche",
        Flaconi: "Flaconi",
        Confezioni: "Confezioni",
        Kilogrammi: "Kilogrammi",
        Kit: "Kit",
        Millilitri: "Millilitri",
        Milligrammi: "Milligrammi"
      },
      posologyVias: {
        Orale: "Orale",
        Transdermica: "Transdermica",
        Nasale: "Nasale",
        Endovena: "Endovena",
        Intramuscolo: "Intramuscolo",
        Oftalmica: "Oftalmica",
        Rettale: "Rettale",
        Uretale: "Uretale",
        Vaginale: "Vaginale",
        Sottocute: "Sottocute"
      },
      everyUms: {
        0: "mesi",
        1: "settimane",
        2: "giorni"
      },
      everyPosologyTypes: {
        0: "dì",
        1: "ore",
        2: "bisogno"
      },
      everyPosologyUms: {
        1: "ore",
        2: "giorni"
      },
      successSalvataggio: "Nuova terapia salvata",
      erroreSalvataggio: "Si è verificato un errore durante il salvataggio",
      erroreGenerico: "Si è verificato un errore."
    },
    AccessLogs: {
      titolo: "Attività registrate sul tuo profilo sanitario",
      mese: "mese",
      anno: "Anno",
      nessunAccessoMese: "Nessuna attività nel mese selezionato.",
      nessunAccessoAnno: "Nessuna attività nell'anno selezionato.",
      nessunaAzione: "Nessuna azione nel periodo selezionato",
      erroreNote: "Non è stato possibile recuperare le note",
      filtro_elementi: "Elementi per pagina",
      take_label: "Elementi per pagina",
      day_label: "Giorno",
      month_label: "Mese",
      year_label: "Anno",
      tutti_giorni: "Tutti",
      opzione_elementi: "Mostra {count} elementi",
      azione_label: "Attività registrata",
      data_label: "Data e ora",
      azienda_label: "Struttura",
      operatore_sconosciuto: "Operatore non disponibile",
      company_missing: "Dato non disponibile",
      azione_sconosciuta: "Attività non specificata",
      mesi: {
        "01": "gennaio",
        "02": "febbraio",
        "03": "marzo",
        "04": "aprile",
        "05": "maggio",
        "06": "giugno",
        "07": "luglio",
        "08": "agosto",
        "09": "settembre",
        10: "ottobre",
        11: "novembre",
        12: "dicembre"
      }
    },
    nessunaImpostazione: "Nessuna impostazione per questa utenza",
    UserModule: {
      password_reimpostata: "Password reimpostata!",
      password_attuale_errata: "Password attuale errata. Se non ricordi la password, esegui la procedura di recupero."
    },
    AccessoEPermessi: {
      datiAccesso: "Dati di Accesso",
      modificaPasswordTemporanea: "Modifica la tua password temporanea",
      passwordScaduta: "La tua password è scaduta: aggiornala per proseguire.",
      username: "Username",
      password: "Password",
      cambiaPassword: "Cambia password",
      terminiEPrivacy: "Termini e Condizioni e Informativa Privacy",
      visioneTermini: "Hai preso visione dei",
      revocaTermini: "Hai revocato il consenso a",
      titoloTermini: "Termini e Condizioni d'uso del servizio",
      modifica: "Modifica",
      visionePrivacy: "Hai preso visione dell'",
      revocaPrivacy: "Hai revocato il consenso a",
      titoloPrivacy: "Informativa Privacy",
      visionati1341: "Hai espressamente preso visione, ai sensi dell'articolo 1341 e ss c.c., delle previsioni di cui agli articoli 2, 7, 8, 10, 12 dei presenti del",
      revocati1341: "Hai revocato il consenso agli articoli 2, 7, 8, 10, 12 dei presenti del",
      acconsentoComunicazioni: "Hai acconsentito alla ricezione di comunicazioni commerciali per finalità promozionali come da",
      nonAcconsentoComunicazioni: "Non hai acconsentito alla ricezione di comunicazioni commerciali per finalità promozionali come da",
      titleConsensoComunicazioni: "Consenso comunicazioni commerciali",
      acconsento: "Acconsento alla ricezione di comunicazioni commerciali per finalità promozionali come da Informativa Privacy",
      nonAccetto: "Non accetto",
      annulla: "Annulla",
      salva: "Salva modifiche",
      titleModificaPassword: "Modifica la tua password",
      passwordAttuale: "Password Attuale*",
      placeholderAttuale: "Password attuale...",
      nuovaPassword: "Password*",
      confermaPassword: "Conferma password*",
      placeholderConferma: "Conferma password...",
      requisitiPassword: "La password non può includere il nome né il cognome e deve contenere almeno 8 caratteri, di cui almeno un numero, una maiuscola, una minuscola ed un carattere speciale. Deve essere diversa da quella attuale e dalle ultime {count} utilizzate.",
      tooltipCaratteri: "Devi usare almeno un carattere tra ! @ # $ % ^ & * ) ( + = . _ -",
      carattereSpeciale: "carattere speciale",
      passwordDiversa: "La nuova password deve essere diversa da quella attuale.",
      passwordGiaUtilizzata: "La nuova password deve essere diversa da quella attuale e dalle ultime {count} utilizzate.",
      annullaOperazione: "Annulla operazione",
      confermaModifica: "Conferma modifica",
      siRevoca: "Sì, revoca permesso",
      noAnnulla: "No, annulla",
      revocaNecessaria: "Il consenso è necessario per la fruizione della piattaforma. Revocando il consenso, non potrai più utilizzare le funzionalità della piattaforma.",
      desideriRevoca: "Desideri procedere con la revoca del consenso?",
      revoca: {
        data_consense: "Vuoi revocare il consenso a Termini e Condizioni d'uso del servizio?",
        share_consense: "Vuoi revocare il consenso agli articoli 2, 7, 8, 10, 12 dei presenti del Termini e Condizioni d'uso",
        charge_consense: "Vuoi revocare il consenso per l'Informativa Privacy?"
      },
      successModifica: "Modifiche effettuate con successo",
      erroreModifica: "Non è stato possibile effettuare la modifica",
      modificaPasswordTemp: "Devi ancora modificare la tua password temporanea",
      passwordScadutaCambio: "La tua password è scaduta e deve essere cambiata"
    },
    ShowUserCode: {
      codice_utente: "Codice utente",
      descrizione_codice: "Il tuo codice utente ti permette di essere identificato in modo sicuro da altri utenti in piattaforma.",
      mostra: "Mostra",
      nascondi: "Nascondi",
      codice: "codice",
      etichetta_codice: "Il tuo codice utente:",
      istruzioni_caregiver: "Mostra questo codice al tuo caregiver affinché possa trovarti ed inserirti nella sua lista di assistiti.",
      nota_validita: "Nota: questo codice sarà <u>valido fino alla mezzanotte di oggi</u>.",
      errore_codice: "Non è stato possibile recuperare il codice",
      codice_copiato: "Codice copiato!",
      copia_codice: "Copia codice",
      button_label: "utente"
    },
    NotificationChannels: {
      accessi_notifiche: "Accessi e Notifiche",
      descrizione_accessi: "Visualizza e gestisci i tuoi accessi, e scegli quali notifiche ricevere nei canali di Concura.",
      notifiche_email1: "Notifiche Email",
      consenso_email: "Hai acconsentito alla ricezione di notifiche via e-mail come indicato nell'",
      no_consenso_email: "Non hai acconsentito alla ricezione di notifiche via e-mail come indicato nell'",
      informativa_privacy: "Informativa Privacy",
      modifica: "Modifica",
      ricezione_notifiche: "Ricezione notifiche",
      consent_push: "Concedi consenso alla ricezione di notifiche push per ricevere notifiche in app",
      canale_telegram: "Canale Telegram",
      ricezione_stato: "Ricezione notifiche",
      attiva: "attiva",
      disattivata: "disattivata",
      rimuovi_accesso: "Rimuovi questo accesso",
      nessun_accesso: "Nessun accesso Telegram attivo",
      accedi_telegram: "Accedi su Telegram!",
      elimina_accesso: "Elimina accesso",
      annulla: "No, annulla",
      conferma: "Sì, conferma",
      vuoi_rimuovere: "Vuoi rimuovere l'accesso via",
      accesso_da: "da",
      modifica_stato: "Modifica stato ricezione notifiche",
      vuoi: "Vuoi",
      notifiche_messenger: "la ricezione di notifiche via",
      notifiche_email: "la ricezione di notifiche via email?",
      email_question: "Vuoi {azione} le notifiche email?",
      attivare: "attivare",
      disattivare: "disattivare",
      da: "da",
      conferma_operazione: "Conferma operazione",
      consenso_email_title: "Consenso ricezione email",
      acconsento_email: "Acconsento alla ricezione di notifiche via e-mail come indicato nell'",
      non_accetto: "Non accetto",
      salva_modifiche: "Salva modifiche",
      errore_accessi: "Non è stato possibile recuperare gli accessi",
      accesso_eliminato: "Accesso eliminato con successo",
      errore_eliminazione: "Non è stato possibile eliminare l'accesso",
      modifiche_successo: "Modifiche effettuate con successo",
      errore_modifiche: "Non è stato possibile effettuare la modifica",
      notifiche_push: "Notifiche Push"
    },
    PermessiSchedaPaziente: {
      titolo: "Visualizzazione Scheda Paziente",
      descrizione: "Scegli quali sezioni della scheda paziente desideri visualizzare. Le sezioni non selezionate non saranno visibili nel profilo sanitario del paziente.",
      archivio_sanitario: "Archivio Sanitario",
      patologie: "Patologie",
      terapie: "Terapie",
      anamnesi: "Anamnesi",
      note: "Note",
      notifiche: "Notifiche Paziente",
      alert: "Alert Paziente",
      dispositivi: "Dispositivi",
      prenotazioni: "Prenotazioni",
      piani_terapeutici: "Piani Terapeutici",
      referti: "Referti",
      non_disponibile: "Non disponibile",
      nessun_permesso: "Nessun permesso di visualizzazione disponibile per il tuo ruolo.",
      salva: "Salva preferenze",
      salvataggio_ok: "Preferenze salvate con successo.",
      salvataggio_errore: "Errore durante il salvataggio delle preferenze.",
      pss: "Profilo Sanitario Sintetico",
    },
    StatoSottoscrizioniProfilo: {
      stato_profilo: "Stato Profilo",
      sottoscrizione_attesa: "Sottoscrizione in attesa di pagamento:",
      mesi: "mesi",
      acquista: "Acquista",
      sottoscrizione_attiva: "Sottoscrizione attiva:",
      nessuna_sottoscrizione: "Nessuna sottoscrizione attiva.",
      vai_acquisti: "Vai agli acquisti",
      conferma_operazione: "Conferma operazione",
      annulla: "No, annulla",
      conferma: "Sì, conferma",
      sei_sicuro_attivare: "Sei sicuro di voler attivare il servizio di monitoraggio per",
      testo_attivazione: `
		Con questa operazione verrà avviato il processo di attivazione della
		sottoscrizione al servizio di monitoraggio: il paziente verrà assegnato
		ad un operatore del Centro Servizi che lo guiderà nella procedura di
		acquisto del servizio. <br />
		Inoltre, se ancora non impostato, dopo aver confermato l'operazione
    potrai selezionare, tra le opzioni disponibili, un percorso di cura
    idoneo alle esigenze del paziente; diversamente, verrà attivato il
    monitoraggio "standard" dei principali parametri<br />
    Per il monitoraggio dei principali parametri verranno impostati i
    valori-soglia e le frequenze di rilevazione di default.
  `,
      profilo_sospeso: "Profilo sospeso correttamente.",
      errore_operazione: "Non è stato possibile completare l'operazione.",
      attivazione_successo: "Attivazione eseguita correttamente!"
    },
    QrSubscriptionCard: {
      titolo: "La tua Tessera Digitale",
      membro_premium: "Membro Premium",
      valido_fino: "Valida fino al",
      si_rinnova_il: "Si rinnova il",
      scansiona_qr: "Scansiona il codice QR per verificare la validità",
      abbonamento_attivo: "Abbonamento Attivo",
      in_attivazione: "In Attivazione",
      in_attesa_pagamento: "In attesa di pagamento",
      footer_info: "Tessera digitale verificabile",
      aria_card: "Tessera digitale della sottoscrizione",
      scarica_pdf: "Scarica PDF",
      invia_email: "Invia email",
      invia_email_paziente: "Invia al paziente",
      email_inviata_te: "Email inviata alla tua casella di posta",
      email_inviata_paziente: "Email inviata al paziente",
      errore_invio_email: "Errore durante l'invio dell'email",
      throttle_email: "Attendi ancora {seconds} secondi prima di inviare un'altra email"
    },
    SubscriptionVerify: {
      caricamento: "Verifica in corso...",
      valido_titolo: "Sottoscrizione Valida",
      valido_sottotitolo: "Questa sottoscrizione è attiva e verificata",
      pending_titolo: "Sottoscrizione In Attivazione",
      pending_sottotitolo: "Questa sottoscrizione è in attesa di pagamento",
      scaduto_titolo: "Sottoscrizione Scaduta",
      scaduto_sottotitolo: "Questa sottoscrizione non è più attiva",
      non_trovato_titolo: "Sottoscrizione Non Trovata",
      non_trovato_sottotitolo: "Il codice QR non corrisponde a nessuna sottoscrizione valida",
      intestatario: "Intestatario",
      piano: "Piano",
      valido_fino: "Valida fino al",
      si_rinnova_il: "Si rinnova il",
      scaduto_il: "Scaduta il",
      verificato: "Verificata",
      in_attivazione: "In attivazione",
      footer_info: "Pagina di verifica ufficiale",
      aria_valido: "Sottoscrizione valida e verificata",
      aria_pending: "Sottoscrizione in attesa di attivazione",
      aria_scaduto: "Sottoscrizione scaduta",
      aria_non_trovato: "Sottoscrizione non trovata"
    },
    PercorsoCuraPaziente: {
      percorso_di_cura: "Percorso di cura",
      modifica_percorso: "Modifica percorso",
      nessun_percorso: "Nessun percorso di cura selezionato",
      seleziona_percorso: "Seleziona percorso",
      label_percorso: "Percorso di cura*",
      scegli: "scegli",
      dettagli_per: "Dettagli percorso per",
      piano_include: "Il piano include:",
      teleconsulti: "Teleconsulti",
      programmati_ogni: "programmati ogni",
      questionari: "Questionari e valutazioni",
      ogni: "ogni",
      monitoraggio_parametri: "Monitoraggio dei parametri",
      dispositivi_indossabili: "Dispositivi indossabili suggeriti",
      annulla: "Annulla",
      modifica_percorso_di_cura: "Modifica percorso di cura",
      seleziona_percorso_di_cura: "Seleziona percorso di cura",
      modal_descrizione_modifica: "Modifica il percorso di cura del paziente.",
      modal_descrizione_selezione: "Seleziona il percorso di cura adeguato alle esigenze del paziente.",
      conferma_modifica: "Conferma modifica",
      conferma_selezione: "Conferma selezione",
      percorso_aggiornato: "Percorso di cura aggiornato",
      errore_lista_piani: "Non è stato possibile prelevare la lista dei piani disponibili.",
      errore_operazione: "Non è stato possibile completare l'operazione.",
      ogni_giorno: "ogni giorno"
    },
    EliminaProfilo: {
      titolo: "Elimina Profilo",
      sottotitolo: "Elimina definitivamente la tua utenza",
      bottone_elimina: "Elimina il mio profilo",
      domanda_conferma: "Sei sicuro di voler eliminare il tuo profilo?",
      testo_conferma: `
        Se elimini il tuo profilo non potrai più accedere alla piattaforma ed
        usufruire dei servizi offerti. <br />
        L'operazione è irreversibile, una volta confermata l'eliminazione non
        potrai più tornare indietro.
        `,
      title_conferma: "Conferma Operazione",
      ok_elimina: "Sì, elimina",
      annulla: "No, annulla"
    },
    AnagraficaComponent: {
      profilo: "Profilo",
      modifica: "Modifica",
      scegli_immagine: "Scegli immagine",
      elimina: "Elimina",
      carica_immagine: "Carica immagine",
      titolo: "Titolo",
      titolo_placeholder: "Sig...",
      nome: "Nome*",
      nome_placeholder: "Nome...",
      cognome: "Cognome*",
      cognome_placeholder: "Cognome...",
      data_nascita: "Data di nascita*",
      genere: "Genere",
      uomo: "uomo",
      donna: "donna",
      codice_fiscale: "Codice fiscale*",
      codice_fiscale_placeholder: "Codice fiscale...",
      tessera_sanitaria: "Numero Tessera Sanitaria",
      tessera_sanitaria_placeholder: "Numero tessera...",
      nazione_nascita: "Nazione di nascita*",
      medico_base: "Medico di base",
      medico_base_placeholder: "Medico di base...",
      asl: "Asl/Asp/Ats di riferimento",
      scegli_asl: "Scegli azienda sanitaria locale",
      asl_placeholder: "Asl/Asp/Ats di riferimento...",
      id_albo: "ID Iscrizione Albo",
      id_albo_doppio: "ID Iscrizione Albo**",
      id_albo_placeholder: "ID ordine...",
      albo_number: "Numero albo",
      albo_number_placeholder: "Es. 12345",
      albo_province: "Provincia",
      seleziona_provincia_albo: "Seleziona Provincia",
      seleziona_tipo_albo: "Seleziona ordine",
      albo_incompleto: "Se inserisci il numero albo, seleziona anche la provincia",
      specializzazione: "Specializzazione",
      specializzazione_placeholder: "Specializzazione medica...",
      annulla: "Annulla",
      salva: "Salva",
      residenza: "Residenza",
      regione: "Regione*",
      regione_placeholder: "Regione...",
      seleziona_regione: "Seleziona Regione",
      provincia: "Provincia*",
      provincia_placeholder: "Provincia...",
      seleziona_provincia: "Seleziona Provincia",
      comune: "Comune*",
      comune_placeholder: "Comune...",
      seleziona_comune: "Seleziona Comune",
      indirizzo: "Indirizzo e numero civico*",
      indirizzo_placeholder: "Indirizzo...",
      cap: "CAP*",
      cap_placeholder: "CAP...",
      contatti: "Contatti",
      telefono: "Numero di telefono",
      telefono_placeholder: "Telefono...",
      telefono_domicilio: "Telefono Domicilio",
      telefono_domicilio_placeholder: "Telefono domicilio...",
      telefono_riserva: "Telefono di Riserva",
      telefono_riserva_placeholder: "Telefono di riserva...",
      torna_verifica: "Torna alla verifica",
      conferma_eliminazione: "Conferma eliminazione",
      conferma: "Sì, conferma",
      domanda_eliminazione_immagine: "Confermi di voler eliminare l'immagine del profilo?",
      immagine_eliminata_successo: "Immagine del profilo eliminata correttamente",
      errore_eliminazione: "Errore nell'eliminazione della nota",
      immagine_caricata_successo: "Immagine del profilo caricata correttamente",
      errore_caricamento: "Errore nel caricamento dell'immagine del profilo",
      telefono_non_valido: "Numero di telefono non valido",
      includere_sigla: "**Includere la sigla provincia",
      title_sig: "Sig.",
      title_sigra: "Sig.ra",
      title_dott: "Dott.",
      title_dottssa: "Dott.ssa",
      tipo_medici: "Medici",
      tipo_dentisti: "Dentisti",
      tipo_farmacisti: "Farmacisti",
      tipo_infermieri: "Infermieri",
      tipo_biologi: "Biologi"
    },
    BancaDati: {
      modifica_libreria: "Modifica libreria",
      imposta_preferito: "Imposta preferito",
      elimina_libreria: "Elimina libreria"
    },
    SessionLengthSetter: {
      timeout_sessione: "Timeout Sessione",
      descrizione: "Stabilisci quando far scadere la sessione. A sessione scaduta, verrai automaticamente sloggato.",
      sessione_logout: "La sessione si chiude con il logout",
      sessione_scade: "La sessione scade dopo",
      minuti_inattivita: "minuti di inattività",
      annulla: "Annulla",
      salva_modifiche: "Salva modifiche",
      successo: "Timeout sessione aggiornato con successo",
      errore: "Errore durante l'aggiornamento del timeout della sessione",
      modifica_timeout: "Modifica timeout sessione"
    },
    StoricoAppuntamentiAsl: {
      apri_chat: "Apri chat messaggi"
    },
    CompilatoreQuestionarioInBlocks: {
      naviga_blocchi: "Navigazione tra i blocchi del questionario",
      vai_al_blocco: "Vai al blocco {blocco}",
      scorri_sinistra: "Scorri i blocchi verso sinistra",
      scorri_destra: "Scorri i blocchi verso destra"
    },
    CompilaQuestionarioCittadino: {
      questionario_prenotazione: "Questionario per la prenotazione prevista per il",
      ore: "ore",
      consenso: "Ho letto l'informativa e do il mio consenso",
      procedi: "Procedi",
      operazione_completata: "Operazione completata.",
      vai_agenda: "Vai all'agenda",
      vai_profilo_sanitario: "Vai al profilo sanitario",
      questionario_gia_compilato: "Hai già compilato il questionario.",
      errore_attivita: "Non è stato possibile recuperare le attività",
      questionario_inviato: "Questionario inviato correttamente.",
      errore_invio: "Non è stato possibile inviare il questionario",
      questionario_non_disponibile: "Questo questionario non è più disponibile, è scaduto o è già stato compilato."
    },
    FillScoreSurveyCittadino: {
      consenso: "Ho letto l'informativa e do il mio consenso",
      procedi: "Procedi",
      operazione_completata: "Operazione completata.",
      vai_agenda: "Vai all'agenda",
      vai_profilo_sanitario: "Vai al profilo sanitario",
      questionario_gia_compilato: "Hai già compilato il questionario.",
      errore_attivita: "Non è stato possibile recuperare le attività",
      questionario_inviato: "Questionario inviato correttamente.",
      errore_invio: "Non è stato possibile inviare il questionario"
    },
    NuovaTerapiaAssistito: {
      pazienti: "Pazienti",
      nessun_paziente: "Nessun Paziente selezionato",
      profilo_sanitario: "Profilo sanitario",
      riepilogo: "Riepilogo",
      scarica_promemoria: "Scarica promemoria",
      torna_profilo: "Torna al profilo sanitario",
      errore_scaricamento: "Non è stato possibile scaricare il promemoria"
    },
    PianoTerapeuticoCittadino: {
      indietro: "Indietro",
      piano_terapeutico: "Piano terapeutico",
      caricato_in_data: "Caricato in data:",
      validita: "Validità:",
      stato: "Stato:",
      farmacia: "Farmacia",
      telefono: "Telefono",
      indirizzo: "Indirizzo",
      mostra_piano: "Mostra piano terapeutico",
      nascondi_piano: "Nascondi piano terapeutico",
      caricamento: "Caricamento in corso...",
      farmaci_previsti: "Farmaci previsti dal Piano Terapeutico",
      consegnato: "Consegnato",
      quantita: "Quantità:",
      pacchetti_programmati: "Pacchetti consegna programmati per il Piano Terapeutico",
      pacchetto: "Pacchetto",
      stato_pacchetto: "Stato pacchetto:",
      farmaci_contenuti: "Farmaci contenuti nel pacchetto",
      conf: "conf.",
      scadenza: "scad.",
      lotto: "lotto",
      piano_non_trovato: "Piano non trovato",
      errore_info: "non è stato possibile prelevare le informazioni richieste",
      scegli: "scegli...",
      attesa_autorizzazione: "In attesa di autorizzazione",
      classe_c: "classe C",
      no_ssn: "Non a carico SSN",
      autorizzato_classe_a: "autorizzato classe A",
      rimborsabile: "Autorizzato come rimborsabile",
      autorizzato_dpc: "autorizzato DPC",
      per_conto: "Autorizzato per la dispensazione per conto",
      autorizzato_dd: "autorizzato DD",
      distribuzione_diretta: "Autorizzato per la distribuzione diretta",
      etichetta: "Etichetta",
      toggle_dettagli: "Mostra/nascondi dettagli piano"
    },
    PianoTerapeuticoDetailOperatoreAsl: {
      toggle_dettagli: "Mostra/nascondi dettagli piano",
      toggle_info: "Mostra/nascondi informazioni",
      modifica_validita: "Modifica date validità"
    },
    FamiliariView: {
      genere: "Genere",
      data_nascita: "Data di nascita",
      non_indicata: "Non indicata",
      vai_profilo_sanitario: "Vai al profilo sanitario",
      disabilita: "Abilita",
      abilitata: "Abilitata",
      vuoi_abilitare: "Vuoi abilitare questo caregiver?",
      vuoi_disabilitare: "Vuoi disabilitare questo caregiver?",
      abilita_caregiver: "Abilita caregiver",
      disabilita_caregiver: "Disabilita caregiver",
      errore_recupero_informazioni: "Errore nel recupero delle informazioni",
      caregiver_abilitato: "Caregiver abilitato correttamente",
      errore_operazione: "Errore durante l'operazione",
      caregiver_disabilitato: "Caregiver disabilitato correttamente"
    },
    Routes: {
      cittadino_home: "Home Cittadino",
      familiari: "I tuoi familiari",
      appuntamenti: {
        prestazione: "Visite e Prestazioni",
        prodotto: "Farmaci",
        teleconsulto: "Teleconsulti"
      },
      agenda: "La tua agenda",
      il_tuo_consulto: "Il tuo consulto",
      circolo_di_cura: "Il tuo circolo di cura",
      sottoscrizioni_paziente: "Acquisti e Sottoscrizioni",
      progetti_cittadino: "Blog",
      profilo_sanitario: "Profilo sanitario",
      profilo_cittadino: "Dati Anagrafici",
      impostazioni: "Impostazioni",
      guida_cittadino: "Guida",
      completa_questionario: "Completa il questionario",
      score_questionario: "Completa il questionario",
      nuova_terapia_assistito: "Nuova terapia assistito",
      acquisto: "Acquisto",
      pagina_non_trovata: "Pagina non trovata",
      verifica_numero: "Verifica il tuo numero",
      verifica_email: "Verifica la tua email",
      teleconsulti: {
        tcemergenza: "Teleconsulto Rapido",
        pediatrico: "Teleconsulto Pediatrico",
        specialistico: "Teleconsulto Specialistico",
        teleconsulto: "Teleconsulti"
      }
    },
    // Titoli delle pagine dell'admin, mostrati nell'header (AdminTopHeader)
    AdminRoutes: {
      dashboard: "Dashboard di amministrazione",
      servizi: "Gestione servizi",
      servizio_teleconsulto: "Servizio di teleconsulto",
      servizio_prenotazioni: "Servizio di prenotazione",
      aziende: "Gestione aziende",
      aziende_portale: "Aziende del portale",
      aziende_pubbliche: "Aziende del sito pubblico",
      nuova_azienda: "Nuova azienda",
      dettaglio_azienda: "Scheda azienda",
      utenti: "Gestione utenti",
      contatti: "Contatti pubblici",
      registrazioni: "Registrazioni",
      prenotazioni: "Gestione prenotazioni",
      sottoscrizioni: "Sottoscrizioni",
      voucher: "Voucher sottoscrizioni",
      pagamenti: "Pagamenti della piattaforma",
      screening: "Screening",
      raccolte: "Raccolte",
      questionari: "Questionari",
      sessioni: "Sessioni",
      piani_terapeutici: "Piani terapeutici",
      piano_terapeutico: "Piano terapeutico",
      alerts: "Alert di sistema",
      logs: "Log di sistema",
      reports: "Reports",
      impostazioni: "Impostazioni di sistema",
    },
    ChatPazientiWhitelist: {
      titolo: "Chat medico-paziente - gestione whitelist",
      sottotitolo: "Abilitazione e monitoraggio dei canali di messaggistica asincrona fra pazienti e professionisti sanitari.",
      nuovo_canale: "Abilita nuovo canale",
      filtra_stato: "Filtra per stato",
      aggiorna: "Aggiorna elenco",
      nessun_canale: "Nessun canale di chat con i filtri selezionati.",
      caricamento: "Caricamento dei canali in corso",
      stato_tutti: "Tutti gli stati",
      stato_solo_attivi: "Solo canali attivi",
      stato_solo_revocati: "Solo canali revocati",
      col_paziente: "Paziente",
      col_operatore: "Medico o operatore",
      col_stato: "Stato",
      col_data: "Data abilitazione",
      col_azioni: "Azioni",
      stato_attivo: "Attivo",
      stato_revocato: "Revocato",
      azione_visualizza: "Visualizza la chat clinica con il paziente",
      azione_archivia: "Archivia la trascrizione nel profilo sanitario",
      azione_revoca: "Revoca il canale",
      azione_riattiva: "Riattiva il canale",
      conferma_revoca_titolo: "Revoca del canale",
      conferma_revoca_ok: "Revoca",
      conferma_revoca_testo: "La chat con {paziente} viene revocata: non sarà più possibile inviare nuovi messaggi. Lo storico resta consultabile.",
      paziente: "Paziente",
      revoca_riuscita: "Canale revocato",
      revoca_fallita: "Non è stato possibile revocare il canale",
      caricamento_fallito: "Non è stato possibile caricare i canali della struttura",
      riattivazione_riuscita: "Canale riattivato",
      riattivazione_fallita: "Non è stato possibile riattivare il canale",
      archiviazione_riuscita: "Trascrizione archiviata nell'archivio sanitario del paziente",
      archiviazione_titolo: "Archiviazione completata",
      archiviazione_fallita: "Non è stato possibile archiviare la trascrizione",
      errore: "Errore",
    },
    ModalChatPaziente: {
      paziente: "Paziente",
      titolo_operatore_proprie: "Le mie conversazioni",
      titolo_cittadino: "Chat Clinica con i tuoi Medici",
      titolo_con_paziente: "Chat Clinica con {nome}",
    },
    ModalNuovoCanale: {
      titolo: "Abilita la chat con il paziente",
      conferma: "Abilita la chat",
      label_operatore: "Operatore sanitario (medico o infermiere)",
      descrizione_operatore: "Il professionista sanitario abilitato al servizio",
      descrizione_operatore_tu: "La chat si apre a tuo nome. Per aprirla a nome di un collega serve chi gestisce le chat della struttura.",
      scegli_operatore: "Seleziona un operatore",
      label_paziente: "Paziente",
      descrizione_paziente: "Ricerca per cognome, nome o codice fiscale",
      paziente_dalla_scheda: "Apri la scheda del paziente e premi il bottone della chat: lì il paziente è già scelto.",
      placeholder_ricerca: "Cerca paziente",
      cerca: "Cerca",
      scegli_paziente: "Seleziona il paziente trovato",
      caricamento: "Caricamento in corso",
      nota: "L'abilitazione consente lo scambio asincrono di messaggi e documenti protetti tra il paziente e il medico designato.",
      errore_operatori: "L'elenco dei medici non si è caricato. Chiudi la finestra e riprova.",
      canale_creato: "Canale di chat abilitato",
      titolo_successo: "Operazione riuscita",
      errore_creazione: "Non è stato possibile abilitare il canale di chat",
      titolo_errore: "Errore",
    },
    PatientChatSection: {
      titolo_cittadino: "Chat con i tuoi medici",
      titolo_operatore: "Messaggistica e chat clinica",
      sottotitolo_cittadino: "Comunicazione diretta e sicura con i professionisti sanitari abilitati.",
      sottotitolo_operatore: "Storico e gestione delle conversazioni dirette con il paziente.",
      abilita_medico: "Abilita nuovo medico",
      caricamento: "Caricamento della chat in corso",
      nessun_canale: "Nessun canale di chat abilitato",
      nessun_canale_operatore: "Abilita la chat per scambiare messaggi e documenti con questo paziente.",
      nessun_canale_operatore_proprie: "Una conversazione si apre dalla scheda del paziente, con il bottone della chat.",
      nessun_canale_cittadino: "Nessun medico ha ancora abilitato un canale di messaggistica per il tuo profilo.",
      abilita_ora: "Abilita la chat",
      elenco_cittadino: "I tuoi medici",
      elenco_operatore: "Canali chat",
      revocato: "Revocato",
      archivia: "Archivia nel profilo",
      archivia_tooltip: "Genera la trascrizione in PDF e la archivia nell'archivio sanitario",
      nessun_messaggio: "Nessun messaggio in questa conversazione.",
      inizia_a_scrivere: "La discussione si avvia con il primo messaggio.",
      allegato: "Allegato",
      file: "file",
      dimensione_file: "({kb} KB, massimo 4 MB)",
      rimuovi_allegato: "Rimuovi allegato",
      allega_tooltip: "Allega un documento o una immagine, massimo 4 MB",
      placeholder_cittadino: "Scrivi un messaggio al medico",
      placeholder_operatore: "Scrivi un messaggio clinico al paziente",
      invia: "Invia",
      allegati_consentiti: "Allegati consentiti: PDF, immagini e referti, fino a 4 MB",
      canale_revocato: "Canale revocato.",
      seleziona_canale: "La conversazione si apre selezionando un canale.",
      file_troppo_grande: "Il file selezionato supera la dimensione massima di 4 MB.",
      file_troppo_grande_titolo: "File troppo grande",
      invio_fallito: "Non è stato possibile inviare il messaggio",
      archiviazione_riuscita: "Trascrizione della chat archiviata nell'archivio sanitario",
      archiviazione_titolo: "Archiviazione completata",
      archiviazione_fallita: "Non è stato possibile archiviare la trascrizione",
      errore: "Errore",
      titolo_medico: "Dott. {nome}",
      operatore: "Operatore",
      paziente: "Paziente",
      download_fallito: "Non è stato possibile scaricare l'allegato",
      download_fallito_titolo: "Errore nel download",
    },
    NavigationCittadino: {
      chat_medico: "Chat con il medico",
      logo_alt: "Logo applicazione - Torna alla home",
      toggle_menu: "Apri o chiudi il menu di navigazione",
      logout_confirm_title: "Confermi di voler uscire dall'area privata?",
      logout_confirm_ok: "Sì, esci",
      prenotazioni: "Prenotazioni",
      visite: "Visite e Prestazioni",
      farmaci: "Farmaci",
      teleconsulti: "Teleconsulti",
      rapido: "Rapido",
      pediatrico: "Pediatrico",
      specialistico: "Specialistico",
      familiari: "Familiari",
      tutti: "Tutti",
      nuovo: "Nuovo",
      blog: "Blog",
      profilo_sanitario: "Profilo Sanitario",
      circolo: "Circolo di Cura",
      gestione: "Gestione",
      strumenti: "Strumenti",
      report: "Report",
      acquisti: "Acquisti",
      sottoscrizioni: "Sottoscrizioni",
      storico: "Storico",
      agenda: "Agenda",
      pazienti: "Pazienti",
      impostazioni: "Impostazioni",
      consulta: "Consulta",
      guida: "Guida",
      accessibility: "Accessibilità",
      servizi: "SERVIZI",
      pagine: "PAGINE"
    },
    NotificationCenter: {
      title: "Notifiche",
      browserPermission: "Per ricevere notifiche è necessario autorizzarne la ricezione sul browser.",
      noNotifications: "Nessuna nuova notifica.",
      open_panel: "Apri pannello notifiche",
      close_panel: "Chiudi pannello notifiche"
    },
    PopupNotificationComponent: {
      action_aria: "Esegui azione notifica: {action}",
      fetch_error: "Non è stato possibile verificare la presenza di nuove notifiche popup",
      seen_error: "Non è stato possibile aggiornare lo stato della notifica popup"
    },
    CallSupportModal: {
      chiama: "Chiama il numero verde",
      chiama_per_prenotare: "Per prenotare chiama il numero verde",
      operatori: "I nostri operatori sono disponibili dal lunedì al venerdì dalle ore 9:00 alle ore 18:00",
      modal_label: "Finestra supporto telefonico"
    },
    CallMailSupportButtons: {
      call_support: "Chiama il supporto al numero verde 800770272",
      email_support: "Invia email al supporto"
    },
    PopupModal: {
      procedi: "Procedi",
      errore_invito: "non è stato possibile invitare il medico",
      success_grazie: "grazie per la tua risposta",
      errore_risposta: "non è stato possibile inviare la risposta"
    },
    LoginPage: {
      call_support: "Chiama il supporto",
      show_password: "Mostra password",
      hide_password: "Nascondi password",
      enter_with_spid: "Entra con SPID",
      enter_with_cie: "Entra con CIE"
    },
    RegisterPage: {
      call_support: "Chiama il supporto",
      codice_fiscale_facoltativo: "Codice Fiscale Operatore",
      placeholder_cf: "Codice fiscale",
      cf_formato_non_valido: "Formato non valido (16 caratteri: lettere e numeri)",
      cf_check_error: "Errore durante la verifica del codice fiscale",
      hide_password: "Nascondi password",
      show_password: "Mostra password",
      albo_incompleto: "Se inserisci il numero albo, seleziona anche la provincia"
    },
    NotFoundPage: {
      title: "Pagina non trovata",
      image_alt: "Illustrazione pagina non trovata"
    },
    EmailVerification: {
      logo_alt: "Logo applicazione"
    },
    Help: {
      logo_alt: "Logo applicazione"
    },
    NumberVerification: {
      logo_alt: "Logo applicazione"
    },
    PasswordRecovery: {
      logo_alt: "Logo applicazione"
    },
    PaymentOutcome: {
      logo_alt: "Logo applicazione"
    },
    RecoverPassword: {
      logo_alt: "Logo applicazione",
      show_password: "Mostra password",
      hide_password: "Nascondi password"
    },
    AccessoCie: {
      logo_alt: "Logo registrazione"
    },
    AccessoSpid: {
      logo_alt: "Logo registrazione"
    },
    CompanyCard: {
      select_company: "Seleziona {name}",
      toggle_info: "Mostra o nascondi dettagli struttura",
      add_favorite: "Aggiungi ai preferiti",
      remove_favorite: "Rimuovi dai preferiti"
    },
    ThresholdEditor: {
      modifica_soglia: "Modifica soglia",
      valore_min: "Valore minimo",
      valore_max: "Valore massimo",
      modifica: "Modifica",
      aggiungi: "Aggiungi"
    },
    SomministraCustomTeleconsultoSurvey: {
      compila_questionario: "Compila il questionario per il Teleconsulto",
      compilazione_obbligatoria: "(la compilazione è obbligatoria)",
      consenso_informativa: "Ho letto l'informativa e do il mio consenso",
      procedi: "Procedi",
      questionario_gia_compilato: "Hai già compilato il questionario.",
      vai_agenda: "Vai all'agenda",
      errore_recupero_attivita: "Non è stato possibile recuperare le attività",
      successo_questionario: "Questionario inviato correttamente.",
      errore_questionario: "Non è stato possibile inviare il questionario"
    },
    FillCustomTeleconsultoSurvey: {
      ok_procedi: "Ok, procedi",
      placeholder_scrivi: "Scrivi qui",
      torna_indietro: "Torna indietro",
      procedi: "Procedi",
      salta: "Salta",
      salva_immagine: "Salva Immagine"
    },
    AslSurveyUploader: {
      remove: "Rimuovi"
    },
    ConsenseComponent: {
      logo_alt: "Logo applicazione"
    },
    CompanyArchiveMain: {
      modifica_stato: "Modifica stato risorsa",
      elimina_risorsa: "Elimina risorsa",
      carica_nuovo_file: "Carica nuovo file",
      conferma_modifica: "Conferma modifica",
      elimina_file: "Elimina file"
    },
    CentriErogatoriCard: {
      mostra_info: "Mostra informazioni struttura"
    },
    ServiceStatusCentriErogatori: {
      conferma_operazione: "Conferma operazione"
    },
    ServiceStatus: {
      conferma_operazione: "Conferma operazione"
    },
    PrestazioniSanitariePerCentroErogatore: {
      modifica_prestazione: "Modifica {name}"
    },
    DettaglioCentroErogatore: {
      toggle_menu: "Espandi o comprimi menu servizi"
    },
    PromemoriaHomeV2: {
      apri_dettaglio: "Apri dettaglio {titolo}",
      apri_questionario: "Apri questionario {titolo}",
      da_compilare: "Da compilare",
      scade_il: "Scade il",
      previsto_il: "Previsto il",
      piano_di_cura: "Piano di cura {nome}",
      prenotazione: "Prenotazione",
      richiesta_operatore: "Richiesta operatore"
    },
    ProjectBannerCard: {
      aria_region: "Sezione iniziativa"
    },
    ProjectHomeBanner: {
      invio_riuscito: "Operazione completata"
    },
    ProjectFormModal: {
      invia: "Invia",
      campo_obbligatorio: "Compila i campi obbligatori"
    },
    PromemoriaQuestionariPaziente: {
      title: "Cosa deve fare il paziente",
      da_compilare: "Da compilare",
      sessione_da_compilare: "Sessione da compilare",
      programmato: "Programmato",
      previsto_il: "Previsto il",
      scade_il: "Scade il",
      somministra_aria: "Somministra il questionario {titolo} al paziente",
      somministra_sessione_aria: "Somministra la sessione {titolo} al paziente",
      promemoria_readonly_aria: "Promemoria: {titolo}",
      programmato_aria: "Questionario {titolo} programmato",
      stop_frequenza: "Interrompi frequenza",
      stop_frequenza_aria: "Interrompi la frequenza di {titolo}",
      stop_frequenza_title: "Interrompi frequenza",
      stop_frequenza_confirm: "Interrompi",
      stop_frequenza_testo_corrente: "Vuoi interrompere la frequenza di {titolo} da questo promemoria in poi?",
      stop_frequenza_dettaglio_corrente: "Questo promemoria e quelli successivi già presenti verranno annullati. Non verranno creati nuovi promemoria per questa frequenza.",
      stop_frequenza_testo_futura: "Vuoi interrompere la frequenza di {titolo}?",
      stop_frequenza_dettaglio_futura: "I promemoria già presenti restano disponibili. Non verranno creati nuovi promemoria per questa frequenza.",
      stop_frequenza_success: "Frequenza interrotta correttamente",
      stop_frequenza_error: "Non è stato possibile interrompere la frequenza",
      notifiche_programmate: "Notifiche programmate",
      notifica_canali: "Canali:",
      notifica_stato: "Stato:",
      notifica_aria: "Notifica prevista per {data}. Canali: {canali}. Stato: {stati}",
      altre_notifiche_aria: "Altre {count} notifiche: {dettagli}",
      canale_push: "push",
      canale_mail: "email",
      canale_sms: "SMS",
      canale_altro: "{channel}",
      canale_non_disponibile: "non disponibile",
      stato_pending: "in attesa",
      stato_planned: "programmata",
      stato_sent: "inviata",
      stato_skipped: "saltata",
      stato_failed: "fallita",
      stato_cancelled: "annullata",
      stato_altro: "{status}",
      stato_non_disponibile: "non disponibile"
    },
    PrestazioniSanitarie: {
      modifica_prestazione: "Modifica {name}",
      elimina_prestazione: "Elimina {name}"
    },
    ServiziCompany: {
      toggle_menu: "Espandi o comprimi menu servizi",
      configura: "Configura",
      configura_servizio: "Configura servizio {name}",
      titolo_configurazione_generico: "Configurazione servizio",
      titolo_configurazione_servizio: "Configurazione servizio {name}",
      nessun_contenuto_configurazione:
        "Nessun contenuto di configurazione disponibile per questo servizio"
    },
    AllegatiPrestazioni: {
      rimuovi: "rimuovi",
      rimuovi_allegato: "Rimuovi allegato {name}"
    },
    DayPlanner: {
      mese_precedente: "Vai al mese precedente",
      mese_successivo: "Vai al mese successivo",
      legenda_libero: "Disponibile",
      legenda_configurato: "Servizio attivo",
      legenda_da_aggiungere: "Da aggiungere",
      legenda_da_rimuovere: "Da rimuovere",
      legenda_chiuso: "Chiuso o festivo",
      data_passata: "Data passata",
      configurato_passato: "Servizio attivo, data passata",
      da_rimuovere: "Da rimuovere",
      giorni_configurati: "Giorni attivi nel mese",
      nessun_giorno_configurato: "Nessun giorno attivo in questo mese.",
      rimuovi_giorno: "Rimuovi {giorno}",
      annulla_rimozione: "Mantieni {giorno}",
      prenotabile_dal_al: "Prenotabile dal {dal} al {al}",
      prenotabile_dal: "Prenotabile dal {dal} fino al giorno stesso",
      prenotabile_fino_al: "Prenotabile da subito fino al {al}",
      prenotabile_sempre: "Prenotabile da subito fino al giorno stesso"
    },
    SettingOrari: {
      rimuovi_giorno: "Rimuovi orari di {giorno}",
      modifica_orari: "Modifica orari di {giorno}",
      duplica_giorno: "Duplica orari di {giorno}",
      nuova_fascia_oraria: "Nuova fascia oraria"
    },
    SettingServiceOrari: {
      rimuovi_giorno: "Rimuovi orari di {giorno}",
      modifica_orari: "Modifica orari di {giorno}",
      duplica_giorno: "Duplica orari di {giorno}",
      nuova_fascia_oraria: "Nuova fascia oraria",
      limite_minimo: "Inserisci un numero intero maggiore o uguale a 1"
    },
    FreeSubscription: {
      descrizione: "Sottoscrizione gratuita",
      dettaglio: '<p class="m-0">Prenotazione veloce per visite e prestazioni: 10€ </p><p class="m-0">Servizio di Televisita o Teleconsulto: 10€</p><p class="m-0">Prenotazione farmaci: 4€</p>'
    },
    app: {
      partita_iva: "Partita IVA:",
      termini_condizioni: "Termini e condizioni",
      informativa_privacy: "Informativa Privacy",
      note_rilascio: "Note di rilascio",
      note_rilascio_modal_label: "Finestra note di rilascio dell'applicazione",
      cookie_policy: "Cookie Policy",
      about: "About",
      about_label: "Apri finestra informazioni applicazione",
      about_modal_label: "Informazioni sull'applicazione",
      about_image_alt: "Logo e informazioni versione applicazione",
      vai_alla_guida: "Vai alla pagina di aiuto"
    },
    DownloadSurveyInfo: {
      stampa_informativa: "Stampa informativa"
    },
    UpdateNotesComponent: {
      title: "Aggiorna le tue note di prenotazione",
      description: "In questo spazio puoi inserire informazioni o comunicazioni rilevanti per questa specifica prenotazione.",
      newNote: "Nuova nota:",
      cancel: "Annulla",
      save: "Salva",
      updateError: "Non è stato possibile aggiornare le note",
      aria_edit: "Modifica note"
    },
    UnreadChatBadge: {
      unread_messages: "{count} messaggi non letti"
    },
    nexi: {
      esito: {
        OK: "Transazione completata correttamente",
        KO: "Transazione fallita",
        ANNULLO: "Transazione annullata",
        ERRORE: "Errore transazione",
        PEN: "Transazione pendente"
      },
      messaggi: {
        "Message OK": "Transazione autorizzata.",
        "Controllo CF": "Il PAN della carta è già associato ad altro codice Fiscale.",
        "Controllo PAN": "Al codice Fiscale indicato sono già associate un numero massimo di carta.",
        "Controllo BLACKLIST": "Transazione bloccata per regole blacklist.",
        "Controllo CF/PAN": "Errore sul controllo tra Codice Fiscale e PAN.",
        "Auth. Denied": "Transazione non autorizzata.",
        "Impossibile eseguire la Post di Notifica": "Annullamento per errore di notifica server to server.",
        "3D Secure annullato da utente": "Autenticazione 3D-Secure non completata o annullata.",
        "Carta non autorizzata causa applicazione regole BIN table": "Carta non autorizzata per regole BIN table.",
        "Problema 3DSecure": "Problema durante l'autenticazione 3D-Secure.",
        "expired card": "Carta scaduta o merchant non abilitato.",
        "Invalid merchant": "Merchant non abilitato o revocato.",
        "transaction not permitted": "Transazione non permessa.",
        "not sufficient funds": "Fondi insufficienti sulla carta.",
        "Technical problem": "Problema tecnico nei sistemi autorizzativi.",
        "Host not found": "Sistema autorizzativo non disponibile.",
        "Transazione chiusa per time-out": "Transazione chiusa per superamento del tempo.",
        "Controllo PAN/CONTRATTO": "PAN presente su altro contratto.",
        "Numero di tentativi di retry esaurito": "Numero massimo di tentativi superato.",
        "soft decline": "Richiesta autenticazione forte (SCA). Riprova.",
        "Transazione avvenuta correttamente": "Transazione completata con successo."
      }
    },
    aggiornata_successo: "Anagrafica aggiornata con successo!",
    common: {
      scegli: "Scegli"
    },
    ProfiloSanitarioSintetico: {
      titolo: "Profilo Sanitario Sintetico",
      salva: "Salva",
      salva_modifiche: "Salva modifiche",
      salvataggio_ok: "Profilo sanitario sintetico salvato",
      nessuna_sintesi: "Nessuna sintesi disponibile.",
      placeholder_scrivi: "Apri per scrivere il profilo sanitario sintetico del paziente.",
      apri_editor: "Apri PSS",
      apri_compila: "Apri e compila",
      apri_modifica: "Apri e modifica",
      espandi: "Apri e modifica",
      ultima_modifica: "Ultima modifica",
      placeholder_textarea: "Testo del profilo sanitario sintetico...",
      errore_caricamento: "Errore nel caricamento del PSS",
      errore_salvataggio: "Errore nel salvataggio del PSS",
      ultimo_dato_clinico: "Ultimo aggiornamento dati clinici",
      dati_aggiornati: "Dati paziente aggiornati rispetto al PSS",
      dati_clinici_raccolti: "Dati clinici raccolti",
      nessun_dato: "nessun dato",
    },
    PatientAnamnesi: {
      title: "Anamnesi",
      salva: "Salva",
      pulisci: "Pulisci",
      annulla: "Annulla",
      cerca: "Cerca",
      titoloConfermaEliminazione: "Conferma eliminazione",
      titoloConfermaPulizia: "Conferma pulizia",
      confermaPulizia: "Sì, pulisci",
      siProcedi: "Sì, procedi",
      noAnnulla: "No, annulla",
      testoConfermaEliminazione: "Sei sicuro di voler eliminare la nota",
      testoConfermaPulizia: 'Sei sicuro di voler pulire il campo "{campo}"?',
      spiegazioneInserimenti: "Le voci aggiunte con i pulsanti sopra vengono mostrate come badge. Il testo nel riquadro resta libero e viene salvato separatamente.",
      labelAllergie: "Allergie note, reazioni allergiche pregresse",
      labelEventiPregressi: "Eventi pregressi",
      labelInterventiOspedalizzazioni: "Interventi chirurgici e ospedalizzazioni",
      labelIntervento: "Interventi chirurgici",
      labelOspedalizzazioni: "Ospedalizzazioni",
      labelEventiAvversi: "Reazioni avverse ai farmaci",
      labelCondizioniNote: "Condizioni note in famiglia",
      gruppoCompilato: "Gruppo anamnestico compilato",
      nuovaNota: "Nuova nota {categoria}",
      nota: "Nota",
      erroreCaricamentoNote: "Errore durante il caricamento delle note",
      notaAggiornata: "Nota aggiornata correttamente",
      erroreAggiornamentoNota: "Errore durante l'aggiornamento della nota",
      notaCreata: "Nota creata correttamente",
      erroreCreazioneNota: "Errore durante la creazione della nota",
      notaEliminata: "Nota eliminata correttamente",
      erroreEliminazioneNota: "Errore durante l'eliminazione della nota",
      allergiePlaceholder: "Allergie alimentari, ambientali, tipo e gravità di reazioni allergiche pregresse...",
      pregressoPlaceholder: "Particolari eventi pregressi da segnalare...",
      interventoPlaceholder: "Interventi chirurgici eseguiti, data, struttura e dettagli utili...",
      ospedalizzazionePlaceholder: "Ospedalizzazioni precedenti, ricoveri, traumi importanti e dettagli utili...",
      eventiAvversiPlaceholder: "Effetti indesiderati, reazioni avverse a farmaci...",
      labelFamiliare: "Anamnesi familiare",
      familiarePlaceholder: "Patologie ereditarie o ricorrenti in famiglia, cause di decesso di parenti stretti...",
      labelStileVita: "Stile di vita",
      stileVitaPlaceholder: "Fumo, alcol, attività fisica, alimentazione, abitudini rilevanti...",
      labelVaccinazione: "Vaccinazioni",
      vaccinazionePlaceholder: "Storico vaccinale, richiami, vaccinazioni raccomandate non effettuate...",
      labelProtesi: "Protesi e impianti",
      protesiPlaceholder: "Dispositivi medici impiantati, protesi, pacemaker, impianti cocleari...",
      labelDonazioneOrgani: "Donazione organi",
      donazioneOrganiPlaceholder: "Stato consenso o dissenso alla donazione di organi e tessuti...",
      codiciAssociati: "Codici associati",
      nessunaVoceCodificata: "Nessuna voce codificata presente",
      eliminaVoce: "Elimina voce",
      eliminaVoceConNome: "Elimina voce {name}",
      aggiungiCodiceSezione: "Aggiungi codice per {section}",
      apriAzioneCodice: "Apri azione {action}",
      modalTitoloVoce: "Aggiungi codice per {section}",
      modalTitoloFallback: "Aggiungi codice",
      titoloEliminaVoce: "Conferma eliminazione voce",
      confermaEliminaVoce: "Elimina voce",
      salvaVoce: "Salva voce",
      cercaCatalogo: "Cerca nel catalogo",
      selezionaVoceCatalogo: "Seleziona una voce",
      erroreRicercaCatalogo: "Errore durante la ricerca nel catalogo",
      tabAggiungiFarmaco: "Aggiungi farmaco a cui il paziente è o è stato allergico",
      tabAggiungiAllergeneCodificato: "Aggiungi allergene codificato",
      tabInserisciCodiceAllergene: "Inserisci codice allergene",
      tabAggiungiIntervento: "Aggiungi intervento",
      tabAggiungiPatologiaFamiliare: "Aggiungi patologia familiare",
      tabInserisciCodicePatologiaFamiliare: "Inserisci codice patologia",
      tabAggiungiVoceStileVita: "Aggiungi voce stile di vita",
      tabAggiungiVaccino: "Aggiungi vaccino",
      tabInserisciCodiceVaccino: "Inserisci codice vaccino",
      tabInserisciCodiceProtesi: "Inserisci protesi",
      tabRegistraDonazioneOrgani: "Registra donazione organi",
      catalogHelpIcd10: "Cerca una patologia ICD10 e selezionala prima di salvare la voce.",
      catalogHelpAic: "Cerca un prodotto o un codice AIC e selezionalo prima di salvare la voce.",
      catalogPlaceholderIcd10: "Cerca per codice o descrizione ICD10...",
      catalogPlaceholderAic: "Cerca per nome prodotto o AIC...",
      codiceGenerico: "Codice",
      codiceSnomed: "Codice SNOMED",
      codiceIcd10: "Codice ICD10",
      codiceIcd9cm: "Codice ICD9-CM",
      codiceAic: "Codice AIC",
      codiceLoinc: "Codice LOINC",
      dataInizio: "Data inizio",
      dataFine: "Data fine",
      voceSenzaDescrizione: "Voce strutturata",
      voceVuota: "Inserisci almeno un dato nella voce",
      voceSalvata: "Voce salvata correttamente",
      voceSalvataConNome: "Elemento salvato: {name}",
      erroreSalvataggioVoce: "Errore durante il salvataggio della voce",
      voceEliminata: "Voce eliminata correttamente",
      erroreEliminazioneVoce: "Errore durante l'eliminazione della voce",
      sezioneSalvata: "Sezione anamnestica aggiornata con successo",
      sezioneSalvataConNome: "Elemento salvato: {label}",
      sezioneRipulitaConNome: "Sezione ripulita: {label}",
      sezioniSalvateConNomi: "Elementi salvati: {labels}",
      schedaSalvata: "Scheda anamnestica salvata con successo",
      erroreSalvataggioScheda: "Errore durante il salvataggio della scheda anamnestica",
      errorePuliziaSezione: "Errore durante la pulizia della sezione",
      structuredTipoAllergia: "Tipo allergia",
      structuredGravita: "Gravità",
      structuredDataInsorgenza: "Data insorgenza",
      structuredDataProcedura: "Data procedura",
      structuredStruttura: "Struttura",
      structuredRelazioneFamiliare: "Relazione familiare",
      structuredStatoFamiliare: "Stato familiare",
      structuredEtaDecesso: "Età al decesso",
      structuredDataSomministrazione: "Data somministrazione",
      structuredLotto: "Numero lotto",
      structuredDose: "Numero dose",
      structuredTipoDispositivo: "Tipo dispositivo",
      structuredUdi: "Codice UDI",
      structuredDataImpianto: "Data impianto",
      structuredSedeCorporea: "Sede corporea",
      structuredCategoriaStileVita: "Categoria",
      structuredStatoAbitudine: "Stato",
      structuredQuantitaAbitudine: "Quantita",
      structuredDataCessazione: "Data cessazione",
      structuredConsensoDonazione: "Consenso",
      structuredDataDichiarazione: "Data dichiarazione",
      optionFarmaco: "Farmaco",
      optionAlimento: "Alimento",
      optionAmbiente: "Ambiente",
      optionAltro: "Altro",
      optionAlta: "Alta",
      optionMedia: "Media",
      optionBassa: "Bassa",
      optionMadre: "Madre",
      optionPadre: "Padre",
      optionFratello: "Fratello",
      optionSorella: "Sorella",
      optionFiglio: "Figlio",
      optionFiglia: "Figlia",
      optionAltroFamiliare: "Altro familiare",
      optionVivente: "Vivente",
      optionDeceduto: "Deceduto",
      optionSconosciuto: "Sconosciuto",
      optionFumo: "Fumo",
      optionAlcol: "Alcol",
      optionAttivitaFisica: "Attivita fisica",
      optionAlimentazione: "Alimentazione",
      optionAssenso: "Assenso",
      optionDissenso: "Dissenso"
    },
    uploader: {
      caricamento_completato: "Caricamento completato",
      placeholder: "Scegli file...",
      carica: "Carica",
      errore_caricamento: "Errore durante il caricamento del file",
      anteprima_pdf_titolo: "Visualizza PDF e procedi al caricamento",
      anteprima_immagine_titolo: "Visualizza immagine e procedi al caricamento",
      annulla_caricamento: "Annulla il caricamento del file",
      conferma_caricamento: "Conferma il caricamento del file",
      caricamento_in_corso: "Caricamento in corso...",
      anteprima_immagine_alt: "Anteprima immagine"
    },
    zip_code: "CAP",
    sono_cittadino_residente: "Sono un cittadino residente in Italia con Codice Fiscale",
    SignedDocumentsList: {
      title: "Documenti firmati",
      signedOn: "Firmato il {date}",
      download: "Scarica",
      downloadError: "Errore nel download del documento"
    },
    CompilazioneSessione: {
      torna_alle_sessioni: "Torna alle sessioni",
      scheda_paziente: "Scheda Paziente",
      seleziona_paziente: "Seleziona il paziente a cui si intende somministrare la sessione:",
      registra_paziente: "Registra Paziente",
      paziente_selezionato: "Paziente selezionato:",
      nome_cognome: "NOME E COGNOME",
      codice_fiscale: "CODICE FISCALE",
      annulla_selezione: "Annulla selezione",
      avvia_sessione: "Avvia sessione",
      inserisci_pseudonimo: "Inserisci pseudonimo*:",
      conferma: "Conferma",
      paziente_label: "Paziente:",
      attenzione: "Attenzione!",
      informativa: "Informativa",
      consenso: "Ho letto l'informativa e do il mio consenso",
      procedi: "Procedi",
      operazione_completata: "Operazione completata.",
      operazione_non_consentita: "Operazione non consentita.",
      cf_mancante: "Per le sessioni in chiaro è richiesto il Codice Fiscale del paziente.",
      errore_caricamento_sessione: "Non è stato possibile recuperare i dati della sessione",
      errore_avvio_sessione: "Non è stato possibile avviare la sessione",
      errore_caricamento_questionario: "Non è stato possibile recuperare il questionario",
      errore_invio_questionario: "Non è stato possibile inviare il questionario",
      sessione_completata: "Sessione completata",
      errore_recupero_utente: "Non è stato possibile recuperare le informazioni dell'utente",
      necessaria_verifica_secondario: "Poiché il paziente non possiede un indirizzo email, è necessario che venga verificato anche il numero di telefono di riserva.",
      necessaria_verifica_numero: "Per proseguire è necessario che venga verificato il numero del paziente selezionato.",
      avviso_cancellazione_mezzanotte: "La sessione non è stata firmata. Se non procedi alla firma entro {days} giorni, verrà cancellata.",
      chiudi: "Chiudi",
      riepilogo_compilazioni: "Riepilogo compilazioni della sessione",
      tab_questionario: "Questionario",
      tab_data: "Data",
      tab_punteggio: "Punteggio",
      tab_azioni: "Azioni",
      visualizza_dettaglio_compilazione: "Visualizza dettaglio compilazione",
      nessuna_compilazione: "Nessuna compilazione disponibile",
      otp_verifica_titolo: "Verifica OTP",
      otp_verifica_testo: "Invia il codice OTP al paziente per validare la compilazione.",
      invia_otp: "Invia OTP",
      risultato: "Risultato",
      non_disponibile: "Non disponibile",
      descrizione: "Descrizione",
      prossimo_questionario: "Prossimo questionario",
      concludi_sessione: "Concludi sessione"
    },
    RiepilogoCompilazioniTable: {
      tab_questionario: "Questionario",
      tab_data: "Data",
      tab_punteggio: "Punteggio",
      tab_azioni: "Azioni",
      visualizza_dettaglio_compilazione: "Visualizza dettaglio compilazione",
      nessuna_compilazione: "Nessuna compilazione disponibile"
    },
    PublicContactForm: {
      nome_cognome: "Nome e cognome",
      nome_cognome_placeholder: "Inserisci nome e cognome",
      email: "Email",
      email_placeholder: "Inserisci indirizzo email",
      cellulare: "Cellulare",
      cellulare_placeholder: "Inserisci numero di cellulare",
      citta: "Città",
      citta_placeholder: "Inserisci città",
      indirizzo: "Indirizzo",
      indirizzo_placeholder: "Inserisci indirizzo",
      source: "Sorgente",
      seleziona_source: "Seleziona sorgente",
      invia: "Invia",
      contatto_creato: "Contatto creato correttamente",
      contatto_aggiornato: "Contatto aggiornato correttamente",
      contatto_non_trovato: "Contatto non trovato o non più valido. Verifica il link ricevuto.",
      errore_generico: "Errore durante la creazione del contatto",
      errore_caricamento: "Errore durante il caricamento del contatto",
      successo: "Operazione completata con successo",
      errore: "Si è verificato un errore"
    },
    PublicContactPage: {
      logo_alt: "Logo registrazione",
      titolo: "Contattaci",
      sottotitolo: "Compila il form per essere ricontattato dal nostro team",
      sottotitolo_completa: "Completa i tuoi dati di contatto",
      form_contatto: "Modulo di contatto",
      step1_descrizione: "Inserisci i dati mancanti per completare la registrazione",
      email_non_valida: "Inserisci un indirizzo email valido",
      telefono_non_valido: "Inserisci un numero di telefono valido (9-20 cifre)",
      avanti: "Avanti",
      indietro: "Indietro",
      conferma: "Conferma",
      errore: "Si è verificato un errore",
      contatto_non_trovato: "Contatto non trovato o non più valido. Verifica il link ricevuto."
    },
    ActivityDetails: {
      visualizza: "Visualizza",
      report: "Report",
      somministra: "Somministra",
      modifica: "Modifica"
    },
    EditQuestionario: {
      elimina_file: "Elimina file"
    },
    NuovoQuestionario: {
      elimina_file: "Elimina file"
    },
    ConfiguratoreRegoleBlocchi: {
      titolo: "Regole blocchi",
      descrizione: "Configura titolo e visibilità dei blocchi già assegnati alle domande.",
      titolo_blocco: "Blocco n°{numero}",
      placeholder_titolo: "Titolo opzionale del blocco",
      domande_associate: "{count} domande associate",
      visibilita: "Visibilità",
      sempre_visibile: "Sempre visibile",
      condizionale: "Condizionale",
      domanda_filtro: "Domanda filtro",
      risposta_abilitante: "Risposta abilitante",
      seleziona_domanda: "Seleziona domanda",
      seleziona_risposta: "Seleziona risposta",
      placeholder_risposta: "Inserisci risposta",
      domanda_senza_testo: "Domanda senza testo",
      domanda_numero: "Domanda {numero}",
      domanda_numero_blocco: "Domanda {numero} - blocco {blocco}",
      regola_interna:
        "La domanda filtro è nello stesso blocco: verrà mostrata sempre e abiliterà le altre domande del blocco.",
      regola_esterna:
        "La domanda filtro è nel blocco {blocco}: questo blocco verrà mostrato o saltato interamente.",
    },
    HomeQuestionari: {
      visualizza: "Visualizza",
      report: "Report",
      somministra: "Somministra",
      modifica: "Modifica"
    },
    UserLastSurveys: {
      vedi: "Vedi",
      modifica: "Modifica",
      elimina: "Elimina",
      scarica: "Scarica"
    },
    HomeAttivita: {
      visualizza: "Visualizza",
      report: "Report",
      nuovo_questionario: "Nuovo questionario",
      modifica: "Modifica",
      elimina: "Elimina"
    },
    ReportQuestionariUtente: {
      vedi: "Vedi",
      modifica: "Modifica",
      elimina: "Elimina",
      scarica: "Scarica"
    },
    ReportQuestionariCompilati: {
      apri_scheda_paziente: "Apri scheda paziente",
      vedi: "Vedi",
      modifica: "Modifica",
      elimina: "Elimina",
      scarica: "Scarica"
    },
    AdminHomeServices: {
      modifica: "Modifica",
      configura: "Configura",
      configura_servizio: "Configura servizio {name}",
      titolo_configurazione_generico: "Configurazione servizio",
      titolo_configurazione_servizio: "Configurazione servizio {name}",
      nessun_contenuto_configurazione:
        "Nessun contenuto di configurazione disponibile per questo servizio"
    },
    OperatoreDashboardImpegniCard: {
      vai_alla_prenotazione: "Vai alla prenotazione"
    },
    GestionePrenotazioniOperatore: {
      vedi_dettagli: "Vedi Dettagli",
      annulla: "Annulla",
      evadi: "Evadi"
    },
    VoucherSottoscrizioni: {
      attiva: "Attiva",
      disattiva: "Disattiva",
      elimina: "Elimina"
    },
    AdminQuestionari: {
      visualizza: "Visualizza",
      report: "Report",
      modifica: "Modifica"
    },
    AdminHomeAttivita: {
      visualizza: "Visualizza",
      report: "Report",
      nuovo_questionario: "Nuovo questionario",
      modifica: "Modifica",
      elimina: "Elimina"
    },
    HomeTeleconsulto: {
      vedi_dettagli: "Vedi dettagli",
      annulla: "Annulla",
      evadi: "Evadi"
    },
    VoucherEditForm: {
      modifica: "Modifica"
    },
    AnagraficaCompany: {
      titolo: "Anagrafica azienda",
      info_referente_popover: "Gli estremi della persona che il Centro Servizi può contattare per ordinaria amministrazione della piattaforma",
      info_referente_title: "Info Referente",
      tab_sede_operativa: "Sede operativa",
      tab_sede_legale: "Sede legale",
      tabs_anagrafica_aria: "Schede anagrafica azienda",
      sezione_sede_legale: "Sede legale",
      sezione_sede_legale_profilo: "Profilo",
      sezione_sede_legale_fiscale: "Informazioni fiscali",
      sezione_sede_legale_indirizzo: "Indirizzo",
      sezione_sede_legale_contatti: "Contatti",
      modifica_sede_legale: "Modifica sede legale",
      sede_legale_denominazione: "Denominazione società",
      placeholder_denominazione: "Denominazione società...",
      sede_legale_nome_titolare: "Nome Titolare",
      sede_legale_cognome_titolare: "Cognome Titolare",
      partita_iva: "Partita IVA",
      codice_fiscale: "Codice Fiscale",
      sede_legale_indirizzo: "Indirizzo e numero civico",
      sede_legale_cap: "CAP",
      sede_legale_frazione: "Frazione",
      sede_legale_regione: "Regione",
      sede_legale_provincia: "Provincia",
      sede_legale_comune: "Comune",
      sede_legale_email: "Email",
      sede_legale_pec: "PEC",
      sede_legale_telefono: "Telefono",
      placeholder_nome: "Nome...",
      placeholder_cognome: "Cognome...",
      placeholder_partita_iva: "Partita IVA...",
      placeholder_codice_fiscale: "Codice fiscale...",
      placeholder_indirizzo: "Indirizzo...",
      placeholder_cap: "CAP...",
      placeholder_frazione: "Frazione...",
      placeholder_email: "Email...",
      placeholder_pec: "PEC...",
      placeholder_telefono: "Telefono...",
      seleziona_regione: "Seleziona Regione",
      seleziona_provincia: "Seleziona Provincia",
      seleziona_comune: "Seleziona Comune",
      errore_caricamento_province: "Errore durante il caricamento delle province",
      errore_caricamento_comuni: "Errore durante il caricamento dei comuni"
    },
    CittadinoMain: {
      navigazione_cittadino: "Navigazione cittadino"
    },
    ArchivioSanitarioOperatore: {
      apri_archivio_sanitario: "Apri archivio sanitario",
      archivio_sanitario: "Archivio sanitario"
    },
    AdminRegistrazioni: {
      rimuovi_filtro_fonte: "Rimuovi filtro fonte",
      rimuovi_filtro_progetti: "Rimuovi filtro progetti",
      filtra_per_struttura: "Filtra per struttura arruolante",
      rimuovi_filtro_struttura: "Rimuovi filtro struttura"
    },
    AdminSurveySessions: {
      visualizza_dettagli: "Visualizza dettagli",
      crea_sessione: "Crea sessione",
      cerca: "Cerca",
      elenco_sessioni: "Elenco sessioni"
    },
    FeverHomeDashboard: {
      percentuale_completamento: "{perc}% completamento",
      nessun_dato: "nessun dato"
    },
    HomeSessioni: {
      sessione_creata_successo: "Sessione creata con successo",
      sessione_avviata_successo: "Sessione avviata con successo",
      sessione_eliminata_successo: "Sessione eliminata con successo",
      errore_caricamento_sessioni: "Errore durante il caricamento delle sessioni",
      errore_caricamento_attivita: "Errore durante il caricamento delle attività",
      nome_questionario_obbligatori: "Nome sessione e almeno un questionario sono obbligatori",
      almeno_due_questionari_obbligatori: "Nome sessione e almeno due questionari sono obbligatori",
      errore_creazione_sessione: "Errore durante la creazione della sessione",
      errore_avvio_sessione: "Errore durante l'avvio della sessione",
      errore_eliminazione_sessione: "Errore durante l'eliminazione della sessione",
      nessuna_sessione_trovata: "Nessuna sessione trovata",
      crea_nuova_sessione: "Nuova sessione",
      titolo_crea_nuova_sessione: "Nuova sessione",
      nome_sessione_asterisco: "Nome Sessione *",
      inserisci_nome_sessione: "Inserisci nome sessione",
      ancora_da_firmare: "Ancora da firmare: {num}",
      ancora_da_firmare_testo: "Ancora da firmare: {num}",
      posizione_numero: "Posizione {num}",
      descrizione_opzionale: "Descrizione opzionale",
      questionari_asterisco: "Questionari *",
      questionari_disponibili: "Questionari Disponibili",
      cerca_questionari: "Cerca questionari",
      placeholder_cerca_questionari: "Digita per filtrare per nome",
      questionari_selezionati: "Questionari Selezionati",
      nessun_questionario_selezionato: "Nessun questionario selezionato",
      seleziona_questionari_per_iniziare: "Seleziona i questionari tra quelli disponibili per comporre la sessione",
      caricamento_attivita: "Caricamento attività...",
      nessun_questionario_disponibile: "Nessun questionario disponibile",
      attivo: "Attivo",
      inattivo: "Inattivo",
      questionari_sessione_ordinati: "Questionari della sessione",
      nessun_questionario_configurato: "Nessun questionario configurato per questa sessione.",
      visualizza_questionari: "Visualizza questionari",
      nessuna_descrizione: "Nessuna descrizione",
      visualizza_dettaglio: "Visualizza dettagli",
      richiede_firma_operatore: "Richiede firma operatore",
      informazioni_sessione: "Informazioni sessione",
      ruoli_consentiti: "Ruoli consentiti",
      somministrazione_consentita_ai_ruoli: "Somministrazione consentita ai ruoli",
      firma_operatore_si: "Sì",
      firma_operatore_no: "No",
      giorni_firma_asterisco: "Giorni per firma *",
      placeholder_giorni_firma: "Inserisci giorni (1-15)",
      aiuto_giorni_firma: "Numero di giorni entro cui l'operatore deve firmare la sessione; superata la scadenza la sessione viene eliminata. Valori consentiti 1–15; predefinito 3.",
      seleziona_numero_giorni_firma: "Seleziona il numero di giorni per la firma",
      somministra_sessione: "Somministra sessione",
      permesso_somministra_mancante: "Permesso somministrazione mancante",
      ruoli_non_autorizzati_msg: "Non hai i ruoli richiesti: {ruoli}",
      ruoli_non_autorizzati_generico: "Non hai i ruoli richiesti per somministrare questa sessione",
      elimina_sessione: "Elimina sessione",
      creata_da: "Creata da",
      eliminazione_non_consentita_sessione_somministrata: "Impossibile eliminare: esiste almeno una compilazione per questa sessione",
      conferma_eliminazione_sessione: "Sei sicuro di voler eliminare la sessione \"{nome}\"?",
      nessuna_compilazione_associata: "Non ci sono compilazioni associate a questa sessione.",
      espandi_dettagli: "Espandi dettagli questionari",
      comprimi_dettagli: "Comprimi dettagli questionari",
      cerca_sessione: "Cerca sessione per nome",
      seleziona_elementi_per_pagina: "Seleziona numero di elementi per pagina",
      filtra_per_stato: "Filtra sessioni per stato",
      elementi_per_pagina: "Elementi per pagina",
      stato_filtro: "Filtro stato",
      caricamento_sessioni: "Caricamento sessioni in corso",
      lista_sessioni: "Lista delle sessioni",
      dettagli_questionari: "Dettagli questionari della sessione",
      posizione_questionario: "Questionario {numero}: {nome}",
      stato_sessione: "Stato: {stato}",
      questionari_totali: "{totale} questionari trovati",
      nome: "Nome",
      descrizione: "Descrizione",
      tipologia: "Tipologia",
      somministrati: "Somministrati",
      stato: "Stato",
      azioni: "Azioni",
      tutti_stati: "Tutti gli stati",
      in_attesa: "In attesa",
      in_corso: "In corso",
      completate: "Completate",
      annullate: "Annullate",
      filtri_e_paginazione: "Controlli filtri e paginazione",
      tipo_questionari_asterisco: "Tipo Questionari *",
      anonimo: "Anonimo",
      pseudoanonimo: "Pseudoanonimo",
      in_chiaro: "In Chiaro",
      tutti_operatori_autorizzati: "Tutti gli operatori sono autorizzati",
      si: "Sì",
      no_solo_ruoli_specifici: "No, solo ruoli specifici",
      ruoli_consentiti_label: "Seleziona ruoli consentiti",
      rimuovi_ruolo: "Rimuovi ruolo {name}",
      questionari_in_chiaro: "Questionari in Chiaro",
      questionari_anonimi: "Questionari Anonimi",
      questionari_pseudoanonimi: "Questionari Pseudoanonimi",
      tipo_in_chiaro_desc: "I dati dei questionari sono collegati direttamente all'identità del paziente",
      tipo_anonimo_desc: "I dati dei questionari non sono collegabili a nessuna identità specifica",
      tipo_pseudoanonimo_desc: "I dati dei questionari sono collegati tramite un codice anonimo",
      questionari: "Questionari",
      nessuna_attivita_tipo_selezionato: "Nessuna attività disponibile per il tipo di questionario selezionato",
      numero_questionari_selezionati: "{count} questionari selezionati",
      lista_questionari_ordinabili: "Lista questionari ordinabili tramite trascinamento",
      questionario_posizione: "Questionario {numero}: {nome}",
      rimuovi_questionario: "Rimuovi questionario {nome}",
      modifica_sessione: "Modifica sessione",
      titolo_modifica_sessione: "Modifica sessione",
      modifica_sessione_apri: "Apri modifica sessione",
      sessione_modificata_successo: "Sessione modificata con successo",
      errore_modifica_sessione: "Errore durante la modifica della sessione",
      lista_attivita_questionari: "Lista attività con questionari disponibili",
      attivita_con_questionari: "Attività {nome} con questionari",
      espandi_attivita: "Espandi attività {nome} - {stato}",
      espansa: "espansa",
      chiusa: "chiusa",
      questionari_attivita: "Questionari disponibili per attività {nome}",
      questionario_item: "Questionario: {nome}",
      aggiungi_questionario: "Aggiungi questionario {nome} alla sessione",
      visualizza_dettaglio_compilazione: "Visualizza dettaglio compilazioni"
    },
    PatientSurveySessions: {
      titolo: "Sessioni",
      nessuna_descrizione: "Nessuna descrizione",
      somministra_sessione: "Somministra sessione",
      nessuna_sessione: "Nessuna sessione disponibile",
      nuova_sessione: "Nuova sessione",
      seleziona_sessione: "Seleziona sessione",
      procedi: "Procedi",
      cerca_sessione: "Cerca sessione",
      filtro_in_chiaro: "Solo in chiaro",
      filtro_attive: "Solo attive",
      nessun_risultato: "Nessun risultato",
      permesso_somministra_mancante: "Permesso somministrazione mancante",
      ruoli_non_autorizzati_generico: "Non hai i ruoli richiesti per somministrare questa sessione",
      ruoli_non_autorizzati_msg: "Non hai i ruoli richiesti: {ruoli}",
      cf_mancante: "Per le sessioni in chiaro è richiesto il Codice Fiscale del paziente.",
      in_chiaro: "In Chiaro",
      pseudoanonimo: "Pseudoanonimo",
      anonimo: "Anonimo",
      item_position: "Elemento {number}: {name}",
      errore_caricamento_sessioni: "Errore durante il caricamento delle sessioni",
      lista_sessioni: "Lista delle sessioni"
    },
    NavigationOperatoreCRoom: {
      checklist_templates: "Checklist"
    },
    ChecklistTemplatesControlRoom: {
      titolo: "Template Checklist",
      info_titolo: "Template di default:",
      info_testo: "Questi template sono i modelli riutilizzabili messi a disposizione degli operatori. Le modifiche non hanno effetto sulle checklist paziente già create.",
      cerca: "Cerca template",
      crea_template: "Nuovo template",
      nessuna_descrizione: "Nessuna descrizione",
      sequenziale_si: "Sequenziale",
      sequenziale_no: "Non sequenziale",
      attivo: "Attivo",
      disattivo: "Disattivo",
      modifica: "Modifica template",
      elimina: "Elimina template",
      nessun_template: "Nessun template disponibile",
      nome: "Nome",
      tipo: "Tipo",
      descrizione: "Descrizione",
      sequenziale: "Sequenziale",
      stato: "Stato",
      azioni: "Azioni",
      conferma_eliminazione: "Confermi l'eliminazione del template \"{nome}\"?",
      template_eliminato: "Template eliminato",
      errore_permesso: "Non hai i permessi necessari per questa operazione",
      errore_caricamento: "Errore durante il caricamento dei template",
      errore_eliminazione_vincolo: "Impossibile eliminare il template: è in uso o presenta vincoli",
      errore_eliminazione: "Errore durante l'eliminazione del template"
    },
    ChecklistTemplateModal: {
      titolo_crea: "Nuovo template checklist",
      titolo_modifica: "Modifica template checklist",
      crea_template: "Crea template",
      form_label: "Modulo template checklist",
      nome_asterisco: "Nome *",
      nome_placeholder: "Es. ERAS Chirurgia Colorettale",
      tipo: "Tipo",
      tipo_placeholder: "Es. eras",
      descrizione: "Descrizione",
      descrizione_placeholder: "Descrizione del percorso",
      sequenziale: "Checklist sequenziale",
      sequenziale_desc: "Se attiva, le sezioni e gli step successivi possono essere completati solo dopo quelli precedenti richiesti",
      attivo: "Attivo",
      sezioni: "Sezioni",
      aggiungi_sezione: "Aggiungi sezione",
      nessuna_sezione: "Nessuna sezione: aggiungi almeno una sezione",
      lista_sezioni_ordinabili: "Elenco sezioni ordinabili",
      trascina_sezione: "Trascina per riordinare la sezione",
      titolo_sezione: "Titolo sezione",
      titolo_sezione_placeholder: "Titolo della sezione",
      descrizione_sezione: "Descrizione sezione",
      descrizione_sezione_placeholder: "Descrizione della sezione (opzionale)",
      rimuovi_sezione: "Rimuovi sezione {titolo}",
      sezione_sequenziale: "Sequenziale",
      sezione_obbligatoria: "Obbligatoria",
      step: "Step",
      aggiungi_step: "Aggiungi step",
      nessuno_step: "Nessuno step in questa sezione",
      lista_step_ordinabili: "Elenco step ordinabili",
      trascina_step: "Trascina per riordinare lo step",
      titolo_step: "Titolo step",
      titolo_step_placeholder: "Titolo dello step",
      descrizione_step: "Descrizione step",
      descrizione_step_placeholder: "Descrizione dello step (opzionale)",
      ruolo_atteso: "Ruolo atteso",
      ruolo_atteso_placeholder: "Es. infermiere / chirurgo",
      nessun_ruolo: "Nessun ruolo",
      rimuovi_ruolo: "Rimuovi {name}",
      step_obbligatorio: "Obbligatorio",
      tag_obbligatorio: "Obbligatorio",
      tag_facoltativo: "Facoltativo",
      tag_classificazione: "Classificazione step",
      rimuovi_step: "Rimuovi step {titolo}",
      nome_obbligatorio: "Il nome del template è obbligatorio",
      almeno_una_sezione: "Aggiungi almeno una sezione",
      titoli_sezioni_obbligatori: "Tutte le sezioni devono avere un titolo",
      ogni_sezione_uno_step: "Ogni sezione deve contenere almeno uno step",
      titoli_step_obbligatori: "Tutti gli step devono avere un titolo",
      template_creato: "Template creato",
      template_aggiornato: "Template aggiornato",
      errore_permesso: "Non hai i permessi necessari per questa operazione",
      errore_salvataggio: "Errore durante il salvataggio del template"
    },
    CreatePatientChecklistModal: {
      titolo: "Nuova checklist",
      sottotitolo_scegli: "Scegli come iniziare",
      crea_da_zero: "Crea da zero",
      crea_da_zero_desc: "Parti da una checklist vuota e aggiungi fasi e attività manualmente.",
      parti_da_template: "Parti da un template",
      parti_da_template_desc: "Usa un percorso predefinito e personalizzalo per il paziente.",
      titolo_da_zero: "Crea da zero",
      sottotitolo_da_zero: "Definisci la checklist, poi aggiungi fasi e attività",
      titolo_checklist: "Titolo checklist",
      titolo_checklist_placeholder: "Es. Percorso post-operatorio",
      descrizione_facoltativa: "Descrizione (facoltativa)",
      descrizione_placeholder: "Note di contesto sul percorso…",
      sequenziale: "Fasi sequenziali",
      sequenziale_desc: "Se attiva, le fasi successive si completano solo dopo quelle precedenti richieste.",
      info_fase_vuota: "Verrà creata una prima fase vuota. Potrai aggiungere altre fasi sequenziali e le relative attività direttamente dalla checklist.",
      titolo_template: "Parti da un template",
      sottotitolo_template: "Seleziona un percorso predefinito",
      cerca_template: "Cerca template",
      nessun_template: "Nessun template disponibile",
      fasi: "{numero} fasi",
      attivita: "{numero} attività",
      anteprima_fasi: "Anteprima fasi sequenziali",
      titolo_per_paziente: "Titolo per questo paziente",
      indietro: "Indietro",
      crea_checklist: "Crea checklist",
      seleziona_template: "Seleziona un template",
      nome_obbligatorio: "Il titolo della checklist è obbligatorio",
      checklist_creata: "Checklist creata",
      errore_permesso: "Non hai i permessi necessari per questa operazione",
      errore_creazione: "Errore durante la creazione della checklist"
    },
    ChecklistCard: {
      sequenziale: "Sequenziale",
      meta_fasi: "{numero} fasi",
      avanzamento_aria: "Avanzamento {perc}%",
      attivita_count: "{done} / {total} attività",
      comprimi: "Comprimi",
      espandi: "Espandi",
      stato_da_iniziare: "Da iniziare",
      stato_in_corso: "In corso",
      stato_completata: "Completata",
      stato_vuota: "Vuota",
      fase_completata: "Completata",
      fase_in_corso: "In corso",
      fase_bloccata: "Si sblocca al completamento della fase precedente",
      fase_attivita_completate: "{done} di {total} attività completate",
      nessuna_attivita: "Nessuna attività in questa fase.",
      aggiungi_attivita: "Aggiungi attività",
      descrizione_attivita_placeholder: "Descrizione attività…",
      titolo_attivita_placeholder: "Titolo attività",
      aggiungi: "Aggiungi",
      aggiungi_fase: "Aggiungi fase",
      nuova_fase: "Nuova fase {numero}",
      nome_fase: "Nome della fase",
      nota_placeholder: "Aggiungi una nota clinica…",
      salva: "Salva",
      chiudi: "Chiudi",
      azioni_checklist: "Azioni checklist",
      salva_come_template: "Adotta come template",
      elimina_checklist: "Elimina checklist",
      azioni_fase: "Azioni fase",
      rinomina_fase: "Rinomina fase",
      sposta_su: "Sposta la fase su",
      sposta_giu: "Sposta la fase giù",
      elimina_fase: "Elimina fase",
      completa_attivita: "Completa l'attività {nome}",
      riapri_attivita: "Riapri l'attività {nome}",
      nota_attivita: "Nota per l'attività {nome}",
      modifica_attivita: "Modifica l'attività {nome}",
      rimuovi_attivita: "Rimuovi l'attività {nome}",
      errore_permesso: "Non hai i permessi necessari per questa operazione",
      errore_sequenzialita: "Operazione non consentita: completa prima le fasi precedenti richieste",
      errore_aggiornamento: "Errore durante l'aggiornamento della checklist",
      errore_completato_non_eliminabile: "Non è possibile eliminare un'attività completata",
      tag_obbligatorio: "Obbligatoria",
      tag_facoltativo: "Facoltativa",
      tag_classificazione: "Classificazione attività",
      tag_obbligatorio_aria: "Attività obbligatoria",
      tag_facoltativo_aria: "Attività facoltativa",
      ruolo_atteso: "Ruolo",
      ruolo_atteso_aria: "Ruolo previsto per l'attività",
      nessun_ruolo: "Nessun ruolo",
      rimuovi_ruolo: "Rimuovi {name}",
      ruolo_badge_aria: "Ruolo: {nome}"
    },
    ChecklistItemModal: {
      aggiungi: "Aggiungi",
      titolo_aggiungi: "Aggiungi step",
      titolo_modifica: "Modifica step",
      titolo_nuova_sezione: "Nuova sezione",
      nuova_sezione: "Nuova sezione",
      primo_step: "Primo step",
      titolo_sezione_asterisco: "Titolo sezione *",
      titolo_sezione_placeholder: "Titolo della nuova sezione",
      sezione_sequenziale: "Sezione sequenziale",
      sezione_obbligatoria: "Sezione obbligatoria",
      titolo_asterisco: "Titolo *",
      titolo_placeholder: "Titolo dello step",
      descrizione: "Descrizione",
      descrizione_placeholder: "Descrizione dello step (opzionale)",
      ruolo_atteso: "Ruolo atteso",
      ruolo_atteso_placeholder: "Es. infermiere",
      obbligatorio: "Obbligatorio",
      note: "Note",
      note_placeholder: "Note (opzionale)",
      titolo_obbligatorio: "Il titolo dello step è obbligatorio",
      titolo_sezione_obbligatorio: "Il titolo della sezione è obbligatorio",
      step_aggiunto: "Step aggiunto",
      step_aggiornato: "Step aggiornato",
      errore_permesso: "Non hai i permessi necessari per questa operazione",
      errore_salvataggio: "Errore durante il salvataggio dello step"
    },
    PatientChecklists: {
      titolo: "Checklist del paziente",
      tab_label: "Checklist",
      sottotitolo: "Percorsi clinici strutturati in fasi sequenziali, con avanzamento monitorato.",
      nuova_checklist: "Nuova checklist",
      lista_checklist: "Elenco delle checklist del paziente",
      checklist_attive: "checklist attive",
      completate: "completate",
      attivita_svolte: "attività svolte",
      avanzamento_complessivo: "Avanzamento complessivo",
      avanzamento_aria: "Avanzamento complessivo {perc}%",
      nessuna_checklist_titolo: "Nessuna checklist per questo paziente",
      nessuna_checklist_desc: "Crea una checklist da zero o parti da un template clinico predefinito.",
      crea_prima_checklist: "Crea la prima checklist",
      conferma_eliminazione: "Confermi l'eliminazione della checklist \"{nome}\"?",
      checklist_eliminata: "Checklist eliminata",
      conferma_eliminazione_fase: "Confermi l'eliminazione della fase \"{nome}\"? Verranno eliminate anche le relative attività.",
      fase_eliminata: "Fase eliminata",
      adotta_titolo: "Adotta come template",
      adotta_sottotitolo: "Riutilizza questa struttura come template per altri pazienti.",
      adotta_nome: "Nome template",
      adotta_specialita: "Specialità / categoria",
      adotta_info: "{fasi} fasi · {attivita} attività verranno salvate (senza lo stato di completamento).",
      adotta_salva: "Salva template",
      adotta_template_adottato: "Template salvato nella libreria Control Room",
      adotta_nome_obbligatorio: "Il nome del template è obbligatorio",
      adotta_errore: "Errore durante l'adozione della checklist come template",
      errore_permesso: "Non hai i permessi necessari per questa operazione",
      errore_caricamento: "Errore durante il caricamento delle checklist",
      errore_eliminazione_vincolo: "Impossibile eliminare la checklist: presenta vincoli",
      errore_eliminazione: "Errore durante l'eliminazione della checklist",
      errore_eliminazione_fase: "Errore durante l'eliminazione della fase",
      errore_eliminazione_fase_vincolo: "Impossibile eliminare la fase: contiene attività completate"
    },
    PatientChecklistDetail: {
      torna_elenco: "Elenco checklist",
      sequenziale: "Sequenziale",
      modifica_checklist: "Modifica checklist",
      avanzamento_complessivo: "Avanzamento complessivo",
      avanzamento_percentuale: "Avanzamento complessivo {perc}%",
      nessuna_sezione: "Questa checklist non ha ancora sezioni",
      aggiungi_sezione: "Aggiungi sezione",
      sezioni: "Sezioni",
      obbligatoria: "Obbligatoria",
      aggiungi_step: "Aggiungi step",
      avanzamento_sezione: "Avanzamento sezione",
      avanzamento_sezione_percentuale: "Avanzamento sezione {perc}%",
      nessuno_step: "Nessuno step in questa sezione",
      lista_step: "Elenco degli step",
      step_posizione: "Step {numero}: {nome}",
      trascina_step: "Trascina per riordinare lo step",
      completa_step: "Completa lo step {nome}",
      riapri_step: "Riapri lo step {nome}",
      step_bloccato_sequenziale: "Step bloccato: completa prima gli step obbligatori precedenti",
      obbligatorio: "Obbligatorio",
      completato_il: "Completato il {data}",
      assegnato_a: "Assegnato a {nome}",
      modifica_step: "Modifica step",
      elimina_step: "Elimina step",
      nome_checklist: "Nome checklist",
      conferma_eliminazione_step: "Confermi l'eliminazione dello step \"{nome}\"?",
      step_eliminato: "Step eliminato",
      checklist_aggiornata: "Checklist aggiornata",
      eliminazione_step_completato: "Non è possibile eliminare uno step completato",
      errore_sequenzialita: "Operazione non consentita: la sequenzialità impedisce di procedere prima di completare gli step richiesti",
      errore_aggiornamento_step: "Errore durante l'aggiornamento dello step",
      errore_eliminazione_step: "Errore durante l'eliminazione dello step",
      errore_riordino: "Errore durante il riordino degli step",
      errore_aggiornamento_checklist: "Errore durante l'aggiornamento della checklist",
      errore_caricamento: "Errore durante il caricamento della checklist",
      errore_permesso: "Non hai i permessi necessari per questa operazione",
      stato_pending: "Da iniziare",
      stato_in_corso: "In corso",
      stato_completata: "Completata",
      stato_bozza: "Bozza"
    },
    UserLastSessions: {
      titolo: "Ultime sessioni",
      nuova_sessione: "Somministra nuova sessione",
      vedi: "Vedi",
      vedi_dettaglio_sessione: "Vedi dettaglio sessione",
      vedi_storico_sessioni: "Vedi storico sessioni",
      nessuna_sessione: "Nessuna sessione disponibile",
      dettaglio_questionario: "Dettaglio questionario",
      chiudi: "Chiudi",
      dettaglio_sessione: "Dettaglio sessione",
      questionari_nella_sessione: "Questionari nella sessione",
      cf_mancante: "Per le sessioni in chiaro è richiesto il Codice Fiscale del paziente.",
      seleziona_sessione: "Seleziona sessione",
      procedi: "Procedi",
      cerca_sessione: "Cerca sessione",
      nessun_risultato: "Nessun risultato"
    },
    DettaglioSessioneModal: {
      titolo_dettaglio_sessione: "Dettaglio Sessione",
      contenuto_dettaglio_sessione: "Contenuto dettaglio sessione",
      informazioni_sessione: "Informazioni sessione",
      questionari_configurati: "questionari configurati",
      stato_sessione: "Stato: {stato}",
      istanze_compilazione: "Istanze di compilazione",
      compilazioni_sessione: "Compilazioni della Sessione",
      totale_compilazioni: "{totale} compilazioni totali",
      nessuna_compilazione: "Nessuna compilazione trovata",
      lista_istanze: "Lista istanze di compilazione",
      caricamento_istanze: "Caricamento istanze in corso",
      paziente: "Paziente",
      stato: "Stato",
      data_inizio: "Data Inizio",
      data_completamento: "Data Completamento",
      cf: "Codice Fiscale",
      progresso: "Progresso",
      azioni: "Azioni",
      in_corso: "In corso",
      progresso_compilazione: "Progresso: {percentuale}%",
      visualizza_dettaglio_compilazione: "Visualizza dettaglio compilazione",
      errore_caricamento_sessione: "Errore durante il caricamento dei dettagli della sessione",
      errore_caricamento_dettagli: "Errore durante il caricamento dei dettagli",
      chiudi_dettagli: "Chiudi dettagli",
      paziente_anonimo: "Paziente anonimo",
      istanza_iniziata: "Iniziata",
      istanza_in_corso: "In corso",
      istanza_completata: "Completata",
      istanza_abbandonata: "Abbandonata",
      stato_in_attesa: "In attesa",
      stato_in_corso: "In corso",
      stato_completate: "Completate",
      stato_annullate: "Annullate",
      funzione_in_sviluppo: "Funzione in fase di sviluppo"
    },
    DettaglioSessione: {
      contenuto_dettaglio_sessione: "Contenuto della sessione",
      mostra_prima_da_firmare: "Mostra prima le compilazioni da firmare",
      azioni_per_compilazione: "Azioni per compilazione {num}",
      sessioni: "Sessioni",
      titolo_compilazioni_sessione: "Compilazioni della sessione",
      titolo_dettaglio_sessione: "Dettaglio Sessione",
      torna_alle_sessioni: "Torna alle Sessioni",
      sessione_non_trovata: "Sessione non trovata",
      nessuna_compilazione: "Nessuna compilazione trovata",
      paziente: "Paziente",
      stato: "Stato",
      cf: "Codice Fiscale",
      questionario: "Questionario",
      data: "Data",
      punteggio: "Punteggio",
      esito: "Esito",
      data_inizio: "Data Inizio",
      data_completamento: "Data Completamento",
      progresso: "Progresso",
      azioni: "Azioni",
      filtro_cf: "Codice Fiscale",
      elementi_per_pagina: "Elementi per pagina",
      seleziona_elementi_per_pagina: "Seleziona numero di elementi per pagina",
      cf_solo_in_chiaro: "Filtro attivo solo per sessioni in chiaro",
      chiudi: "Chiudi",
      in_corso: "In corso",
      progresso_compilazione: "Progresso: {percentuale}%",
      visualizza_dettaglio_compilazione: "Visualizza dettaglio compilazione",
      visualizza_compilazioni_sessione: "Visualizza compilazioni della sessione",
      errore_caricamento_sessione: "Errore durante il caricamento dei dettagli della sessione",
      errore_caricamento_dettagli: "Errore durante il caricamento dei dettagli",
      paziente_anonimo: "Paziente anonimo",
      istanza_iniziata: "Iniziata",
      istanza_in_corso: "In corso",
      istanza_completata: "Completata",
      istanza_abbandonata: "Abbandonata",
      stato_in_attesa: "In attesa",
      stato_in_corso: "In corso",
      stato_completate: "Completate",
      stato_annullate: "Annullate",
      funzione_in_sviluppo: "Funzione in fase di sviluppo"
    },
    SchedaArruolamento: {
      invia_link_pagamento_checkbox: "Invia link pagamento via email dopo l'arruolamento",
      link_validita_4_ore: "Il link di pagamento avrà una validità di 4 ore dalla generazione.",
      conferma_invio_link_title: "Conferma invio link pagamento",
      si_conferma_invia: "Sì, conferma e invia",
      inoltra_link_email_heading: "Inoltra link pagamento via email al paziente",
      inoltra_link_email_descrizione: "Cliccando su \"Conferma\" inoltrerai all'indirizzo email del paziente un collegamento al sistema di pagamento sicuro Nexi, affinché possa finalizzare in autonomia l'attivazione della sottoscrizione. Il link ha validità di 4 ore dalla generazione, dopo sarà necessario rigenerarlo dalla scheda paziente.",
      quali_sottoscrizioni_disponibili: "Quali sottoscrizioni sono disponibili?"
    },
    AssegnaSottoscrizioneArruolamento: {
      label_assegna: "Assegna una sottoscrizione al paziente (opzionale)",
      info_attesa_pagamento: "La sottoscrizione sarà assegnata al paziente in attesa di pagamento",
      quali_sottoscrizioni: "Quali sottoscrizioni sono disponibili?",
      invia_link_checkbox: "Invia link pagamento via email dopo l'arruolamento",
      link_validita: "Il link di pagamento avrà una validità di 4 ore dalla generazione.",
      conferma_invio_link_title: "Conferma invio link pagamento",
      si_conferma_invia: "Sì, conferma e invia",
      inoltra_link_email_heading: "Inoltra link pagamento via email al paziente",
      inoltra_link_email_descrizione: "Cliccando su \"Conferma\" inoltrerai all'indirizzo email del paziente un collegamento al sistema di pagamento sicuro Nexi, affinché possa finalizzare in autonomia l'attivazione della sottoscrizione. Il link ha validità di 4 ore dalla generazione, dopo sarà necessario rigenerarlo dalla scheda paziente."
    },
    SeeAndActivateFreeSubscriptionsAsAdmin: {
      sottoscrizione_non_attiva: "Sottoscrizione non attiva",
      storico_sottoscrizioni: "Storico sottoscrizioni",
      mesi: "mesi",
      disattivata: "Disattivata",
      scaduta_il: "Scaduta il",
      prossimo_rinnovo: "Prossimo tentativo rinnovo:",
      rinnovo_attivo: "Rinnovo automatico attivo",
      rinnovo_disattivato: "Rinnovo automatico disattivato",
      annulla_rinnovo: "Annulla rinnovo automatico",
      aria_annulla_rinnovo: "Annulla rinnovo automatico per {name}",
      aria_toggle_storico: "Espandi o comprimi storico sottoscrizioni",
      conferma_annullamento_title: "Conferma annullamento rinnovo",
      conferma_annullamento_msg: "Confermi di voler annullare il rinnovo automatico per questa sottoscrizione?",
      si_annulla: "Sì, annulla",
      annullamento_non_reversibile: "Attenzione: questa operazione non è reversibile per le sottoscrizioni disattivate.",
      errore_sottoscrizione_non_trovata: "Sottoscrizione non trovata.",
      rinnovo_annullato_successo: "Rinnovo automatico annullato con successo!",
      errore_annulla_rinnovo: "Non è stato possibile annullare il rinnovo automatico.",
      rinnovo_ripristinato_successo: "Rinnovo automatico ripristinato con successo!",
      errore_ripristino_rinnovo: "Non è stato possibile ripristinare il rinnovo automatico.",
      errore_operazione: "Non è stato possibile completare l'operazione."
    }
  },
  en: {
    RichiediServizioChat: {
      testo: "Chat with a doctor is not active for your profile. Call our toll-free number {numero} to request it.",
      bottone: "Request the service",
      aria: "Request the service: call the toll-free number {numero}",
    },
    ChatPartecipanti: {
      titolo: "Add a participant",
      conferma: "Add",
      spiegazione: "A colleague who already has their own chat with this patient can join. They will also see the messages written so far.",
      caricamento: "Loading doctors",
      errore_elenco: "The doctors could not be loaded.",
      nessuno: "No colleague has their own chat with this patient yet. The colleague opens it from the patient's record: chat button, then “Enable the chat”. Once done, their name appears here.",
      scegli: "Choose the doctor",
      aggiunto: "The doctor has joined the conversation",
      titolo_successo: "Done",
      errore_aggiunta: "The doctor could not be added",
      in_chat: "In this conversation",
      aggiungi: "Add",
      tu: "you",
      titolo_errore: "Error",
      con_altri: "Also with {nomi}",
    },
    SoapTemplatesManager: {
      conferma_eliminazione_titolo: "Confirm deletion",
      conferma_eliminazione: 'The "{titolo}" template is about to be deleted.',
      elimina: "Delete",
      eliminato: "Template deleted",
      eliminazione_fallita: "The template could not be deleted",
    },
    SearchUtenteDashboard: {
      seleziona: "Select",
      solo_in_agenda: "Calendar only",
      voce_agenda_non_apribile_titolo: "Agenda entry",
      voce_agenda_non_apribile:
        "The selected result comes from a calendar appointment, not from a patient record, and has no record to open. The person needs to be searched by tax code, surname or name.",
    },
    ModalChatPaziente: {
      paziente: "Patient",
      titolo_operatore_proprie: "My conversations",
      titolo_cittadino: "Clinical chat with your doctors",
      titolo_con_paziente: "Clinical chat with {nome}",
    },
    ModalNuovoCanale: {
      titolo: "Enable doctor-patient chat",
      conferma: "Enable channel",
      label_operatore: "Healthcare professional (doctor or nurse)",
      descrizione_operatore: "The professional enabled for this service",
      scegli_operatore: "Select a professional",
      label_paziente: "Patient",
      descrizione_paziente: "Search by surname, name or tax code",
      placeholder_ricerca: "Search patient",
      cerca: "Search",
      scegli_paziente: "Select the patient found",
      caricamento: "Loading",
      nota: "Enabling the channel allows asynchronous exchange of protected messages and documents between the patient and the designated doctor.",
      errore_operatori: "Eligible professionals could not be retrieved",
      canale_creato: "Chat channel enabled",
      titolo_successo: "Operation completed",
      errore_creazione: "The chat channel could not be enabled",
      titolo_errore: "Error",
    },
    ChatPazientiWhitelist: {
      titolo: "Doctor-patient chat - whitelist management",
      sottotitolo: "Enabling and monitoring of asynchronous messaging channels between patients and healthcare professionals.",
      nuovo_canale: "Enable new channel",
      filtra_stato: "Filter by status",
      aggiorna: "Refresh list",
      nessun_canale: "No chat channel matches the selected filters.",
      caricamento: "Loading channels",
      stato_tutti: "All statuses",
      stato_solo_attivi: "Active channels only",
      stato_solo_revocati: "Revoked channels only",
      col_paziente: "Patient",
      col_operatore: "Doctor or operator",
      col_stato: "Status",
      col_data: "Enabled on",
      col_azioni: "Actions",
      stato_attivo: "Active",
      stato_revocato: "Revoked",
      azione_visualizza: "View the clinical chat with the patient",
      azione_archivia: "Archive the transcript in the health profile",
      azione_revoca: "Revoke the channel",
      azione_riattiva: "Re-enable the channel",
      conferma_revoca_titolo: "Channel revocation",
      conferma_revoca_ok: "Revoke",
      conferma_revoca_testo: "The chat with {paziente} will be revoked: no new messages can be sent. The history remains available.",
      paziente: "Patient",
      revoca_riuscita: "Channel revoked",
      revoca_fallita: "The channel could not be revoked",
      caricamento_fallito: "The organisation channels could not be loaded",
      riattivazione_riuscita: "Channel re-enabled",
      riattivazione_fallita: "The channel could not be re-enabled",
      archiviazione_riuscita: "Transcript archived in the patient health record",
      archiviazione_titolo: "Archiving completed",
      archiviazione_fallita: "The transcript could not be archived",
      errore: "Error",
    },
    PatientChatSection: {
      titolo_cittadino: "Chat with your doctors",
      titolo_operatore: "Messaging and clinical chat",
      sottotitolo_cittadino: "Direct and secure communication with the enabled healthcare professionals.",
      sottotitolo_operatore: "History and management of direct conversations with the patient.",
      abilita_medico: "Enable new doctor",
      caricamento: "Loading chat",
      nessun_canale: "No chat channel enabled",
      nessun_canale_operatore: "Enabling a doctor starts the asynchronous exchange of clinical messages with this patient.",
      nessun_canale_cittadino: "No doctor has enabled a messaging channel for your profile yet.",
      abilita_ora: "Enable chat",
      elenco_cittadino: "Your doctors",
      elenco_operatore: "Chat channels",
      revocato: "Revoked",
      archivia: "Archive in profile",
      archivia_tooltip: "Generate the PDF transcript and archive it in the health record",
      nessun_messaggio: "No message in this conversation.",
      inizia_a_scrivere: "The discussion starts with the first message.",
      allegato: "Attachment",
      file: "file",
      dimensione_file: "({kb} KB, maximum 4 MB)",
      rimuovi_allegato: "Remove attachment",
      allega_tooltip: "Attach a document or an image, maximum 4 MB",
      placeholder_cittadino: "Write a message to the doctor",
      placeholder_operatore: "Write a clinical message to the patient",
      invia: "Send",
      allegati_consentiti: "Allowed attachments: PDF, images and reports, up to 4 MB",
      canale_revocato: "Channel revoked.",
      seleziona_canale: "Select a channel to open the conversation.",
      file_troppo_grande: "The selected file exceeds the maximum size of 4 MB.",
      file_troppo_grande_titolo: "File too large",
      invio_fallito: "The message could not be sent",
      archiviazione_riuscita: "Chat transcript archived in the health record",
      archiviazione_titolo: "Archiving completed",
      archiviazione_fallita: "The transcript could not be archived",
      errore: "Error",
      titolo_medico: "Dr. {nome}",
      operatore: "Operator",
      paziente: "Patient",
      download_fallito: "The attachment could not be downloaded",
      download_fallito_titolo: "Download error",
    },
    ...timelineTranslations.en,
    SegnalazioneCittadino: {
      menu: "Reports",
      torna_indietro: "Back",
      intro_titolo: "How it works",
      intro_testo: "When you send a report, it is forwarded to the facility that enrolled you in the selected project. The operators read it and reply to you right here: you'll find their reply in the report's conversation and, whenever there's a new unread message, a notice on the \"Reports\" menu item. You'll also receive an email notification.",
      nuova_segnalazione: "New report",
      progetto: "Project",
      descrivi: "Describe what you want to report",
      scrivi_placeholder: "Write...",
      invia: "Send report",
      nessun_progetto: "No project with the reports service enabled.",
      le_tue_segnalazioni: "Your reports",
      nessuna_segnalazione: "You haven't sent any reports yet.",
      vedi_conversazione: "View conversation",
      nascondi_conversazione: "Hide conversation",
      tu: "You",
      operatore: "Operator",
      nessuna_risposta: "No replies yet.",
      rispondi: "Reply",
      scrivi_risposta_placeholder: "Write a reply...",
      invia_risposta: "Send reply",
      caricamento: "Loading",
      stato_gestita: "Handled",
      stato_in_attesa: "Pending",
      errore_progetti: "Error loading projects",
      errore_segnalazioni: "Error loading reports",
      errore_conversazione: "Error loading the conversation",
      segnalazione_inviata: "Report sent successfully",
      errore_invio: "Error sending the report",
      risposta_inviata: "Reply sent",
      errore_invio_risposta: "Error sending the reply"
    },
    AccessibilityToolbar: {
      title: "Accessibility settings",
      toggleLabel: "Accessibility",
      close: "Close accessibility menu",
      textSizeLabel: "Text size",
      increaseText: "Increase text size",
      decreaseText: "Decrease text size",
      textScaleChanged: "Text size set to {value}%",
      accessibleColors: "Accessible colors",
      bigCursor: "Large cursor",
      focusHighlight: "Keyboard focus highlight",
      reducedMotion: "Disable animations",
      easyRead: "High readability font",
      reset: "Reset preferences",
      resetConfirmation: "Accessibility preferences restored.",
      featureEnabled: "{feature} enabled.",
      featureDisabled: "{feature} disabled.",
      skipToContent: "Skip to main content"
    },
    NavigationAdmin: {
      logo_alt: "Application logo",
      menu: "Menu",
      dashboard: "Dashboard",
      servizi: "Services",
      aziende: "Companies",
      aziende_portale_concura: "{app} Portal",
      aziende_sito_pubblico: "Public Website",
      utenti: "Users",
      contatti: "Contacts",
      registrazioni: "Registrations",
      prenotazioni: "Bookings",
      sottoscrizioni: "Subscriptions",
      pagamenti: "Payments",
      voucher: "Vouchers",
      screening: "Screening",
      raccolte: "Collections",
      questionari: "Surveys",
      sessioni: "Sessions",
      piani_terapeutici: "Therapeutic Plans",
      alerts: "Alerts",
      logs: "Logs",
      reports: "Reports",
      impostazioni: "Settings",
      logout: "Logout",
      logout_confirm_title: "Do you want to leave the private area?",
      logout_confirm_ok: "Yes, logout",
      toggle_menu_visibility: "Show or hide the menu",
      toggle_menu_size: "Collapse or expand the menu",
      toggle_submenu: "Open or close submenu {name}"
    },
    PagamentiPiattaforma: {
      titolo: "Platform Payments",
      titolo_prossimi: "Upcoming Payments",
      titolo_passati: "Past Payments",
      data_da: "Date from",
      data_a: "Date to",
      esito: "Outcome",
      rinnovo_abilitato: "Renewal enabled",
      tutti: "All",
      si: "Yes",
      no: "No",
      elementi: "items",
      elementi_per_pagina: "Items per page",
      di: "of",
      totale: "Total",
      totale_ok: "Total OK",
      importo_totale: "Total amount",
      importo_ok: "OK amount",
      prima_attivazione: "First activation",
      rinnovi: "Renewals",
      col_utente: "User",
      col_abbonamento: "Subscription",
      col_prossimo_pagamento: "Next payment",
      col_importo_previsto: "Expected amount",
      col_voucher: "Voucher",
      col_giorni_scadenza: "Days to expiry",
      col_rinnovo: "Renewal",
      col_data_pagamento: "Payment date",
      col_importo: "Amount",
      col_esito: "Outcome",
      col_metodo: "Method",
      col_fattura: "Invoice No.",
      col_oggetto: "Subject",
      scarica_fattura: "Download invoice",
      nessun_pagamento_prossimo: "No upcoming payments found",
      nessun_pagamento_passato: "No past payments found",
      errore_caricamento: "Error loading payments",
      esito_fittizio: "Dummy",
      riepilogo_prossimi: "Upcoming payments summary",
      riepilogo_passati: "Past payments summary",
      voucher_assente: "Absent",
      voucher_applicato: "Applied",
      voucher_valido: "Valid",
      voucher_non_valido: "Invalid",
      rinnovo_attivo: "Automatic",
      rinnovo_disabilitato: "Disabled"
    },
    GestioneAziende: {
      azioni_azienda: "Actions for {name}",
      scheda: "Details",
      chiudi_scheda: "Close details",
      panoramica: "Overview"
    },
    GestioneAziendePubbliche: {
      elementi_per_pagina: "Items per page",
      titolo: "Public Website Companies",
      descrizione: "Manage companies visible in the public website directory",
      nuova_azienda: "New company",
      cerca_placeholder: "Search by name, city, province...",
      filtro_provincia: "Filter by province",
      filtro_regione: "Filter by region",
      filtro_stato: "Filter by status",
      tutte: "All",
      abilitate: "Enabled",
      disabilitate: "Disabled",
      col_denominazione: "Name",
      col_comune: "City",
      col_provincia: "Province",
      col_regione: "Region",
      col_telefono: "Phone",
      col_email: "Email",
      col_sito_web: "Website",
      col_stato: "Status",
      col_azioni: "Actions",
      stato_attivo: "Active",
      stato_inattivo: "Inactive",
      btn_modifica: "Edit",
      btn_elimina: "Delete",
      nessuna_azienda: "No companies found",
      caricamento: "Loading...",
      errore_caricamento: "Error loading companies",
      modal_nuova_titolo: "New Public Website Company",
      modal_modifica_titolo: "Edit Company",
      modal_elimina_titolo: "Confirm deletion",
      modal_elimina_messaggio: "Are you sure you want to delete the company \"{name}\"? This action cannot be undone.",
      form_denominazione: "Company Name",
      form_denominazione_placeholder: "Enter company name",
      form_email: "Email",
      form_email_placeholder: "email@company.com",
      form_telefono: "Phone",
      form_telefono_placeholder: "+39 000 0000000",
      form_indirizzo: "Address",
      form_indirizzo_placeholder: "Street, number",
      form_cap: "ZIP Code",
      form_cap_placeholder: "00000",
      form_comune: "City",
      form_comune_placeholder: "City name",
      seleziona_comune: "Select City",
      form_provincia: "Province",
      form_provincia_placeholder: "e.g. Milan",
      seleziona_provincia: "Select Province",
      form_regione: "Region",
      form_regione_placeholder: "e.g. Lombardy",
      seleziona_regione: "Select Region",
      form_sito_web: "Website",
      form_sito_web_placeholder: "https://www.example.com",
      form_immagine: "Profile image",
      form_immagine_carica: "Upload image",
      form_immagine_rimuovi: "Remove image",
      form_immagine_formati: "Accepted formats: JPEG, PNG, GIF, WebP. Max 2MB",
      form_abilitata: "Company enabled",
      form_abilitata_help: "If enabled, the company will be visible on the public website",
      btn_salva: "Save",
      btn_annulla: "Cancel",
      btn_conferma_elimina: "Delete",
      successo_creazione: "Company created successfully",
      successo_modifica: "Company updated successfully",
      successo_eliminazione: "Company deleted successfully",
      errore_creazione: "Error creating company",
      errore_modifica: "Error updating company",
      errore_eliminazione: "Error deleting company",
      errore_campi_obbligatori: "Please fill all required fields (name, region, city, province)",
      errore_cap_invalido: "ZIP Code must be 5 digits",
      errore_url_invalido: "Enter a valid URL (e.g. https://www.example.com)",
      aria_modifica: "Edit company {name}",
      aria_elimina: "Delete company {name}",
      aria_stato: "Company status: {status}",
      aria_immagine_anteprima: "Company profile image preview"
    },
    ListaPazienti: {
      bottone_richieste: "Requests",
      aria_control_room_richieste: "Open control room requests for {name} {surname}",
      aria_nuova_richiesta: "Create new control room request for {name} {surname}",
      aria_count_richieste: "{count} control room requests",
      nuova_richiesta_modal_title: "New Control Room Request",
      invia_richiesta: "Send request",
      nuova_richiesta_placeholder: "Feature under development",
      funzionalita_in_sviluppo: "Feature under development",
      control_room_modal_ok: "Close",
      control_room_loading: "Loading control room requests...",
      control_room_empty: "No control room requests sent for this patient.",
      control_room_error_load: "Unable to retrieve control room requests",
      control_room_col_codice: "Request code",
      control_room_col_tipo: "Type",
      control_room_col_stato: "Status",
      control_room_col_inviata: "Sent on",
      control_room_col_gestita: "Handled on",
      control_room_col_chiusa: "Closed on",
      control_room_modal_title_generic: "Control room requests",
      control_room_modal_title: "Control room requests for {name} {surname}",
      control_room_table_caption: "List of requests sent to the control room",
      control_room_template_title: "Request details",
      control_room_status_pending: "Pending",
      control_room_status_in_progress: "In progress",
      control_room_status_completed: "Completed",
      control_room_status_rejected: "Rejected",
      control_room_status_cancelled: "Cancelled",
      control_room_type_reservation: "Reservation",
      control_room_type_teleconsultation: "Teleconsultation",
      control_room_type_support: "Support",
      control_room_type_generic: "Generic",
      control_room_error_generic: "Generic error while creating the request",
      control_room_error_incomplete: "Please fill all required fields",
      control_room_request_sent: "Request successfully sent to control room",
      control_room_error_send: "Error sending the request",
      placeholder_nome: "First name",
      placeholder_cognome: "Last name",
      placeholder_username: "Username (email or phone)",
      placeholder_codice_univoco: "Unique code",
      placeholder_codice_fiscale: "Tax code",
      aria_campo_nome: "Search field for patient first name",
      aria_campo_cognome: "Search field for patient last name",
      aria_campo_username: "Search field for username, email or phone",
      aria_campo_codice_univoco: "Search field for patient unique code",
      aria_campo_codice_fiscale: "Search field for tax code",
      ricerca_avanzata: "Advanced search",
      chiudi_ricerca_avanzata: "Close filters",
      filtro_patologia: "Pathology",
      placeholder_patologia: "Filter by pathology...",
      filtro_terapia: "Therapy / Drug",
      placeholder_terapia: "Filter by drug or active ingredient...",
      filtro_prenotazione: "Booking status",
      opzione_tutti: "All patients",
      opzione_con_prenotazione: "With active/future booking",
      opzione_senza_prenotazione: "Without bookings",
      azzera_filtri: "Reset filters",
      tooltip_username: "Username can be the patient's email address or phone number",
      help_username: "Email or phone",
      username_help_title: "Username search",
      username_help_text: "Enter the patient's email address. If the patient was registered without an email, you can search using their phone number.",
      bottone_cerca: "Search",
      aria_bottone_cerca: "Execute patient search",
      colonna_nome_cognome: "Name and Last Name",
      colonna_codice_fiscale: "Tax Code",
      colonna_data_nascita: "Date of Birth",
      colonna_telefono: "Phone",
      colonna_email: "Email",
      colonna_azioni: "Actions",
      codice_univoco_label: "Unique code",
      pin_label: "Pin",
      aria_scheda_assistito: "Open assisted person card for {name} {surname}",
      aria_scheda_medica: "Open medical record for {name} {surname}",
      tooltip_scheda_paziente: "Patient card",
      tooltip_scheda_familiari: "Family members card",
      errore_caricamento: "Unable to load patient list",
      nessun_paziente: "No patient found",
      caricamento_pazienti: "Loading patient list...",
      sottoscrizione_attiva: "Active subscription",
      sottoscrizione_pending: "Subscription awaiting payment",
      sottoscrizione_inattiva: "No subscription"
    },
    ControlRoomRequestCard: {
      aria_toggle: "Expand or collapse {type} request details",
      nessun_dettaglio: "No details available for this request"
    },
    CompilaRichiestaControlRoom: {
      select_placeholder: "Select an option...",
      company_picker_placeholder: "Search facility by name, city or province",
      loading_template: "Loading request template...",
      reservation_type_prestazione: "Healthcare service",
      reservation_type_teleconsulto: "Teleconsultation",
      reservation_type_prodotto: "Pharmaceutical product"
    },
    NuovaRichiestaControlRoom: {
      loading: "Loading...",
      select_type_prompt: "Select the type of request you want to send:",
      aria_select_type: "Select request type",
      no_templates: "No request templates available",
      error_loading_templates: "Error loading available templates",
      error_loading_template: "Error loading request template",
      template_not_found: "Request template not found"
    },
    NuovaRichiestaControlRoomModal: {
      modal_title: "New Control Room Request",
      modal_title_for: "New Control Room Request for {name} {surname}",
      invia_richiesta: "Send request",
      error_generic: "Generic error while sending the request",
      error_incomplete: "Incomplete request. Fill all required fields",
      error_send: "Error while sending the request",
      request_sent: "Request sent successfully"
    },
    ControlRoomRequests: {
      bottone_richieste: "Requests",
      aria_control_room_richieste: "Open control room requests for {name} {surname}",
      aria_nuova_richiesta: "Create new control room request for {name} {surname}",
      aria_count_richieste: "{count} control room requests",
      tooltip_visualizza_richieste: "View requests",
      tooltip_nuova_richiesta: "New request",
      control_room_modal_ok: "Close",
      control_room_loading: "Loading control room requests...",
      control_room_empty: "No control room requests sent for this patient.",
      control_room_error_load: "Unable to retrieve control room requests",
      control_room_modal_title_generic: "Control room requests",
      control_room_modal_title: "Control room requests for {name} {surname}",
      control_room_type_reservation: "Reservation",
      control_room_type_teleconsultation: "Teleconsultation",
      control_room_type_support: "Support",
      control_room_type_generic: "Generic"
    },
    AdminOperatorsList: {
      abilita_tooltip: "Enable account",
      email_verificata: "Email verified",
      password: "Password",
      abilita_utenza_titolo: "Enable operator account",
      abilita_utenza_testo: "Do you confirm enabling this account?",
      nome: "Name",
      email: "Email",
      ruolo: "Role",
      operatore: "operator",
      abilitazione_successo: "Account enabled",
      abilitazione_errore: "Error while enabling the account"
    },
    OperatorFeaturePermissions: {
      titolo_modale: "Feature Permissions",
      gestisci_permessi: "manage permissions",
      gestisci_permessi_aria: "Manage feature permissions for {nome}",
      seleziona_gruppo: "Select all items in group {gruppo}",
      salva: "Save changes",
      applica_a_tutti: "Apply to all operators",
      applica_a_tutti_desc: "Changes will be applied to all operators in the organization",
      applica_a_tutti_label: "Apply changes to all operators in the organization",
      permessi_aggiornati: "Permissions updated",
      errore_caricamento: "Could not load permissions",
      errore_salvataggio: "Could not update permissions",
      permesso_non_disponibile: "One or more permissions are no longer available for this organization. The list has been updated."
    },
    CompanyFeaturePermissions: {
      titolo_modale: "Organization Feature Permissions",
      gestisci_permessi: "Manage Permissions",
      gestisci_permessi_aria: "Manage organization feature permissions",
      descrizione: "Enable or disable features available for this organization. Disabling a feature also revokes it from all operators. Changes will take effect at the operators' next login.",
      seleziona_gruppo: "Select all items in group {gruppo}",
      salva: "Save changes",
      permessi_aggiornati: "Organization permissions updated",
      errore_caricamento: "Could not load organization permissions",
      errore_salvataggio: "Could not update organization permissions"
    },
    RoleDropdownSelect: {
      seleziona_ruolo: "Select a role",
      info_ruolo: "Role information"
    },
    DettaglioAzienda: {
      si: "Yes",
      no: "No",
      gratuita_titolo: "Free of charge for the citizen",
      gratuita_da_progetto: "As per project",
      gratuita_gratuito: "Free",
      gratuita_a_pagamento: "Chargeable",
      gratuita_stato_gratuito: "The citizen gets this service free of charge.",
      gratuita_stato_a_pagamento: "The citizen is charged for this service.",
      gratuita_nota_progetto:
        "A project of this company makes this service free of charge.",
      gratuita_nota_nessun_progetto:
        "No project of this company makes this service free of charge.",
      gratuita_nota_pregresso:
        "Existing bookings are not affected: the choice applies from now on.",
      gratuita_aggiornata: "Charging rule updated successfully",
      gratuita_errore: "An error occurred while updating the charging rule",
      control_room_toggle_active: "Enabled",
      control_room_toggle_inactive: "Disabled",
      control_room_toggle_enable_aria: "Enable Control Room service",
      control_room_toggle_disable_aria: "Disable Control Room service",
      control_room_enable_success: "Control Room service enabled successfully",
      control_room_disable_success: "Control Room service disabled successfully",
      control_room_toggle_error: "An error occurred while updating the Control Room service",
      control_room_unavailable: "Control Room service not available",
      control_room_company_missing: "Company not available",
      cup_privato_si: "Yes",
      cup_privato_no: "No",
      configura: "Configure",
      titolo_configurazione_generico: "Service configuration",
      titolo_configurazione_servizio: "Service configuration {name}",
      nessun_contenuto_configurazione:
        "No configuration content available for this service",
      warning_somministrazione_sottoscrizioni: "Make sure that the \\\"Patients\\\" service is also active to use this feature correctly",
      warning_attivazione_permessi: "Upon service activation, previously configured permissions for the facility and its operators will be automatically restored.",
      warning_disattivazione_permessi: "Disabling the service will hide the corresponding permissions for the facility and its operators. Permissions will be preserved and automatically restored upon reactivation.",
      visibile_only_project_patients: "Searchable only by patients enrolled in projects",
      sede_legale: "Registered Office",
      sede_operativa: "Operational Office",
      sede_legale_denominazione: "Company name",
      sede_legale_titolare: "owner",
      sede_operativa_titolare: "operational office owner",
      sede_legale_partita_iva: "VAT number",
      sede_legale_codice_fiscale: "tax code",
      sede_legale_email: "email",
      sede_legale_pec: "PEC",
      codice_asl: "ASL code",
      comunale: "municipal",
      azienda: "company",
      codice_titolare: "owner code",
      codice_tracciabilita: "tracking code",
      contatti: "contacts",
      telefono: "phone",
      fax: "fax",
      contatto_dpo: "DPO contact"
    },
    NuovaCompany: {
      si: "Yes",
      no: "No",
      nome_titolare: "Owner's first name",
      cognome_titolare: "Owner's last name",
      servizio_somministrazione_label: "The facility can administer subscriptions during enrollment",
      servizio_somministrazione_aria: "Enable subscription administration",
      servizio_control_room_label: "The facility can send requests to the Control Room",
      servizio_control_room_aria: "Enable Control Room request sending",
      visibile_only_project_patients_label: "Searchable only by patients enrolled in projects",
      visibile_only_project_patients_aria: "Limit visibility to patients enrolled in the facility's projects",
      sezione_sede_operativa: "Operational Office",
      sezione_impostazioni_struttura: "Facility Settings",
      sede_operativa_uguale_sede_legale: "Same data as registered office",
      sede_operativa_uguale_sede_legale_aria: "Copy registered office data into operational office",
      sezione_sede_legale: "Registered Office",
      sede_legale_uguale_sede_operativa: "Same data as operational office",
      sede_legale_uguale_sede_operativa_aria: "Copy operational office data into registered office",
      sede_legale_denominazione: "Company name",
      placeholder_denominazione: "company name...",
      sede_legale_nome_titolare: "Owner First Name",
      sede_legale_cognome_titolare: "Owner Last Name",
      partita_iva: "VAT Number",
      codice_fiscale: "Tax Code",
      sede_legale_partita_iva: "VAT Number",
      sede_legale_codice_fiscale: "Tax Code",
      sede_legale_indirizzo: "Address",
      sede_legale_cap: "Postal Code",
      sede_legale_frazione: "District",
      sede_legale_regione: "Region",
      sede_legale_provincia: "Province",
      sede_legale_comune: "Municipality",
      sede_legale_email: "Email",
      sede_legale_pec: "PEC",
      placeholder_nome: "first name...",
      placeholder_cognome: "last name...",
      placeholder_partita_iva: "VAT number...",
      placeholder_codice_fiscale: "tax code...",
      placeholder_indirizzo: "address...",
      placeholder_cap: "postal code...",
      placeholder_frazione: "district...",
      placeholder_email: "email...",
      placeholder_pec: "pec...",
      partita_iva_title: "VAT number must be 11 numeric digits",
      seleziona_regione: "Select Region",
      seleziona_provincia: "Select Province",
      seleziona_comune: "Select Municipality",
      errore_caricamento_province: "Error while loading registered office provinces",
      errore_caricamento_comuni: "Error while loading registered office municipalities",
      errore_sede_legale_obbligatoria: "Fill in the required registered office fields",
      errore_sede_legale_partita_iva: "Registered office VAT number must be 11 numeric digits",
      errore_sede_legale_codice_fiscale: "Registered office tax code is invalid",
      errore_sede_legale_email: "Enter a valid email address for the registered office",
      errore_sede_legale_pec: "Enter a valid PEC address for the registered office",
      sede_legale_telefono: "Phone",
      placeholder_telefono: "phone..."
    },
    ModificaCompany: {
      si: "Yes",
      no: "No",
      servizio_somministrazione_label: "The facility can administer subscriptions during enrollment",
      servizio_somministrazione_aria: "Enable subscription administration",
      servizio_control_room_label: "The facility can send requests to the Control Room",
      servizio_control_room_aria: "Enable Control Room request sending",
      visibile_only_project_patients_label: "Searchable only by patients enrolled in projects",
      visibile_only_project_patients_aria: "Limit visibility to patients enrolled in the facility's projects",
      sezione_sede_operativa: "Operational Office",
      sezione_impostazioni_struttura: "Facility Settings",
      sede_operativa_uguale_sede_legale: "Same data as registered office",
      sede_operativa_uguale_sede_legale_aria: "Copy registered office data into operational office",
      sezione_sede_legale: "Registered Office",
      sede_legale_uguale_sede_operativa: "Same data as operational office",
      sede_legale_uguale_sede_operativa_aria: "Copy operational office data into registered office",
      sede_legale_denominazione: "Company name",
      placeholder_denominazione: "company name...",
      sede_legale_nome_titolare: "Owner First Name",
      sede_legale_cognome_titolare: "Owner Last Name",
      partita_iva: "VAT Number",
      codice_fiscale: "Tax Code",
      sede_legale_partita_iva: "VAT Number",
      sede_legale_codice_fiscale: "Tax Code",
      sede_legale_indirizzo: "Address",
      sede_legale_cap: "Postal Code",
      sede_legale_frazione: "District",
      sede_legale_regione: "Region",
      sede_legale_provincia: "Province",
      sede_legale_comune: "Municipality",
      sede_legale_email: "Email",
      sede_legale_pec: "PEC",
      placeholder_nome: "first name...",
      placeholder_cognome: "last name...",
      placeholder_partita_iva: "VAT number...",
      placeholder_codice_fiscale: "tax code...",
      placeholder_indirizzo: "address...",
      placeholder_cap: "postal code...",
      placeholder_frazione: "district...",
      placeholder_email: "email...",
      placeholder_pec: "pec...",
      partita_iva_title: "VAT number must be 11 numeric digits",
      seleziona_regione: "Select Region",
      seleziona_provincia: "Select Province",
      seleziona_comune: "Select Municipality",
      errore_caricamento_province: "Error while loading registered office provinces",
      errore_caricamento_comuni: "Error while loading registered office municipalities",
      errore_sede_legale_obbligatoria: "Fill in the required registered office fields",
      errore_sede_legale_partita_iva: "Registered office VAT number must be 11 numeric digits",
      errore_sede_legale_codice_fiscale: "Registered office tax code is invalid",
      errore_sede_legale_email: "Enter a valid email address for the registered office",
      errore_sede_legale_pec: "Enter a valid PEC address for the registered office",
      sede_legale_telefono: "Phone",
      placeholder_telefono: "phone..."
    },
    EwsIndicator: {
      tooltip_dati_incompleti: "Incomplete data: open details",
      tooltip_ews_obsoleta: "EWS is stale — recorded {eta} ago, reassessment required",
      tooltip_news2_score: "NEWS2 score: {score} ({rischio})",
      tooltip_storico: "NEWS2 calculation history",
      tooltip_informazioni: "NEWS2 information",
      badge_ews: "EWS: {score} - {date}",
      badge_obsoleta: "— recorded {eta} ago, reassessment required",
      rivaluta: "Reassess",
      chiudi: "Close",
      modale_warning_titolo: "Incomplete clinical data for NEWS2",
      attenzione_calcolo_parziale: "Warning: partial calculation",
      warning_descrizione: "The displayed NEWS2 score is partial because some physiological parameters have not been recorded in the last 4 hours.",
      parametri_mancanti: "Missing parameters",
      warning_nota: "Parameters not measured recently do not contribute to the total score, so the clinical index may be underestimated.",
      modale_info_titolo: "NEWS2 clinical guide (Early Warning Score)",
      info_descrizione: "NEWS2 (National Early Warning Score 2) is the standard recommended by the Royal College of Physicians to assess clinical severity and identify acute deterioration early. The total score is calculated by adding the individual scores (from 0 to 3) assigned to 7 physiological parameters.",
      parametro: "Parameter",
      param_resp_rate: "Respiratory rate (rr)",
      param_spo2_scala_1: "O2 saturation (Scale 1) (%)",
      param_spo2_scala_2: "O2 saturation (Scale 2 / COPD) (%)",
      param_ossigenoterapia: "Supplemental oxygen",
      param_sbp: "Systolic blood pressure (mmHg)",
      param_heart_rate: "Heart rate (hr)",
      param_body_temp: "Body temperature (°C)",
      param_loc: "Level of consciousness (ACVPU)",
      si_ossigeno: "Yes (O2)",
      no_aria: "No (Air)",
      loc_alert_breve: "Alert",
      loc_alterato_breve: "New confusion / V / P / U",
      interpretazione_bande: "Risk band interpretation",
      punteggio_singolo: "Score of 3 on one parameter",
      rischio_basso: "Low risk.",
      rischio_basso_azione: "Standard monitoring.",
      rischio_medio_basso: "Low-medium risk (Override).",
      rischio_medio_basso_azione: "Urgent medical reassessment required.",
      rischio_medio: "Medium risk.",
      rischio_medio_azione: "Requires reassessment and more frequent monitoring.",
      rischio_alto: "High risk.",
      rischio_alto_azione: "Clinical emergency requiring immediate medical escalation.",
      modale_storico_titolo: "EWS calculation history (NEWS2)",
      nessun_calcolo: "No NEWS2 calculation has been recorded for this patient.",
      colonna_data_ora: "DATE AND TIME",
      colonna_punteggio: "SCORE",
      colonna_rischio: "RISK BAND",
      colonna_azioni: "RECOMMENDED ACTIONS",
      colonna_tipo_dati: "DATA TYPE",
      espandi_dettaglio: "Expand calculation details",
      comprimi_dettaglio: "Collapse calculation details",
      parziale: "Partial",
      completo: "Complete",
      snapshot_titolo: "Parameter snapshot at calculation time",
      rilevato_il: "Recorded on {data}",
      non_disponibile: "N/A",
      rischio_non_disponibile: "Not available",
      risk_low: "Low risk",
      risk_low_medium: "Low-medium risk",
      risk_medium: "Medium risk",
      risk_high: "High risk",
      snapshot_resp_rate: "Respiratory rate (rr)",
      snapshot_spo2: "Saturation (spo2)",
      snapshot_suppl_o2: "Supplemental oxygen (suppl_o2)",
      snapshot_body_temp: "Body temperature (temperature)",
      snapshot_sbp: "Systolic pressure (sys)",
      snapshot_heart_rate: "Heart rate (hr)",
      snapshot_loc: "Level of consciousness (loc)",
      loc_a: "A - Alert",
      loc_c: "C - Confusion",
      loc_v: "V - Voice",
      loc_p: "P - Pain",
      loc_u: "U - Unresponsive"
    },
    ArchivioSanitarioComponent: {
      aria_tablist_label: "Health profile sections",
      tab_parametri: "Parameters",
      tab_esami: "Exams",
      tab_sintomi: "Symptoms",
      tab_referti: "Reports",
      tab_altri_file: "Other files",
      tab_questionari: "Surveys",
      tab_sessioni: "Sessions",
      aria_selector_parametri: "Select Parameters section",
      aria_selector_esami: "Select Exams section",
      aria_selector_sintomi: "Select Symptoms section",
      aria_selector_referti: "Select Reports section",
      aria_selector_altri_file: "Select Other files section",
      aria_selector_scores: "Select Scores section",
      aria_selector_questionari: "Select Surveys section",
      aria_selector_sessioni: "Select Sessions section",
      modifica_rilevazione: "Edit measurement",
      elimina_rilevazione: "Delete measurement"
    },
    RilevazioniComponent: {
      aria_tablist_label: "Health record sections",
      tab_parametri: "Parameters",
      tab_esami: "Tests",
      tab_referti: "Reports",
      tab_altri_file: "Other files",
      tab_questionari: "Questionnaires",
      tab_sessioni: "Sessions",
      modifica_rilevazione: "Edit measurement",
      elimina_rilevazione: "Delete measurement"
    },
    SinglePrescriptionAnnotationComponent: {
      toggle_contenuto: "Show/hide annotation content",
      elimina_nota: "Delete prescription note"
    },
    SingleAnnotationComponent: {
      toggle_contenuto: "Show/hide annotation content",
      soapLabel: "medical note",
      visita: "visit/service",
      abilita_modifica: "Enable annotation editing",
      elimina_nota: "Delete annotation"
    },
    PatientPrescriptions: {
      mese_precedente: "Previous month",
      mese_successivo: "Next month"
    },
    NewPrescriptionAnnotationComponent: {
      elimina_allegato: "Delete attachment {name}",
      allegati_referto: "Report attachments",
      conferma_rimozione: "Confirm removal",
      conferma: "Confirm"
    },
    PatientList: {
      vai_a_scheda: "Go to patient record",
      completa: "Complete"
    },
    PreConsulto: {
      appuntiNonSalvati: "Unable to save the consultation notes.",
      consultoNonAvviato: "The connection did not succeed: the consultation stays open and can be restarted.",
      vedi_questionario: "View completed survey",
      vedi_questionario_label: "View survey"
    },
    SchedaFamiliareSperimentazione: {
      toggle_menu: "Expand/collapse section menu",
      conferma_cancellazione: "Confirm deletion",
      conferma: "Confirm",
      errore_cancellazione: "Error during deletion. Please try again.",
      caricamento_episodi: "Loading episodes..."
    },
    SessionDetailModal: {
      dettaglio_sessione: "Session detail",
      questionari_nella_sessione: "Surveys in the session",
      vedi: "View"
    },
    SchedaPaziente: {
      chat_tooltip: "Clinical chat with the patient",
      paziente: "Patient",
      archivio_sanitario: "Health archive",
      apri_archivio_sanitario: "Open health archive",
      paziente_non_in_carico: "The selected user is not in your patient list."
    },
    PersonalizzazioneGrafica: {
      descrizione: "Choose the colours and banner your company shows to patients.",
      banner_descrizione: "The banner appears at the top of the pages of the patients you follow.",
      banner_dimensioni: "Recommended size: 1200×200 pixels.",
      titolo: "Graphic customization",
      descrizione:
        "Configure the platform colors for your organization. Changes will be visible to all operators.",
      sezione_colori: "Colors",
      colore_primario: "Primary color",
      colore_secondario: "Secondary color",
      seleziona_colore_primario: "Select primary color",
      seleziona_colore_secondario: "Select secondary color",
      placeholder_hex: "e.g. #009DA9",
      valore_hex_primario: "Primary color hexadecimal value",
      valore_hex_secondario: "Secondary color hexadecimal value",
      anteprima: "Preview",
      anteprima_bottone_primario: "Primary color button preview",
      anteprima_bottone_secondario: "Secondary color button preview",
      anteprima_bottone_outline: "Outline secondary button preview",
      bottoni: "Buttons",
      bottone_primario: "Primary button",
      bottone_secondario: "Secondary button",
      bottone_outline: "Outline button",
      campioni_colore: "Color swatches",
      primario: "Primary",
      secondario: "Secondary",
      sfondo_primario: "Primary background",
      sfondo_secondario: "Secondary background",
      ripristina_default: "Restore default colors",
      salva_personalizzazione: "Save color customization",
      salva: "Save customization",
      salvataggio_ok: "Graphic customization saved successfully",
      salvataggio_errore: "Could not save customization",
      errore_formato_hex:
        "Invalid color format. Use hexadecimal format (e.g. #009DA9)",
      sezione_banner: "Dashboard banner",
      banner_descrizione:
        "Upload a banner image that will be displayed below the dashboard header for all operators in your organization.",
      carica_banner: "Upload banner",
      sostituisci_banner: "Replace banner",
      rimuovi_banner: "Remove banner",
      banner_dimensioni:
        "Recommended size: 1200×150 px. Accepted formats: JPG, PNG, WebP. Max 8 MB.",
      banner_anteprima: "Dashboard banner preview",
      banner_caricato_ok: "Banner uploaded successfully",
      banner_rimosso_ok: "Banner removed successfully",
      banner_errore_upload: "Could not upload banner",
      banner_errore_rimozione: "Could not remove banner",
      conferma_caricamento: "Confirm upload",
      anteprima_banner_titolo: "Banner preview",
    },
    PatientQuickSearch: {
      titolo: "Find a patient",
      campo: "Search by",
      cognome: "Surname",
      nome: "First name",
      codice_fiscale: "Tax code",
      placeholder_surname: "Patient's surname…",
      placeholder_name: "Patient's first name…",
      placeholder_cf: "Patient's tax code…",
      nessuno: "No enrolled patient matches this.",
      aiuto: "Type at least two letters and pick the patient: their record opens.",
    },
    PatientArchive: {
      download_fallito: "The selected document could not be downloaded",
      download_fallito_titolo: "Download error",
      titolo: "Health archive",
      title: "Other files",
      carica_documento: "Upload document",
      annulla_caricamento: "Cancel upload",
      caricamento_contenuti: "Loading content...",
      nessun_documento: "No documents available",
      nome_documento: "Document",
      data_caricamento: "Upload date",
      azioni: "Actions",
      archivia: "Archive",
      ripristina: "Restore",
      elimina: "Delete",
      visualizza_documento: "View document {name}"
    },
    PatientArchiveCittadino: {
      titolo: "Health archive",
      title: "Other files",
      nuovo_documento: "New file",
      modal_upload_titolo: "Upload new document",
      visualizza: "View",
      scarica: "Download",
      elimina_risorsa: "Delete resource",
      conferma_eliminazione_titolo: "Confirm deletion",
      conferma_eliminazione_testo: "Are you sure you want to permanently delete this document?",
      nessun_documento: "No documents available",
      caricato_da: "Uploaded by",
      aria_visualizza: "View {name}",
      aria_scarica: "Download {name}",
      aria_elimina: "Delete {name}",
      apri_documento: "Open document {name}",
      documento_alt: "Document page",
      anteprima_alt: "Image preview"
    },
    UserLastSessions: {
      titolo: "Latest sessions",
      nuova_sessione: "New session",
      vedi: "View",
      vedi_dettaglio_sessione: "View session details",
      vedi_storico_sessioni: "View sessions history",
      nessuna_sessione: "No sessions available",
      dettaglio_questionario: "Questionnaire detail",
      chiudi: "Close",
      dettaglio_sessione: "Session detail",
      questionari_nella_sessione: "Questionnaires in the session",
      cf_mancante: "A Tax Code is required for clear-type sessions.",
      seleziona_sessione: "Select session",
      procedi: "Proceed",
      cerca_sessione: "Search session",
      nessun_risultato: "No results"
    },
    welcome: "Welcome",
    logout: "Logout",
    profile: "Profile",
    hello: "Hello",
    esci: "Logout",
    seleziona_lingua: "Select language",
    non_verificato_email: "You have not yet verified your email address",
    tooltip_email: "To use the platform, it is necessary to verify your email address",
    non_verificato_telefono: "You have not yet verified your phone number",
    tooltip_telefono: "To use the platform, it is necessary to verify your phone number",
    non_compilata_anagrafica: "You have not yet completed your personal information",
    tooltip_anagrafica: "To fully benefit from all services provided by this platform, it is necessary to complete your personal information",
    titolo_informativa: "Terms and Conditions and Privacy Policy",
    testo_informativa: "To complete the registration, it is necessary to confirm that you have read the",
    condizioni_generali: "general terms and conditions",
    informativa_privacy: "Privacy Policy",
    ho_letto_privacy: "I have read and accept the",
    ho_letto_termini: "I have read and accept the",
    termini_uso: "Terms and Conditions of Service",
    accetto_esplicitamente: "Pursuant to Article 1341 and following of the Civil Code, I expressly accept the provisions of Articles 2, 7, 8, 10, 12 of the present",
    titolo_marketing: "Authorization for commercial communications",
    conferma_scelte: "Confirm my choices",
    registrati: "Register",
    placeholder_password: "Password",
    dimenticato_password: "I forgot my password",
    accedi: "Login",
    testo_recupera_password: "Enter the email address used during registration.",
    placeholder_inserisci_email: "Enter email...",
    alert_demo_cie_spid: "Login with CIE and SPID not available in demo environment",
    mail_inviata: "Email sent! Check your inbox.",
    email_non_valida: "Invalid email address",
    hai_bisogno_aiuto: "Need help?",
    contattaci: "Contact us",
    indietro: "Back",
    registrazione: "Registration",
    registrati_descrizione: "Sign up for free on our platform to enter the world of ConCura and receive a personalized, fast, and always-on service designed to help you take care of your health.",
    numero_supporto: "800.770.272",
    step: "Step",
    sono_cittadino: "I am a citizen",
    sono_operatore: "I am a healthcare professional",
    utenza_disabilitata: "Account Disabled",
    messaggio_utenza_disabilitata: "Your account has been disabled",
    reimposta_password_titolo: "Reset your password",
    reimposta_password_descrizione_1: "The new password must contain at least 8 characters, including a number, an uppercase letter, a lowercase letter and a",
    reimposta_password_descrizione_2: "It must be different from the current one and from the last {count} used.",
    reimposta_password_carattere_speciale: "special character",
    tooltip_password_special_chars: "Any symbol counts, for example ! @ # $ % & * ? , . _ -",
    placeholder_nuova_password: "Password...",
    placeholder_conferma_password: "Confirm password...",
    credenziali_errate: "Invalid credentials.",
    salva_nuova_password: "Save new password",
    manuali_uso: "User Manuals",
    video_tutorial: "Tutorial Videos",
    scarica_versione_aggiornata: "Download the updated version",
    scarica_versione_inglese: "Download the English version",
    ultima_versione: "Latest version",
    altre_versioni: "Other versions",
    nessun_manuale: "No manuals available",
    scarica_selezionato: "Download selected version",
    recupera_password: "Recover your password",
    mail_inviata_controlla: "Email sent! Check your inbox.",
    non_ho_ricevuto_email: "I haven't received the email",
    inserisci_email_registrazione: "Enter the email address used during registration.",
    placeholder_email: "email@ ...",
    caricamento: "Loading...",
    carica: "Upload",
    salvataggio: "Saving...",
    invia: "Send",
    non_ricordo_email: "I don't remember the email address",
    sms_inviato_cf: "An SMS with the password reset link has been sent to the phone number associated with this tax code. Please wait a moment.",
    non_ho_ricevuto_sms: "I haven't received the SMS",
    inserisci_codice_fiscale: "Enter your tax code.",
    sms_inviato_telefono_riserva: "An SMS with the reset link was sent to the backup number associated with this tax code, if set. Please wait a moment.",
    nessun_link_contatta_assistenza: "If it wasn't set or you didn't receive any link and couldn't access the system,",
    invia_richiesta_supporto: "send a support request",
    torna_login: "Back to login page",
    invia_numero_riserva: "Send to backup number",
    registrazione_successo: "Registration completed successfully!",
    benvenuto: "Welcome",
    email_confermata_successo: "Thank you for confirming your email address.",
    email_gia_verificata: "Email already verified.",
    email_gia_verificata_descrizione: "You have already confirmed your email address. If not yet done, proceed with filling out your personal information sheet.",
    vai_scheda_anagrafica: "Personal data form",
    vai_al_login: "Go to login",
    conferma_email: "Confirm your email",
    link_non_valido: "The link used is no longer valid.",
    email_non_ricevuta_controlla_spam: "If you haven't received the confirmation email, check your spam folder or",
    richiedi_nuova_mail: "request a new confirmation email",
    invia_nuova_mail: "Send new email",
    verifica_numero_telefono: "Verify your phone number",
    verifica_istruzioni_1: "To use the platform, you must complete the registration by verifying the provided phone number.",
    verifica_istruzioni_link: "Check the number provided.",
    verifica_istruzioni_2: 'Click on "send verification code" to receive an OTP via SMS.',
    inserisci_numero_telefono: "Enter your phone number",
    inserisci_istruzioni: "To use the platform, you need to enter and verify your phone number.",
    etichetta_numero_telefono: "Phone number:",
    placeholder_numero: "1234...",
    salva_numero: "Save number",
    invia_codice_verifica: "Send verification code",
    verifica_fuori_piattaforma: "Verify phone number outside the platform",
    verifica_otp: "OTP Verification",
    codice_verificato: "Code successfully verified!",
    prosegui_istruzioni: "Thanks for completing the process. Click 'Close' to proceed.",
    sms_inviato: "We have sent the verification code via SMS to the number {numero}",
    inserisci_codice: "Enter the numeric code received via SMS:",
    otp_status_0: "Verification code sent",
    otp_status_minus1: "System error",
    otp_status_1: "Code successfully verified",
    otp_status_2: "Incorrect code",
    otp_status_3: "Code expired",
    otp_status_4: "Code already verified",
    otp_status_5: "Code deleted",
    codice_scade: "The code will expire in",
    secondi: "seconds",
    codice_scaduto: "Code expired",
    non_ricevuto: "Didn't receive the code?",
    invia_nuovo_codice: "Send new code",
    alternativa: "Alternatively,",
    invia_otp_riserva: "send OTP to backup number (if available).",
    chiudi: "Close",
    verifica: "Verify",
    verifica_non_completata: "Verification could not be completed.",
    verifica_controlla_assistenza: "Check that the contact number in the profile is correct. If the problem persists, contact support.",
    verifica_manuale: "Manual Verification",
    manuale_istruzioni: "Please call the user to verify their contact.",
    chiama: "Call",
    contrassegna_verificato: "Mark number as verified",
    non_possibile_effettuare_procedura: "The procedure could not be completed.",
    numero_verificato_successo: "Number successfully verified.",
    errore_verifica_numero: "An error occurred during phone number verification.",
    vai_homepage: "Go to Homepage",
    errore_salvataggio_pagamento: "Payment saving failed. Please check in your private area.",
    effettua_login: "Please log in",
    richieste_prenotazione: "Active services",
    servizi_prenotabili: "Bookable services",
    prenota_visite_prestazioni: "Book visits and procedures",
    richiedi_farmaci: "Request medications",
    prenota_teleconsulto: "Book a teleconsultation",
    contatta_medico: "Contact a doctor",
    chat_con_medico: "Chat with the doctor",
    chat_con_medico_desc: "Message the doctors who follow you",
    teleconsulto_rapido_desc: "A doctor contacts you within 60 minutes",
    teleconsulto_pediatrico_desc: "For your children, a paediatrician answers",
    visite_prestazioni: "Visits and procedures",
    farmaci: "Medications",
    teleconsulti: "Teleconsultations",
    errore_recupero_prenotazioni: "Unable to retrieve recent bookings",
    HomeHealthSummary: {
      titolo: "Your health profile",
      nessunParametro: "No parameters recorded.",
    },
    CittadinoHome: {
      hero_titolo: "Talk to a doctor",
      hero_testo_rapido:
        "A doctor calls you back within 60 minutes. For anything that can wait, message the doctors who follow you.",
      hero_testo_chat:
        "Message the doctors who follow you: they reply in your chat.",
      da_fare_titolo: "To do today",
      da_fare_scorri: "Scroll the to-do list",
      da_fare_precedenti: "Previous to-dos",
      da_fare_successivi: "Next to-dos",
      prenota_titolo: "Book a service",
      prenota_visite: "Visits and services",
      prenota_farmaci: "Medicines and products",
      prenota_teleconsulto: "Specialist teleconsultation",
    },
    DaRicordare: {
      titolo: "Your appointments",
      appuntamenti: "Appointments",
      promemoria: "Reminders",
      prossimiAppuntamenti: "Upcoming appointments",
      nessunAppuntamento: "No appointments scheduled.",
      teleconsulto: "Teleconsultation",
      visita: "Visit",
      ordine: "Order",
    },
    buongiorno: "Good morning",
    buon_pomeriggio: "Good afternoon",
    buona_sera: "Good evening",
    attesa_pagamento: "waiting for payment",
    vai_alla_prenotazione: "Go to booking",
    vedi_dettagli_prenotazione: "View booking details",
    nessuna_prenotazione_oggi: "No bookings for today.",
    vedi_tutte_sottoscrizioni: "View all subscriptions",
    piano_attivo: "Active plan",
    durata_minima: "Minimum duration",
    si_rinnova_il: "Renews on",
    scadra_il: "Expires on",
    leggi_di_piu: "Read more",
    cosa_prevede_sottoscrizione: "What's included in your subscription",
    prestazioni_disponibili: "Available services",
    ordine_farmaci_disponibili: "Available medication orders",
    effettua_upgrade_sottoscrizione: "Upgrade your subscription",
    gratis: "FREE",
    piani: "Plans",
    mese: "month",
    anno: "year",
    subscriptionDetail: {
      base: "Basic Subscriptions",
      advanced: "Advanced Subscriptions",
      monitoring: "Monitoring Subscriptions"
    },
    successUpdate: "Personal information updated successfully!",
    convenzioni: "Affiliations",
    richiedi_voucher: "Request voucher",
    richiedi_teleconsulto_rapido: "Request Quick Teleconsultation",
    teleconsulto_rapido: "Quick Teleconsultation",
    medico_contatto_entro_60_minuti: "A doctor will contact you within 60 minutes of the request.",
    durata_massima_15_minuti: "The Quick Teleconsultation lasts a maximum of 15 minutes.",
    scrivi_motivo: "Write the reason",
    iva_esclusa: "+ VAT",
    riprova: "Retry",
    annulla: "Cancel",
    rimuovi: "Remove",
    in_attesa_di_risposta: "Waiting for response",
    medico_presto_disponibile: "A doctor will soon handle your request",
    programmato_ore: "Scheduled at",
    clicca_per_pagamento_nexi: "Click on 'Complete Purchase' to start the secure Nexi payment session and finalize your purchase.",
    clicca_per_privacy_nexi: "Click",
    carte_accettate: "Accepted cards:",
    completa_acquisto: "Complete Purchase",
    link_pagamento_inviato: "A payment link has been sent to your email address.",
    errore_pagamento_link: "Unable to initialize the payment. Please contact support.",
    errore_salvataggio_pagamento_semplice: "Payment saving error",
    non_puoi_lasciare_pagina_pagamento: "You can't leave this page during the payment process.",
    richiedi_tc_pediatrico: "Request Pediatric Teleconsultation",
    teleconsulto_pediatrico: "Pediatric Teleconsultation",
    tc_pediatrico_descrizione_1: "A doctor will contact you within 60 minutes of the request.",
    tc_pediatrico_descrizione_2: "The Pediatric Teleconsultation has a maximum duration of 15 minutes.",
    motivo_richiesta: "Reason for request",
    placeholder_motivo: "Enter the reason",
    costo_prestazione: "Service cost",
    iva_inclusa: "VAT included",
    piu_iva: "+ VAT {percentuale} %",
    in_attesa_risposta: "Waiting for response",
    tc_medico_in_carico: "A doctor will soon take charge of your request",
    rimani_collegato: "Stay connected",
    programmato_per_ore: "Scheduled for",
    avvia_ora: "Start now",
    errore_info_pagamento: "Unable to retrieve payment information",
    errore_inoltro_richiesta: "Unable to submit the request",
    nessun_operatore_disponibile: "No operator available at this time",
    transazione_non_finalizzata: "Transaction not finalized",
    errore_operazione: "Operation could not be completed",
    registra_familiare: "Register Family Member",
    scegli_familiare: "Choose family member",
    titolo_nuovo_familiare: "New Family Member",
    placeholder_nome: "First name...",
    placeholder_cognome: "Last name...",
    placeholder_cf: "Tax code...",
    numero_tessera_sanitaria: "Health Card Number",
    placeholder_ts_number: "Card number...",
    fascia_eta: "Age Range",
    seleziona_fascia_eta: "Select age range",
    relazione: "Relationship",
    seleziona_relazione: "Select relationship",
    campi_obbligatori: "*Required fields",
    salva: "Save",
    nuovo_familiare_successo: "New family member successfully added!",
    errore_salvataggio_familiare: "It was not possible to save the information.",
    tutti: "All",
    nuovo: "New",
    paziente_non_trovato: "Patient not found",
    data_di_nascita: "Birthday",
    non_indicata: "Not indicated",
    i_tuoi_familiari: "Your family members",
    aggiungi: "Add",
    tooltip_familiari_1: "People not registered on the platform that you added as family members.",
    tooltip_familiari_2: "Click \"+\" to create new members: once added you can book drugs and services for them.",
    i_tuoi_assistiti: "Your assisted persons",
    tooltip_assistiti: "People who chose you as their caregiver. They allowed you to book services and medications on their behalf.",
    nessun_assistito_registrato: "There are no assisted persons registered for this account.",
    i_tuoi_caregiver: "Your caregivers",
    tooltip_caregivers: "People who take care of you. They are allowed to book services and medications for you.",
    nessun_caregiver_registrato: "There are no caregivers registered for this account.",
    vuoi_abilitare: "Do you want to enable",
    vuoi_disabilitare: "Do you want to disable",
    come_tuo_caregiver: "as your caregiver?",
    conferma_informativa: "To confirm, you must acknowledge that you have read the privacy policy.",
    ho_letto_informativa: "I have read and understood the privacy policy",
    acconsento_trattamento_dati: "I consent to the processing of my personal data for the purposes stated in the policy",
    no_annulla: "No, Cancel",
    si_conferma: "Yes, Confirm",
    si_elimina: "Yes, delete",
    si_procedi: "Yes, proceed",
    conferma_eliminazione: "Confirm deletion",
    nessun_utente_selezionato: "No user selected",
    errore_recupero_informazioni: "It was not possible to retrieve the information.",
    caregiver_abilitato: "Caregiver enabled",
    caregiver_disabilitato: "Caregiver disabled",
    abilita_caregiver: "Enable caregiver",
    disabilita_caregiver: "Disable caregiver",
    registrazione_step: "Step {n}",
    titolo: "Title",
    nome: "First name",
    cognome: "Last name",
    codice_azienda: "Company code",
    tooltip_codice_azienda: "The company code can be found in the settings section of the administrator operator",
    inserisci_codice_azienda: "Enter the 10-digit code provided by your company.",
    codice_fiscale: "Tax code",
    data_nascita: "Date of birth",
    genere: "Gender",
    maschile: "male",
    femminile: "female",
    nazione_nascita: "Country of birth",
    indirizzo: "Address and house number",
    telefono: "Phone number",
    ordine: "Order",
    id_albo: "Professional Order ID",
    specializzazione: "Specialization",
    specializzazione_placeholder: "Medical specialization...",
    consulta_termini: "View Terms and Conditions of Service",
    completa: "Complete",
    informativa_commerciale: "Authorization for commercial communications",
    accetta_informativa: "I have read and accept the Privacy Policy",
    accetta_termini: "I have read and accept the Terms and Conditions of Service",
    accetta_articoli: "Pursuant to Articles 1341 et seq. of the Civil Code, I expressly accept the provisions of Articles 2, 7, 8, 10, 12 of these Terms and Conditions of Use",
    acconsento_marketing: "I consent to receiving promotional communications for marketing purposes",
    avanti: "Forward",
    regione_residenza: "Region of residence",
    regione: "Region",
    provincia: "Province",
    provincia_residenza: "Province of residence",
    comune: "City",
    comune_residenza: "City of residence",
    indirizzo_numero_civico: "Address and street number",
    cap: "ZIP code",
    seleziona_regione: "Select Region",
    seleziona_provincia: "Select Province",
    seleziona_comune: "Select City",
    placeholder_indirizzo: "Address",
    placeholder_cap: "ZIP",
    email: "Email",
    numero_telefono: "Phone number",
    telefono_fisso: "Landline phone",
    aderisco_progetto: "Join the project",
    nessun_progetto: "No project",
    nessuna_selezione: "--",
    password: "Password",
    conferma_password: "Confirm password",
    password_requisiti: "The password cannot include your name or surname and must contain at least 8 characters, including one number, one uppercase, one lowercase and one",
    carattere_speciale: "special character",
    tooltip_carattere_speciale: "Any symbol counts, for example ! @ # $ % & * ? , . _ -",
    termini_condizioni_privacy: "Terms and Privacy Policy",
    concludi_registrazione_testo: "To complete the registration, it is necessary to confirm that you have read the",
    termini_condizioni_link: "general terms and conditions",
    informativa_privacy_link: "Privacy Policy",
    accetto_informativa_privacy: "I have read and accept the",
    accetto_comunicazioni_commerciali: "I agree to receive promotional communications as per the Privacy Policy",
    progetto_selezionato_testo: "**By selecting the project {projectName}, the healthcare facility involved will be added to your circle of care",
    consulta_informativa_privacy: "View Privacy Policy",
    accetto_termini_condizioni: "I have read and accept",
    termini_condizioni_uso: "Terms and Conditions of Service",
    non_accetto: "I do not accept",
    e: "and",
    accetto_articoli_cc: "Pursuant to Article 1341 and following of the Civil Code, I expressly accept the provisions of Articles 2, 7, 8, 10, 12 of the",
    autorizzazione_marketing: "Authorization for marketing communications",
    accetto_marketing: "I consent to receiving marketing communications for promotional purposes as described in the",
    scheda: {
      rilevazioni: "Measurements",
      patologie: "Conditions",
      terapie: "Therapies",
      note: "Notes",
      dispositivi: "Devices",
      genere: "Gender",
      regione: "Region",
      indirizzo: "Address",
      data_nascita: "Date of birth",
      provincia: "Province",
      telefono: "Phone number",
      codice_fiscale: "Tax Code",
      comune: "Municipality",
      email: "Email",
      non_indicato: "Not specified",
      utente_non_trovato: "User not found",
      alert_recupero_errore: "Unable to retrieve information."
    },
    familiari: {
      nessun_familiare: "No family members registered for this account.",
      familiari: "Family members",
      annulla: "Cancel",
      salva: "Save",
      nessun_elemento_selezionato: "No member selected",
      alert_recupero_errore: "Unable to retrieve the requested information.",
      alert_creazione_successo: "Family member added succesfully",
      alert_creazione_errore: "Unable to invite your family member",
      alert_invito_successo: "Family member invited successfully",
      alert_salvataggio_successo: "Information updated successfully",
      alert_salvataggio_errore: "Unable to update the information.",
      eta_pediatrica: "Pediatric age",
      adulto: "Adult",
      anziano: "Elderly",
      figlio: "Child",
      genitore: "Parent",
      coniuge: "Spouse",
      convivente: "Partner",
      nipote: "Grandchild",
      altro_parente: "Other (relative)",
      altro_non_parente: "Other (non-relative)",
      ts_non_inserita: "Not entered",
      seleziona_tipo_inserimento: "Select the type of entry",
      inserimento_semplice: "Simple entry",
      inserimento_semplice_descrizione: "Manually enter a user not already in the system",
      utente_registrato: "Registered user",
      utente_registrato_descrizione: "If the user is already in the platform, you can add them via user code",
      nuovo_familiare: "New family member",
      condivisione_dati: "Your family member's identifying data will be shared with the healthcare professionals in your care circle",
      nome: "First name",
      nome_placeholder: "First name...",
      cognome: "Last name",
      cognome_placeholder: "Last name...",
      cf: "Tax code",
      cf_placeholder: "Tax code...",
      ts: "Health card number",
      ts_placeholder: "health card number...",
      fascia_eta: "Age group",
      fascia_eta_seleziona: "select age group",
      relazione: "Relationship",
      relazione_seleziona: "Select relationship",
      genere: "Gender",
      maschile: "male",
      femminile: "female",
      autorizzazione_dichiarazione: "* In accordance with DPR no. 445/2000, I declare that I am authorized, by law or by my family member, to use the ConCura services to manage their medical data on their behalf",
      campi_obbligatori: "*Required fields",
      richiesta_codice_descrizione: "Search for a relative or assisted person using their user code – available in the 'Settings' section under 'Personal user code' – and invite them to join your family. The invited user will receive an email through which they can accept your invitation and designate you as their caregiver.",
      label_codice: "Enter user code",
      placeholder_codice: "User code...",
      bottone_cerca: "Search",
      utente_trovato: "User found:",
      domanda_inviare_richiesta: "Send request?",
      invia_richiesta: "Send request",
      invita: "Invite",
      utente_non_trovato: "No user found.",
      alert_codice_non_trovato: "User code not associated with any user"
    },
    informativa: {
      titolo: "PRIVACY POLICY FOR BOOKING, ORDER AND TELECONSULTATION SERVICES MANAGED BY FAMILY MEMBERS AND CAREGIVERS",
      sottotitolo: "(Art. 14 EU Reg. 679/2016)",
      blocco_1: `
      <h6 class="text-center bg-primary text-white py-2 border-bottom border-dark">Who processes my relative's/assisted person's data?</h6>
      <p class="px-1 mb-0 border-bottom border-dark">
        The Data Controller is the healthcare entity affiliated with <b>{{ appName }}</b> that processes your personal data for all the purposes listed below.
        You can view their contact details in the <span class="text-prim-grad-1 fw-bolder">"My care facility"</span> section of your personal area.
      </p>
    `,
      quali_dati: `
      <h6 class="text-center">1. WHAT PERSONAL DATA IS PROCESSED?</h6>
      <p>The Controller will process the following personal data:</p>
      <ul>
        <li>First and last name</li>
        <li>Tax code</li>
        <li>Health insurance card number (optional)</li>
        <li>Age group</li>
        <li>Relationship with your caregiver (e.g. child, parent, relative, etc.)</li>
        <li>Type, date and time of the service</li>
        <li>Product related to the order</li>
        <li>NRE and REV code of the prescription</li>
        <li>Prescription in PDF format (optional)</li>
        <li>Medical condition for teleconsultation</li>
        <li>Teleconsultation date and time</li>
      </ul>
    `,
      finalita: `
      <h6 class="text-center">2. FOR WHAT PURPOSES IS MY DATA PROCESSED AND WHY IS IT LEGAL?</h6>
      <p>The Controller processes your data to allow you to book through a family member/caregiver:</p>
      <ul>
        <li>services at the pharmacy;</li>
        <li>orders at the pharmacy;</li>
        <li>teleconsultation services at the pharmacy.</li>
      </ul>
      <p>This processing is lawful because:</p>
      <ul>
        <li>for common data (e.g. personal info), it is necessary for the execution of a contract;</li>
        <li>for health data, it is based on consent given through the caregiver, approved or inserted as such via the platform.</li>
      </ul>
    `,
      comunicazioni: `
      <h6 class="text-center">3. WHO IS MY DATA SHARED WITH?</h6>
      <p>Your data is shared with:</p>
      <ul>
        <li>the IT consultancy company Qwince Innovation S.r.l. for platform management;</li>
        <li>the individuals (e.g. family members, caregivers) you choose to share your data with via the platform.</li>
      </ul>
      <p>
        You may request a full list of recipients by writing to
        <a href="mailto:assistenza@concura.online">assistenza@concura.online</a>. Your data will not be disclosed publicly.
      </p>
    `,
      trasferimenti: `
      <h6 class="text-center">4. IS MY DATA TRANSFERRED OUTSIDE THE EU?</h6>
      <p>No, your data is not transferred outside the European Union.</p>
    `,
      conservazione: `
      <h6 class="text-center">5. HOW LONG IS MY DATA STORED?</h6>
      <p>
        Your data will be stored as long as your account is active. Once deactivated, your data will be either permanently deleted or anonymized.
      </p>
    `,
      profilazione: `
      <h6 class="text-center">6. WILL I BE PROFILED?</h6>
      <p>
        No, your data will not be used for profiling or subject to any automated decision-making.
      </p>
    `,
      diritti: `
      <h6 class="text-center">7. WHAT ARE MY RIGHTS?</h6>
      <p>You have the following rights:</p>
      <ul>
        <li><b>Right of access:</b> to obtain confirmation and a copy of your data.</li>
        <li><b>Right to rectification:</b> to correct or complete your data.</li>
        <li><b>Right to erasure:</b> to delete your data if no longer needed, processed unlawfully, or due to legal obligations.</li>
        <li><b>Right to restriction:</b> to restrict processing in specific circumstances (e.g., accuracy disputed, legal claims).</li>
        <li><b>Right to data portability:</b> to receive your data in a structured format and transmit it to another controller.</li>
        <li><b>Right to object to automated decision-making:</b> including profiling, if it significantly affects you.</li>
      </ul>
      <p>You can exercise your rights by writing to the Data Controller. You will receive a reply within 30 days.</p>
    `,
      raccolta: `
      <h6 class="text-center">8. HOW DID THE CONTROLLER OBTAIN MY DATA?</h6>
      <p>Your data was provided by your family member or caregiver.</p>
    `,
      reclamo: `
      <h6 class="text-center">9. HOW CAN I FILE A COMPLAINT?</h6>
      <p>
        If you wish to file a complaint regarding how your data is handled, you can contact the competent authority via
        <a href="https://www.garanteprivacy.it" target="_blank">www.garanteprivacy.it</a>.
      </p>
    `
    },
    utente_non_trovato: "User not found",
    misurazioni: {
      parametri: "Parameters",
      esami: "Exams",
      referti: "Reports",
      nuovo_parametro_btn: "New parameter",
      inserisci: "Add",
      inserisci_parametro: "Add {nome}",
      nuova_rilevazione_sintomo: "New symptom",
      nuovo_parametro_title: "New parameter measurement",
      nuova_rilevazione_sintomo_title: "New symptom measurement",
      intensita_sintomo_aria: "Intensity of symptom {nome}, whole number from 1 to 10",
      trova_parametro: "Find parameter",
      nuovo_esame_btn: "New exam",
      nuovo_esame_title: "New exam measurement",
      nuovo_referto_btn: "New report",
      nessuna_rilevazione: "No measurements recorded.",
      nessun_referto: "No reports uploaded.",
      nuovo_referto_title: "New report",
      referto_carica_da_file: "Upload report from file",
      referto_scrivi: "Write report",
      referto_carica_desc: "Upload an existing PDF or image",
      referto_scrivi_desc: "Compose the report with Assessment, Prescription and attachments",
      referto_modal_question: "How do you want to create the report?",
      cerca: "Search...",
      inserisci_data: "Enter date",
      inserisci_ora: "Enter time",
      valore_placeholder: "Value*",
      visibile_solo_a_me: "visible only to me**",
      storico: "History",
      anno: "Year",
      mese: "Month",
      giorno: "Day",
      valori_rilevati: "Measured values",
      referto_seen: "downloaded",
      referto_unseen: "not yet downloaded",
      nessuna_altra_rilevazione: "No other measurements available",
      modifica_valore: "Edit Value",
      conferma: "Confirmation",
      si_elimina: "Yes, delete",
      no_annulla: "No, cancel",
      data_ora: "Date and Time of Measurement",
      valori_riferimento: "Reference values",
      annotazioni: "Notes",
      fuori_soglia_lab: "Value outside lab reference range",
      parametro_osservato: "The parameter is being monitored.",
      parametro_non_osservato: "Parameter not monitored.",
      visualizza_soglie: "View thresholds",
      imposta_soglie: "Set thresholds",
      tutti: "all",
      nuovo_parametro: "New parameter measurement",
      nuovo_esame: "New exam measurement",
      nuovo_referto: "New report upload",
      referti_richiedono_sottoscrizione: "Uploading reports requires an active subscription.",
      errore_generico: "Something went wrong",
      inserimento_successo: "Measurement successfully added",
      inserimento_errore: "Unable to insert the measurement",
      aggiornamento_successo: "Measurement successfully updated",
      aggiornamento_errore: "Unable to update the measurement",
      eliminazione_successo: "Measurement successfully deleted",
      eliminazione_errore: "Unable to delete the measurement",
      download_errore: "Unable to download the resource",
      referto: "this report",
      esame: "this exam",
      rilevazione: "this measurement",
      visibileSoloMe: "**if you select this option, only you will be able to view",
      scarica: "Download",
      aggiungi: "add",
      salva_modifiche: "Save changes",
      cancel_title: "Cancel",
      soglie_parametro: "Thresholds for parameter {parametro}",
      elimina_valore: "Do you want to delete this value of",
      mesi: {
        gennaio: 'January',
        febbraio: 'February',
        marzo: 'March',
        aprile: 'April',
        maggio: 'May',
        giugno: 'June',
        luglio: 'July',
        agosto: 'August',
        settembre: 'September',
        ottobre: 'October',
        novembre: 'November',
        dicembre: 'December'
      }
    },
    soglie: {
      valori_soglia_per_parametro: "Threshold values for the parameter",
      descrizione_soglie_custom: "By configuring critical threshold values for a parameter, an alert will be triggered when the patient enters an out-of-range value, corresponding to the appropriate severity level. Values below the 'normal' range are displayed on the left side of the table, while values above are shown on the right. Click the pencil icon to edit the threshold for the selected severity. You can configure from a minimum of 1 to a maximum of 7 thresholds.",
      valori_default_parametro: "Default values for the parameter",
      descrizione_valori_default: "Below are the available threshold values for the parameter. Click on \"use default values for monitoring\" to apply them for the patient. After saving, you can customize them if needed according to the patient's needs.",
      usa_default: "Use default values for monitoring",
      nessun_valore_default: "No default values available for the parameter",
      soglie_personalizzate: "custom thresholds",
      errore_generico: "Something went wrong",
      valori_modificati_successo: "Values successfully updated",
      errore_modifica_valori: "Unable to update the value",
      note_aggiornate: "Notes successfully updated",
      errore_note: "Unable to update the notes",
      soglia_eliminata: "Threshold successfully deleted",
      errore_eliminazione: "Unable to delete the threshold",
      valori_impostati: "Values successfully set",
      conferma_operazione: "Confirm action",
      si_elimina: "Yes, delete",
      no_annulla: "No, cancel",
      sicuro_eliminare: "Are you sure you want to delete this threshold?",
      modifica_note: "Edit notes",
      note_soglia: "Threshold notes",
      note_titolo: "Threshold Notes",
      note_descrizione: "You can enter notes here to suggest or take actions in case the parameter falls within the selected threshold, for diagnostic (Diagnostic protocol) and/or operational (Operational protocol) purposes. Fill in either one or both fields.",
      protocollo_diagnostico: "Diagnostic protocol:",
      protocollo_operativo: "Operational protocol:",
      placeholder_diagnostico: "Diagnostic test suggested, consult with...",
      placeholder_operativo: "Suggested to check, take, interrupt...",
      annulla: "Cancel",
      salva_note: "Save notes"
    },
    PatologieComponent: {
      nessuna: "No condition recorded",
      title: "Pathologies",
      new: "new pathology",
      create: "Create therapy for",
      primaria: "Primary",
      priorita: "Priority",
      impostaPrimaria: "Set as primary",
      impostaPrimariaHelp: "Only one pathology can be primary at a time",
      searchTitle: "Search pathology",
      searchPlaceholder: "Search pathology by name or code...",
      searchDescription: "*source: updated ICD-10 classification",
      selectPatologia: "Select pathology",
      nomePatologia: "Pathology name*",
      tipo: "Type*",
      inizio: "Start date",
      fine: "End date",
      visibileSoloAMe: "visible only to me**",
      visibilitaDescrizione: "**if you select this option only you will be able to see this pathology",
      annotazioni: "Notes",
      campiObbligatori: "*Required fields",
      annulla: "Cancel",
      salva: "Save",
      modifica: "Edit",
      inseritaIl: "entered on",
      codicePatologia: "Pathology Code (ICD-10):",
      vedi: "View",
      successSave: "Pathology successfully saved!",
      failSave: "Unable to save the pathology",
      successUpdate: "Changes saved successfully!",
      failUpdate: "Unable to save changes",
      failFetch: "Unable to retrieve pathologies",
      cronica: "chronic",
      acuta: "acute",
      stagionale: "seasonal",
      data_inizio: "start",
      dal: "from",
      al: "to",
      seleziona_patologia: "Select pathology",
      vedi_dettaglio: "View pathology details"
    },
    IndiceAderenza: {
      title: "Adherence Index",
      references: "Reference:",
      level0: "not determinable",
      level1: "poor",
      level2: "medium",
      level3: "optimal"
    },
    TerapieComponent: {
      activeTitle: "Current therapies",
      newTherapy: "new therapy",
      downloadProspetto: "Therapy Overview",
      until: "Until",
      since: "Since",
      finished: "end date",
      historyTitle: "Therapy history",
      noHistory: "No items in the history",
      edit: "Edit",
      resume: "Resume",
      suspend: "Suspend",
      downloadReminder: "Download reminder",
      createdAt: "Inserted on:",
      deleteConfirmTitle: "Delete confirmation",
      deleteConfirmText: "Do you confirm you want to delete the therapy?",
      downloadError: "It was not possible to download the overview.",
      fetchError: "Unable to retrieve therapies",
      suspended: "suspended",
      resumed: "resumed",
      therapy: "Therapy",
      operationFailed: "The operation could not be completed",
      deleted: "Therapy deleted!",
      deleteError: "Unable to delete the therapy",
      downloadReminderError: "Unable to download the reminder",
      si_conferma: "Yes, confirm",
      no_annulla: "No, cancel",
      scaricaProspetto: "Download Therapy Summary",
      nuovaTerapia: "New Therapy",
      elimina: "Delete",
      elimina_terapia: "Delete therapy",
      vedi: "View",
      vedi_terapia: "View therapy details",
      conferma: "Confirm",
      testoConfermaSospensione: "Do you confirm you want to {azione} the therapy?",
      azioneSospendere: "suspend",
      azioneRiprendere: "resume"
    },
    RecapTherapy: {
      pathology: "pathology",
      indicazione: "indication",
      noPathology: "No pathology specified",
      dosage: "Dosage",
      of: "of",
      byRoute: "by route",
      toTake: "To be taken:",
      duration: "Duration",
      from: "From",
      until: "until",
      followEvery: "The therapy must be followed every",
      for: "for",
      startingFrom: "starting from",
      undefined: "undefined",
      notes: "Notes",
      noNotes: "no notes",
      details: "Details",
      prescriber: "Prescriber",
      source: "Information source",
      sideEffects: "Side effects",
      allergicReactions: "Allergic reactions",
      interactions: "Interactions",
      notIndicated: "not indicated",
      reminder: "Reminder",
      tenMinutesBefore: "10 minutes before administration",
      adherenceIndex: "Adherence index",
      selectDrug: "Select drug",
      searchDrug: "Search drug by name..",
      notFound: "Product not found",
      frequency: "Frequency",
      frequencyAndDosage: "Frequency, method and dosage",
      daily: "daily",
      asNeeded: "as needed",
      every: "every",
      onlyOneIntakeTime: "Only one intake moment can be selected with this frequency",
      morning: "Morning",
      midMorning: "Mid-morning",
      lunch: "Lunch",
      afternoon: "Afternoon",
      evening: "Evening",
      night: "Night",
      prescriberSelect: "indicate who prescribed the therapy",
      sourceSelect: "indicate information source",
      sideEffectsPlaceholder: "any side effects attributed to the drug..",
      allergicReactionsPlaceholder: "any allergic reactions attributed to the drug..",
      interactionsPlaceholder: "possible interactions with other drugs or foods..",
      privateInfoNote: "**if you select this option, only you will see this therapy",
      visibleOnlyToMe: "visible only to me**",
      cancel: "Cancel",
      saveChanges: "Save changes",
      saveSuccess: "New therapy saved",
      saveError: "An error occurred while saving",
      startDate: "Starting from",
      endDate: "Until",
      unitsSing: {
        mese: "month",
        settimana: "week",
        giorno: "day"
      },
      unitsPlur: {
        mesi: "months",
        settimane: "weeks",
        giorni: "days",
        ore: "hours"
      },
      unit: {
        compressa: "tablet",
        capsula: "capsule",
        goccia: "drop",
        inalazione: "inhalation",
        busta: "sachet",
        supposta: "suppository",
        scatola: "box",
        cerotto: "patch",
        fiala: "vial",
        fleboclisi: "infusion",
        ovulo: "vaginal ovule",
        sacca: "bag",
        flacone: "bottle",
        confezione: "package",
        kilogrammo: "kilogram",
        kit: "kit",
        millilitro: "milliliter",
        milligrammo: "milligram",
        applicazione: "application",
        UI: "IU"
      },
      vias: {
        orale: "Oral",
        transdermica: "Transdermal",
        nasale: "Nasal",
        endovena: "Intravenous",
        intramuscolo: "Intramuscular",
        oftalmica: "Ophthalmic",
        rettale: "Rectal",
        uretale: "Urethral",
        vaginale: "Vaginal",
        sottocute: "Subcutaneous"
      }
    },
    EditTherapy: {
      Annotazioni: 'Notes',
      Annulla: 'Cancel',
      Farmaco_indicato: 'Prescribed drug',
      Mattina: 'Morning',
      Meta_mattina: 'Mid-morning',
      Notte: 'Night',
      Ore: 'Hours',
      Pomeriggio: 'Afternoon',
      Pranzo: 'Lunch',
      Prodotto_non_trovato: 'Product not found',
      Salva_modifiche: 'Save changes',
      Sera: 'Evening',
      al_bisogno: 'as needed',
      al_di: 'per day',
      indica_prescrittore: 'indicate who prescribed the therapy',
      indica_fonte: 'indicate information source',
      indica_patologia: 'indicate pathology',
      mesi: 'months',
      non_indicare_patologia: 'do not indicate pathology',
      occasionale: 'occasional',
      ogni: 'every',
      ore: 'hours',
      giorni: 'days',
      per_sempre: 'forever',
      periodica: 'periodic',
      settimane: 'weeks',
      ikey_descrizione: '{{ ikey.descrizione }}',
      prod_Nome: '{{ prod.Nome }}',
      dosaggio: 'dosage',
      durata_terapia: "Therapy duration"
    },
    Common: {
      genericError: "An error occured."
    },
    nuovaPrenotazioneSalvata: {
      prenotazionePassata: "past appointment",
      testoIstruzioni: "Select a service, a date and a time slot to enter a service already performed.",
      prestazione: "Service to be entered*",
      dataInserimento: "Insertion date*",
      labelHelp: "Use the arrows to navigate between dates",
      fasciaOraria: "Time slot*",
      placeholderData: "Select a date",
      selezionaFascia: "Select a time slot",
      mattina: "morning",
      pomeriggio: "afternoon",
      sera: "evening",
      modalTitle: "New past appointment",
      success: "Appointment successfully saved",
      error: "Error while saving the appointment"
    },
    SelectCompanyHealthService: {
      loading: "Loading...",
      empty: "No active and available services",
      choose: "choose a service",
      loadError: "Error while loading health services"
    },
    PatientAnnotations: {
      mese_precedente: "Previous month",
      mese_successivo: "Next month",
      title: "Visits/Notes",
      new: "New note/visit",
      info: "Add a health note to the patient's profile. This note will not be visible to the patient.",
      month: "Month",
      year: "Year",
      all: "All",
      yours: "Your notes",
      noneForMonth: "No notes for this month.",
      noneForFilters: "No notes with the selected filters.",
      loadError: "Unable to retrieve notes",
      months: {
        january: "January",
        february: "February",
        march: "March",
        april: "April",
        may: "May",
        june: "June",
        july: "July",
        august: "August",
        september: "September",
        october: "October",
        november: "November",
        december: "December"
      }
    },
    ClinicalReportGenerator: {
      emit: "Issue Report",
      modalTitle: "Generate signed report",
      placeholder: "Your notes...",
      authorizeAndEmit: "Authorize and issue report",
      otpInstruction: "The facility requires this operation to be confirmed by verifying a code (OTP) sent to your phone number.\n\nClick \"send verification code\" to receive the OTP.",
      or: "or",
      cancel: "Cancel operation",
      serviceNotAvailable: "Service not available for this facility.",
      contactSupport: "Contact us for more information",
      emitSuccess: "Report issued successfully",
      emitError: "Error during report processing",
      downloadError: "Unable to download the resource"
    },
    singleAnnotationComponent: {
      visible: "Visible to patient",
      notVisible: "Not visible to patient",
      soapLabel: "health note",
      subjective: "Subjective",
      objective: "Objective",
      assessment: "Assessment",
      plan: "Plan",
      other: "Other",
      saveChanges: "Save changes",
      cancelChanges: "Cancel changes",
      modalTitle: "Confirm deletion",
      cancelDelete: "No, Cancel",
      confirmDelete: "Yes, Confirm",
      confirmDeleteText: "Do you confirm you want to delete this note?",
      updateSuccess: "Note updated successfully",
      updateError: "Error updating note",
      deleteSuccess: "Note deleted successfully",
      deleteError: "Error deleting note",
      viewInvoice: "View invoice",
      issueInvoice: "Generate invoice",
      generateInvoice: "Generate invoice",
      confirmInvoice: "Confirm invoice",
      editInvoice: "Edit draft invoice",
      issueInvoiceTitle: "Generate invoice",
      confirmInvoiceTitle: "Confirm invoice",
      editInvoiceTitle: "Edit Draft Invoice",
      confirmIssue: "Confirm invoice",
      warningTitle: "Warning",
      issueWarning: " The generated invoice can no longer be edited. SDI/TS submission is handled from Document Submission.",
      billingProfile: "Fiscal profile",
      billingProfilePlaceholder: "Select fiscal profile",
      billingProfileRequired: "Select the fiscal profile to use for the invoice.",
      billingProfilesLoadError: "Error while loading fiscal profiles.",
      paymentMethod: "Payment method",
      missingInvoice: "No invoice is associated with this note/visit.",
      invoiceRequiredBeforeView: "To view the invoice, generate it from this note/visit first.",
      downloadInvoiceError: "Error while loading the invoice.",
      missingInvoiceBeforeIssue: "No invoice is associated with this note/visit yet. Use Generate invoice to create it.",
      issueInvoiceDraftInfo: "No invoice is linked to this note/visit yet. Fill in the data and choose whether to save it as draft or generate it now. SDI/TS submission is handled from Document Submission.",
      createDraftInvoice: "Create Draft",
      saveDraftInvoice: "Save Draft",
      defaultInvoiceDescription: "Healthcare service",
      patientRequiredForInvoice: "Patient unavailable for invoice creation.",
      invoiceDescriptionRequired: "Enter a description for the invoice line.",
      invoiceLineDataRequired: "Fill in description, quantity and price for each invoice line.",
      invoiceDiscountOutOfRange: "The discount of each line ranges from 0 to 100%.",
      draftInvoiceCreated: "Invoice draft created successfully.",
      draftInvoiceCreateError: "Error while creating invoice draft.",
      issueInvoiceLoadError: "Unable to verify the invoice to confirm.",
      invoiceAlreadyIssued: "The invoice has already been generated.",
      issueInvoiceSuccess: "Invoice generated successfully.",
      issueInvoiceError: "Error while generating the invoice.",
      invoiceNotEditable: "The invoice has already been generated and cannot be edited.",
      missingInvoiceBeforeEdit: "No editable invoice exists for this note/visit yet.",
      loadInvoiceError: "Unable to load the invoice for editing.",
      saveInvoiceChanges: "Save Changes",
      itemDescription: "Description",
      itemQuantity: "Qty",
      itemUnitPrice: "Unit Price",
      itemDiscount: "Discount (%)",
      itemVatRate: "VAT %",
      vatLockedByRegime: "Under the flat-rate and minimum schemes services carry no VAT: the rate stays at 0%.",
      stampDutyMethodNotice: "The billing profile does not yet specify how the stamp duty is paid. Invoices to patients without VAT above € 77.47 are subject to the € 2 stamp duty and, until the choice is made, they cannot be issued.",
      stampDutyMethodMissing: "Above € 77.47 the invoice is subject to stamp duty: without the stamp duty method in the profile it cannot be issued. The draft can be saved.",
      stampDutyMethodMissingOnIssue: "This invoice is subject to the € 2 stamp duty: until the billing profile specifies how the stamp duty is paid, it cannot be issued. The draft stays saved.",
      stampDutyMethodSettingsLink: "Open billing settings",
      addInvoiceRow: "Add line",
      removeInvoiceRow: "Remove invoice line",
      updateInvoiceSuccess: "Invoice updated successfully.",
      updateInvoiceError: "Error while updating the invoice.",
      payment_mp01: "MP01: Cash",
      payment_mp02: "MP02: Cheque",
      payment_mp03: "MP03: Cashier's cheque",
      payment_mp05: "MP05: Bank transfer",
      payment_mp06: "MP06: Promissory note",
      payment_mp07: "MP07: Bank payment slip",
      payment_mp08: "MP08: Payment card",
      payment_mp12: "MP12: Direct debit",
      payment_mp18: "MP18: Postal current account payment",
      payment_mp22: "MP22: SEPA direct debit"
    },
    NewAnnotationComponent: {
      placeholder: "Add a simple note",
      focus_input: "Activate the field to enter a new note",
      visibilityLabel: "Patient Visibility",
      notVisible: "Not visible to the patient",
      visible: "Visible to the patient",
      save: "Save note",
      cancel: "Cancel",
      success: "Note added successfully",
      error: "Error while adding the note"
    },
    NewSoapAnnotationComponent: {
      subjective: "Subjective",
      objective: "Objective",
      assessment: "Assessment",
      plan: "Plan",
      other: "Other",
      subjectivePlaceholder: "Impressions, symptoms reported by the patient, family history...",
      objectivePlaceholder: "Signs, physical exam, instrumental investigations...",
      assessmentPlaceholder: "Evaluation, diagnosis, progress...",
      planPlaceholder: "Recommendations, procedures or treatments, changes to the plan...",
      otherPlaceholder: "Other relevant observations...",
      save: "Save note",
      cancel: "Cancel",
      success: "Note added successfully",
      error: "Error while adding the note",
      tipo_annotazione: "Type",
      tipo_nota_sanitaria: "Health note",
      tipo_visita_prestazione: "Visit/Service"
    },
    ScoresComponent: {
      vediQuestionario: "View the questionnaire",
      title: "Questionnaires",
      new: "new questionnaire score",
      newBtn: "New questionnaire",
      newTitle: "New questionnaire score",
      history: "History",
      lastScore: "Last recorded score",
      year: "Year",
      month: "Month",
      day: "Day",
      all: "all",
      values: "Recorded values",
      noValues: "No values recorded",
      findByScore: "Find questionnaire by score",
      add: "add",
      back: "back",
      complete: "complete questionnaire",
      error: "something went wrong",
      placeholder: "Search...",
      esito_title: "Questionnaire result",
      vediQuestioniario: "see questionnaire",
      esito: "Outcome"
    },
    FrequenzaValutazioneScore: {
      frequencyPer: "Detection frequency: one assessment every",
      suspended: "Assessment suspended",
      setFrequency: "Set assessment frequency",
      parameterNeeded: "The parameter must be measured every",
      toggleQuestion: "Do you want to {{ selectedFrequency.enabled ? 'disable' : 'enable' }} this monitoring frequency?",
      confirmDeleteQuestion: "Do you want to delete this monitoring frequency?",
      deleteTitle: "Edit operation",
      updateTitle: "Edit setting",
      modificaTitle: "edit",
      seleziona_frequenza: "Select frequency",
      modifica_frequenza: "Edit frequency",
      sospendiTitle: "stop",
      riprendiTitle: "resume",
      eliminaTitle: "remove",
      confirmTitle: "Confirm operation",
      deleteConfirm: "Yes, delete",
      saveChanges: "Save changes",
      cancel: "Cancel",
      confirm: "Confirm",
      genericError: "Something went wrong",
      setSuccess: "Values set successfully",
      updateSuccess: "Frequency setting successfully updated",
      updateError: "Unable to update frequency",
      deleteSuccess: "Frequency setting successfully deleted",
      deleteError: "Unable to delete frequency",
      sing: {
        mese: "month",
        settimana: "week",
        giorno: "day",
        ora: "hour",
        minuto: "minute"
      },
      plur: {
        mesi: "months",
        settimane: "weeks",
        giorni: "days",
        ore: "hours",
        minuti: "minutes"
      }
    },
    PatientDevices: {
      title: "Devices",
      newDevice: "New device",
      noneAssociated: "No device associated with the user.",
      newDeviceTitle: "New User Device",
      searchDevice: "Find device",
      searchPlaceholder: "Search...",
      noneAvailable: "No available device for assignment.",
      codePlaceholder: "Enter code*",
      back: "Back",
      save: "Save",
      addSuccess: "Device added successfully",
      addError: "Failed to add the device",
      removeSuccess: "Device removed successfully",
      removeError: "Failed to remove the device",
      updateCodeSuccess: "Product code updated successfully",
      updateCodeError: "Failed to update product code",
      enabled: "enabled",
      disabled: "disabled",
      examStatusUpdated: "Exam {status} successfully",
      examStatusError: "Failed to update exam status",
      updateRequested: "Update requested. You will receive a notification once completed",
      updateRequestError: "Failed to request update"
    },
    DeviceCard: {
      requestUpdate: "Request data update",
      noExams: "No exam enabled on this device.",
      confirmTitle: "Confirm operation",
      confirmOk: "Yes, confirm",
      confirmCancel: "No, cancel",
      confirmMessage: "Do you want to deactivate the device",
      editTitle: "Edit Device {name}",
      parameters: "Parameters",
      enabled: "Enabled",
      disabled: "Disabled",
      productCode: "Product Code",
      edit: "Edit",
      save: "Save",
      cancel: "Cancel",
      close: "Close",
      productCodePlaceholder: "Product Code",
      elimina_dispositivo: "Delete device",
      modifica_dispositivo: "Edit device"
    },
    EsenzioniAnamnesiComponent: {
      title: "Exemptions",
      new: "Add",
      none: "No exemptions",
      modalTitle: "Add exemption",
      selectLabel: "Select exemption*",
      choose: "choose",
      save: "Save",
      deleteTitle: "Do you confirm you want to delete the exemption?",
      deleteOk: "Yes, delete",
      saveSuccess: "Exemption successfully saved!",
      saveError: "Unable to save the exemption",
      deleteSuccess: "Exemption successfully deleted!",
      deleteError: "Unable to delete the exemption",
      loadError: "Unable to retrieve exemptions",
      elimina_esenzione: "Delete exemption {code}"
    },
    EsenzioniComponent: {
      title: "Exemptions",
      new: "new exemption",
      none: "No exemptions entered",
      modalTitle: "Add exemption",
      choose: "choose",
      requiredField: "*Required field",
      cancel: "Cancel",
      save: "Save",
      deleteTitle: "Do you confirm you want to delete the exemption?",
      deleteOk: "Yes, delete",
      cancelDelete: "No, cancel",
      saveSuccess: "Exemption successfully saved!",
      saveError: "Unable to save the exemption",
      deleteSuccess: "Exemption successfully deleted!",
      deleteError: "Unable to delete the exemption",
      pathologiesError: "Unable to fetch list of pathologies",
      loadError: "Unable to retrieve exemptions",
      elimina_esenzione: "Delete exemption {code}"
    },
    ProfiloAnagraficoAssistito: {
      title: "Patient Information",
      subtitle: "Patient profile",
      loadError: "Unable to retrieve the information.",
      vai_scheda_assistito: "Go to patient profile"
    },
    SchedaAssistito: {
      toggle_menu: "Expand or collapse sections menu",
      vai_profilo_assistito: "Go to assisted profile"
    },
    AnagraficaPazienteComponent: {
      profile: "Profile",
      title: "Title",
      titlePlaceholder: "Mr./Ms...",
      firstName: "First name*",
      firstNamePlaceholder: "First name...",
      lastName: "Last name*",
      lastNamePlaceholder: "Last name...",
      birthDate: "Date of birth*",
      gender: "Gender",
      male: "male",
      female: "female",
      taxCode: "Tax code*",
      taxCodePlaceholder: "Tax code...",
      healthCard: "Health Card Number",
      healthCardPlaceholder: "Health card number...",
      birthCountry: "Country of birth*",
      gp: "Primary care doctor",
      gpPlaceholder: "Primary doctor...",
      localHealthAuthority: "Reference LHA (ASL/ASP/ATS)",
      selectAuthority: "Select local health authority",
      cancel: "Cancel",
      save: "Save Changes",
      residence: "Residence",
      region: "Region*",
      regionPlaceholder: "Region...",
      province: "Province*",
      provincePlaceholder: "Province...",
      city: "City*",
      cityPlaceholder: "City...",
      selectRegion: "Select Region",
      selectProvince: "Select Province",
      selectCity: "Select City",
      address: "Address and street number*",
      addressPlaceholder: "Address...",
      zip: "ZIP code*",
      zipPlaceholder: "ZIP...",
      contacts: "Contacts",
      phone: "Phone number",
      phonePlaceholder: "Phone...",
      homePhone: "Home phone",
      homePhonePlaceholder: "Home phone...",
      backupPhone: "Backup phone",
      backupPhonePlaceholder: "Backup phone...",
      deleteImageTitle: "Confirm deletion",
      confirm: "Yes, Confirm",
      confirmDeleteImage: "Do you confirm you want to delete the profile image?",
      selectCountry: "Select Country",
      titleOptions: {
        sig: "Mr.",
        sigRa: "Ms.",
        dott: "Dr.",
        dottSsa: "Dr. (female)"
      },
      invalidPhone: "Invalid phone number",
      success: "Changes saved successfully",
      genericError: "Unable to complete the operation"
    },
    UploadComponent: {
      uploadSuccess: "successfully uploaded!",
      uploadNew: "Upload new file",
      codeDetected: "Code successfully detected!",
      codeNotDetected: "Unable to detect the code from the uploaded prescription. Please try scanning the code with the camera or manually enter the code in the appropriate field.",
      placeholder: "select file...",
      upload: "Upload",
      invalidFile: "Invalid file or file size too large (max 8MB)"
    },
    ContattiEmergenza: {
      title: "Useful Contacts",
      none: "No contact entered.",
      newContact: "new contact",
      modalTitle: "Add useful contact",
      cancel: "Cancel",
      save: "Save contact",
      loadError: "Unable to retrieve the information."
    },
    NewEmergencyContact: {
      type: "Contact type",
      firstName: "First name*",
      firstNamePlaceholder: "First name...",
      lastName: "Last name*",
      lastNamePlaceholder: "Last name...",
      organization: "Organization*",
      relation: "Contact relationship*",
      selectRelation: "Select relationship type",
      region: "Region*",
      selectRegion: "Select Region",
      province: "Province*",
      selectProvince: "Select Province",
      city: "City*",
      selectCity: "Select City",
      address: "Address and street number",
      addressPlaceholder: "Address...",
      zip: "ZIP",
      zipPlaceholder: "ZIP...",
      phone: "Phone number*",
      phonePlaceholder: "Phone...",
      success: "Contact added successfully",
      error: "Error saving the contact",
      relations: {
        family: "family",
        friend: "friend",
        assistance: "assistance",
        medicalStaff: "medical staff",
        healthStaff: "healthcare staff",
        other: "other"
      },
      contactTypes: {
        person: "person",
        place: "place"
      },
      cityPlaceholder: "City...",
      delete: "Delete",
      edit: "Edit",
      cancel: "Cancel",
      save: "Save",
      confirm: "Yes, Confirm",
      confirmDeleteTitle: "Confirm deletion",
      confirmDeleteText: "Do you confirm you want to delete contact details for",
      updateSuccess: "Contact updated successfully",
      updateError: "Error saving the changes",
      deleteSuccess: "Contact deleted successfully",
      deleteError: "Unable to delete the contact"
    },
    AdminMain: {
      nav_label: "Administrator navigation"
    },
    ImpostazioniSistemaEsami: {
      titolo: "Exams, parameters and reports",
      bande: "bands",
      aggiornamento: "Updating",
      cerca_placeholder: "Name...",
      elementi_per_pagina: "Items per page",
      apri_dettaglio_lab: "Open reference values detail",
      apri_dettaglio_soglie: "Open monitoring thresholds detail",
      rif_maschile: "M",
      rif_femminile: "F"
    },
    LabRefHint: {
      descrizione_parametro: "If the clinical parameter only requires a lower or upper limit, you can fill in just the minimum or just the maximum.",
      descrizione_esame: "If the clinical exam only requires a lower or upper limit, you can fill in just the minimum or just the maximum."
    },
    CreateEditDeleteParametroForm: {
      modifica: "Edit parameter",
      elimina: "Delete parameter",
      aggiungi: "add",
      tipologia: "Type *",
      nome: "Name",
      unita_misura: "Unit of measure *",
      campi_obbligatori: "*required fields",
      errore_min_maggiore_max: "Minimum value cannot be greater than maximum",
      invia: "Submit",
      seleziona_tipologia: "Select type",
      tipo_parametro: "Parameter",
      tipo_esame: "Exam",
      tipo_referto: "Report",
      nuovo_parametro: "New parameter",
      modifica_label: "Edit",
      conferma_eliminazione: "Confirm deletion",
      sei_sicuro: "Are you sure you want to delete",
      elimina_btn: "Delete",
      inserito_ok: "has been added successfully",
      modificato_ok: "has been updated successfully",
      eliminato_ok: "Element deleted successfully",
      valore_esistente: "Value already exists in the system",
      errore_modifica: "Error while editing the value",
      errore_eliminazione: "Error while deleting the element",
      rif_lab_default: "Reference values",
      lab_min: "Min",
      lab_max: "Max",
      soglie_monitoraggio: "Monitoring thresholds",
      soglie_descrizione: "Click Edit or Add in each column to set the min/max values for each severity level.",
      inizializza_soglie: "Initialize thresholds",
      soglie_inizializzate: "Thresholds initialized successfully",
      rimuovi_tutte: "Remove all thresholds",
      conferma_rimuovi_tutte: "Are you sure you want to remove all monitoring thresholds?",
      aggiungi_banda: "Add band",
      nessuna_soglia: "No monitoring thresholds configured for this parameter.",
      livello: "Level",
      eta_min: "Min age",
      eta_max: "Max age",
      salva_banda: "Save band",
      elimina_banda: "Delete band",
      conferma_elimina_banda: "Confirm band deletion",
      conferma_elimina_banda_msg: "Are you sure you want to delete this threshold band?",
      banda_aggiunta: "Band added successfully",
      banda_aggiornata: "Band updated successfully",
      banda_eliminata: "Band deleted successfully",
      errore_salvataggio_banda: "Error while saving the band",
      errore_eliminazione_banda: "Error while deleting the band",
      differenzia_per_genere: "Different reference values for men and women",
      rif_lab_generico: "Generic",
      rif_lab_maschile: "Male",
      rif_lab_femminile: "Female",
      errore_min_maggiore_max_m: "Male minimum value cannot be greater than maximum",
      errore_min_maggiore_max_f: "Female minimum value cannot be greater than maximum"
    },
    OperatoreMain: {
      nav_label: "Operator navigation"
    },
    CompanyBanner: {
      alt: "Company banner"
    },
    NavigationOperatore: {
      logo_alt: "Application logo - Go to home",
      mie_conversazioni: "My conversations",
      toggle_menu: "Open or close navigation menu",
      accessibility: "Accessibility",
      fatturazione: "Billing",
      logout: "Logout from private area",
      logout_confirm_title: "Do you confirm you want to leave the private area?",
      logout_confirm_ok: "Yes, exit"
    },
    InvoiceEditor: {
      title: "New Invoice",
      edit_title: "Edit Invoice",
      cancel: "Cancel",
      cancel_aria: "Back to invoice list",
      save_and_generate: "Save and Generate",
      save_aria: "Save invoice",
      saving: "Saving",
      patient_title: "Patient / Customer Data",
      patient: "Patient",
      select_patient: "Select a patient",
      recipient_name: "Name",
      patient_search: "Search patient...",
      address: "Address",
      city: "City",
      tax_code: "Tax Code",
      vat_optional: "VAT (optional)",
      document_title: "Document Details",
      number: "Number",
      auto_number: "AUTO",
      date_issue: "Issue Date",
      payment_method: "Payment Method",
      ts_objection: "TS submission objection",
      payment_cash: "Cash",
      payment_card: "Card / POS",
      payment_transfer: "Bank Transfer",
      items_title: "Services",
      add_row: "+ Add Row",
      add_row_aria: "Add invoice row",
      col_description: "Description",
      col_quantity: "Qty",
      col_unit_price: "Unit Price",
      col_vat_rate: "VAT %",
      col_total: "Total",
      col_actions: "Actions",
      row_description_aria: "Row {number} description",
      row_quantity_aria: "Row {number} quantity",
      row_price_aria: "Row {number} price",
      row_vat_aria: "Row {number} VAT rate",
      remove_row_aria: "Remove row {number}",
      vat_exempt: "0% (Exempt)",
      subtotal: "Subtotal:",
      vat: "VAT:",
      stamp_duty: "Stamp Duty (Virtual):",
      stamp_duty_note: "Over €77.47 (VAT exempt)",
      total_due: "TOTAL DUE:",
      profile_load_warning: "Unable to load fiscal profiles.",
      patient_load_warning: "Unable to load patient list.",
      load_error: "Unable to load invoice.",
      patient_required: "Select a patient before saving the invoice.",
      created: "Invoice created successfully.",
      updated: "Invoice updated successfully.",
      create_error: "Error creating invoice.",
      patient_unavailable: "Patient unavailable"
    },
    BillingSettingsEmbedded: {
      title: "Billing Configuration",
      subtitle: "Manage your tax profiles and submission preferences.",
      profile_dropdown_aria: "Select fiscal profile",
      profile_placeholder: "Select fiscal profile",
      new_profile: "Create New Tax Profile",
      edit_profile: "Edit Profile: {name}",
      new_personal_profile: "New Personal Profile",
      create_profile_aria: "Create new fiscal profile",
      cancel_new_profile: "Cancel new profile",
      profile_selected: "Selected Profile",
      profile_studio: "Studio Profile (Company)",
      profile_personal: "Personal Profile (Doctor)",
      loading: "Loading...",
      save: "Save Profile",
      save_aria: "Save fiscal profile",
      saving: "Saving",
      saved: "Profile saved successfully",
      save_error: "Error saving profile",
      load_error: "Error loading profiles",
      fill_required: "Fill in required fields",
      tab_fiscal: "Tax Data",
      tab_invoice: "Invoice Options",
      tab_privacy: "Privacy",
      tab_ts: "TS System",
      tab_submission: "Document Submission",
      business_name: "Business Name / Full Name",
      business_name_placeholder: "e.g. Dr. John Smith",
      vat_number: "VAT Number",
      tax_code: "Tax Code",
      tax_code_required: "Tax Code is required",
      tax_regime: "Tax Regime",
      regime_ordinario: "Standard",
      regime_forfettario: "Flat-rate (L. 190/2014)",
      regime_minimi: "Minimum taxpayers",
      sdi_code: "SDI Recipient Code",
      sdi_code_placeholder: "0000000",
      pec: "PEC Email Address",
      pec_placeholder: "name{'@'}pec.it",
      address_title: "Office Address",
      address_street: "Street / Square",
      address_civic: "Number",
      address_cap: "ZIP Code",
      address_city: "City",
      address_province: "Prov.",
      select_province: "Select Province",
      invoice_advanced_title: "Advanced Invoice Settings",
      albo_province: "Board Province",
      albo_number: "Board Registration Number",
      albo_number_placeholder: "e.g. 12345",
      albo_number_required: "Registration number required when province is set",
      albo_date: "Board Registration Date",
      invoice_number_start: "Numbering start",
      vat_rate: "VAT Rate",
      payment_reason: "Default Payment Reason",
      select_option: "Select...",
      payment_mp01: "MP01: Cash",
      payment_mp02: "MP02: Cheque",
      payment_mp03: "MP03: Cashier's cheque",
      payment_mp05: "MP05: Bank transfer",
      payment_mp06: "MP06: Promissory note",
      payment_mp07: "MP07: Bank payment slip",
      payment_mp08: "MP08: Payment card",
      payment_mp12: "MP12: Direct debit",
      payment_mp18: "MP18: Postal current account payment",
      payment_mp22: "MP22: SEPA direct debit",
      additional_info: "Additional information to appear at the bottom of each invoice",
      additional_info_placeholder: "e.g. VAT-exempt transaction under art. 1, paragraph 58, L. 190/2014",
      additional_info_help: "The stamp duty wording does not go here: the system adds it according to the method chosen in the «Stamp duty» section.",
      stamp_duty_title: "Stamp duty",
      stamp_duty_intro: "Invoices without VAT above € 77.47 are subject to a € 2 stamp duty, owed by whoever issues the invoice. Invoices to patients do not go through SDI: the professional chooses how the stamp duty is paid, possibly with their accountant, and the invoice shows the corresponding wording. Without this choice, invoices to patients subject to stamp duty cannot be issued.",
      stamp_duty_method: "Stamp duty payment method",
      bollo_contrassegno: "Revenue stamp on the original",
      bollo_contrassegno_help: "The invoice is handed over on paper, with the € 2 revenue stamp applied to the copy given to the patient.",
      bollo_virtuale_autorizzato: "Virtual stamp duty authorised by the Agenzia delle Entrate",
      bollo_virtuale_autorizzato_help: "With the authorisation of the Agenzia delle Entrate (art. 15 DPR 642/1972): the stamp duty is paid with F24 and the invoice shows the authorisation details.",
      bollo_documento_informatico: "PDF invoice kept as an electronic document",
      bollo_documento_informatico_help: "The invoice is sent as a PDF and stored digitally; the stamp duty is paid with F24 under art. 6 of D.M. 17 June 2014.",
      stamp_duty_authorization: "Authorisation details",
      stamp_duty_authorization_help: "Number, date and office of the Agenzia delle Entrate that issued the authorisation, e.g.: no. 12345 of 10/01/2024, Palermo provincial office.",
      stamp_duty_authorization_required: "With the authorised virtual stamp duty, the authorisation details are required.",
      funds_title: "Professional Funds and Withholdings",
      cassa_rate: "Professional Fund (%)",
      cassa_name: "Fund Name/Notes",
      inps_rate: "INPS Contribution (%)",
      apply_inps: "Apply INPS Contribution",
      wh_rate: "Withholding Tax (%)",
      wh_taxable_perc: "Taxable % for Withholding",
      wh_taxable_desc: "Percentage of taxable amount for withholding calculation",
      apply_wh: "Apply Withholding Tax",
      privacy_title: "Privacy and Communication Consent",
      privacy_info: "Privacy Notice",
      privacy_info_desc: "Ask patients to read the privacy notice before the visit.",
      privacy_toggle_aria: "Enable privacy notice request",
      communication_consent: "Communication Consent",
      communication_consent_desc: "Ask patients for consent to receive communications before the visit.",
      communication_toggle_aria: "Enable communication consent request",
      ts_title: "National Health System Credentials",
      ts_subtitle: "Enter credentials for automatic expense submission.",
      ts_username: "Identification Code",
      ts_password: "Password",
      ts_pin: "PIN",
      ts_structure_title: "Healthcare facility data",
      ts_structure_desc: "Fill in these fields only when TS submission must be sent as a facility/company. Leave them empty for professional submission.",
      ts_cod_regione: "Region Code",
      ts_cod_asl: "ASL Code",
      ts_cod_ssa: "SSA Code",
      ts_cf_proprietario: "Owner / legal representative tax code",
      ts_structure_required: "For TS facility submission, fill in Region code, ASL code and SSA code.",
      ts_structure_owner_required: "For TS facility submission, enter a 16-character owner or legal representative tax code.",
      ts_encrypted_note: "NOTE: Credentials will be saved encrypted.",
      ts_organization_sync_notice: "Saving now will synchronize the fiscal profile with ASE before saving TS credentials.",
      ts_organization_missing_data_notice: "To save TS credentials, first complete VAT number, tax code and fiscal profile address.",
      manage_rates: "Manage Rates",
      vat_rates_title: "VAT Rate Management",
      vat_rate_close: "Close",
      vat_rate_new: "New Rate",
      vat_rate_edit: "Edit Rate",
      vat_rate_label: "Rate (%)",
      vat_rate_desc: "Description",
      vat_rate_desc_placeholder: "e.g. Standard VAT 22%",
      vat_rate_natura: "Nature",
      vat_rate_none: "None (taxable)",
      natura_n1: "Excluded under art. 15",
      natura_n21: "Not subject - arts. 7 to 7-septies DPR 633/72",
      natura_n22: "Not subject - other cases",
      natura_n31: "Non-taxable - exports",
      natura_n32: "Non-taxable - intra-EU supplies",
      natura_n33: "Non-taxable - supplies to San Marino",
      natura_n34: "Non-taxable - operations equivalent to exports",
      natura_n35: "Non-taxable - following declarations of intent",
      natura_n36: "Non-taxable - other operations outside plafond",
      natura_n4: "Exempt",
      natura_n5: "Margin scheme / VAT not shown",
      natura_n61: "Reverse charge - scrap and recovered materials",
      natura_n62: "Reverse charge - gold and pure silver",
      natura_n63: "Reverse charge - building subcontracting",
      natura_n64: "Reverse charge - building transfers",
      natura_n65: "Reverse charge - mobile phones",
      natura_n66: "Reverse charge - electronic products",
      natura_n67: "Reverse charge - building services",
      natura_n68: "Reverse charge - energy sector",
      natura_n69: "Reverse charge - other cases",
      natura_n7: "VAT paid in another EU country",
      vat_rate_no_data: "No rates configured. Add one above.",
      vat_rate_save_edit: "Save Edit",
      vat_rate_add: "Add Rate",
      vat_rate_cancel: "Cancel",
      vat_rate_saved: "Saved Rates",
      vat_rate_actions: "Actions",
      vat_rate_edit_aria: "Edit rate {description}",
      vat_rate_delete_aria: "Delete rate {description}"
    },
    FiscalDocumentSubmission: {
      title: "Fiscal document submission",
      filter_aria: "Filter documents by status",
      refresh_aria: "Refresh fiscal documents",
      loading: "Loading...",
      no_documents: "No fiscal documents found.",
      table_aria: "Fiscal document submission table",
      filter_all: "All statuses",
      filter_non_inviabile: "Not submittable",
      filter_da_inviare: "To be sent",
      filter_presa_in_carico: "Accepted",
      filter_inviato: "Sent",
      filter_scartato: "Rejected",
      filter_accolto_anomalie: "Accepted with warnings",
      filter_accolto: "Accepted",
      col_number: "Invoice No.",
      col_date: "Document Date",
      col_payment_date: "Payment Date",
      col_name: "Name",
      col_tax_code: "Tax Code",
      col_amount: "Fees",
      col_sdi_status: "SDI Status",
      col_ts_status: "TS Status",
      col_actions: "Actions",
      send_sdi: "SDI",
      send_ts: "TS",
      send_sdi_aria: "Send invoice {number} to SDI",
      send_ts_aria: "Send invoice {number} to TS",
      refresh_sdi: "Refresh SDI status",
      refresh_sdi_aria: "Refresh SDI status for invoice {number}",
      refresh_ts: "Refresh TS status",
      refresh_ts_aria: "Refresh TS status for invoice {number}",
      sdi_rejection_details: "SDI rejection details",
      sdi_rejection_details_aria: "Show SDI rejection details for invoice {number}",
      sdi_rejection_title: "SDI rejection details",
      sdi_rejection_invoice: "Invoice {number}",
      sdi_rejection_unknown_code: "Code not available",
      sdi_rejection_unknown_description: "Description not available",
      sdi_rejection_no_details: "No rejection details available.",
      download_xml: "Download XML",
      download_xml_aria: "Download invoice {number} XML",
      pagination_of: "of",
      pagination_documents: "documents",
      pagination_aria: "Fiscal document pagination",
      confirm_title: "Confirm fiscal document submission",
      confirm_ok: "Yes, proceed",
      confirm_ok_anyway: "Send anyway",
      confirm_sdi: "Generate XML and send invoice {number} to SDI?",
      confirm_ts: "Send healthcare expense data for invoice {number} to the TS system?",
      sdi_person_title: "Healthcare services to private individuals are not sent to SDI",
      sdi_person_text: "The law forbids sending invoices for healthcare services to private individuals to SDI (art. 10-bis D.L. 119/2018, made permanent by D.Lgs. 81/2025). The patient receives the invoice as a PDF or on paper, and the expense data go to the Sistema Tessera Sanitaria. Sending to SDI remains possible for services that are not healthcare services.",
      sdi_success: "File sent successfully",
      sdi_error: "Error sending to SDI",
      sdi_refresh_success: "SDI status updated",
      sdi_refresh_error: "Error refreshing SDI status",
      ts_success: "Data sent to TS system.",
      ts_error: "Error sending to TS system",
      ts_refresh_success: "TS status updated",
      ts_refresh_error: "Error refreshing TS status",
      load_error: "Error loading documents.",
      xml_download_error: "Error downloading XML file.",
      sdi_non_inviabile: "Not submittable",
      sdi_da_inviare: "To be sent",
      sdi_presa_in_carico: "Accepted",
      sdi_scartato: "Rejected",
      sdi_accolto_anomalie: "Accepted with warnings",
      sdi_accolto: "Accepted",
      ts_non_inviabile: "Not submittable",
      ts_da_inviare: "To be sent",
      ts_inviato: "Sent",
      ts_accolto: "Accepted",
      ts_accolto_anomalie: "Accepted with warnings",
      ts_scartato: "Rejected"
    },
    PrenotazioniCittadinoMain: {
      newRequest: "New booking request",
      pending: "Pending",
      confirmed: {
        plural: "Confirmed",
        singular: "Confirmed"
      },
      history: "History",
      inactiveService: "Service not active."
    },
    UserReservations: {
      myBookings: "My bookings",
      assistiti: "Assisted patients",
      noReservations: "No reservations.",
      loadError: "Unable to retrieve recent reservations",
      updateSuccess: "Request successfully updated",
      genericError: "Unable to complete the operation",
      downloadError: "Unable to download the reminder",
      sendSuccess: "Request sent successfully"
    },
    DettaglioPrenotazioneCittadino: {
      cost: "cost {costo}",
      productRequest: "Product request",
      teleconsulto: "Teleconsultation",
      estimatedDate: "DATE AND TIME (ESTIMATED)",
      toConfirm: "To be confirmed",
      forWho: "On behalf of",
      requestCode: "REQUEST CODE",
      status: "STATUS",
      nameSurname: "NAME AND SURNAME",
      taxCode: "TAX CODE",
      booking: "Booking",
      location: "LOCATION",
      details: "Details",
      operationDate: "OPERATION DATE",
      yourNotes: "YOUR NOTES",
      purchase: "Purchase",
      date: "DATE"
    },
    UserDetailPrestazione: {
      attachments: "ATTACHMENTS",
      prescription: "PRESCRIPTION",
      download: "Download",
      questionnaireToFill: "QUESTIONNAIRE TO FILL IN",
      completeQuestionnaire: "Complete questionnaire",
      questionnaire: "QUESTIONNAIRE",
      questionnaireMin: "Questionnaire",
      openQuestionnaire: "open questionnaire",
      downloadPdf: "download as PDF",
      notes: "SERVICE NOTES:",
      operatorNotes: "OPERATOR NOTES",
      confirmBooking: "Confirm Booking",
      rejectChanges: "Reject Changes",
      cancelBooking: "Cancel Appointment",
      confirmCancelTitle: "Confirm Cancellation",
      confirmCancelMessage: "Are you sure you want to cancel this appointment?",
      confirm: "Yes, Confirm",
      cancel: "Cancel",
      loadQuestionnaireError: "Unable to retrieve the questionnaire",
      downloadError: "Unable to download the resource"
    },
    FilledSurveyShower: {
      totalScore: "Total score",
      resultValue: "Result",
      numericScore: "Score",
      scoreClass: "Outcome",
      description: "Description",
      questions: "Questions",
      noFile: "No file uploaded",
      information: "Information notice",
      hide_unanswered: "Hide unanswered questions"
    },
    ImageShower: {
      downloadAttachment: "download attachment",
      downloadError: "unable to retrieve the attachment"
    },
    PickMessageForm: {
      attachMessage: "Attach a message for the user:",
      noMessage: "No message",
      placeholder: "Write a message...",
      cancel: "No, close",
      confirm: "Yes, proceed"
    },
    UserDetailTeleconsulto: {
      expectedDuration: "EXPECTED DURATION",
      actualDuration: "ACTUAL DURATION",
      minutes: "minutes",
      prescription: "PRESCRIPTION",
      download: "Download",
      questionnaire: "QUESTIONNAIRE",
      openQuestionnaire: "open questionnaire",
      downloadPdf: "download as PDF",
      toFillQuestionnaire: "QUESTIONNAIRE TO FILL IN",
      completeQuestionnaire: "Complete questionnaire",
      teleconsultation: "TELECONSULTATION",
      goToTeleconsultation: "go to Teleconsultation",
      operatorNotes: "OPERATOR NOTES",
      notes: "NOTES",
      saveChanges: "Save Changes",
      confirmBooking: "Confirm Booking",
      rejectChanges: "Reject Changes",
      cancelBooking: "Cancel Booking",
      confirmCancelTitle: "Confirm Cancellation",
      confirmCancelMessage: "Are you sure you want to cancel this appointment?",
      confirm: "Yes, Confirm",
      cancel: "Cancel",
      questionnaireError: "Unable to retrieve the questionnaire",
      downloadError: "Unable to download the resource"
    },
    UserDetailProdotto: {
      medicalPrescription: "MEDICAL PRESCRIPTION",
      vetPrescription: "VETERINARY PRESCRIPTION",
      productsAvailable: "The prescribed products are available",
      productsNotAvailable: "The prescribed products are not available",
      reminder: "Remember to bring the prescription pin when collecting your order!",
      requestedProducts: "REQUESTED PRODUCTS",
      generic: "GENERIC",
      prescription: "Prescription",
      prescriptionNeeded: "required",
      prescriptionNotNeeded: "not required",
      product: "Product",
      available: "available",
      notAvailable: "not available",
      orderNotes: "ORDER NOTES",
      prescriptionShort: "PRESCRIPTION",
      noPrescriptionAttached: "No prescription attached",
      operatorNotes: "OPERATOR NOTES",
      saveChanges: "Save Changes",
      confirmOrder: "Confirm Order",
      rejectChanges: "Reject Changes",
      cancelOrder: "Cancel Order",
      confirmCancelTitle: "Confirm Cancellation",
      confirmCancelMessage: "Are you sure you want to cancel this appointment?",
      confirm: "Yes, Confirm",
      cancel: "Cancel",
      downloadError: "Unable to download the resource",
      download: "Download"
    },
    UpdateReservationDate: {
      reschedule: "Reschedule",
      modalTitle: "Request change of date/time",
      currentDateTime: "Currently scheduled date and time:",
      selectNewDate: "Select new date and time*:",
      updateNotes: "Update notes",
      cancel: "Cancel",
      submit: "Submit",
      fetchError: "Unable to retrieve the request",
      submitError: "Unable to submit the request"
    },
    DatetimeSelection: {
      selectDateTime: "Select date and time",
      month: "Month",
      year: "Year",
      prev: "Previous",
      next: "Next",
      noAvailabilityThisWeek: "No availability for this week. Try checking the upcoming weeks.",
      noAvailabilityThisWeekMsg: "No availability for the selected week and service",
      noAvailabilityForService: "Unable to find availability for this service",
      infoNoAvailability: "The selected service has no availability for the current week",
      teleconsultDurationError: "Error retrieving teleconsultation duration. Please try again later.",
      months: {
        january: "January",
        february: "February",
        march: "March",
        april: "April",
        may: "May",
        june: "June",
        july: "July",
        august: "August",
        september: "September",
        october: "October",
        november: "November",
        december: "December"
      }
    },
    PreferenzeSelection: {
      selectPreferences: "Select preferred days and times",
      noPreference: "I have no particular preferences",
      hasPreference: "I want to specify preferences",
      preferredDate: "Preferred date*",
      preferredTimeSlot: "Preferred time slot*",
      datePlaceholder: "Select a date",
      labelHelp: "Use the arrows to browse dates",
      addPreference: "Add preference",
      saveAndContinue: "Save and continue",
      saveSelection: "Save selection",
      timeOptions: {
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        allDay: "all day"
      }
    },
    ChatComponent: {
      operatore: "Operator",
      paziente: "Patient",
      startChat: "Start chat",
      viewConversation: "View conversation",
      title: "Conversation",
      connectionError: "Unable to connect",
      messageSendError: "Unable to send the message",
      updateError: "Unable to update the conversation",
      fetchMessagesError: "Unable to retrieve previous messages",
      downloadError: "Unable to download the resource",
      loadingError: "Unable to load the chat",
      utenteConnesso: "...connected.",
      presenzaDentro: "{nome} is in the conversation",
      presenzaFuori: "{nome} is no longer in the conversation",
      solaLettura: "You cannot send messages in this conversation.",
      conversazioneChiusa:
        "This conversation is closed: you can still read the messages.",
      realtimeUnavailable: "Real-time connection unavailable: messages are still saved"
    },
    CardPrenotazioneCittadino: {
      waitingForPayment: "awaiting payment",
      waitingForConfirmation: "awaiting confirmation",
      location: "Location:",
      scheduledFor: "Appointment scheduled for:",
      costOnSite: "Cost on site:",
      memo: "Reminder",
      calendar: "Calendar",
      view: "View",
      pay: "Pay",
      ore: "at"
    },
    NuovoOrdineCittadino: {
      need: "What do you need",
      forWhom: "For whom",
      at: "At",
      cancel: "Cancel",
      date: "Date",
      confirm: "Confirm",
      summary: "Summary",
      noFacilities: "No facilities available for booking.",
      scrollFacilities: "Scroll the facilities",
      previousFacilities: "Previous facilities",
      nextFacilities: "Next facilities",
      selectCompanyPreference: "Select a preference from the affiliated facilities",
      tryOtherFilters: "Try changing the search filters.",
      saveAndProceed: "Save and proceed",
      backToFacilities: "Back to facilities",
      availabilityPrompt: "INDICATE YOUR AVAILABILITY",
      selectedDates: "Selected dates:",
      fillQuestionnaire: "Fill out the questionnaire",
      service: "Service:",
      generic: "generic",
      reminder: "Remember to bring the prescription pin when collecting your order.",
      assignedStructureChoice: "Structure choice assigned to",
      preferenzeOrLocation: "Preferred structure",
      preferenzeFallback: "At",
      dateTimeSelected: "Selected date and time:",
      dateTimeEstimated: "Estimated date and time:",
      selectedPreferences: "Selected preferences:",
      attachedPrescription: "Attached prescription:",
      serviceFee: "Service handling cost:",
      totalDue: "Total due:",
      free: "Free of charge",
      operatorNote: "If you wish, add a note for the operator",
      operatorNoteProduct: "If you wish, add a note for the operator (e.g., a different delivery address)",
      confirmInstruction: 'By clicking "proceed" you will submit the booking request.',
      waitForOperator: "Wait for",
      operatorWillContactWithPayment: "an operator to contact you to confirm the booking and process the payment.",
      operatorWillContact: "an operator to contact you to confirm the booking.",
      readPolicy: "To proceed with the order confirmation, you must",
      acknowledgePolicy: "confirm that you have read the privacy policy",
      autoAssignProduct: "Let {app} choose the structure for you",
      autoAssignHealth: "Let {app} choose the healthcare facility for you",
      vatExcluded: "VAT {iva}% excluded",
      informRead: "I have read and understood",
      informativeLink: "the privacy policy",
      informConsent: "I consent to the processing of my personal data for the purposes stated in the privacy policy",
      proceed: "Proceed",
      viewReservation: "View reservation",
      downloadCalendar: "download calendar",
      downloadReminder: "download reminder",
      purchaseCompleted: "Purchase completed",
      purchasePending: "Purchase pending payment",
      informativaProdotto: "product policy",
      informativaPrestazione: "treatment policy",
      informativaTeleconsulto: "teleconsultation policy",
      genericError: "Unable to complete the operation.",
      preferencesUpdated: "Preferences updated successfully!",
      updatePreferencesError: "Unable to update preferences",
      noAvailabilityThisWeek: "The selected service has no availability for the current week",
      noAvailabilityThisService: "Unable to find availability for this service",
      noAvailabilityWeek: "No availability for the current week",
      bookingSuccess: "Booking submitted successfully!",
      bookingError: "Unable to submit the request",
      reminderDownloadError: "Unable to download the reminder",
      questionnaireSendError: "Unable to submit the questionnaire",
      paymentInfoError: "Unable to retrieve payment information",
      companyNotFound: "Unable to find companies for the selected service",
      downloadFailed: "Unable to download the resource",
      costo: "cost",
      timeSlots: {
        morning: 'morning',
        afternoon: 'afternoon',
        allday: 'all day'
      },
      preferenzaStruttura: "Preferred facility",
      presso: "At",
      preferenzeScelte: "Selected Preferences",
      informativa: "Policy",
      skipConfirmationEmail: "Do not send booking confirmation email",
      skipConfirmationEmailHelp: "If selected, the user will not receive the booking confirmation email",
      bypassPreferences: "Continue without preferences",
      bypassPreferencesHelp: "Proceed without entering patient preferences"
    },
    CalendarioDisponibilitaGiornalieraCittadino: {
      chooseDateTime: "Choose date and time from available slots",
      labelHelp: "Use the arrows to navigate between dates",
      day: "day",
      noAvailability: "No availability for the selected day",
      giorno_precedente: "Previous day",
      giorno_successivo: "Next day"
    },
    FamiliareCard: {
      modifica_familiare: "Edit family member details"
    },
    OperatoreDashboardServiziCard: {
      vai_a_in_attesa: "Go to pending bookings",
      vai_a_confermate: "Go to confirmed bookings",
      vai_a_annullate: "Go to cancelled bookings",
      vai_a_evase: "Go to completed bookings"
    },
    CompanyHomeDashboard: {
      vai_appuntamenti: "Go to appointments",
      prenota_appuntamento: "Book an appointment"
    },
    FrequenzeRilevazioni: {
      titleModifica: "Edit the frequency",
      titleElimina: "Delete the frequency",
      titleSospendi: "Pause the frequency",
      titleRiprendi: "Resume the frequency",
      titleAdd: "New monitoring frequency",
      titleUpdate: "Edit setting",
      titleDelete: "Edit operation",
      titleConfirm: "Confirm operation",
      labelEvery: "The parameter must be measured every",
      labelFrequency: "Monitoring frequency: one measurement every",
      labelSuspended: "Monitoring suspended",
      labelDeleteQuestion: "Do you want to delete this monitoring frequency?",
      labelEnableQuestion: "Do you want to enable this monitoring frequency?",
      labelDisableQuestion: "Do you want to disable this monitoring frequency?",
      buttonSetFrequency: "Set monitoring frequency",
      buttonSave: "Save frequency",
      buttonCancel: "Cancel",
      buttonConfirm: "Confirm",
      buttonEdit: "Save changes",
      buttonDeleteYes: "Yes, delete",
      buttonDeleteNo: "No, cancel",
      error_generic: "Something went wrong",
      success_saved: "Values successfully saved",
      success_updated: "Frequency setting successfully updated",
      error_update: "Unable to update frequency",
      success_deleted: "Frequency setting successfully deleted",
      error_delete: "Unable to delete frequency",
      months: "months",
      month: "month",
      weeks: "weeks",
      week: "week",
      days: "days",
      day: "day",
      hours: "hours",
      hour: "hour",
      minutes: "minutes",
      minute: "minute",
      seleziona_frequenza: "Select frequency",
      modifica_frequenza: "Edit frequency"
    },
    RefertoDimissioni: {
      contattaci: "Contact us for information",
      contattaci_label: "Contact us for information"
    },
    PickMessageCarousel: {
      messaggio_precedente: "Previous message",
      messaggio_successivo: "Next message"
    },
    SearchCompany: {
      back: "Go back",
      noResults: "No results found with these search parameters.",
      rangeHelp: 'Use the "range" field to increase or decrease the search radius',
      geolocWarning: "To use this feature, you must allow location sharing.",
      allowConsent: "Grant consent",
      meters: "meters",
      repeatSearch: "Repeat search",
      searchByPosition: "Search using my current location",
      searchHelp: 'Fill in one or more fields and press "search" to view the results',
      labelRegion: "Region*",
      selectRegion: "Select Region",
      labelProvince: "Province*",
      selectProvince: "Select Province",
      labelMunicipality: "Municipality*",
      selectMunicipality: "Select Municipality",
      labelName: "Name",
      placeholderName: "Name...",
      requiredFields: "*required fields",
      clearFields: "Clear fields",
      search: "Search",
      increaseRange: "Increase search radius",
      clickToSetPreferredFromHome: 'Click the location you want to set as preferred and confirm by pressing "Confirm Choice"',
      clickToSetPreferred: 'Click your preferred location and confirm by pressing "Confirm Choice"',
      setAsPreferred: "Set as Preferred",
      cancel: "Cancel",
      confirm: "Confirm Choice",
      noResultsSearch: "No results for this search",
      successPreferences: "Preferences updated successfully!",
      errorPreferences: "Unable to update preferences"
    },
    FeverPrivacy: {
      titolo: "Fever Privacy Policy",
      logo_alt: "Fever Logo",
      pdf_title: "Fever privacy policy PDF document",
      pdf_aria_label: "PDF viewer for Fever privacy policy",
      scarica_pdf: "Download PDF",
      scarica_aria_label: "Download Fever privacy policy as PDF",
      indietro_aria_label: "Go back to previous page"
    },
    FeverDownload: {
      header_aria: "Fever header with app description",
      logo_alt: "Fever Logo",
      hero_text_before: "The app to help parents manage",
      febbre: "fever",
      hero_text_middle: "and",
      dolore: "pain",
      hero_text_after: "in children in a simple and safe way.",
      lucky_alt: "Lucky, the Fever mascot",
      download_aria: "Fever app download section",
      scarica_app: "DOWNLOAD THE APP",
      super_lucky_alt: "Super Lucky flying",
      google_play_aria: "Download Fever on Google Play",
      google_play_alt: "Available on Google Play",
      app_store_aria: "Download Fever on App Store",
      app_store_alt: "Download on App Store"
    },
    FillSurvey: {
      privacyIntro: "More details can be found in the",
      privacyPolicy: "Privacy Policy",
      termsIntro: "The terms of use are available",
      termsLink: "here",
      requiredAnswer: "This question is required",
      okProceed: "Ok, Proceed",
      back: "Go back",
      next: "Next",
      thankYou: "Thank you for completing the survey!",
      canContinueBooking: "You may proceed with the booking.",
      continue: "Continue",
      skip: "Skip",
      reset: "Reset answer",
      finishStep: "Finish"
    },
    SurveyUploader: {
      filesUploaded: "Files uploaded successfully!",
      fileUploaded: "File uploaded successfully!",
      remove: "Remove",
      upload: "Upload",
      select_file: "select file...",
      select_more_file: "select one or more file..."
    },
    SurveySliderInput: {
      selettore_valore: "Value selector",
      valore_corrente: "Current value",
      non_risposto: "Not answered"
    },
    SurveyQuestionInput: {
      campo_risposta: "Answer",
      campo_obbligatorio: "This field is required",
      aiuto_slider: "How to use",
      aiuto_slider_titolo: "How to choose the value",
      aiuto_slider_testo:
        "Drag the ball along the bar to choose a value: move it to the right for a higher value, to the left for a lower one. Alternatively, tap directly on the point of the bar you want.",
      aiuto_slider_label: "Help: how to use the selector to choose the value"
    },
    NewSubjectSelection: {
      forMe: "For me",
      forFamilyMember: "For a family member",
      forAssisted: "For a patient of mine",
      chooseFamilyMember: "choose family member",
      chooseAssisted: "choose assisted person",
      noneRegistered: "You haven't registered any",
      continueToRegister: "Continue to register",
      registerNow: "register now",
      selectFamilyMember: "Select family member",
      selectAssisted: "Select assisted person",
      cannotFetchInfo: "Unable to retrieve the requested information",
      cannotFetchInfoShort: "Unable to retrieve the information."
    },
    ProductSelection: {
      productSelectionTitle: "Product Selection",
      searchInstruction: "Search the formulary for the products you need by typing at least 3 characters below:",
      searchLabel: "Search product",
      searchPlaceholder: "Search product...",
      noProductFound: "No product found",
      for: "for",
      selectOneOrMore: "Select one or more products from the formulary",
      selectProductsOption: "Select products...",
      selectProductOption: "Select product...",
      selectedProductsTitle: "Selected products list",
      quantityLabel: "Quantity:",
      generic: "Generic",
      cannotFindProduct: "I can't find the product I'm looking for",
      insertManualProduct: "Enter product not listed in formulary",
      manualProductLabel: "Product name*:",
      manualProductPlaceholder: "Enter product name...",
      add: "Add",
      prescriptionExplanation: "If you want to place an order for a medical or veterinary prescription, fill in one of the fields below. It is not necessary to manually enter the products already listed in the prescription.",
      insertNRECode: "Enter the code below",
      nreLabel: "Enter NRE prescription code",
      nrePlaceholder: "Enter NRE prescription...",
      insertREVCode: "If veterinary, enter the code below",
      revLabel: "Enter REV prescription code",
      revDescription: "*13 characters. Do not include the pin.",
      revPlaceholder: "Enter REV prescription...",
      pdfUploadAlt: "Alternatively, upload the prescription as a PDF",
      pdfUploadInstruction: "Upload the prescription in PDF format: the system will read the NRE code from the file and insert it in the appropriate field. Files uploaded here are not stored in the system. Code reading is only valid for NRE prescriptions; for veterinary ones, please enter the code manually.",
      scanWithCamera: "Or scan the NRE code using the camera",
      saveOrder: "Save order",
      prodotto: "Product:"
    },
    BarcodeComponent: {
      instructions: "Press the button below to activate the scanner. Once active, frame the two barcodes located at the top right of the prescription, one at a time from left to right (first the shorter code, then the longer one). Once the full code is detected, confirm that it matches the one written on the request.",
      scanWithCamera: "Scan code using device camera",
      cancelOperation: "Cancel Operation",
      codeDetected: "Code Detected:",
      invalidCode: "Invalid code",
      confirm: "Confirm",
      retry: "Retry"
    },
    NewPrestazioneSelection: {
      searchLabel: "Search for the visit or service you need",
      searchPlaceholder: "Enter the name of the service",
      skip_payment_label: "Request that no payment be required for this reservation"
    },
    PickHealthServiceFromCompany: {
      skip_payment_label: "Request that no payment be required for this reservation"
    },
    SkipPaymentCheckbox: {
      title: "Request reservation without payment",
      section_title: "The reservation:",
      standard_label: "follows standard payment rules",
      skip_label: "must be without payment",
      standard_description: "Payment will be applied based on the patient's subscription, any available free services, or the settings of projects the patient is enrolled in",
      skip_description: "No payment will be required, even without an active subscription and with free services still available",
      section_label: "Enable or disable reservation without payment request"
    },
    TeleconsultoSurveySelection: {
      reasonLabel: "Why are you requesting the consultation?",
      fetchError: "Unable to retrieve the questionnaires"
    },
    StepperButtons: {
      remainingFreeBookings: "Remaining free bookings",
      goBack: "Go Back",
      continue: "Continue"
    },
    PrivacyInfoComponent: {
      title: "INFORMATION ON THE PROCESSING OF PERSONAL DATA – ORDERS FOR ME / FOR FAMILY MEMBERS / ASSISTED PERSONS",
      whoProcessesData: "Who processes my data?",
      whoProcessesDataContent: `
		<p class="px-1 mb-0 border-bottom border-dark">
			The Data Controller is Qwince Innovation S.R.L.
		</p>
		<p class="px-1 mb-0 border-bottom border-dark">
			Registered office:
		</p>
		<p class="px-1 mb-0 border-bottom border-dark">
			Email address: info@concura.online / Certified email (PEC): qwince.legalmail.it
		</p>
		<p class="px-1 mb-0">
			Contact details of the Data Protection Officer (DPO): dpo@qwince.com.
		</p>
	`,
      controller: "Data Processor",
      controllerContent: `
		<p>The data processor is:</p>
		<p>Registered office:</p>
		<p>Email:</p>
		<p v-if="company.contatto_dpo" class="px-1 mb-0">
			Contact details of the Data Protection Officer (DPO): {{ company.contatto_dpo }}
		</p>
	`,
      section1Title: "1. FOR WHAT PURPOSES ARE MY / MY FAMILY MEMBER'S DATA PROCESSED AND WHY IS IT LEGITIMATE?",
      section1Content: `
		<p>The Controller processes your data to allow you to book orders for yourself or a family member/assisted person at the facility. This processing is lawful because:</p>
		<ul>
			<li>for common data (e.g., personal information), the processing is necessary for the execution of a contract;</li>
			<li>for health data, the processing is based on your consent, which you may provide by checking the appropriate box before submitting the order.</li>
		</ul>
	`,
      section2Title: "2. WHO IS MY / MY FAMILY MEMBER'S DATA SHARED WITH?",
      section2Content: `
		<p>Your data is shared with an IT consulting company and with Qwince Innovation S.R.L. for the management of the Platform. You may request the complete list of data recipients by writing to <a href="mailto:assistenza@concura.online" class="text-secondary">assistenza@concura.online</a>. Your data will not be publicly disclosed.</p>
	`,
      section3Title: "3. ARE MY / MY FAMILY MEMBER'S DATA TRANSFERRED OUTSIDE THE EUROPEAN UNION?",
      section3Content: `
		<p>Your data are not transferred outside the European Union.</p>
	`,
      section4Title: "4. HOW LONG ARE MY / MY FAMILY MEMBER'S DATA RETAINED?",
      section4Content: `
		<p>The Controller retains personal data for no longer than necessary to achieve the purposes for which the data is being processed. Specifically, your data will be stored for the entire period your profile remains active, and therefore until your profile is deactivated. After this period, unless legally required, the Controller will delete the data irreversibly using secure destruction or deletion methods or store it in anonymized form that does not allow identification, even indirectly.</p>
	`,
      section5Title: "5. WILL I BE SUBJECT TO PROFILING?",
      section5Content: `
		<p>Your data will never be used to gather information about your preferences or behavior, and you will not be subject to any decision based solely on automated processing of your personal data.</p>
	`,
      section6Title: "6. WHAT ARE MY RIGHTS?",
      section6Content: `
		<p>You have the following rights:</p>
		<ul>
			<li><b>Right of access:</b> the right to obtain confirmation as to whether your personal data is being processed and, if so, access to it and related information.</li>
			<li><b>Right to rectification:</b> the right to have inaccurate personal data corrected and incomplete data completed.</li>
			<li>
				<b>Right to erasure:</b> the right to have your personal data deleted without undue delay if:
				<ul>
					<li>the data are no longer necessary for the purposes for which they were collected or processed;</li>
					<li>the data were unlawfully processed;</li>
					<li>the data must be erased to comply with a legal obligation;</li>
					<li>the data were collected in relation to the offer of information society services.</li>
				</ul>
			</li>
			<li>
				<b>Right to restriction of processing:</b> applicable in the following cases:
				<ul>
					<li>you contest the accuracy of the data, for a period enabling verification;</li>
					<li>the processing is unlawful and you oppose deletion, requesting restriction instead;</li>
					<li>the controller no longer needs the data, but you require it for legal claims;</li>
					<li>you object to processing pending verification of the controller's legitimate grounds.</li>
        </ul>
      </li>
      <li><b>Right to data portability:</b> the right to receive your data in a structured, commonly used, machine-readable format and to transmit it to another controller, when processing is based on consent or contract and carried out by automated means.</li>
      <li><b>Right not to be subject to automated decision-making:</b> including profiling, if it produces legal effects or significantly affects you.</li>
    </ul>
    <p>You can exercise your rights by contacting the Controller by email. You will receive a response within 30 days.</p>
  `,
      section7Title: "7. AM I REQUIRED TO PROVIDE MY / MY FAMILY MEMBER'S DATA?",
      section7Content: `
    <p>You are free not to provide your data, but if you do not, you will not be able to proceed with the order.</p>
  `,
      section8Title: "8. HOW CAN I FILE A COMPLAINT?",
      section8Content: `
    <p>If you wish to file a complaint regarding how your personal data are processed or how your complaint was handled, you have the right to contact the supervisory authority via the procedures indicated at <a href="https://www.garanteprivacy.it" target="_blank">www.garanteprivacy.it</a>.</p>
  `,
      controllerLabel: "The data processor is:",
      controllerAddress: "Registered office:",
      controllerEmail: "Email:",
      controllerDPO: "Contact details of the Data Protection Officer (DPO):"
    },
    RiepilogoPrenotazione: {
      service: "Service:",
      generic: "generic",
      rememberPin: "Remember to bring the prescription PIN with you when you collect the order.",
      structureAssigned: "Facility selection managed by",
      selectedDateTime: "Selected date and time:",
      estimatedDateTime: "Estimated date and time:",
      downloadableDocs: "Downloadable Documents",
      docsNote: "There are documents related to this booking. You can view them by clicking on each one. Documents with fields to fill in must be downloaded, printed, completed, and presented at the appointment.",
      recommendations: "Recommendations",
      thankYou: "Thank you",
      forRequest: "for your booking request.",
      forBooking: "for your booking.",
      confirmationMessage: "You will soon receive a message from one of our operators to confirm the booking.",
      structurePreference: "Preferred Healthcare Facility:"
    },
    PickNuovaPrenotazioneType: {
      ricerca_per_visita: "Search by visit or service",
      ricerca_per_centro: "Search by provider center",
      skip_payment_label: "Request that no payment be required for this reservation",
      skip_payment_help: "The reservation will be marked as free"
    },
    PickCompanyOperator: {
      labelAssign: "Operator to assign to the booking",
      labelPreference: "Preferred Healthcare Professional",
      noPreference: "No Preference",
      emailDocumentiFirmatiInfo: "The selected operator will receive emails of documents signed during the service."
    },
    qui: "HERE",
    NewPreferenzeSelection: {
      insertAtLeast3: "Enter at least 3 preferences and time slots.",
      saveAndProceed: "Save and continue",
      saveSelection: "Save selection",
      selectDaysAndTimes: "Select preferred days and time slots",
      noPreference: "I have no particular preferences",
      wantToSpecify: "I want to specify preferences",
      labelHelp: "Use the arrows to navigate between dates",
      datePlaceholder: "Choose a date",
      timeSlotLabel: "Preferred time slot*",
      addPreference: "Add preference",
      timeOptions: {
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        allday: "all day"
      },
      dateLabel: "Preferred date*"
    },
    PreferenzePicker: {
      morning: "Morning",
      afternoon: "Afternoon",
      allday: "All day",
      days: {
        long: {
          monday: "Monday",
          tuesday: "Tuesday",
          wednesday: "Wednesday",
          thursday: "Thursday",
          friday: "Friday",
          saturday: "Saturday",
          sunday: "Sunday"
        },
        short: {
          monday: "M",
          tuesday: "T",
          wednesday: "W",
          thursday: "T",
          friday: "F",
          saturday: "S",
          sunday: "S"
        }
      },
      months: {
        gennaio: "January",
        febbraio: "February",
        marzo: "March",
        aprile: "April",
        maggio: "May",
        giugno: "June",
        luglio: "July",
        agosto: "August",
        settembre: "September",
        ottobre: "October",
        novembre: "November",
        dicembre: "December"
      },
      scegliFasciaOraria: "Choose your preferred time slot",
      preferenze_selezionate: "Selected preferences",
      rimuovi_preferenza: "Remove preference",
      rimuovi_preferenza_aria: "Remove preference for {date}",
      nessuna_preferenza_selezionata: "No preferences selected",
      mese_precedente: "Previous month",
      mese_successivo: "Next month",
      calendario_preferenze: "Date preference selection calendar",
      rimuovi_data: "Remove selected date",
      seleziona_giorno: "Select {date}",
      giorno_selezionato: "{date} - selected",
      giorno_non_selezionabile: "{date} - not selectable"
    },
    SearchCompanyFilters: {
      removeFilter: "Remove filter",
      searchCenter: "Search provider center",
      namePlaceholder: "Name",
      type: "Type",
      region: "Region",
      province: "Province",
      municipality: "Municipality",
      zip: "ZIP code",
      zipPlaceholder: "ZIP"
    },
    ClinicalTimeline: {
      titolo: "Clinical timeline",
      conteggio_eventi: "events",
      cerca_placeholder: "Search the timeline...",
      zoom_label: "Period shown",
      zoom_mese: "Last month",
      zoom_trimestre: "Last 3 months",
      zoom_semestre: "Last 6 months",
      zoom_anno: "Last year",
      zoom_oltre_anno: "Over a year",
      zoom_tutto: "Full history",
      filtri_categoria: "Filter by category",
      cat_patologie: "Conditions",
      cat_terapie: "Therapies",
      cat_fuori_norma: "Out-of-range values",
      cat_note: "Notes",
      cat_referti: "Reports",
      filtro_patologie: "Show or hide conditions",
      filtro_terapie: "Show or hide therapies",
      filtro_fuori_norma: "Show or hide out-of-range values",
      filtro_note: "Show or hide notes",
      filtro_referti: "Show or hide reports",
      filtro_attivo: "Active filter",
      rimuovi_filtro: "Remove the filter",
      caricamento: "Loading the timeline...",
      nessun_evento: "No clinical event in the selected period.",
      ricerca_vuota: "No results found.",
      valore: "Value",
      min: "Minimum",
      max: "Maximum",
    },
    SearchUtente: {
      cerca: "Search",
      istruzioni_base: "Search for a user by tax code or username.",
      istruzioni_estese: "Enter the tax code or username (email or phone) of the user you want to search for.",
      label_cerca_cf: "Search by tax code",
      label_cerca_username: "Search by username",
      placeholder_cf: "Enter tax code...",
      placeholder_username: "Enter email or phone...",
      utente_trovato_con: "User found with",
      email: "email",
      codice_fiscale: "tax code",
      istruzioni_otp: "To proceed, the user must authorize access via OTP code.",
      oppure: "or",
      annulla_torna_indietro: "Cancel and go back",
      nessun_utente_trovato: "No user found",
      registra: "Register new user"
    },
    CittadinoAgenda: {
      title: "Calendar",
      serviceInactive: "Service not active."
    },
    CalendarioCittadino: {
      month: "Month",
      year: "Year",
      previous: "Previous",
      next: "Next",
      showMondayOnly: "show only Monday",
      showTuesdayOnly: "show only Tuesday",
      showWednesdayOnly: "show only Wednesday",
      showThursdayOnly: "show only Thursday",
      showFridayOnly: "show only Friday",
      showSaturdayOnly: "show only Saturday",
      showSundayOnly: "show only Sunday",
      noRequests: "No requests here.",
      teleconsulto: "Teleconsultation",
      ordine: "Order",
      prestazioneSanitaria: "Healthcare service",
      evento: "Event",
      statusConfirmed: "Confirmed",
      statusCompleted: "Completed",
      statusForwarded: "Forwarded/Pending response",
      statusError: "Error/Rejected/Cancelled",
      fetchError: "Unable to retrieve bookings",
      updateSuccess: "Request successfully updated",
      genericError: "Operation failed",
      downloadError: "Unable to download reminder",
      months: {
        january: "January",
        february: "February",
        march: "March",
        april: "April",
        may: "May",
        june: "June",
        july: "July",
        august: "August",
        september: "September",
        october: "October",
        november: "November",
        december: "December"
      },
      daysShort: {
        mon: "Mon",
        tue: "Tue",
        wed: "Wed",
        thu: "Thu",
        fri: "Fri",
        sat: "Sat",
        sun: "Sun"
      },
      rangeDate: "{start} - {end}"
    },
    Eventi: {
      nuovoEvento: "New Event",
      nomeLabel: "Event Name*",
      luogoLabel: "Location*",
      dataLabel: "Date*",
      dataPlaceholder: "Select a date",
      oraLabel: "Time*",
      noteLabel: "Notes",
      notePlaceholder: "Add notes (optional)",
      parametriObbligatori: "*required fields",
      salva: "Save",
      salvaModifiche: "Save Changes",
      modifica: "Edit Event",
      elimina: "Delete Event",
      annullaModifiche: "Cancel Changes",
      confermaElimina: "Do you confirm you want to delete the event?",
      okElimina: "Yes, delete",
      annullaElimina: "No, cancel",
      testoConfermaElimina: `If confirmed, the event {titolo} will be permanently deleted.`,
      titoloNuovo: "New Event",
      titoloModifica: "Edit Event",
      titoloDettagli: "Event Details",
      successoModifica: "Event updated successfully",
      erroreModifica: "Error updating the event",
      successoCreazione: "Event created successfully",
      erroreCreazione: "Error creating the event",
      successoEliminazione: "Event deleted successfully",
      erroreEliminazione: "Error deleting the event"
    },
    Calendario: {
      salva_evento: "Save event",
      aggiungi_a_lista_pazienti: "The appointment can be booked anyway. To take the user in charge — their record, their history — they have to be added to the patient list, from the Patients section.",
      rimuovi_filtro_stato: "Remove status filter",
      rimuovi_filtro_servizio: "Remove service filter",
      rimuovi_filtro_prestazione: "Remove health service filter",
      rimuovi_filtro_annullati: "Remove exclude cancelled filter",
      aggiungi_nota_slot: "Add new event to slot",
      nuovo_evento: "New Event",
      nuova_nota: "new event",
      tab_nota_semplice: "Simple Note",
      tab_prenotazione: "Book Appointment",
      durata_slot: "Slot duration",
      durata_minuti: "{minutes} minutes",
      data_ora_inizio: "Start date and time",
      dettaglio_opzionale: "Details (optional)",
      placeholder_titolo_evento: "Enter the event or note title...",
      placeholder_dettaglio_evento: "Enter additional details or notes...",
      chiudi: "Close",
      modifica_nota: "Edit",
      titolo_nota: "Title",
      testo_nota: "Details",
      salva_nota: "Save",
      elimina_nota: "Delete",
      conferma_eliminazione_nota: "Confirm deletion",
      testo_conferma_eliminazione_nota: "Are you sure you want to delete this event?",
      nota_volante: "Agenda note",
      nessuna_prestazione: "No health service configured",
      crea_prestazione: "Create a health service →",
      nota_salvata: "Event saved successfully",
      nota_eliminata: "Event deleted successfully",
      errore_nota_obbligatoria: "Enter the event title",
      errore_salvataggio_nota: "Unable to save the event",
      errore_eliminazione_nota: "Unable to delete the event",
      apri_promemoria_agenda: "Open event",
      apri_nota_agenda: "Open event",
      sezione_nota: "Note",
      sezione_paziente: "Patient",
      sezione_prestazione: "Service",
      sezione_quando: "When",
      sezione_note: "Notes"
    },
    CalendarioCittadinoMobile: {
      labelHelp: "Use the arrows to navigate between dates",
      day: "day",
      loading: "loading",
      noRequests: "No requests here.",
      teleconsulto: "Teleconsultation",
      ordine: "Order",
      prestazioneSanitaria: "Healthcare service",
      evento: "Event",
      statusConfirmed: "Confirmed",
      statusCompleted: "Completed",
      statusForwarded: "Forwarded/Pending response",
      statusError: "Error/Rejected/Cancelled",
      fetchError: "Unable to retrieve bookings",
      updateSuccess: "Request updated successfully",
      operationError: "Operation could not be completed",
      downloadError: "Unable to download reminder",
      requestSuccess: "Request sent successfully",
      giorno_precedente: "Go to previous day",
      giorno_successivo: "Go to next day"
    },
    PreviewConsultoCittadino: {
      avvia: "Start",
      termina: "End",
      messaggi: "Messages",
      consulto: "Consultation",
      questionario: "Your questionnaire",
      tempoRimanente: "Time remaining",
      status: "status",
      durata: "Duration",
      consultoConcluso: "Consultation completed.",
      vaiAiReferti: "Go to your reports",
      consultiPrevisti: "Consultations scheduled for today",
      ora: "Time",
      con: "with",
      durataPrevista: "expected duration",
      minuti: "minutes",
      nessunConsulto: "No consultations scheduled for today",
      abbonamentoNonAttivo: "Unfortunately, the selected pharmacy no longer has an active subscription for the service.",
      erroreRichieste: "Unable to retrieve requests",
      connessione: {
        attesa: "Waiting for connection...",
        inCorso: "Connecting...",
        connesso: "Connected.",
        fallita: "Connection failed. End and restart the session.",
        abbandonato: "The user has left the consultation."
      },
      documentiDaFirmare: {
        titolo: "Document to sign",
        titoloMultipli: "Documents to sign",
        caricamentoDocumenti: "Loading documents...",
        firmato: "Signed",
        firma: "Sign",
        documentiCompletati: "Documents signed!",
        tuttiDocumentiFirmati: "All documents have been signed successfully",
        riduzioneAutomatica: "Auto-minimize",
        firmati: "Signed",
        documentiFirmati: "Signed documents",
        firmatoIl: "signed on"
      }
    },
    DocumentSigningModal: {
      firmaDocumento: "Sign Document",
      caricamentoDocumento: "Loading document...",
      leggiAttentamente: "Please read the document carefully before proceeding with digital signature.",
      scorriFineFondo: "Scroll to the bottom of the document to enable signing.",
      puoiProcedere: "You have read the entire document. You can proceed with signing.",
      scarica: "Download",
      scaricamento: "Downloading...",
      scorriDocumento: "Scroll the document to enable signing",
      scorriAbilitare: "Scroll through the entire document to enable signing",
      scorriPercentuale: "Scroll document ({percentuale}%)",
      documentoFirmato: "Document signed successfully",
      caricamentoDatiUtente: "Loading user data...",
      erroreFirma: "Error signing document",
      erroreCaricamento: "Error loading document",
      erroreDownload: "Error downloading document",
      documentoFirmatoSuccesso: "Document signed successfully",
      emailInviata: "An email with the signed document has been sent to you and healthcare staff"
    },
    VideoCaller: {
      attesaCollegamento: "Waiting for the other user to connect...",
      reteAssente: "No internet signal.",
      avviso: "Warning...",
      connectionStatus: {
        1: "Opening new secure connection channel...",
        2: "Secure connection initialized...",
        3: "Connecting...",
        4: "Connected!",
        5: "Connection error, closing secure channel...",
        6: "Connection error, secure channel closed.",
        7: "The user left the consultation. Teleconsultation ended.",
        8: "The user left the consultation. Teleconsultation ended."
      },
      clientStatus: {
        1: "New client",
        2: "Client connected to the internet",
        3: "Internet connection interrupted. Please check your device's connectivity."
      },
      connessioneFallita: "Unable to connect",
      avvioMediaFallito: "Unable to start camera and/or microphone",
      connessioneNonRiuscita: 'Unable to connect. Click "End" and restart the session.',
      connessioneStabilita: "Connection established.",
      connessioneSconosciuta: "Unknown connection status",
      connessioneInstabile: "Unable to establish a stable connection. Please end and restart the consultation.",
      browserNonSupportato: "Your browser does not support video calls. Please use an updated browser."
    },
    LiveKitCaller: {
      nonAutorizzato: "Teleconsultation not available: this account does not take part in this consultation.",
      fotocamera: "Camera",
      microfono: "Microphone",
      sceltaFotocamera: "Choose camera",
      sceltaMicrofono: "Choose microphone",
      attivaAudio: "Enable audio",
      riconnessione: "Connection lost, reconnecting...",
      cambioDispositivoFallito: "Unable to switch device.",
      mediaNonDisponibili:
        "Camera and microphone unavailable: the teleconsultation can start once access is allowed in the browser and the session is restarted.",
      soloAudio:
        "Camera unavailable or not allowed: the teleconsultation continues with audio only.",
      soloVideo:
        "Microphone unavailable or not allowed: the teleconsultation continues without audio.",
    },
    LiveKitMessaging: {
      tu: "You",
      operatore: "Operator",
      paziente: "Patient",
      conversazione: "Consultation messages",
      messaggio: "Message",
      scriviMessaggio: "Write a message",
      chatNonAttiva: "Messages can be sent once the consultation is connected.",
    },
    MessagingComponent: {
      chat: "Chat",
      invio: "sending",
      connessioneFallita: "Unable to connect",
      connesso: "...connected to the chat",
      invia_messaggio: "Send message"
    },
    PrenotazioniTeleconsultoCittadino: {
      nuovaRichiesta: "New booking request",
      inSospeso: "Pending",
      confermati: "Confirmed",
      confermate: "Confirmed",
      storico: "History",
      servizioNonAttivo: "Service not active."
    },
    TeleconsultoOperatoreMain: {
      servizio_non_abilitato: "Service not enabled",
      contattaci: "Contact us",
      per_abilitare: "to learn more or to enable the service",
    },
    RichiesteEmergenzaCittadinoMain: {
      titolo: "My requests",
      aggiornamento: "Updating...",
      nessunaRichiesta: "No requests here.",
      modalTitle: "Quick Teleconsultation",
      modalOk: "Start now",
      programmato: "Scheduled at",
      servizioNonAttivo: "Service not active.",
      erroreRichieste: "Unable to retrieve requests"
    },
    DettaglioRichiestaEmergenza: {
      attesaRisposta: "waiting for response",
      terminato: "Completed",
      programmato: "Scheduled",
      annullato: "Cancelled",
      dataRichiesta: "Request date",
      orarioRichiesta: "Request time",
      teleconsultoCon: "Teleconsultation with",
      prenotazionePer: "Booking made for",
      avviaOra: "Start now"
    },
    CircoloCura: {
      titolo: "Your circle of care",
      aggiungiNuovo: "add new",
      consigliati: "Recommended for you",
      nessunElemento: "No items in your circle of care.",
      area: "Area",
      sede: "Operational office",
      mioCircolo: "My circle of care",
      contatti: "Contacts",
      email: "email",
      telefono: "phone",
      sedeLegale: "Registered office",
      datiFiscali: "Tax details",
      titolare: "Owner",
      partitaIva: "VAT number",
      codiceFiscale: "Tax code",
      pec: "Certified email",
      apertura: "Opening",
      chiuso: "Closed",
      nonInseriti: "Not provided",
      prenota: "Book",
      impostaPreferito: "Set as favorite",
      rimuoviCircolo: "Remove from my circle of care",
      rimossoSuccesso: "Item removed successfully!",
      rimossoErrore: "Unable to remove the selected item",
      preferenzeAggiornate: "Preferences updated successfully!",
      preferenzeErrore: "Unable to update preferences",
      infoErrore: "Unable to retrieve information",
      aggiungiTooltip: "Add to your circle of care"
    },
    AddMedicoModal: {
      invitaMedico: "invite my doctor",
      titleTooltip: "Invite your doctor to ",
      nomeLabel: "First Name*",
      nomePlaceholder: "First name...",
      cognomeLabel: "Last Name*",
      cognomePlaceholder: "Last name...",
      cittaLabel: "City*",
      cittaPlaceholder: "City...",
      emailLabel: "Email",
      emailPlaceholder: "Email...",
      campiObbligatori: "*Required fields",
      invia: "Invite",
      successo: "Doctor invited successfully!",
      erroreInvito: "Unable to invite the doctor"
    },
    SottoscrizioniCittadinoMain: {
      acquisti: "Purchases",
      acquisto: "Purchase",
      gestione: "Management",
      storico: "History",
      sottoscriviAbbonamento: "Subscribe to a plan",
      acquistaAbbonamento: "Purchase subscription",
      acquistaPrenotazione: "Purchase reservation",
      storicoAcquisti: "Purchase history",
      riepilogo: "Summary",
      abbonamento: "Subscription",
      sottoscrizione: "Plan",
      ivaInclusa: "VAT included",
      ivaEsclusa: "+ VAT",
      mese: "Month",
      mesi: "Months",
      anno: "Year",
      servizio: "Service",
      costiServizio: "Service management costs",
      codiceSconto: "Discount Code",
      voucher: "Voucher discount code",
      totale: "Total",
      imponibile: "Taxable amount",
      iva: "VAT",
      sottoscrivi: "Subscribe",
      rinnovoAutomatico: "*The subscription renews automatically",
      ogniMese: "every month",
      ogni: "every",
      riprova: "Retry",
      attesaPagamento: "Purchase pending payment",
      homepage: "Homepage",
      completata: "Subscription to plan completed",
      ore: "at",
      interrompibile: "Automatic renewal can be canceled at any time.",
      completed: "completed",
      erroreGenerico: "The operation could not be completed.",
      errorePagamento: "Unable to retrieve payment information",
      sottoscrizioneSuccesso: "Subscription completed",
      erroreSottoscrizione: "Subscription could not be completed"
    },
    PianiTerapeuticiScheda: {
      nessunPiano: "No therapeutic plan recorded",
      titolo: "Therapeutic Plans",
      nuovoPiano: "new therapeutic plan",
      nessunRisultato: "No results found.",
      piano: "Therapeutic Plan",
      validoDal: "valid from",
      al: "to",
      dal: "from",
      pianoInvalidato: "The plan has been invalidated by the ASL.",
      rinnovoRifiutato: "Supply renewal was rejected by the ASL.",
      motivazioni: "Reasons:",
      pacchetto: "Package",
      stato: "Status",
      il: "on",
      etichetta: "Label:",
      contenuto: "Content:",
      quantità: "Quantity:",
      lotto: "Batch:",
      scadenza: "Expiration:",
      noteAsl: "ASL Notes:",
      nessunPacchetto: "No packages scheduled for this plan yet.",
      nessunElemento: "No items among the plans",
      caricaPiano: "Upload new Therapeutic Plan",
      documento: "Document",
      fileCaricato: 'File uploaded successfully.',
      validitàPiano: "Plan validity",
      farmaciInclusi: "Drugs included in the plan",
      selezionaTerapie: "Select therapies*",
      scegliTerapie: "Choose therapies",
      annotazioni: "Notes",
      inserisciNote: "Enter any notes related to the Therapeutic Plan",
      salvaPiano: "Save Plan",
      seiSicuro: "Are you sure you want to delete this plan?",
      rinnovoPerFarmaci: "For which drugs do you want to request renewal?",
      questionarioPaziente: "Patient Questionnaire",
      informativaPaziente: "Patient Information",
      consentoInformativa: "I have delivered/communicated the information to the citizen",
      procedi: "Proceed",
      operazioneCompletata: "Operation completed.",
      istruzioniCaricamento: "Each time a new Therapeutic Plan is issued and brought to the pharmacy, review and update the patient's record with particular attention to the therapies section, where the drugs prescribed in the plan must be entered. After updating the patient's record, proceed with uploading the plan; once uploaded, it is necessary to specify the plan's validity dates and select the drugs included using the \"select therapies\" menu. Click \"save plan\" to complete the operation: the competent ASL office will be notified and will take charge of the plan. When the drug is ready for delivery, the ASL will notify both the pharmacy staff and the patient.",
      ricordaInserimento: "Remember to enter and verify the prescribed drugs under therapies before uploading the Therapeutic Plan. To request renewal of an already uploaded and valid plan, do not upload a new plan, but use the \"supply renewal\" function on the completed therapeutic plan row.",
      descrizioneScarica: "By clicking on the \"download pdf for the patient\" button, you can download the completed questionnaire in a printable version, including the information sheet (if present) and a dedicated signature area. You can still download the PDF and the questionnaire in other formats from the dedicated reporting section.",
      chiudiFinestra: "close window",
      scaricaPdf: "download pdf for the patient",
      servizioNonAbilitato: "Service not enabled",
      placeholderCerca: "Search ID...",
      rinnovoFornitura: "Supply renewal",
      somministraQuestionario: "Administer questionnaire",
      caricaNuovoPiano: "Upload new Therapeutic Plan",
      annulla: "Cancel",
      noAnnulla: "No, Cancel",
      salva: "Save",
      siElimina: "Yes, delete",
      conferma: "Confirm",
      confermaOperazione: "Confirm Operation"
    },
    CambiaStatoConsegna: {
      cambia: "Change",
      aggiorna: "Update",
      stato: "status",
      title: "Update delivery package status",
      ok: "Confirm",
      annulla: "Cancel",
      selezionaStato: "Select the new status of package",
      inPreparazione: "in preparation",
      prontoRitiro: "ready for pickup",
      ritiratoProntoConsegna: "picked up, ready for delivery to the patient",
      consegnato: "delivered to the patient",
      reso: "returned by the patient",
      successo: "Package status updated successfully",
      errore: "Unable to update the package status"
    },
    CompilaQuestionarioOperatore: {
      domandaOperatore: "- question for the operator",
      scegliOpzioni: "select one or more options...",
      aggiungiAltro: "add another",
      placeholderAltro: "other custom option",
      invia: "Submit"
    },
    GestioneSottoscrizioni: {
      titolo: "Subscription Management",
      visualizzaTutte: "View all subscriptions",
      pianoAttivo: "Active plan",
      durataMinima: "Minimum duration",
      mese: "month",
      mesi: "months",
      anno: "year",
      siRinnovaIl: "Renews on",
      scadraIl: "Expires on",
      leggiDiPiu: "Read more",
      prestazioniDisponibili: "Available services",
      ordineFarmaci: "Available medication orders",
      teleconsultoRapido: "Rapid Teleconsultation",
      teleconsultoPediatrico: "Pediatric Teleconsultation",
      gratis: "FREE",
      altreSottoscrizioni: "Other Subscriptions",
      contattaci: "Contact us",
      acquista: "Purchase",
      completaAcquisto: "Complete purchase",
      elimina: "Delete",
      confermaAnnullamento: "Do you confirm to cancel the subscription",
      siCancella: "Yes, cancel",
      noAnnulla: "No, cancel",
      piani: "Plans",
      erroreGenerico: "The operation could not be completed.",
      sottoscrizioneEliminata: "Subscription successfully deleted.",
      dataFineModificata: "Subscription end date updated successfully.",
      rinnovoStatoSuccesso: "Subscription renewal {stato} successfully.",
      attivato: "enabled",
      disattivato: "disabled",
      mostraCard: "Show your digital card",
      laTua: "Your",
      titoloModaleCard: "Your Digital Card",
      scrollSinistra: "Scroll subscriptions left",
      scrollDestra: "Scroll subscriptions right"
    },
    SendHelpRequest: {
      titolo: "Support",
      descrizione: "Select the option that best describes your request, then write your message and click 'send request': the system will forward an email to the support center, which will handle your request as soon as possible. Depending on the request, you may receive a reply via email or be contacted by phone.",
      campiObbligatori: "*Required fields",
      inviaRichiesta: "Send Request",
      titoloModale: "Support Request",
      oggettoLabel: "Subject*",
      messaggioLabel: "Message*",
      selezionaOggetto: "Select a subject",
      richiestaInformazioni: "Information request",
      richiestaImplementazione: "Feature request",
      malfunzionamento: "Bug report",
      correzioneDati: "Incorrect data correction",
      successo: "Support request successfully sent",
      errore: "Unable to send the request",
      testoRichiestaFullMonitor: "I would like to know more about the ConCura Full Monitor subscription"
    },
    EditSubscription: {
      titolo: "Edit Subscription",
      infoInizio: "You can set an end date for the subscription, or disable automatic renewal.",
      infoGiaImpostata: "You have already set a subscription end date.",
      infoModificaVincolo: "You can only change the auto-renewal status if no end date is set.",
      infoAzzeraPerModificare: "To disable auto-renewal, first clear the end date.",
      infoRiabilitaPerDataFine: "You can only set an end date if auto-renewal is enabled. Re-enable it to select a final date.",
      rinnovoIl: "The subscription will renew on",
      scadraIl: "The subscription will expire on",
      attivaProssimoPagamento: "The subscription is active and the next payment is scheduled for",
      gestisciRinnovo: "Manage Auto-Renewal",
      rinnovoAutomatico: "Auto-renewal",
      impostaDataFine: "Set a subscription end date",
      descrizioneDataFine: "For subscriptions with enabled auto-renewal, an end date can be set. From that date, renewal will stop.",
      nessunaData: "No end date set.",
      impostaData: "Set end date",
      modificaData: "An end date is already set. You can modify or clear it.",
      selezionaPeriodo: "Select",
      unMeseE: "a month and",
      unAnno: "a year for the subscription end date",
      annoFine: "End year",
      imposta: "Set date",
      azzera: "Clear",
      validazioneData: "The end date must be later than the next payment date",
      gennaio: "January",
      febbraio: "February",
      marzo: "March",
      aprile: "April",
      maggio: "May",
      giugno: "June",
      luglio: "July",
      agosto: "August",
      settembre: "September",
      ottobre: "October",
      novembre: "November",
      dicembre: "December",
      meseFine: "End month"
    },
    StoricoAcquisti: {
      nessunAcquisto: "No purchases made.",
      visualizzaAcquisti: "View Purchases",
      mostraProforma: "Show Proforma Invoice",
      descrizione: "Description",
      stato: "Status",
      erroreGenerico: "The operation could not be completed.",
      idTransazione: "Transaction ID",
      importo: "Amount",
      esito: "Result",
      dataPagamento: "Payment Date",
      azioni: "Actions",
      acquisti: "Purchases"
    },
    SubscriptionVoucherValidator: {
      labelCodice: "Do you have a discount code? Enter it here:",
      conferma: "Confirm",
      voucherNonValido: "Invalid voucher"
    },
    ProgettiMain: {
      servizioNonAbilitato: "Service not enabled",
      contattaci: "Contact us",
      perAbilitare: "to learn more or to enable the service",
      confermaEliminazione: "Are you sure you want to delete the selected post?",
      siElimina: "Yes, delete",
      noAnnulla: "No, cancel",
      caricaArticolo: "Upload an article",
      modificaArticolo: "Edit article",
      inserisci: "Insert a",
      modifica: "Edit",
      webinar: "Webinar",
      video: "Video",
      servizioNonAttivo: "Service not active.",
      erroreServizi: "Error retrieving services",
      errorePost: "Error retrieving posts",
      postCreato: "Post created successfully",
      erroreCreazione: "Error creating post",
      postModificato: "Post updated successfully",
      erroreModifica: "Error updating post",
      postEliminato: "Post deleted successfully",
      erroreEliminazione: "Error deleting post"
    },
    ProjectPanoramica: {
      webinar: "Webinars",
      leggi_articolo: "Read article {title}",
      benvenuto: "Welcome to the Blog of",
      articoli: "Articles",
      vediTutti: "See all",
      nuovoArticolo: "new article",
      nessunArticolo: "No articles available at the moment.",
      video: "Videos",
      nuovoVideo: "new video",
      nessunVideo: "No videos available at the moment.",
      nuovoWebinar: "new webinar",
      nessunWebinar: "No webinars available at the moment.",
      videoTipoWebinar: "Webinar-type video",
      logo_alt: "Blog logo"
    },
    VideoCard: {
      apri_video: "Open video {title}"
    },
    OperatorePostCard: {
      apri_post: "Open post {title}",
      mostra_post: "Show post",
      modifica: "Edit",
      elimina: "Delete"
    },
    CardFamiliare: {
      apri_scheda: "Open family member card {name}"
    },
    CardFamiliareSperimentazione: {
      apri_scheda: "Open child card {index}",
      conferma_revoca_title: "Confirm consent revocation",
      conferma_revoca_msg: "Are you sure you want to revoke consent for the trial?",
      revoca_consenso: "Revoke consent",
      revoca_successo: "Consent successfully revoked",
      revoca_errore: "Error revoking consent. Please try again.",
      conferma_approva_title: "Confirm consent approval",
      conferma_approva_msg: "Are you sure you want to approve consent for the trial?",
      approva_consenso: "Approve consent",
      approva_successo: "Consent successfully approved",
      approva_errore: "Error approving consent. Please try again.",
      conferma_elimina_title: "Confirm patient deletion",
      conferma_elimina_msg: "Are you sure you want to delete this enrolled patient from the trial? This action cannot be undone.",
      elimina_paziente: "Delete patient",
      elimina_successo: "Enrolled patient successfully deleted from the trial",
      elimina_errore: "Error deleting enrolled patient. Please try again."
    },
    SchedaFamiliare: {
      toggle_menu: "Expand or collapse sidebar menu"
    },
    NuovoBambinoSperimentazione: {
      arruola_paziente: "Enroll patient for trial",
      prosegui: "Continue"
    },
    EpisodioCard: {
      rinomina_episodio: "Rename episode",
      termina_episodio: "End episode",
      termina: "End",
      caricamento: "Loading...",
      rinominazione_in_corso: "Renaming in progress...",
      terminazione_in_corso: "Termination in progress..."
    },
    ModaleAggiungiEventoEpisodio: {
      seleziona_somministrazione: "Select drug administration event",
      seleziona_misurazione: "Select measurement event",
      seleziona_sintomo: "Select symptom event",
      torna_indietro: "Go back"
    },
    RisultatoCalcolo: {
      calcolo_in_corso: "Calculation in progress...",
      elaborazione_dosaggio: "Processing dosage..."
    },
    CalcoloStepByStep: {
      verifica_in_corso: "Verification in progress...",
      controllo_parametri: "Checking parameters..."
    },
    FamiliariAssistiti: {
      caricamento_familiari: "Loading family members..."
    },
    FamiliariAssistitiSperimentazione: {
      caricamento_familiari: "Loading family members..."
    },
    DocumentEditor: {
      caricamento_editor: "Loading document editor...",
      salva_documento: "Save Document"
    },
    PatientQueries: {
      caricamento_segnalazioni: "Loading reports..."
    },
    AlertEventDetail: {
      inoltra_alert: "Forward alert",
      perche_alert: "Show alert cause",
      modifica_alert: "Edit alert",
      vai_scheda_paziente: "Go to patient card",
      inoltra_a_struttura: "Forward to facility",
      scegli_struttura: "Choose the facility...",
      destinatario: "Recipient",
      aria_destinatario: "Type of forwarding recipient",
      destinatario_operatore: "One operator",
      destinatario_ruolo: "All operators with a role",
      operatore_destinatario: "Operator",
      ruolo_destinatario: "Role",
      scegli_operatore: "Choose the operator...",
      scegli_ruolo: "Choose the role...",
      nessun_operatore_struttura: "No operator available in this facility.",
      nessun_ruolo_struttura: "No role available in this facility.",
      nota_inoltro: "Note for the recipient",
      nota_placeholder: "Your notes...",
      caricamento_opzioni: "Loading the facility operators and roles",
      errore_opzioni: "The facility operators and roles could not be loaded.",
      riprova: "Retry",
      errore_inoltro: "The alert could not be forwarded.",
      inoltro_gia_fatto: "The alert has already been forwarded by another operator: the page shows its current state.",
      inoltro_alert_chiuso: "The alert has been completed in the meantime: the page shows its current state.",
      destinatario_non_valido: "The chosen recipient is no longer available: the facility operators and roles have been reloaded.",
      inoltro_riuscito: "Alert forwarded successfully.",
      inoltrato_a_operatore: "Forwarded to {nome}",
      inoltrato_a_ruolo: "Forwarded to: {ruolo} - {struttura}",
      inoltrato_a_tutti_operatori: "Forwarded to: all operators - {struttura}",
      in_gestione_da: "Handled by {nome}",
      non_ancora_in_carico: "Not yet taken in charge",
      prendi_in_carico: "Take charge",
      subentra: "Take over",
      conferma_subentro_titolo: "Take over handling",
      conferma_subentro: "The alert is handled by {nome}. Confirming, handling passes to you and the change is kept in the activity log.",
      presa_in_carico_riuscita: "Alert taken in charge.",
      subentro_riuscito: "Alert handling taken over.",
      azione_non_consentita: "Operation not allowed on this alert.",
      alert_aggiornato: "The alert was updated by another operator: the page shows its current state.",
      errore_azione: "The operation could not be completed.",
      torna_indietro: "Go back",
      completa: "Complete",
      completato: "Completed",
      completamento_riuscito: "Alert set as completed!",
      errore_completamento: "The alert could not be completed."
    },
    AlertList: {
      visualizza: "View",
      completato: "Completed",
      inoltrato: "Forwarded",
      in_gestione_da: "Handled by {nome}",
      da_prendere_in_carico: "To be taken in charge",
      da_gestire: "To be handled",
      nessun_alert: "No alerts",
      utente_eliminato: "Deleted user"
    },
    UserAlertEvents: {
      inoltrato_a_ruolo: "Forwarded to: {ruolo} - {struttura}",
      inoltrato_a_tutti_operatori: "Forwarded to: all operators - {struttura}",
      in_gestione_da: "Handled by {nome}"
    },
    Ruoli: {
      "amministratore": "administrator",
      "amministratore anagrafica": "registry administrator",
      "operatore": "operator",
      "operatore avanzato": "advanced operator",
      "medico": "doctor",
      "infermiere": "nurse",
      "infermiere avanzato": "advanced nurse",
      "oss": "healthcare assistant",
      "company-cup": "CUP operator",
      "operatore avanzato emergenza": "Rapid Teleconsultation operator",
      "operatore avanzato pediatrico": "Paediatric Teleconsultation operator",
      "operatore solo centralino emergenza": "Rapid Teleconsultation switchboard operator",
      "operatore solo centralino pediatrico": "Paediatric Teleconsultation switchboard operator",
      "operatore solo centralino pediatrico ed emergenza": "Paediatric and Emergency Teleconsultation switchboard operator",
      "croom-operatore": "croom-operatore",
      "croom-operatore-sanitario": "croom-operatore-sanitario",
      "croom-admin": "croom-admin"
    },
    RuoliTitolo: {
      "operatore": "Operator",
      "operatore avanzato": "Advanced Operator",
      "amministratore": "Administrator",
      "medico": "Doctor",
      "infermiere": "Nurse",
      "infermiere avanzato": "Advanced Nurse",
      "oss": "Healthcare Assistant",
      "operatore avanzato emergenza": "Rapid Teleconsultation Operator",
      "operatore avanzato pediatrico": "Paediatric Teleconsultation Operator",
      "operatore solo centralino emergenza": "Rapid Teleconsultation Switchboard Operator",
      "operatore solo centralino pediatrico": "Paediatric Teleconsultation Switchboard Operator",
      "operatore solo centralino pediatrico ed emergenza": "Paediatric and Emergency Teleconsultation Switchboard Operator"
    },
    RuoliDescrizioni: {
      "amministratore": "Can view and manage all sections, the settings panel and its sub-sections, all services and requests. Can download booking and screening reports.",
      "amministratore anagrafica": "Can view and edit the company registry. Has no access to service or operator management.",
      "operatore": "Basic role assigned by default to employees registered with the company code. Can manage booking requests and administer screening questionnaires, but cannot change service settings or create questionnaires.",
      "operatore avanzato": "Can manage booking requests and configure service settings. Can create and manage questionnaires and collections. Has no access to the operators section or the company registry.",
      "medico": "Clinical role with full access to patient management: can enrol patients, manage reports, write medical notes and update the patient record.",
      "infermiere": "Care-oriented clinical role: can update the patient record, add medical notes and view reports. Cannot enrol patients or manage reports.",
      "infermiere avanzato": "Same capabilities as the nurse (update the patient record, add medical notes, view reports) and can also enrol patients. Cannot manage reports.",
      "oss": "Healthcare support role with limited features: can administer questionnaires and add simple notes.",
      "company-cup": "CUP operator with access to booking management, service settings and operator management.",
      "operatore avanzato emergenza": "Same privileges as the advanced operator and, if the facility has enabled the service, access to the Rapid Teleconsultation area.",
      "operatore avanzato pediatrico": "Same privileges as the advanced operator and, if the facility has enabled the service, access to the Paediatric Teleconsultation area.",
      "operatore solo centralino emergenza": "Dedicated to receiving Rapid Teleconsultation requests. Has the advanced operator privileges and receives the service notifications.",
      "operatore solo centralino pediatrico": "Dedicated to receiving Paediatric Teleconsultation requests. Has the advanced operator privileges and receives the service notifications.",
      "operatore solo centralino pediatrico ed emergenza": "Dedicated to receiving both Paediatric and Rapid Teleconsultation requests. Combines the notifications of both services.",
      "croom-operatore": "Control Room operator with access to daily operations: orders, services, questionnaires and patient records.",
      "croom-operatore-sanitario": "Control Room healthcare operator. Compared with the basic operator, can enrol patients, add medical notes and activate patient services.",
      "croom-admin": "Control Room administrator with full access: management of the room operators, patient lists and company registry."
    },
    PrenotazioniPaziente: {
      vedi_dettaglio: "View booking details"
    },
    CalendarioFilters: {
      apri_filtri: "Open calendar filters",
      chiudi_overlay: "Close filters panel",
      chiudi_filtri: "Close filters"
    },
    CompanyReservationCard: {
      toggle_preferito: "Set/remove as favorite",
      aggiungi_suggerimento: "Add as suggestion",
      toggle_info: "Show/hide information"
    },
    PickHealthServiceFromCompanyCard: {
      toggle_info: "Show/hide information"
    },
    ProjectDetail: {
      tornaIndietro: "Go back",
      nuovo: "new",
      cerca: "Search",
      nessunElemento: "There is nothing to show",
      cercaPerTitolo: "Search by Title",
      cercaPerData: "Search by Date",
      nonCiSono: "There are no",
      daMostrare: "to show",
      subsection: {
        articolo: "articles",
        video: "videos",
        webinar: "webinars",
        "altri-contenuti": "other contents",
        evento: "events"
      }
    },
    CreateEditArticle: {
      tipoContenuto: "Content type",
      opzioneArticolo: "Article",
      opzioneAltriContenuti: "Other contents (PDF)",
      immagineCopertina: "Cover image",
      filePdf: "PDF file*",
      pdfObbligatorio: "Upload a PDF file to continue",
      apriPdf: "Open uploaded PDF",
      titolo: "Title*",
      placeholderTitolo: "Enter the article title",
      contenuto: "Content*",
      placeholderContenuto: "Article content",
      data: "Date",
      abilitato: "Enabled",
      disabilitato: "Disabled",
      campiObbligatori: "* required fields",
      salva: "Save",
      modifiche: "changes",
      nuovoArticolo: "new article",
      immagine_copertina_alt: "Article cover image"
    },
    ArticleShower: {
      article_image: "Article image",
      apri_pdf: "Open/Download PDF"
    },
    CreateEditVideo: {
      immagineCopertina: "Cover image*",
      erroreCopertina: "Please upload a cover image",
      titolo: "Title*",
      placeholderTitolo: "Enter the video title",
      abilitato: "Enabled",
      disabilitato: "Disabled",
      categoriaWebinar: "Webinar Category",
      tipoWebinar: "This video is a Webinar",
      tipoNonWebinar: "This video is not a Webinar",
      campiObbligatori: "* required fields",
      salva: "Save",
      modifiche: "changes",
      nuovoVideo: "new video",
      immagine_copertina_alt: "Video cover image"
    },
    ProfiloSanitarioMain: {
      archivioSanitario: "Health Archive",
      patologie: "Conditions",
      terapie: "Therapies",
      piani: "Therapeutic Plans",
      note: "Notes",
      dispositivi: "Devices",
      accessi: "Recorded activity",
      servizioNonAttivo: "Service not active.",
      errore: "The operation could not be completed.",
      anamnesi: "Anamnesis",
      timeline: "Clinical Timeline"
    },
    LineChart: {
      gennaio: "January",
      febbraio: "February",
      marzo: "March",
      aprile: "April",
      maggio: "May",
      giugno: "June",
      luglio: "July",
      agosto: "August",
      settembre: "September",
      ottobre: "October",
      novembre: "November",
      dicembre: "December",
      ordiniAlMese: "Orders per month"
    },
    ArmadiettoComponent: {
      nessunaInAtto: "No ongoing therapy",
      terapieInAtto: "Active therapies",
      prospettoTerapie: "Therapy Overview",
      nuovaTerapia: "New therapy",
      finoAl: "Until",
      dal: "From",
      elimina: "Delete",
      vedi: "View",
      storicoTerapie: "Therapy History",
      terminataIl: "Ended on",
      nessunElemento: "No items in history",
      modificaTerapia: "Edit therapy",
      dettaglioTerapia: "Therapy details",
      perPatologia: "for condition",
      patologia: "condition",
      modifica: "Edit",
      riprendi: "Resume",
      sospendi: "Suspend",
      scaricaPromemoria: "Download reminder",
      inseritaIl: "Inserted on",
      conferma: "Confirm",
      noAnnulla: "No, Cancel",
      siConferma: "Yes, Confirm",
      confermiSospRipr: "Do you confirm you want to",
      sospendere: "suspend",
      riprendere: "resume",
      laTerapia: "the therapy?",
      confermaEliminazione: "Confirm deletion",
      confermiEliminazione: "Do you confirm you want to delete the therapy?",
      erroreRecupero: "Unable to retrieve therapies",
      terapia: "Therapy",
      sospesa: "suspended",
      ripresa: "resumed",
      erroreOperazione: "The operation could not be completed",
      eliminata: "Therapy deleted!",
      erroreEliminazione: "Unable to delete the therapy",
      erroreDownloadPromemoria: "Unable to download the reminder",
      erroreDownloadProspetto: "Unable to download the overview.",
      mattina: "morning",
      meta_mattina: "mid-morning",
      pranzo: "lunch",
      pomeriggio: "afternoon",
      sera: "evening",
      notte: "night"
    },
    RecapTherapyModal: {
      posologia: "Dosage",
      di: "of",
      perVia: "by route",
      daFinoA: "From {{start}} to {{end}}",
      daAssumere: "To be taken",
      durata: "Duration",
      terapiaOgni: "The therapy must be taken every",
      per: "for",
      aPartireDa: "starting from",
      cronica: "chronic",
      prescrittore: "Prescriber",
      effettiCollaterali: "Side Effects",
      reazioniAllergiche: "Allergic Reactions",
      interazioni: "Interactions",
      annotazioni: "Notes",
      non_indicata: "not indicated",
      non_indicate: "not indicated",
      non_indicato: "not indicated",
      non_indicati: "not indicated",
      nessuna_nota: "no notes",
      typesMap: {
        Compresse: "tablet",
        Capsule: "capsule",
        Gocce: "drop",
        Inalazioni: "inhalation",
        Buste: "sachet",
        Supposte: "suppository",
        Scatole: "box",
        Cerotti: "patch",
        Fiale: "vial",
        Fleboclisi: "IV infusion",
        Ovuli: "ovule",
        Sacche: "bag",
        Flaconi: "bottle",
        Confezioni: "package",
        Kilogrammi: "kilogram",
        Kit: "kit",
        Millilitri: "milliliter",
        Milligrammi: "milligram",
        Applicazioni: "application",
        UI: "IU"
      },
      forEveryUmsSing: {
        0: "month",
        1: "week",
        2: "day"
      },
      forEveryUmsPlur: {
        0: "months",
        1: "weeks",
        2: "days"
      },
      assunzioni: {
        mattina: "morning",
        meta_mattina: "mid-morning",
        pranzo: "lunch",
        pomeriggio: "afternoon",
        sera: "evening",
        notte: "night"
      }
    },
    NuovaTerapiaCittadino: {
      profiloSanitario: "Health profile",
      riepilogo: "Summary",
      scaricaPromemoria: "Download reminder",
      erroreDownloadPromemoria: "Unable to download the reminder"
    },
    NewTherapy: {
      titoloPatologia: "Condition for which the therapy was prescribed",
      indicaPatologia: "specify condition",
      nonIndicare: "do not specify",
      farmacoIndicato: "Prescribed medication",
      labelCercaFarmaco: "Search medication",
      placeholderCercaFarmaco: "Search by name or AIC...",
      labelSelezionaFarmaco: "Select medication*",
      prodottoNonTrovato: "Product not found",
      frequenzaModalitaDosaggio: "Frequency, method and dosage of administration",
      dosaggio: "Dosage*",
      frequenza: "Frequency*",
      alDi: "per day",
      alBisogno: "as needed",
      ore: "hours",
      daAssumere: "To be taken",
      mattina: "Morning",
      metaMattina: "Mid-morning",
      pranzo: "Lunch",
      pomeriggio: "Afternoon",
      sera: "Evening",
      notte: "Night",
      maxUnoAssunzione: "With this frequency you can select at most one intake time",
      inviaAlert: "Send alert 10 minutes before administration",
      durataTerapia: "Therapy duration",
      indeterminata: "undetermined",
      periodica: "periodic/cyclic",
      occasionale: "occasional",
      mesi: "months",
      settimane: "weeks",
      giorni: "days",
      ogni: "Every",
      aPartireDal: "Starting from*",
      finoAl: "Until*",
      dettagli: "Details",
      prescrittore: "Prescribing physician*",
      indicaPrescrittore: "specify who prescribed the therapy",
      fonte: "Information source*",
      indicaFonte: "specify the information source",
      effettiCollaterali: "Side effects",
      placeholderEffetti: "any side effects attributed to the medication...",
      reazioniAllergiche: "Allergic reactions",
      placeholderAllergie: "any allergic reactions attributed to the medication...",
      interazioni: "Interactions",
      placeholderInterazioni: "possible interactions with medications or foods...",
      annotazioni: "Notes",
      salva: "Save therapy",
      visibileSoloMe: "**if you select this option, only you will be able to view this therapy",
      posologyTypes: {
        Compresse: "Tablets",
        Capsule: "Capsules",
        Gocce: "Drops",
        Inalazioni: "Inhalations",
        Buste: "Sachets",
        Supposte: "Suppositories",
        Scatole: "Boxes",
        Cerotti: "Patches",
        Fiale: "Vials",
        Fleboclisi: "IV Infusion",
        Ovuli: "Ovules",
        Sacche: "Bags",
        Flaconi: "Bottles",
        Confezioni: "Packages",
        Kilogrammi: "Kilograms",
        Kit: "Kit",
        Millilitri: "Milliliters",
        Milligrammi: "Milligrams"
      },
      posologyVias: {
        Orale: "Oral",
        Transdermica: "Transdermal",
        Nasale: "Nasal",
        Endovena: "Intravenous",
        Intramuscolo: "Intramuscular",
        Oftalmica: "Ophthalmic",
        Rettale: "Rectal",
        Uretale: "Urethral",
        Vaginale: "Vaginal",
        Sottocute: "Subcutaneous"
      },
      everyUms: {
        0: "months",
        1: "weeks",
        2: "days"
      },
      everyPosologyTypes: {
        0: "day",
        1: "hours",
        2: "as needed"
      },
      everyPosologyUms: {
        1: "hours",
        2: "days"
      },
      successSalvataggio: "New therapy saved",
      erroreSalvataggio: "An error occurred while saving",
      erroreGenerico: "An error occurred."
    },
    AccessLogs: {
      titolo: "Recorded activity on your health profile",
      mese: "month",
      anno: "Year",
      nessunAccessoMese: "No activity for this month.",
      nessunAccessoAnno: "No activity in the selected year.",
      nessunaAzione: "No activity in the selected period",
      erroreNote: "Unable to retrieve notes",
      filtro_elementi: "Items per page",
      take_label: "Items per page",
      day_label: "Day",
      month_label: "Month",
      year_label: "Year",
      tutti_giorni: "All",
      opzione_elementi: "Show {count} items",
      azione_label: "Recorded activity",
      data_label: "Date and time",
      azienda_label: "Facility",
      operatore_sconosciuto: "Operator not available",
      company_missing: "Not available",
      azione_sconosciuta: "Activity not specified",
      mesi: {
        "01": "January",
        "02": "February",
        "03": "March",
        "04": "April",
        "05": "May",
        "06": "June",
        "07": "July",
        "08": "August",
        "09": "September",
        10: "October",
        11: "November",
        12: "December"
      }
    },
    nessunaImpostazione: "No settings for this user",
    UserModule: {
      password_reimpostata: "Password reset!",
      password_attuale_errata: "Incorrect current password. If you don't remember your password, use the recovery procedure."
    },
    AccessoEPermessi: {
      datiAccesso: "Access Data",
      modificaPasswordTemporanea: "Change your temporary password",
      passwordScaduta: "Your password has expired: please update it to continue.",
      username: "Username",
      password: "Password",
      cambiaPassword: "Change Password",
      terminiEPrivacy: "Terms and Conditions and Privacy Policy",
      visioneTermini: "You have reviewed the",
      revocaTermini: "You have withdrawn your consent to the",
      titoloTermini: "Terms and Conditions of Service",
      modifica: "Edit",
      visionePrivacy: "You have reviewed the",
      revocaPrivacy: "You have withdrawn your consent to the",
      titoloPrivacy: "Privacy Policy",
      visionati1341: "You have expressly reviewed, pursuant to Article 1341 et seq. of the Civil Code, the provisions of Articles 2, 7, 8, 10, 12 of these Terms",
      revocati1341: "You have withdrawn consent to Articles 2, 7, 8, 10, 12 of these Terms",
      acconsentoComunicazioni: "You have consented to receive promotional communications as described in the",
      nonAcconsentoComunicazioni: "You have not consented to receive promotional communications as described in the",
      titleConsensoComunicazioni: "Consent to marketing communications",
      acconsento: "I consent to receiving promotional communications as described in the Privacy Policy",
      nonAccetto: "I do not accept",
      annulla: "Cancel",
      salva: "Save changes",
      titleModificaPassword: "Change your password",
      passwordAttuale: "Current Password*",
      placeholderAttuale: "Current password...",
      nuovaPassword: "Password*",
      confermaPassword: "Confirm Password*",
      placeholderConferma: "Confirm password...",
      requisitiPassword: "The password must not include your first or last name and must be at least 8 characters long, including one number, one uppercase letter, one lowercase letter, and one special character. It must be different from the current one and from the last {count} used.",
      tooltipCaratteri: "You must use at least one special character from ! @ # $ % ^ & * ) ( + = . _ -",
      carattereSpeciale: "special character",
      passwordDiversa: "The new password must be different from the current one.",
      passwordGiaUtilizzata: "The new password must be different from the current one and from the last {count} used.",
      annullaOperazione: "Cancel Operation",
      confermaModifica: "Confirm Change",
      siRevoca: "Yes, revoke permission",
      noAnnulla: "No, cancel",
      revocaNecessaria: "Consent is required to use the platform. By withdrawing your consent, you will no longer be able to use the platform's features.",
      desideriRevoca: "Do you wish to proceed with revoking your consent?",
      revoca: {
        data_consense: "Do you want to withdraw consent to the Terms and Conditions of use?",
        share_consense: "Do you want to withdraw consent to articles 2, 7, 8, 10, 12 of the Terms and Conditions of use?",
        charge_consense: "Do you want to withdraw consent to the Privacy Policy?"
      },
      successModifica: "Changes saved successfully",
      erroreModifica: "It was not possible to save the changes",
      modificaPasswordTemp: "You still need to change your temporary password",
      passwordScadutaCambio: "Your password has expired and must be changed"
    },
    ShowUserCode: {
      codice_utente: "User code",
      descrizione_codice: "Your user code allows you to be securely identified by other users on the platform.",
      mostra: "Show",
      nascondi: "Hide",
      codice: "code",
      etichetta_codice: "Your user code:",
      istruzioni_caregiver: "Show this code to your caregiver so they can find you and add you to their list of assisted users.",
      nota_validita: "Note: this code will be <u>valid until midnight today</u>.",
      errore_codice: "Unable to retrieve the code",
      codice_copiato: "Code copied!",
      copia_codice: "Copy code",
      button_label: "user"
    },
    NotificationChannels: {
      accessi_notifiche: "Access and Notifications",
      descrizione_accessi: "View and manage your access, and choose which notifications to receive through Concura channels.",
      notifiche_email1: "Email Notifications",
      email_question: "Do you want to {azione} email notifications?",
      consenso_email: "You have consented to receive email notifications as stated in the",
      no_consenso_email: "You have not consented to receive email notifications as stated in the",
      informativa_privacy: "Privacy Policy",
      modifica: "Edit",
      ricezione_notifiche: "Notification reception",
      consent_push: "Consent to receive push notifications to get alerts in app",
      canale_telegram: "Telegram Channel",
      ricezione_stato: "Notification reception",
      attiva: "enabled",
      disattivata: "disabled",
      rimuovi_accesso: "Remove this access",
      nessun_accesso: "No active Telegram access",
      accedi_telegram: "Log in on Telegram!",
      elimina_accesso: "Delete access",
      annulla: "No, Cancel",
      conferma: "Yes, Confirm",
      vuoi_rimuovere: "Do you want to remove access via",
      accesso_da: "from",
      modifica_stato: "Edit notification reception status",
      vuoi: "Do you want to",
      attivare: "enable",
      disattivare: "disable",
      notifiche_messenger: "notification reception via",
      notifiche_email: "Email notifications",
      da: "from",
      conferma_operazione: "Confirm operation",
      consenso_email_title: "Email reception consent",
      acconsento_email: "I consent to receiving email notifications as stated in the",
      non_accetto: "I do not accept",
      salva_modifiche: "Save changes",
      errore_accessi: "Failed to retrieve accesses",
      accesso_eliminato: "Access successfully removed",
      errore_eliminazione: "Failed to remove access",
      modifiche_successo: "Changes saved successfully",
      errore_modifiche: "Unable to save changes",
      notifiche_push: "Push Notification"
    },
    PermessiSchedaPaziente: {
      titolo: "Patient Card View",
      descrizione: "Choose which sections of the patient card you want to view. Unselected sections will not be visible in the patient's health profile.",
      archivio_sanitario: "Health Archive",
      patologie: "Pathologies",
      terapie: "Therapies",
      anamnesi: "Medical History",
      note: "Notes",
      notifiche: "Patient Notifications",
      alert: "Patient Alerts",
      dispositivi: "Devices",
      prenotazioni: "Appointments",
      piani_terapeutici: "Treatment Plans",
      referti: "Reports",
      non_disponibile: "Not available",
      nessun_permesso: "No view permissions available for your role.",
      salva: "Save preferences",
      salvataggio_ok: "Preferences saved successfully.",
      salvataggio_errore: "Error saving preferences.",
      pss: "Patient Health Summary",
    },
    StatoSottoscrizioniProfilo: {
      stato_profilo: "Profile Status",
      sottoscrizione_attesa: "Subscription pending payment:",
      mesi: "months",
      acquista: "Purchase",
      sottoscrizione_attiva: "Active subscription:",
      nessuna_sottoscrizione: "No active subscription.",
      vai_acquisti: "Go to Purchases",
      conferma_operazione: "Confirm operation",
      annulla: "No, Cancel",
      conferma: "Yes, Confirm",
      sei_sicuro_attivare: "Are you sure you want to activate the monitoring service for",
      testo_attivazione: `
		This operation will start the subscription activation process for the
		monitoring service: the patient will be assigned to a Service Center
		operator who will guide them through the service purchase procedure. <br />
		Also, if not yet configured, after confirming the operation you can
		select a suitable care path among the available options; otherwise, the
		"standard" monitoring of key parameters will be activated.<br />
		For the monitoring of key parameters, default threshold values and
		detection frequencies will be set.
	`,
      profilo_sospeso: "Profile successfully suspended.",
      errore_operazione: "The operation could not be completed.",
      attivazione_successo: "Activation successfully completed!"
    },
    QrSubscriptionCard: {
      titolo: "Your Digital Card",
      membro_premium: "Premium Member",
      valido_fino: "Valid until",
      si_rinnova_il: "Renews on",
      scansiona_qr: "Scan the QR code to verify validity",
      abbonamento_attivo: "Active Subscription",
      in_attivazione: "Activating",
      in_attesa_pagamento: "Awaiting payment",
      footer_info: "Verifiable digital card",
      aria_card: "Digital subscription card",
      scarica_pdf: "Download PDF",
      invia_email: "Send email",
      invia_email_paziente: "Send to patient",
      email_inviata_te: "Email sent to your inbox",
      email_inviata_paziente: "Email sent to patient",
      errore_invio_email: "Error sending email",
      throttle_email: "Please wait {seconds} seconds before sending another email"
    },
    SubscriptionVerify: {
      caricamento: "Verifying...",
      valido_titolo: "Valid Subscription",
      valido_sottotitolo: "This subscription is active and verified",
      pending_titolo: "Subscription Activating",
      pending_sottotitolo: "This subscription is awaiting payment",
      scaduto_titolo: "Expired Subscription",
      scaduto_sottotitolo: "This subscription is no longer active",
      non_trovato_titolo: "Subscription Not Found",
      non_trovato_sottotitolo: "The QR code does not match any valid subscription",
      intestatario: "Subscriber",
      piano: "Plan",
      valido_fino: "Valid until",
      si_rinnova_il: "Renews on",
      scaduto_il: "Expired on",
      verificato: "Verified",
      in_attivazione: "Activating",
      footer_info: "Official verification page",
      aria_valido: "Valid and verified subscription",
      aria_pending: "Subscription awaiting activation",
      aria_scaduto: "Expired subscription",
      aria_non_trovato: "Subscription not found"
    },
    PercorsoCuraPaziente: {
      percorso_di_cura: "Care plan",
      modifica_percorso: "Edit plan",
      nessun_percorso: "No care plan selected",
      seleziona_percorso: "Select plan",
      label_percorso: "Care plan*",
      scegli: "choose",
      dettagli_per: "Plan details for",
      piano_include: "The plan includes:",
      teleconsulti: "Scheduled teleconsultations",
      programmati_ogni: "scheduled every",
      questionari: "Questionnaires and evaluations",
      ogni: "every",
      monitoraggio_parametri: "Monitoring of parameters",
      dispositivi_indossabili: "Recommended wearable devices",
      annulla: "Cancel",
      modifica_percorso_di_cura: "Edit care plan",
      seleziona_percorso_di_cura: "Select care plan",
      modal_descrizione_modifica: "Edit the patient's care plan.",
      modal_descrizione_selezione: "Select the appropriate care plan based on the patient's needs.",
      conferma_modifica: "Confirm Edit",
      conferma_selezione: "Confirm Selection",
      percorso_aggiornato: "Care plan successfully updated",
      errore_lista_piani: "Unable to retrieve the list of available plans.",
      errore_operazione: "The operation could not be completed.",
      ogni_giorno: "every day"
    },
    EliminaProfilo: {
      titolo: "Delete Profile",
      sottotitolo: "Permanently delete your account",
      bottone_elimina: "Delete my profile",
      domanda_conferma: "Are you sure you want to delete your profile?",
      testo_conferma: `
				If you delete your profile, you will no longer be able to access the
				platform or use the available services. <br />
				This action is irreversible. Once confirmed, the deletion cannot be undone.
				`,
      title_conferma: "Confirm Operation",
      ok_elimina: "Yes, delete",
      annulla: "No, cancel"
    },
    AnagraficaComponent: {
      profilo: "Profile",
      modifica: "Edit",
      scegli_immagine: "Choose image",
      elimina: "Delete",
      carica_immagine: "Upload Image",
      titolo: "Title",
      titolo_placeholder: "Mr...",
      nome: "First name*",
      nome_placeholder: "First name...",
      cognome: "Last name*",
      cognome_placeholder: "Last name...",
      data_nascita: "Date of birth*",
      genere: "Gender",
      uomo: "male",
      donna: "female",
      codice_fiscale: "Tax code*",
      codice_fiscale_placeholder: "Tax code...",
      tessera_sanitaria: "Health Insurance Card Number",
      tessera_sanitaria_placeholder: "Card number...",
      nazione_nascita: "Country of birth*",
      medico_base: "Primary care doctor",
      medico_base_placeholder: "Primary care doctor...",
      asl: "Local Health Authority",
      scegli_asl: "Select local health authority",
      asl_placeholder: "Local health authority...",
      id_albo: "Medical Registry ID",
      id_albo_doppio: "Medical Registry ID**",
      id_albo_placeholder: "Registry ID...",
      albo_number: "Registry number",
      albo_number_placeholder: "e.g. 12345",
      albo_province: "Province",
      seleziona_provincia_albo: "Select Province",
      seleziona_tipo_albo: "Select order",
      albo_incompleto: "If you enter a registration number, select the province too",
      specializzazione: "Specialization",
      specializzazione_placeholder: "Medical specialization...",
      annulla: "Cancel",
      salva: "Save",
      residenza: "Residence",
      regione: "Region*",
      regione_placeholder: "Region...",
      seleziona_regione: "Select Region",
      provincia: "Province*",
      provincia_placeholder: "Province...",
      seleziona_provincia: "Select Province",
      comune: "Municipality*",
      comune_placeholder: "Municipality...",
      seleziona_comune: "Select Municipality",
      indirizzo: "Address and street number*",
      indirizzo_placeholder: "Address...",
      cap: "ZIP code*",
      cap_placeholder: "ZIP code...",
      contatti: "Contacts",
      telefono: "Phone number",
      telefono_placeholder: "Phone...",
      telefono_domicilio: "Home phone",
      telefono_domicilio_placeholder: "Home phone...",
      telefono_riserva: "Backup phone",
      telefono_riserva_placeholder: "Backup phone...",
      torna_verifica: "return to verification",
      conferma_eliminazione: "Confirm deletion",
      conferma: "Yes, Confirm",
      domanda_eliminazione_immagine: "Do you confirm the deletion of the profile image?",
      immagine_eliminata_successo: "Profile image successfully deleted",
      errore_eliminazione: "Error deleting the note",
      immagine_caricata_successo: "Profile image uploaded successfully",
      errore_caricamento: "Error uploading the profile image",
      telefono_non_valido: "Invalid phone number",
      includere_sigla: "**Include province abbreviation",
      title_sig: "Mr.",
      title_sigra: "Ms.",
      title_dott: "Dr.",
      title_dottssa: "Dr. (female)",
      tipo_medici: "Doctors",
      tipo_dentisti: "Dentists",
      tipo_farmacisti: "Pharmacists",
      tipo_infermieri: "Nurses",
      tipo_biologi: "Biologists"
    },
    BancaDati: {
      modifica_libreria: "Edit library",
      imposta_preferito: "Set as favorite",
      elimina_libreria: "Delete library"
    },
    SessionLengthSetter: {
      timeout_sessione: "Session Timeout",
      descrizione: "Set when the session should expire. Once expired, you will be automatically logged out.",
      sessione_logout: "The session ends with logout",
      sessione_scade: "The session expires after",
      minuti_inattivita: "minutes of inactivity",
      annulla: "Cancel",
      salva_modifiche: "Save Changes",
      successo: "Session timeout successfully updated",
      errore: "Error updating session timeout",
      modifica_timeout: "Edit session timeout"
    },
    StoricoAppuntamentiAsl: {
      apri_chat: "Open chat messages"
    },
    CompilatoreQuestionarioInBlocks: {
      naviga_blocchi: "Navigation between questionnaire blocks",
      vai_al_blocco: "Go to block {blocco}",
      scorri_sinistra: "Scroll blocks left",
      scorri_destra: "Scroll blocks right"
    },
    CompilaQuestionarioCittadino: {
      questionario_prenotazione: "Questionnaire for the appointment scheduled on",
      ore: "at",
      consenso: "I have read the privacy policy and I give my consent",
      procedi: "Proceed",
      operazione_completata: "Operation completed.",
      vai_agenda: "Go to calendar",
      vai_profilo_sanitario: "Go to health profile",
      questionario_gia_compilato: "You have already filled out the questionnaire.",
      errore_attivita: "Failed to retrieve activities",
      questionario_inviato: "Questionnaire successfully submitted.",
      errore_invio: "Failed to submit the questionnaire",
      questionario_non_disponibile: "This questionnaire is no longer available, has expired, or has already been completed."
    },
    FillScoreSurveyCittadino: {
      consenso: "I have read the information and I give my consent",
      procedi: "Proceed",
      operazione_completata: "Operation completed.",
      vai_agenda: "Go to agenda",
      vai_profilo_sanitario: "Go to health profile",
      questionario_gia_compilato: "You have already completed the questionnaire.",
      errore_attivita: "Unable to retrieve activities",
      questionario_inviato: "Questionnaire successfully submitted.",
      errore_invio: "Unable to submit the questionnaire"
    },
    NuovaTerapiaAssistito: {
      pazienti: "Patients",
      nessun_paziente: "No patient selected",
      profilo_sanitario: "Health profile",
      riepilogo: "Summary",
      scarica_promemoria: "Download reminder",
      torna_profilo: "Back to health profile",
      errore_scaricamento: "Failed to download the reminder"
    },
    PianoTerapeuticoCittadino: {
      indietro: "Back",
      piano_terapeutico: "Therapeutic plan",
      caricato_in_data: "Uploaded on:",
      validita: "Validity:",
      stato: "Status:",
      farmacia: "Pharmacy",
      telefono: "Phone",
      indirizzo: "Address",
      mostra_piano: "Show Therapeutic Plan",
      nascondi_piano: "Hide Therapeutic Plan",
      caricamento: "Loading...",
      farmaci_previsti: "Medications included in the Therapeutic Plan",
      consegnato: "Delivered",
      quantita: "Quantity:",
      pacchetti_programmati: "Scheduled delivery packages for the Therapeutic Plan",
      pacchetto: "Package",
      stato_pacchetto: "Package status:",
      farmaci_contenuti: "Medications contained in the package",
      conf: "pack",
      scadenza: "exp.",
      lotto: "batch",
      piano_non_trovato: "Plan not found",
      errore_info: "Unable to retrieve the requested information",
      scegli: "choose...",
      attesa_autorizzazione: "Awaiting authorization",
      classe_c: "class C",
      no_ssn: "Not covered by NHS",
      autorizzato_classe_a: "authorized class A",
      rimborsabile: "Authorized as reimbursable",
      autorizzato_dpc: "authorized DPC",
      per_conto: "Authorized for third-party dispensing",
      autorizzato_dd: "authorized DD",
      distribuzione_diretta: "Authorized for direct distribution",
      etichetta: "Label",
      toggle_dettagli: "Show/hide plan details"
    },
    PianoTerapeuticoDetailOperatoreAsl: {
      toggle_dettagli: "Show/hide plan details",
      toggle_info: "Show/hide info",
      modifica_validita: "Edit validity dates"
    },
    FamiliariView: {
      genere: "Gender",
      data_nascita: "Date of birth",
      non_indicata: "Not specified",
      vai_profilo_sanitario: "Go to health profile",
      disabilita: "Disable",
      abilita: "Enable",
      abilitata: "Enabled",
      vuoi_abilitare: "Do you want to enable this caregiver?",
      vuoi_disabilitare: "Do you want to disable this caregiver?",
      abilita_caregiver: "Enable caregiver",
      disabilita_caregiver: "Disable caregiver",
      errore_recupero_informazioni: "Error retrieving information",
      caregiver_abilitato: "Caregiver successfully enabled",
      errore_operazione: "Operation failed",
      caregiver_disabilitato: "Caregiver successfully disabled"
    },
    Routes: {
      cittadino_home: "Citizen Home",
      familiari: "Your family members",
      appuntamenti: {
        prestazione: "Visits and Services",
        prodotto: "Medications",
        teleconsulto: "Teleconsultations"
      },
      agenda: "Your schedule",
      il_tuo_consulto: "Your consultation",
      circolo_di_cura: "Your care circle",
      sottoscrizioni_paziente: "Purchases and Subscriptions",
      progetti_cittadino: "Blog",
      profilo_sanitario: "Health profile",
      profilo_cittadino: "Personal data",
      impostazioni: "Settings",
      guida_cittadino: "Guide",
      completa_questionario: "Complete the questionnaire",
      score_questionario: "Complete the questionnaire",
      nuova_terapia_assistito: "New therapy",
      acquisto: "Purchase",
      pagina_non_trovata: "Page not found",
      verifica_numero: "Verify your number",
      verifica_email: "Verify your email",
      teleconsulti: {
        tcemergenza: "Quick Teleconsultation",
        pediatrico: "Pediatric Teleconsultation",
        specialistico: "Specialist Teleconsultation",
        teleconsulto: "Teleconsultations"
      }
    },
    // Page titles of the admin area, shown in the header (AdminTopHeader)
    AdminRoutes: {
      dashboard: "Administration dashboard",
      servizi: "Services management",
      servizio_teleconsulto: "Teleconsultation service",
      servizio_prenotazioni: "Booking service",
      aziende: "Companies management",
      aziende_portale: "Portal companies",
      aziende_pubbliche: "Public website companies",
      nuova_azienda: "New company",
      dettaglio_azienda: "Company record",
      utenti: "Users management",
      contatti: "Public contacts",
      registrazioni: "Registrations",
      prenotazioni: "Bookings management",
      sottoscrizioni: "Subscriptions",
      voucher: "Subscription vouchers",
      pagamenti: "Platform payments",
      screening: "Screening",
      raccolte: "Collections",
      questionari: "Questionnaires",
      sessioni: "Sessions",
      piani_terapeutici: "Therapeutic plans",
      piano_terapeutico: "Therapeutic plan",
      alerts: "System alerts",
      logs: "System logs",
      reports: "Reports",
      impostazioni: "System settings",
    },
    ChatPazientiWhitelist: {
      titolo: "Doctor-patient chat - whitelist management",
      sottotitolo: "Enabling and monitoring of asynchronous messaging channels between patients and healthcare professionals.",
      nuovo_canale: "Enable new channel",
      filtra_stato: "Filter by status",
      aggiorna: "Refresh list",
      nessun_canale: "No chat channel matches the selected filters.",
      caricamento: "Loading channels",
      stato_tutti: "All statuses",
      stato_solo_attivi: "Active channels only",
      stato_solo_revocati: "Revoked channels only",
      col_paziente: "Patient",
      col_operatore: "Doctor or operator",
      col_stato: "Status",
      col_data: "Enabled on",
      col_azioni: "Actions",
      stato_attivo: "Active",
      stato_revocato: "Revoked",
      azione_visualizza: "View the clinical chat with the patient",
      azione_archivia: "Archive the transcript in the health profile",
      azione_revoca: "Revoke the channel",
      azione_riattiva: "Re-enable the channel",
      conferma_revoca_titolo: "Channel revocation",
      conferma_revoca_ok: "Revoke",
      conferma_revoca_testo: "The chat with {paziente} will be revoked: no new messages can be sent. The history remains available.",
      paziente: "Patient",
      revoca_riuscita: "Channel revoked",
      revoca_fallita: "The channel could not be revoked",
      caricamento_fallito: "The organisation channels could not be loaded",
      riattivazione_riuscita: "Channel re-enabled",
      riattivazione_fallita: "The channel could not be re-enabled",
      archiviazione_riuscita: "Transcript archived in the patient health record",
      archiviazione_titolo: "Archiving completed",
      archiviazione_fallita: "The transcript could not be archived",
      errore: "Error",
    },
    ModalChatPaziente: {
      paziente: "Patient",
      titolo_operatore_proprie: "My conversations",
      titolo_cittadino: "Clinical chat with your doctors",
      titolo_con_paziente: "Clinical chat with {nome}",
    },
    ModalNuovoCanale: {
      titolo: "Enable the chat with the patient",
      conferma: "Enable the chat",
      label_operatore: "Healthcare professional (doctor or nurse)",
      descrizione_operatore: "The professional enabled for this service",
      descrizione_operatore_tu: "The chat opens in your name. Opening it in a colleague's name requires someone who manages the facility's chats.",
      scegli_operatore: "Select a professional",
      label_paziente: "Patient",
      descrizione_paziente: "Search by surname, name or tax code",
      paziente_dalla_scheda: "Open the patient's record and press the chat button: the patient is already selected there.",
      placeholder_ricerca: "Search patient",
      cerca: "Search",
      scegli_paziente: "Select the patient found",
      caricamento: "Loading",
      nota: "Enabling the channel allows asynchronous exchange of protected messages and documents between the patient and the designated doctor.",
      errore_operatori: "The list of doctors did not load. Close the window and try again.",
      canale_creato: "Chat channel enabled",
      titolo_successo: "Operation completed",
      errore_creazione: "The chat channel could not be enabled",
      titolo_errore: "Error",
    },
    PatientChatSection: {
      titolo_cittadino: "Chat with your doctors",
      titolo_operatore: "Messaging and clinical chat",
      sottotitolo_cittadino: "Direct and secure communication with the enabled healthcare professionals.",
      sottotitolo_operatore: "History and management of direct conversations with the patient.",
      abilita_medico: "Enable new doctor",
      caricamento: "Loading chat",
      nessun_canale: "No chat channel enabled",
      nessun_canale_operatore: "Enable the chat to exchange messages and documents with this patient.",
      nessun_canale_operatore_proprie: "A conversation starts from the patient's record, with the chat button.",
      nessun_canale_cittadino: "No doctor has enabled a messaging channel for your profile yet.",
      abilita_ora: "Enable chat",
      elenco_cittadino: "Your doctors",
      elenco_operatore: "Chat channels",
      revocato: "Revoked",
      archivia: "Archive in profile",
      archivia_tooltip: "Generate the PDF transcript and archive it in the health record",
      nessun_messaggio: "No message in this conversation.",
      inizia_a_scrivere: "The discussion starts with the first message.",
      allegato: "Attachment",
      file: "file",
      dimensione_file: "({kb} KB, maximum 4 MB)",
      rimuovi_allegato: "Remove attachment",
      allega_tooltip: "Attach a document or an image, maximum 4 MB",
      placeholder_cittadino: "Write a message to the doctor",
      placeholder_operatore: "Write a clinical message to the patient",
      invia: "Send",
      allegati_consentiti: "Allowed attachments: PDF, images and reports, up to 4 MB",
      canale_revocato: "Channel revoked.",
      seleziona_canale: "Select a channel to open the conversation.",
      file_troppo_grande: "The selected file exceeds the maximum size of 4 MB.",
      file_troppo_grande_titolo: "File too large",
      invio_fallito: "The message could not be sent",
      archiviazione_riuscita: "Chat transcript archived in the health record",
      archiviazione_titolo: "Archiving completed",
      archiviazione_fallita: "The transcript could not be archived",
      errore: "Error",
      titolo_medico: "Dr. {nome}",
      operatore: "Operator",
      paziente: "Patient",
      download_fallito: "The attachment could not be downloaded",
      download_fallito_titolo: "Download error",
    },
    NavigationCittadino: {
      chat_medico: "Chat with your doctor",
      logo_alt: "Application logo - Go to home",
      toggle_menu: "Open or close navigation menu",
      logout_confirm_title: "Do you confirm you want to leave the private area?",
      logout_confirm_ok: "Yes, exit",
      prenotazioni: "Bookings",
      visite: "Visits and Services",
      farmaci: "Medications",
      teleconsulti: "Teleconsultations",
      rapido: "Quick",
      pediatrico: "Pediatric",
      specialistico: "Specialist",
      familiari: "Family Members",
      tutti: "All",
      nuovo: "New",
      blog: "Blog",
      profilo_sanitario: "Health Profile",
      circolo: "Care Circle",
      gestione: "Management",
      strumenti: "Tools",
      report: "Reports",
      acquisti: "Purchases",
      sottoscrizioni: "Subscriptions",
      storico: "History",
      agenda: "Schedule",
      pazienti: "Patients",
      impostazioni: "Settings",
      consulta: "View",
      guida: "Help",
      accessibility: "Accessibility",
      servizi: "SERVICES",
      pagine: "PAGES"
    },
    NotificationCenter: {
      title: "Notifications",
      browserPermission: "To receive notifications you must authorize their reception on your browser.",
      noNotifications: "No new notifications.",
      open_panel: "Open notifications panel",
      close_panel: "Close notifications panel"
    },
    PopupNotificationComponent: {
      action_aria: "Run notification action: {action}",
      fetch_error: "Unable to check for new popup notifications",
      seen_error: "Unable to update popup notification status"
    },
    CallSupportModal: {
      chiama: "Call the toll-free number",
      chiama_per_prenotare: "To book, call the toll-free number",
      operatori: "Our operators are available Monday to Friday from 9:00 AM to 6:00 PM",
      modal_label: "Phone support window"
    },
    CallMailSupportButtons: {
      call_support: "Call support at toll-free number 800770272",
      email_support: "Send email to support"
    },
    PopupModal: {
      procedi: "Proceed",
      errore_invito: "It was not possible to invite the doctor",
      success_grazie: "Thank you for your response",
      errore_risposta: "It was not possible to submit the response"
    },
    LoginPage: {
      call_support: "Call support",
      show_password: "Show password",
      hide_password: "Hide password",
      enter_with_spid: "Enter with SPID",
      enter_with_cie: "Enter with CIE"
    },
    RegisterPage: {
      call_support: "Call support",
      codice_fiscale_facoltativo: "Operator Tax Code",
      placeholder_cf: "Tax code",
      cf_formato_non_valido: "Invalid format (16 characters: letters and numbers)",
      cf_check_error: "Error while checking the tax code",
      hide_password: "Hide password",
      show_password: "Show password",
      albo_incompleto: "If you enter a registration number, select the province too"
    },
    NotFoundPage: {
      title: "Page not found",
      image_alt: "Page not found illustration"
    },
    EmailVerification: {
      logo_alt: "Application logo"
    },
    Help: {
      logo_alt: "Application logo"
    },
    NumberVerification: {
      logo_alt: "Application logo"
    },
    PasswordRecovery: {
      logo_alt: "Application logo"
    },
    PaymentOutcome: {
      logo_alt: "Application logo"
    },
    RecoverPassword: {
      logo_alt: "Application logo",
      show_password: "Show password",
      hide_password: "Hide password"
    },
    AccessoCie: {
      logo_alt: "Registration logo"
    },
    AccessoSpid: {
      logo_alt: "Registration logo"
    },
    CompanyCard: {
      select_company: "Select {name}",
      toggle_info: "Show or hide company details",
      add_favorite: "Add to favorites",
      remove_favorite: "Remove from favorites"
    },
    ThresholdEditor: {
      modifica_soglia: "Edit threshold",
      valore_min: "Minimum value",
      valore_max: "Maximum value",
      modifica: "Edit",
      aggiungi: "Add"
    },
    SomministraCustomTeleconsultoSurvey: {
      compila_questionario: "Fill out the questionnaire for the Teleconsultation",
      compilazione_obbligatoria: "(completion is mandatory)",
      consenso_informativa: "I have read the privacy notice and give my consent",
      procedi: "Proceed",
      questionario_gia_compilato: "You have already completed the questionnaire.",
      vai_agenda: "Go to schedule",
      errore_recupero_attivita: "Unable to retrieve activities",
      successo_questionario: "Questionnaire submitted successfully.",
      errore_questionario: "Unable to submit the questionnaire"
    },
    FillCustomTeleconsultoSurvey: {
      ok_procedi: "Ok, Proceed",
      placeholder_scrivi: "Write here",
      torna_indietro: "Go back",
      procedi: "Proceed",
      salta: "Skip",
      salva_immagine: "Save Image"
    },
    AslSurveyUploader: {
      remove: "Remove"
    },
    ConsenseComponent: {
      logo_alt: "Application logo"
    },
    CompanyArchiveMain: {
      modifica_stato: "Change resource status",
      elimina_risorsa: "Delete resource",
      carica_nuovo_file: "Upload new file",
      conferma_modifica: "Confirm change",
      elimina_file: "Delete file"
    },
    CentriErogatoriCard: {
      mostra_info: "Show facility information"
    },
    ServiceStatusCentriErogatori: {
      conferma_operazione: "Confirm operation"
    },
    ServiceStatus: {
      conferma_operazione: "Confirm operation"
    },
    PrestazioniSanitariePerCentroErogatore: {
      modifica_prestazione: "Edit {name}"
    },
    DettaglioCentroErogatore: {
      toggle_menu: "Expand or collapse services menu"
    },
    PromemoriaHomeV2: {
      apri_dettaglio: "Open {titolo} details",
      apri_questionario: "Open questionnaire {titolo}",
      da_compilare: "To fill in",
      scade_il: "Expires on",
      previsto_il: "Scheduled for",
      piano_di_cura: "Care plan {nome}",
      prenotazione: "Reservation",
      richiesta_operatore: "Operator request"
    },
    ProjectBannerCard: {
      aria_region: "Initiative section"
    },
    ProjectHomeBanner: {
      invio_riuscito: "Done"
    },
    ProjectFormModal: {
      invia: "Send",
      campo_obbligatorio: "Please fill in the required fields"
    },
    PromemoriaQuestionariPaziente: {
      title: "What the patient needs to do",
      da_compilare: "To fill in",
      sessione_da_compilare: "Session to fill in",
      programmato: "Scheduled",
      previsto_il: "Scheduled for",
      scade_il: "Expires on",
      somministra_aria: "Administer the {titolo} questionnaire to the patient",
      somministra_sessione_aria: "Administer the {titolo} session to the patient",
      promemoria_readonly_aria: "Reminder: {titolo}",
      programmato_aria: "{titolo} questionnaire scheduled",
      stop_frequenza: "Stop frequency",
      stop_frequenza_aria: "Stop the frequency for {titolo}",
      stop_frequenza_title: "Stop frequency",
      stop_frequenza_confirm: "Stop",
      stop_frequenza_testo_corrente: "Do you want to stop the frequency for {titolo} from this reminder onward?",
      stop_frequenza_dettaglio_corrente: "This reminder and later existing reminders will be cancelled. No new reminders will be created for this frequency.",
      stop_frequenza_testo_futura: "Do you want to stop the frequency for {titolo}?",
      stop_frequenza_dettaglio_futura: "Existing reminders will stay available. No new reminders will be created for this frequency.",
      stop_frequenza_success: "Frequency stopped successfully",
      stop_frequenza_error: "Unable to stop the frequency",
      notifiche_programmate: "Scheduled notifications",
      notifica_canali: "Channels:",
      notifica_stato: "Status:",
      notifica_aria: "Notification scheduled for {data}. Channels: {canali}. Status: {stati}",
      altre_notifiche_aria: "{count} more notifications: {dettagli}",
      canale_push: "push",
      canale_mail: "email",
      canale_sms: "SMS",
      canale_altro: "{channel}",
      canale_non_disponibile: "not available",
      stato_pending: "pending",
      stato_planned: "scheduled",
      stato_sent: "sent",
      stato_skipped: "skipped",
      stato_failed: "failed",
      stato_cancelled: "cancelled",
      stato_altro: "{status}",
      stato_non_disponibile: "not available"
    },
    PrestazioniSanitarie: {
      modifica_prestazione: "Edit {name}",
      elimina_prestazione: "Delete {name}"
    },
    ServiziCompany: {
      toggle_menu: "Expand or collapse services menu",
      configura: "Configure",
      configura_servizio: "Configure service {name}",
      titolo_configurazione_generico: "Service configuration",
      titolo_configurazione_servizio: "Service configuration {name}",
      nessun_contenuto_configurazione:
        "No configuration content available for this service"
    },
    AllegatiPrestazioni: {
      rimuovi: "remove",
      rimuovi_allegato: "Remove attachment {name}"
    },
    DayPlanner: {
      mese_precedente: "Go to previous month",
      mese_successivo: "Go to next month",
      legenda_libero: "Available",
      legenda_configurato: "Service active",
      legenda_da_aggiungere: "To be added",
      legenda_da_rimuovere: "To be removed",
      legenda_chiuso: "Closed or holiday",
      data_passata: "Past date",
      configurato_passato: "Service active, past date",
      da_rimuovere: "To be removed",
      giorni_configurati: "Active days in the month",
      nessun_giorno_configurato: "No active days this month.",
      rimuovi_giorno: "Remove {giorno}",
      annulla_rimozione: "Keep {giorno}",
      prenotabile_dal_al: "Bookable from {dal} to {al}",
      prenotabile_dal: "Bookable from {dal} until the same day",
      prenotabile_fino_al: "Bookable right away until {al}",
      prenotabile_sempre: "Bookable right away until the same day"
    },
    SettingOrari: {
      rimuovi_giorno: "Remove {giorno} schedule",
      modifica_orari: "Edit {giorno} schedule",
      duplica_giorno: "Duplicate {giorno} schedule",
      nuova_fascia_oraria: "New time slot"
    },
    SettingServiceOrari: {
      rimuovi_giorno: "Remove {giorno} schedule",
      modifica_orari: "Edit {giorno} schedule",
      duplica_giorno: "Duplicate {giorno} schedule",
      nuova_fascia_oraria: "New time slot",
      limite_minimo: "Enter an integer greater than or equal to 1"
    },
    FreeSubscription: {
      descrizione: "Free subscription",
      dettaglio: '<p class="m-0">Fast booking for visits and services: €10 </p><p class="m-0">Teleconsultation or telemedicine service: €10</p><p class="m-0">Prescription booking: €4</p>'
    },
    app: {
      partita_iva: "VAT Number:",
      termini_condizioni: "Terms and Conditions",
      informativa_privacy: "Privacy Policy",
      note_rilascio: "Release notes",
      note_rilascio_modal_label: "Application release notes window",
      cookie_policy: "Cookie Policy",
      about: "About",
      about_label: "Open application information window",
      about_modal_label: "Application information",
      about_image_alt: "Logo and application version information",
      vai_alla_guida: "Go to help page"
    },
    DownloadSurveyInfo: {
      stampa_informativa: "Print information"
    },
    UpdateNotesComponent: {
      title: "Update your booking notes",
      description: "In this space you can add relevant information or messages for this specific booking.",
      newNote: "New note:",
      cancel: "Cancel",
      save: "Save",
      updateError: "It was not possible to update the notes",
      aria_edit: "Edit notes"
    },
    UnreadChatBadge: {
      unread_messages: "{count} unread messages"
    },
    nexi: {
      esito: {
        OK: "Transaction completed successfully",
        KO: "Transaction failed",
        ANNULLO: "Transaction canceled",
        ERRORE: "Transaction error",
        PEN: "Transaction pending"
      },
      messaggi: {
        "Message OK": "Transaction authorized.",
        "Controllo CF": "Card PAN already associated with another tax code.",
        "Controllo PAN": "This tax code is already associated with the maximum number of cards.",
        "Controllo BLACKLIST": "Transaction blocked due to blacklist rules.",
        "Controllo CF/PAN": "Mismatch between PAN and tax code.",
        "Auth. Denied": "Transaction not authorized.",
        "Impossibile eseguire la Post di Notifica": "Transaction canceled due to server-to-server notification failure.",
        "3D Secure annullato da utente": "3D Secure authentication not completed or canceled by user.",
        "Carta non autorizzata causa applicazione regole BIN table": "Card denied by BIN table rules.",
        "Problema 3DSecure": "3D Secure issue during authentication.",
        "expired card": "Expired card or merchant not enabled.",
        "Invalid merchant": "Invalid or revoked merchant code.",
        "transaction not permitted": "Transaction not permitted.",
        "not sufficient funds": "Insufficient funds on card.",
        "Technical problem": "Technical issue in authorization system.",
        "Host not found": "Issuer authorization system not available.",
        "Transazione chiusa per time-out": "Transaction closed due to timeout.",
        "Controllo PAN/CONTRATTO": "PAN linked to another contract.",
        "Numero di tentativi di retry esaurito": "Retry attempts exceeded.",
        "soft decline": "Strong customer authentication required. Please retry.",
        "Transazione avvenuta correttamente": "Transaction completed successfully."
      }
    },
    aggiornata_successo: "Profile successfully updated!",
    common: {
      scegli: "Choose"
    },
    ProfiloSanitarioSintetico: {
      titolo: "Patient Health Summary",
      salva: "Save",
      salva_modifiche: "Save changes",
      salvataggio_ok: "Patient health summary saved",
      nessuna_sintesi: "No summary available.",
      placeholder_scrivi: "Open to write the patient health summary.",
      apri_editor: "Open summary",
      apri_compila: "Open and fill in",
      apri_modifica: "Open and edit",
      espandi: "Open and edit",
      ultima_modifica: "Last update",
      placeholder_textarea: "Patient health summary text...",
      errore_caricamento: "Error loading health summary",
      errore_salvataggio: "Error saving health summary",
      ultimo_dato_clinico: "Last clinical data update",
      dati_aggiornati: "Patient data updated after PSS",
      dati_clinici_raccolti: "Collected clinical data",
      nessun_dato: "no data",
    },
    PatientAnamnesi: {
      title: "Anamnesis",
      salva: "Save",
      pulisci: "Clear",
      annulla: "Cancel",
      cerca: "Search",
      titoloConfermaEliminazione: "Delete confirmation",
      titoloConfermaPulizia: "Clear confirmation",
      confermaPulizia: "Yes, clear",
      siProcedi: "Yes, proceed",
      noAnnulla: "No, cancel",
      testoConfermaEliminazione: "Are you sure you want to delete the note",
      testoConfermaPulizia: 'Are you sure you want to clear the "{campo}" field?',
      spiegazioneInserimenti: "Entries added with the actions above are shown as badges. The text in the box remains free text and is saved separately.",
      labelAllergie: "Known allergies, previous allergic reactions",
      labelEventiPregressi: "Past events",
      labelInterventiOspedalizzazioni: "Surgical procedures and hospitalizations",
      labelIntervento: "Surgical procedures",
      labelOspedalizzazioni: "Hospitalizations",
      labelEventiAvversi: "Adverse drug reactions",
      labelCondizioniNote: "Known conditions in the family",
      gruppoCompilato: "Anamnesis group completed",
      nuovaNota: "New note {categoria}",
      nota: "Note",
      erroreCaricamentoNote: "Error while loading notes",
      notaAggiornata: "Note successfully updated",
      erroreAggiornamentoNota: "Error while updating the note",
      notaCreata: "Note successfully created",
      erroreCreazioneNota: "Error while creating the note",
      notaEliminata: "Note successfully deleted",
      erroreEliminazioneNota: "Error while deleting the note",
      allergiePlaceholder: "Food, environmental allergies, type and severity of previous allergic reactions...",
      pregressoPlaceholder: "Relevant past events to report...",
      interventoPlaceholder: "Performed surgical procedures, date, facility and relevant details...",
      ospedalizzazionePlaceholder: "Previous hospitalizations, admissions, major trauma and relevant details...",
      eventiAvversiPlaceholder: "Side effects, adverse drug reactions...",
      labelFamiliare: "Family history",
      familiarePlaceholder: "Hereditary or recurrent family diseases, causes of death of close relatives...",
      labelStileVita: "Lifestyle",
      stileVitaPlaceholder: "Smoking, alcohol, physical activity, diet, relevant habits...",
      labelVaccinazione: "Vaccinations",
      vaccinazionePlaceholder: "Vaccination history, boosters, recommended vaccines not received...",
      labelProtesi: "Prostheses and implants",
      protesiPlaceholder: "Implanted medical devices, prostheses, pacemakers, cochlear implants...",
      labelDonazioneOrgani: "Organ donation",
      donazioneOrganiPlaceholder: "Consent or dissent status for organ and tissue donation...",
      codiciAssociati: "Associated codes",
      nessunaVoceCodificata: "No coded entries available",
      eliminaVoce: "Delete entry",
      eliminaVoceConNome: "Delete entry {name}",
      aggiungiCodiceSezione: "Add code for {section}",
      apriAzioneCodice: "Open action {action}",
      modalTitoloVoce: "Add code for {section}",
      modalTitoloFallback: "Add code",
      titoloEliminaVoce: "Confirm entry deletion",
      confermaEliminaVoce: "Delete entry",
      salvaVoce: "Save entry",
      cercaCatalogo: "Search in catalog",
      selezionaVoceCatalogo: "Select an entry",
      erroreRicercaCatalogo: "Error while searching the catalog",
      tabAggiungiFarmaco: "Add a drug the patient is or has been allergic to",
      tabAggiungiAllergeneCodificato: "Add coded allergen",
      tabInserisciCodiceAllergene: "Enter allergen code",
      tabAggiungiIntervento: "Add procedure",
      tabAggiungiPatologiaFamiliare: "Add family condition",
      tabInserisciCodicePatologiaFamiliare: "Enter condition code",
      tabAggiungiVoceStileVita: "Add lifestyle entry",
      tabAggiungiVaccino: "Add vaccine",
      tabInserisciCodiceVaccino: "Enter vaccine code",
      tabInserisciCodiceProtesi: "Enter prosthesis",
      tabRegistraDonazioneOrgani: "Record organ donation",
      catalogHelpIcd10: "Search an ICD10 pathology and select it before saving the entry.",
      catalogHelpAic: "Search a product or AIC code and select it before saving the entry.",
      catalogPlaceholderIcd10: "Search by ICD10 code or description...",
      catalogPlaceholderAic: "Search by product name or AIC...",
      codiceGenerico: "Code",
      codiceSnomed: "SNOMED code",
      codiceIcd10: "ICD10 code",
      codiceIcd9cm: "ICD9-CM code",
      codiceAic: "AIC code",
      codiceLoinc: "LOINC code",
      dataInizio: "Start date",
      dataFine: "End date",
      voceSenzaDescrizione: "Structured entry",
      voceVuota: "Enter at least one value in the entry",
      voceSalvata: "Entry saved successfully",
      voceSalvataConNome: "Saved item: {name}",
      erroreSalvataggioVoce: "Error while saving the entry",
      voceEliminata: "Entry deleted successfully",
      erroreEliminazioneVoce: "Error while deleting the entry",
      sezioneSalvata: "Anamnesis section updated successfully",
      sezioneSalvataConNome: "Saved item: {label}",
      sezioneRipulitaConNome: "Cleared section: {label}",
      sezioniSalvateConNomi: "Saved items: {labels}",
      schedaSalvata: "Anamnesis form saved successfully",
      erroreSalvataggioScheda: "Error while saving the anamnesis form",
      errorePuliziaSezione: "Error while clearing the section",
      structuredTipoAllergia: "Allergy type",
      structuredGravita: "Severity",
      structuredDataInsorgenza: "Onset date",
      structuredDataProcedura: "Procedure date",
      structuredStruttura: "Facility",
      structuredRelazioneFamiliare: "Family relationship",
      structuredStatoFamiliare: "Family status",
      structuredEtaDecesso: "Age at death",
      structuredDataSomministrazione: "Administration date",
      structuredLotto: "Lot number",
      structuredDose: "Dose number",
      structuredTipoDispositivo: "Device type",
      structuredUdi: "UDI code",
      structuredDataImpianto: "Implant date",
      structuredSedeCorporea: "Body site",
      structuredCategoriaStileVita: "Category",
      structuredStatoAbitudine: "Status",
      structuredQuantitaAbitudine: "Quantity",
      structuredDataCessazione: "Cessation date",
      structuredConsensoDonazione: "Consent",
      structuredDataDichiarazione: "Declaration date",
      optionFarmaco: "Drug",
      optionAlimento: "Food",
      optionAmbiente: "Environment",
      optionAltro: "Other",
      optionAlta: "High",
      optionMedia: "Medium",
      optionBassa: "Low",
      optionMadre: "Mother",
      optionPadre: "Father",
      optionFratello: "Brother",
      optionSorella: "Sister",
      optionFiglio: "Son",
      optionFiglia: "Daughter",
      optionAltroFamiliare: "Other relative",
      optionVivente: "Alive",
      optionDeceduto: "Deceased",
      optionSconosciuto: "Unknown",
      optionFumo: "Smoking",
      optionAlcol: "Alcohol",
      optionAttivitaFisica: "Physical activity",
      optionAlimentazione: "Diet",
      optionAssenso: "Consent",
      optionDissenso: "Dissent"
    },
    uploader: {
      caricamento_completato: "Upload completed",
      placeholder: "Choose file...",
      carica: "Upload",
      errore_caricamento: "File upload error",
      anteprima_pdf_titolo: "View PDF and proceed to upload",
      anteprima_immagine_titolo: "View image and proceed to upload",
      annulla_caricamento: "Cancel file upload",
      conferma_caricamento: "Confirm file upload",
      caricamento_in_corso: "Loading...",
      anteprima_immagine_alt: "Image preview"
    },
    zip_code: "ZIP Code",
    sono_cittadino_residente: "I am a citizen resident in Italy with Tax Code",
    SignedDocumentsList: {
      title: "Signed documents",
      signedOn: "Signed on {date}",
      download: "Download",
      downloadError: "Error downloading document"
    },
    PublicContactForm: {
      nome_cognome: "Full name",
      nome_cognome_placeholder: "Enter full name",
      email: "Email",
      email_placeholder: "Enter email address",
      cellulare: "Mobile phone",
      cellulare_placeholder: "Enter mobile phone number",
      citta: "City",
      citta_placeholder: "Enter city",
      indirizzo: "Address",
      indirizzo_placeholder: "Enter address",
      source: "Source",
      seleziona_source: "Select source",
      invia: "Submit",
      contatto_creato: "Contact successfully created",
      contatto_aggiornato: "Contact successfully updated",
      contatto_non_trovato: "Contact not found or no longer valid. Please check the link you received.",
      errore_generico: "Error creating contact",
      errore_caricamento: "Error loading contact",
      successo: "Operation completed successfully",
      errore: "An error occurred"
    },
    PublicContactPage: {
      logo_alt: "Registration logo",
      titolo: "Contact us",
      sottotitolo: "Fill out the form to be contacted by our team",
      sottotitolo_completa: "Complete your contact information",
      form_contatto: "Contact form",
      step1_descrizione: "Fill in the missing data to complete registration",
      email_non_valida: "Enter a valid email address",
      telefono_non_valido: "Enter a valid phone number (9-20 digits)",
      avanti: "Next",
      indietro: "Back",
      conferma: "Confirm",
      errore: "An error occurred",
      contatto_non_trovato: "Contact not found or no longer valid. Please check the link you received."
    },
    ActivityDetails: {
      visualizza: "View",
      report: "Report",
      somministra: "Administer",
      modifica: "Edit"
    },
    EditQuestionario: {
      elimina_file: "Delete file"
    },
    NuovoQuestionario: {
      elimina_file: "Delete file"
    },
    ConfiguratoreRegoleBlocchi: {
      titolo: "Block rules",
      descrizione: "Configure title and visibility of the blocks already assigned to questions.",
      titolo_blocco: "Block n°{numero}",
      placeholder_titolo: "Optional block title",
      domande_associate: "{count} associated questions",
      visibilita: "Visibility",
      sempre_visibile: "Always visible",
      condizionale: "Conditional",
      domanda_filtro: "Filter question",
      risposta_abilitante: "Enabling answer",
      seleziona_domanda: "Select question",
      seleziona_risposta: "Select answer",
      placeholder_risposta: "Enter answer",
      domanda_senza_testo: "Question without text",
      domanda_numero: "Question {numero}",
      domanda_numero_blocco: "Question {numero} - block {blocco}",
      regola_interna:
        "The filter question is in the same block: it will always be shown and will enable the other questions in the block.",
      regola_esterna:
        "The filter question is in block {blocco}: this block will be shown or skipped entirely.",
    },
    HomeQuestionari: {
      visualizza: "View",
      report: "Report",
      somministra: "Administer",
      modifica: "Edit"
    },
    UserLastSurveys: {
      vedi: "View",
      modifica: "Edit",
      elimina: "Delete",
      scarica: "Download"
    },
    HomeAttivita: {
      visualizza: "View",
      report: "Report",
      nuovo_questionario: "New survey",
      modifica: "Edit",
      elimina: "Delete"
    },
    ReportQuestionariUtente: {
      vedi: "View",
      modifica: "Edit",
      elimina: "Delete",
      scarica: "Download"
    },
    ReportQuestionariCompilati: {
      apri_scheda_paziente: "Open patient file",
      vedi: "View",
      modifica: "Edit",
      elimina: "Delete",
      scarica: "Download"
    },
    AdminHomeServices: {
      modifica: "Edit",
      configura: "Configure",
      configura_servizio: "Configure service {name}",
      titolo_configurazione_generico: "Service configuration",
      titolo_configurazione_servizio: "Service configuration {name}",
      nessun_contenuto_configurazione:
        "No configuration content available for this service"
    },
    OperatoreDashboardImpegniCard: {
      vai_alla_prenotazione: "Go to reservation"
    },
    GestionePrenotazioniOperatore: {
      vedi_dettagli: "View Details",
      annulla: "Cancel",
      evadi: "Process"
    },
    VoucherSottoscrizioni: {
      attiva: "Activate",
      disattiva: "Deactivate",
      elimina: "Delete"
    },
    AdminQuestionari: {
      visualizza: "View",
      report: "Report",
      modifica: "Edit"
    },
    AdminHomeAttivita: {
      visualizza: "View",
      report: "Report",
      nuovo_questionario: "New survey",
      modifica: "Edit",
      elimina: "Delete"
    },
    HomeTeleconsulto: {
      vedi_dettagli: "View details",
      annulla: "Cancel",
      evadi: "Process"
    },
    VoucherEditForm: {
      modifica: "Edit"
    },
    AnagraficaCompany: {
      titolo: "Company details",
      info_referente_popover: "Contact details for the person the Service Center can contact for platform administration",
      info_referente_title: "Reference Info",
      tab_sede_operativa: "Operational office",
      tab_sede_legale: "Registered office",
      tabs_anagrafica_aria: "Company registry tabs",
      sezione_sede_legale: "Registered office",
      sezione_sede_legale_profilo: "Profile",
      sezione_sede_legale_fiscale: "Tax information",
      sezione_sede_legale_indirizzo: "Address",
      sezione_sede_legale_contatti: "Contacts",
      modifica_sede_legale: "Edit registered office",
      sede_legale_denominazione: "Company name",
      placeholder_denominazione: "Company name...",
      sede_legale_nome_titolare: "Owner first name",
      sede_legale_cognome_titolare: "Owner last name",
      partita_iva: "VAT number",
      codice_fiscale: "Tax code",
      sede_legale_indirizzo: "Address and street number",
      sede_legale_cap: "Postcode",
      sede_legale_frazione: "Hamlet",
      sede_legale_regione: "Region",
      sede_legale_provincia: "Province",
      sede_legale_comune: "Municipality",
      sede_legale_email: "Email",
      sede_legale_pec: "Certified email",
      sede_legale_telefono: "Phone",
      placeholder_nome: "First name...",
      placeholder_cognome: "Last name...",
      placeholder_partita_iva: "VAT number...",
      placeholder_codice_fiscale: "Tax code...",
      placeholder_indirizzo: "Address...",
      placeholder_cap: "Postcode...",
      placeholder_frazione: "Hamlet...",
      placeholder_email: "Email...",
      placeholder_pec: "Certified email...",
      placeholder_telefono: "Phone...",
      seleziona_regione: "Select region",
      seleziona_provincia: "Select province",
      seleziona_comune: "Select municipality",
      errore_caricamento_province: "Error loading provinces",
      errore_caricamento_comuni: "Error loading municipalities"
    },
    CittadinoMain: {
      navigazione_cittadino: "Citizen navigation"
    },
    ArchivioSanitarioOperatore: {
      apri_archivio_sanitario: "Open health archive",
      archivio_sanitario: "Health archive"
    },
    AdminRegistrazioni: {
      rimuovi_filtro_fonte: "Remove source filter",
      rimuovi_filtro_progetti: "Remove projects filter",
      filtra_per_struttura: "Filter by enrolling facility",
      rimuovi_filtro_struttura: "Remove facility filter"
    },
    AdminSurveySessions: {
      visualizza_dettagli: "View details",
      crea_sessione: "Create session",
      cerca: "Search",
      elenco_sessioni: "Sessions list"
    },
    FeverHomeDashboard: {
      percentuale_completamento: "{perc}% completion",
      nessun_dato: "no data"
    },
    HomeSessioni: {
      richiede_firma_operatore: "Requires operator signature",
      firma_operatore_si: "Yes",
      firma_operatore_no: "No",
      seleziona_numero_giorni_firma: "Choose the number of days for the signature",
      modifica_sessione: "Edit session",
      titolo_modifica_sessione: "Edit session",
      modifica_sessione_apri: "Open session editing",
      sessione_modificata_successo: "Session updated successfully",
      errore_modifica_sessione: "The session could not be updated",
      sessione_creata_successo: "Session created successfully",
      sessione_avviata_successo: "Session started successfully",
      sessione_eliminata_successo: "Session deleted successfully",
      errore_caricamento_sessioni: "Error loading sessions",
      errore_caricamento_attivita: "Error loading activities",
      nome_questionario_obbligatori: "Session name and at least one survey are required",
      almeno_due_questionari_obbligatori: "Session name and at least two surveys are required",
      errore_creazione_sessione: "Error creating session",
      errore_avvio_sessione: "Error starting session",
      errore_eliminazione_sessione: "Error deleting session",
      nessuna_sessione_trovata: "No sessions found",
      crea_nuova_sessione: "new session",
      titolo_crea_nuova_sessione: "New session",
      nome_sessione_asterisco: "Session Name *",
      inserisci_nome_sessione: "Enter session name",
      descrizione_opzionale: "Optional description",
      questionari_asterisco: "Surveys *",
      questionari_disponibili: "Available Surveys",
      cerca_questionari: "Search surveys",
      placeholder_cerca_questionari: "Type to filter by name",
      questionari_selezionati: "Selected Surveys",
      nessun_questionario_selezionato: "No surveys selected",
      seleziona_questionari_per_iniziare: "Select surveys from available ones to compose the session",
      caricamento_attivita: "Loading activities...",
      ancora_da_firmare: "Still to sign: {num}",
      ancora_da_firmare_testo: "Still to sign: {num}",
      posizione_numero: "Position {num}",
      nessun_questionario_disponibile: "No surveys available",
      attivo: "Active",
      inattivo: "Inactive",
      questionari_sessione_ordinati: "Session surveys",
      nessun_questionario_configurato: "No surveys configured for this session.",
      visualizza_questionari: "View surveys",
      nessuna_descrizione: "No description",
      visualizza_dettaglio: "View details",
      informazioni_sessione: "Session information",
      giorni_firma_asterisco: "Days to sign *",
      placeholder_giorni_firma: "Enter days (1-15)",
      aiuto_giorni_firma: "Number of days within which the operator must sign the session; after the deadline the session is deleted. Allowed values 1–15; default 3.",
      ruoli_consentiti: "Allowed roles",
      somministra_sessione: "Administer session",
      permesso_somministra_mancante: "Missing administer permission",
      ruoli_non_autorizzati_msg: "You don't have the required roles: {ruoli}",
      ruoli_non_autorizzati_generico: "You don't have the required roles to administer this session",
      elimina_sessione: "Delete session",
      creata_da: "Created by",
      eliminazione_non_consentita_sessione_somministrata: "Cannot delete: at least one compilation exists for this session",
      conferma_eliminazione_sessione: "Are you sure you want to delete the session \"{nome}\"?",
      nessuna_compilazione_associata: "There are no compilations associated with this session.",
      espandi_dettagli: "Expand survey details",
      comprimi_dettagli: "Collapse survey details",
      cerca_sessione: "Search sessions by name",
      seleziona_elementi_per_pagina: "Select number of items per page",
      filtra_per_stato: "Filter sessions by status",
      elementi_per_pagina: "Items per page",
      stato_filtro: "Status filter",
      caricamento_sessioni: "Loading sessions",
      lista_sessioni: "Sessions list",
      dettagli_questionari: "Session surveys details",
      posizione_questionario: "Survey {numero}: {nome}",
      stato_sessione: "Status: {stato}",
      questionari_totali: "{totale} surveys found",
      nome: "Name",
      descrizione: "Description",
      tipologia: "Type",
      somministrati: "Administered",
      stato: "Status",
      azioni: "Actions",
      tutti_stati: "All statuses",
      in_attesa: "Pending",
      in_corso: "In progress",
      completate: "Completed",
      annullate: "Cancelled",
      filtri_e_paginazione: "Filter and pagination controls",
      tipo_questionari_asterisco: "Survey Type *",
      anonimo: "Anonymous",
      pseudoanonimo: "Pseudonymous",
      in_chiaro: "Clear",
      tutti_operatori_autorizzati: "All operators are authorized",
      si: "Yes",
      no_solo_ruoli_specifici: "No, only specific roles",
      ruoli_consentiti_label: "Select allowed roles",
      somministrazione_consentita_ai_ruoli: "Administration allowed to roles",
      rimuovi_ruolo: "Remove role {name}",
      questionari_in_chiaro: "Clear Surveys",
      questionari_anonimi: "Anonymous Surveys",
      questionari_pseudoanonimi: "Pseudonymous Surveys",
      tipo_in_chiaro_desc: "Survey data is directly linked to patient identity",
      tipo_anonimo_desc: "Survey data cannot be linked to any specific identity",
      tipo_pseudoanonimo_desc: "Survey data is linked through an anonymous code",
      questionari: "Surveys",
      nessuna_attivita_tipo_selezionato: "No activities available for the selected survey type",
      numero_questionari_selezionati: "{count} surveys selected",
      lista_questionari_ordinabili: "Sortable survey list via drag and drop",
      questionario_posizione: "Survey {numero}: {nome}",
      rimuovi_questionario: "Remove survey {nome}",
      lista_attivita_questionari: "List of activities with available surveys",
      attivita_con_questionari: "Activity {nome} with surveys",
      espandi_attivita: "Expand activity {nome} - {stato}",
      espansa: "expanded",
      chiusa: "collapsed",
      questionari_attivita: "Available surveys for activity {nome}",
      questionario_item: "Survey: {nome}",
      aggiungi_questionario: "Add survey {nome} to session",
      visualizza_dettaglio_compilazione: "View compilation details"
    },
    PatientSurveySessions: {
      titolo: "Sessions",
      nessuna_descrizione: "No description",
      somministra_sessione: "Administer session",
      nessuna_sessione: "No sessions available",
      nuova_sessione: "new session",
      seleziona_sessione: "Select session",
      procedi: "Proceed",
      cerca_sessione: "Search session",
      filtro_in_chiaro: "Cleartext only",
      filtro_attive: "Active only",
      nessun_risultato: "No results",
      permesso_somministra_mancante: "Missing administer permission",
      ruoli_non_autorizzati_generico: "You don't have the required roles to administer this session",
      ruoli_non_autorizzati_msg: "You are missing required roles: {ruoli}",
      cf_mancante: "Tax Code is required for cleartext sessions.",
      in_chiaro: "Cleartext",
      pseudoanonimo: "Pseudonymous",
      anonimo: "Anonymous",
      item_position: "Item {number}: {name}",
      errore_caricamento_sessioni: "Error while loading sessions",
      lista_sessioni: "Session list"
    },
    NavigationOperatoreCRoom: {
      checklist_templates: "Checklists"
    },
    ChecklistTemplatesControlRoom: {
      titolo: "Checklist Templates",
      info_titolo: "Default templates:",
      info_testo: "These templates are the reusable models made available to operators. Changes do not affect patient checklists that have already been created.",
      cerca: "Search template",
      crea_template: "New template",
      nessuna_descrizione: "No description",
      sequenziale_si: "Sequential",
      sequenziale_no: "Not sequential",
      attivo: "Active",
      disattivo: "Inactive",
      modifica: "Edit template",
      elimina: "Delete template",
      nessun_template: "No template available",
      nome: "Name",
      tipo: "Type",
      descrizione: "Description",
      sequenziale: "Sequential",
      stato: "Status",
      azioni: "Actions",
      conferma_eliminazione: "Do you confirm deleting the template \"{nome}\"?",
      template_eliminato: "Template deleted",
      errore_permesso: "You don't have the required permissions for this operation",
      errore_caricamento: "Error while loading templates",
      errore_eliminazione_vincolo: "Unable to delete the template: it is in use or has constraints",
      errore_eliminazione: "Error while deleting the template"
    },
    ChecklistTemplateModal: {
      titolo_crea: "New checklist template",
      titolo_modifica: "Edit checklist template",
      crea_template: "Create template",
      form_label: "Checklist template form",
      nome_asterisco: "Name *",
      nome_placeholder: "E.g. ERAS Colorectal Surgery",
      tipo: "Type",
      tipo_placeholder: "E.g. eras",
      descrizione: "Description",
      descrizione_placeholder: "Pathway description",
      sequenziale: "Sequential checklist",
      sequenziale_desc: "When enabled, following sections and steps can be completed only after the required previous ones",
      attivo: "Active",
      sezioni: "Sections",
      aggiungi_sezione: "Add section",
      nessuna_sezione: "No section: add at least one section",
      lista_sezioni_ordinabili: "Sortable sections list",
      trascina_sezione: "Drag to reorder the section",
      titolo_sezione: "Section title",
      titolo_sezione_placeholder: "Section title",
      descrizione_sezione: "Section description",
      descrizione_sezione_placeholder: "Section description (optional)",
      rimuovi_sezione: "Remove section {titolo}",
      sezione_sequenziale: "Sequential",
      sezione_obbligatoria: "Required",
      step: "Steps",
      aggiungi_step: "Add step",
      nessuno_step: "No step in this section",
      lista_step_ordinabili: "Sortable steps list",
      trascina_step: "Drag to reorder the step",
      titolo_step: "Step title",
      titolo_step_placeholder: "Step title",
      descrizione_step: "Step description",
      descrizione_step_placeholder: "Step description (optional)",
      ruolo_atteso: "Expected role",
      ruolo_atteso_placeholder: "E.g. nurse / surgeon",
      nessun_ruolo: "No role",
      rimuovi_ruolo: "Remove {name}",
      step_obbligatorio: "Required",
      tag_obbligatorio: "Required",
      tag_facoltativo: "Optional",
      tag_classificazione: "Step classification",
      rimuovi_step: "Remove step {titolo}",
      nome_obbligatorio: "Template name is required",
      almeno_una_sezione: "Add at least one section",
      titoli_sezioni_obbligatori: "All sections must have a title",
      ogni_sezione_uno_step: "Each section must contain at least one step",
      titoli_step_obbligatori: "All steps must have a title",
      template_creato: "Template created",
      template_aggiornato: "Template updated",
      errore_permesso: "You don't have the required permissions for this operation",
      errore_salvataggio: "Error while saving the template"
    },
    CreatePatientChecklistModal: {
      titolo: "New checklist",
      sottotitolo_scegli: "Choose how to start",
      crea_da_zero: "Create from scratch",
      crea_da_zero_desc: "Start from an empty checklist and add phases and activities manually.",
      parti_da_template: "Start from a template",
      parti_da_template_desc: "Use a predefined pathway and customize it for the patient.",
      titolo_da_zero: "Create from scratch",
      sottotitolo_da_zero: "Define the checklist, then add phases and activities",
      titolo_checklist: "Checklist title",
      titolo_checklist_placeholder: "E.g. Post-operative pathway",
      descrizione_facoltativa: "Description (optional)",
      descrizione_placeholder: "Context notes about the pathway…",
      sequenziale: "Sequential phases",
      sequenziale_desc: "When enabled, the following phases can be completed only after the required previous ones.",
      info_fase_vuota: "An empty first phase will be created. You can add more sequential phases and their activities directly from the checklist.",
      titolo_template: "Start from a template",
      sottotitolo_template: "Select a predefined pathway",
      cerca_template: "Search template",
      nessun_template: "No template available",
      fasi: "{numero} phases",
      attivita: "{numero} activities",
      anteprima_fasi: "Sequential phases preview",
      titolo_per_paziente: "Title for this patient",
      indietro: "Back",
      crea_checklist: "Create checklist",
      seleziona_template: "Select a template",
      nome_obbligatorio: "The checklist title is required",
      checklist_creata: "Checklist created",
      errore_permesso: "You don't have the required permissions for this operation",
      errore_creazione: "Error while creating the checklist"
    },
    ChecklistCard: {
      sequenziale: "Sequential",
      meta_fasi: "{numero} phases",
      avanzamento_aria: "Progress {perc}%",
      attivita_count: "{done} / {total} activities",
      comprimi: "collapse",
      espandi: "expand",
      stato_da_iniziare: "To start",
      stato_in_corso: "In progress",
      stato_completata: "Completed",
      stato_vuota: "Empty",
      fase_completata: "Completed",
      fase_in_corso: "In progress",
      fase_bloccata: "Unlocks when the previous phase is completed",
      fase_attivita_completate: "{done} of {total} activities completed",
      nessuna_attivita: "No activities in this phase.",
      aggiungi_attivita: "add activity",
      descrizione_attivita_placeholder: "Activity description…",
      titolo_attivita_placeholder: "Activity title",
      aggiungi: "Add",
      aggiungi_fase: "add phase",
      nuova_fase: "New phase {numero}",
      nome_fase: "Phase name",
      nota_placeholder: "Add a clinical note…",
      salva: "Save",
      chiudi: "Close",
      azioni_checklist: "Checklist actions",
      salva_come_template: "Adopt as template",
      elimina_checklist: "Delete checklist",
      azioni_fase: "Phase actions",
      rinomina_fase: "Rename phase",
      sposta_su: "Move phase up",
      sposta_giu: "Move phase down",
      elimina_fase: "Delete phase",
      completa_attivita: "Complete activity {nome}",
      riapri_attivita: "Reopen activity {nome}",
      nota_attivita: "Note for activity {nome}",
      modifica_attivita: "Edit activity {nome}",
      rimuovi_attivita: "Remove activity {nome}",
      errore_permesso: "You don't have the required permissions for this operation",
      errore_sequenzialita: "Operation not allowed: complete the required previous phases first",
      errore_aggiornamento: "Error while updating the checklist",
      errore_completato_non_eliminabile: "A completed activity cannot be deleted",
      tag_obbligatorio: "Required",
      tag_facoltativo: "Optional",
      tag_classificazione: "Activity classification",
      tag_obbligatorio_aria: "Required activity",
      tag_facoltativo_aria: "Optional activity",
      ruolo_atteso: "Role",
      ruolo_atteso_aria: "Role assigned to the activity",
      nessun_ruolo: "No role",
      rimuovi_ruolo: "Remove {name}",
      ruolo_badge_aria: "Role: {nome}"
    },
    ChecklistItemModal: {
      aggiungi: "Add",
      titolo_aggiungi: "Add step",
      titolo_modifica: "Edit step",
      titolo_nuova_sezione: "New section",
      nuova_sezione: "New section",
      primo_step: "First step",
      titolo_sezione_asterisco: "Section title *",
      titolo_sezione_placeholder: "New section title",
      sezione_sequenziale: "Sequential section",
      sezione_obbligatoria: "Required section",
      titolo_asterisco: "Title *",
      titolo_placeholder: "Step title",
      descrizione: "Description",
      descrizione_placeholder: "Step description (optional)",
      ruolo_atteso: "Expected role",
      ruolo_atteso_placeholder: "E.g. nurse",
      obbligatorio: "Required",
      note: "Notes",
      note_placeholder: "Notes (optional)",
      titolo_obbligatorio: "Step title is required",
      titolo_sezione_obbligatorio: "Section title is required",
      step_aggiunto: "Step added",
      step_aggiornato: "Step updated",
      errore_permesso: "You don't have the required permissions for this operation",
      errore_salvataggio: "Error while saving the step"
    },
    PatientChecklists: {
      titolo: "Patient checklists",
      tab_label: "Checklists",
      sottotitolo: "Clinical pathways structured in sequential phases, with monitored progress.",
      nuova_checklist: "new checklist",
      lista_checklist: "Patient checklists list",
      checklist_attive: "active checklists",
      completate: "completed",
      attivita_svolte: "activities done",
      avanzamento_complessivo: "Overall progress",
      avanzamento_aria: "Overall progress {perc}%",
      nessuna_checklist_titolo: "No checklist for this patient",
      nessuna_checklist_desc: "Create a checklist from scratch or start from a predefined clinical template.",
      crea_prima_checklist: "Create the first checklist",
      conferma_eliminazione: "Do you confirm deleting the checklist \"{nome}\"?",
      checklist_eliminata: "Checklist deleted",
      conferma_eliminazione_fase: "Do you confirm deleting the phase \"{nome}\"? Its activities will be deleted too.",
      fase_eliminata: "Phase deleted",
      adotta_titolo: "Adopt as template",
      adotta_sottotitolo: "Reuse this structure as a template for other patients.",
      adotta_nome: "Template name",
      adotta_specialita: "Specialty / category",
      adotta_info: "{fasi} phases · {attivita} activities will be saved (without completion state).",
      adotta_salva: "Save template",
      adotta_template_adottato: "Template saved in the Control Room library",
      adotta_nome_obbligatorio: "The template name is required",
      adotta_errore: "Error while adopting the checklist as a template",
      errore_permesso: "You don't have the required permissions for this operation",
      errore_caricamento: "Error while loading checklists",
      errore_eliminazione_vincolo: "Unable to delete the checklist: it has constraints",
      errore_eliminazione: "Error while deleting the checklist",
      errore_eliminazione_fase: "Error while deleting the phase",
      errore_eliminazione_fase_vincolo: "Unable to delete the phase: it contains completed activities"
    },
    PatientChecklistDetail: {
      torna_elenco: "Checklists list",
      sequenziale: "Sequential",
      modifica_checklist: "Edit checklist",
      avanzamento_complessivo: "Overall progress",
      avanzamento_percentuale: "Overall progress {perc}%",
      nessuna_sezione: "This checklist has no sections yet",
      aggiungi_sezione: "Add section",
      sezioni: "Sections",
      obbligatoria: "Required",
      aggiungi_step: "Add step",
      avanzamento_sezione: "Section progress",
      avanzamento_sezione_percentuale: "Section progress {perc}%",
      nessuno_step: "No step in this section",
      lista_step: "Steps list",
      step_posizione: "Step {numero}: {nome}",
      trascina_step: "Drag to reorder the step",
      completa_step: "Complete step {nome}",
      riapri_step: "Reopen step {nome}",
      step_bloccato_sequenziale: "Step locked: complete the required previous steps first",
      obbligatorio: "Required",
      completato_il: "Completed on {data}",
      assegnato_a: "Assigned to {nome}",
      modifica_step: "Edit step",
      elimina_step: "Delete step",
      nome_checklist: "Checklist name",
      conferma_eliminazione_step: "Do you confirm deleting the step \"{nome}\"?",
      step_eliminato: "Step deleted",
      checklist_aggiornata: "Checklist updated",
      eliminazione_step_completato: "A completed step cannot be deleted",
      errore_sequenzialita: "Operation not allowed: sequentiality prevents proceeding before completing the required steps",
      errore_aggiornamento_step: "Error while updating the step",
      errore_eliminazione_step: "Error while deleting the step",
      errore_riordino: "Error while reordering the steps",
      errore_aggiornamento_checklist: "Error while updating the checklist",
      errore_caricamento: "Error while loading the checklist",
      errore_permesso: "You don't have the required permissions for this operation",
      stato_pending: "To start",
      stato_in_corso: "In progress",
      stato_completata: "Completed",
      stato_bozza: "Draft"
    },
    DettaglioSessioneModal: {
      titolo_dettaglio_sessione: "Session Details",
      contenuto_dettaglio_sessione: "Session details content",
      informazioni_sessione: "Session information",
      questionari_configurati: "surveys configured",
      stato_sessione: "Status: {stato}",
      istanze_compilazione: "Compilation instances",
      compilazioni_sessione: "Session Compilations",
      totale_compilazioni: "{totale} total compilations",
      nessuna_compilazione: "No compilations found",
      lista_istanze: "Compilation instances list",
      caricamento_istanze: "Loading instances",
      paziente: "Patient",
      stato: "Status",
      data_inizio: "Start Date",
      data_completamento: "Completion Date",
      cf: "Tax Code",
      progresso: "Progress",
      azioni: "Actions",
      in_corso: "In progress",
      progresso_compilazione: "Progress: {percentuale}%",
      visualizza_dettaglio_compilazione: "View compilation details",
      errore_caricamento_sessione: "Error loading session details",
      errore_caricamento_dettagli: "Error loading details",
      chiudi_dettagli: "Close details",
      paziente_anonimo: "Anonymous patient",
      istanza_iniziata: "Started",
      istanza_in_corso: "In progress",
      istanza_completata: "Completed",
      istanza_abbandonata: "Abandoned",
      stato_in_attesa: "Pending",
      stato_in_corso: "In progress",
      stato_completate: "Completed",
      stato_annullate: "Cancelled",
      funzione_in_sviluppo: "Feature under development"
    },
    DettaglioSessione: {
      contenuto_dettaglio_sessione: "Session content",
      mostra_prima_da_firmare: "Show unsigned compilations first",
      azioni_per_compilazione: "Actions for compilation {num}",
      sessioni: "Sessions",
      titolo_compilazioni_sessione: "Session compilations",
      titolo_dettaglio_sessione: "Session Details",
      torna_alle_sessioni: "Back to Sessions",
      sessione_non_trovata: "Session not found",
      nessuna_compilazione: "No compilations found",
      paziente: "Patient",
      stato: "Status",
      cf: "Tax Code",
      questionario: "Survey",
      data: "Date",
      punteggio: "Score",
      esito: "Outcome",
      data_inizio: "Start Date",
      data_completamento: "Completion Date",
      progresso: "Progress",
      azioni: "Actions",
      filtro_cf: "Tax Code",
      elementi_per_pagina: "Items per page",
      seleziona_elementi_per_pagina: "Select number of items per page",
      cf_solo_in_chiaro: "Filter available only for clear sessions",
      chiudi: "Close",
      in_corso: "In progress",
      progresso_compilazione: "Progress: {percentuale}%",
      visualizza_dettaglio_compilazione: "View compilation details",
      errore_caricamento_sessione: "Error loading session details",
      errore_caricamento_dettagli: "Error loading details",
      paziente_anonimo: "Anonymous patient",
      istanza_iniziata: "Started",
      istanza_in_corso: "In progress",
      istanza_completata: "Completed",
      istanza_abbandonata: "Abandoned",
      stato_in_attesa: "Pending",
      stato_in_corso: "In progress",
      stato_completate: "Completed",
      stato_annullate: "Cancelled",
      funzione_in_sviluppo: "Feature under development"
    },
    RiepilogoCompilazioniTable: {
      tab_questionario: "Questionario",
      tab_data: "Data",
      tab_punteggio: "Punteggio",
      tab_azioni: "Azioni",
      visualizza_dettaglio_compilazione: "Visualizza dettaglio compilazione",
      nessuna_compilazione: "Nessuna compilazione disponibile"
    },
    CompilazioneSessione: {
      close: "Close",
      torna_alle_sessioni: "Back to Sessions",
      scheda_paziente: "Patient profile",
      seleziona_paziente: "Select the patient to administer the survey:",
      registra_paziente: "Register Patient",
      paziente_selezionato: "Selected patient:",
      nome_cognome: "NAME AND SURNAME",
      codice_fiscale: "TAX CODE",
      annulla_selezione: "Deselect",
      avvia_sessione: "Start session",
      inserisci_pseudonimo: "Enter pseudonym*:",
      conferma: "Confirm",
      paziente_label: "Patient:",
      attenzione: "Attention!",
      informativa: "Information",
      consenso: "I have read the information and give my consent",
      procedi: "Proceed",
      operazione_completata: "Operation completed.",
      operazione_non_consentita: "Operation not allowed.",
      cf_mancante: "Missing tax code",
      errore_caricamento_sessione: "Unable to load session",
      errore_avvio_sessione: "Unable to start session",
      errore_caricamento_questionario: "Unable to load the survey",
      errore_invio_questionario: "Unable to send the survey",
      sessione_completata: "Session completed",
      errore_recupero_utente: "Unable to retrieve user information",
      necessaria_verifica_secondario: "Since the patient does not have an email address, the secondary phone number must also be verified.",
      necessaria_verifica_numero: "To proceed, the patient's phone number must be verified.",
      avviso_cancellazione_mezzanotte: "The session has not been signed. If you do not sign within {days} days, it will be deleted.",
      chiudi: "Chiudi",
      riepilogo_compilazioni: "Session summary",
      tab_questionario: "Questionario",
      tab_data: "Data",
      tab_punteggio: "Punteggio",
      tab_azioni: "Azioni",
      visualizza_dettaglio_compilazione: "Visualizza dettaglio compilazione",
      nessuna_compilazione: "Nessuna compilazione disponibile",
      firmata_da_alle: "Firmata da {nome} alle {ora} del {giorno}",
      firma_richiesta_warning: "Firma richiesta: invia OTP",
      otp_verifica_titolo: "OTP verification",
      otp_verifica_testo: "An OTP verification request has been sent to the patient.",
      invia_otp: "Send OTP",
      risultato: "Result",
      non_disponibile: "Not available",
      descrizione: "Description",
      prossimo_questionario: "Next questionnaire",
      concludi_sessione: "Finish session"
    },
    SchedaArruolamento: {
      invia_link_pagamento_checkbox: "Send payment link via email after enrollment",
      link_validita_4_ore: "The payment link will be valid for 4 hours from generation.",
      conferma_invio_link_title: "Confirm sending payment link",
      si_conferma_invia: "Yes, confirm and send",
      inoltra_link_email_heading: "Forward payment link via email to patient",
      inoltra_link_email_descrizione: "By clicking \"Confirm\" you will send to the patient's email address a link to the secure Nexi payment system, so that they can independently finalize the subscription activation. The link is valid for 4 hours from generation, after which it will need to be regenerated from the patient profile.",
      quali_sottoscrizioni_disponibili: "What subscriptions are available?"
    },
    AssegnaSottoscrizioneArruolamento: {
      label_assegna: "Assign a subscription to the patient (optional)",
      info_attesa_pagamento: "The subscription will be assigned to the patient pending payment",
      quali_sottoscrizioni: "What subscriptions are available?",
      invia_link_checkbox: "Send payment link via email after enrollment",
      link_validita: "The payment link will be valid for 4 hours from generation.",
      conferma_invio_link_title: "Confirm sending payment link",
      si_conferma_invia: "Yes, confirm and send",
      inoltra_link_email_heading: "Forward payment link via email to patient",
      inoltra_link_email_descrizione: "By clicking \"Confirm\" you will send to the patient's email address a link to the secure Nexi payment system, so that they can independently finalize the subscription activation. The link is valid for 4 hours from generation, after which it will need to be regenerated from the patient profile."
    },
    SeeAndActivateFreeSubscriptionsAsAdmin: {
      sottoscrizione_non_attiva: "Subscription not active",
      storico_sottoscrizioni: "Subscription history",
      mesi: "months",
      disattivata: "Disabled",
      scaduta_il: "Expired on",
      prossimo_rinnovo: "Next renewal attempt:",
      rinnovo_attivo: "Auto-renewal active",
      rinnovo_disattivato: "Auto-renewal disabled",
      annulla_rinnovo: "Cancel auto-renewal",
      aria_annulla_rinnovo: "Cancel auto-renewal for {name}",
      aria_toggle_storico: "Expand or collapse subscription history",
      conferma_annullamento_title: "Confirm renewal cancellation",
      conferma_annullamento_msg: "Do you confirm you want to cancel auto-renewal for this subscription?",
      si_annulla: "Yes, cancel",
      annullamento_non_reversibile: "Warning: this operation is not reversible for disabled subscriptions.",
      errore_sottoscrizione_non_trovata: "Subscription not found.",
      rinnovo_annullato_successo: "Auto-renewal successfully cancelled!",
      errore_annulla_rinnovo: "Unable to cancel auto-renewal.",
      rinnovo_ripristinato_successo: "Auto-renewal successfully restored!",
      errore_ripristino_rinnovo: "Unable to restore auto-renewal.",
      errore_operazione: "Unable to complete the operation."
    }
  }
}

export const messages = {
  it: { ...base.it, ...RecapSottoscrizioniPaziente.it, ...PlanSheet.it },
  en: { ...base.en, ...RecapSottoscrizioniPaziente.en, ...PlanSheet.en },
};
